
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ac5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ac5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iBsb3", function(module, exports) {
// data can be any array-like object.  It just needs to support .length, .slice, and an element getter []
function $d8b18a1ad1eb95b5$var$parseMidi(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var headerChunk = p.readChunk();
    if (headerChunk.id != 'MThd') throw "Bad MIDI file.  Expected 'MHdr', got: '" + headerChunk.id + "'";
    var header = $d8b18a1ad1eb95b5$var$parseHeader(headerChunk.data);
    var tracks = [];
    for(var i = 0; !p.eof() && i < header.numTracks; i++){
        var trackChunk = p.readChunk();
        if (trackChunk.id != 'MTrk') throw "Bad MIDI file.  Expected 'MTrk', got: '" + trackChunk.id + "'";
        var track = $d8b18a1ad1eb95b5$var$parseTrack(trackChunk.data);
        tracks.push(track);
    }
    return {
        header: header,
        tracks: tracks
    };
}
function $d8b18a1ad1eb95b5$var$parseHeader(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var format = p.readUInt16();
    var numTracks = p.readUInt16();
    var result = {
        format: format,
        numTracks: numTracks
    };
    var timeDivision = p.readUInt16();
    if (timeDivision & 0x8000) {
        result.framesPerSecond = 0x100 - (timeDivision >> 8);
        result.ticksPerFrame = timeDivision & 0xFF;
    } else result.ticksPerBeat = timeDivision;
    return result;
}
function $d8b18a1ad1eb95b5$var$parseTrack(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var events = [];
    while(!p.eof()){
        var event = readEvent();
        events.push(event);
    }
    var lastEventTypeByte;
    return events;
    function readEvent() {
        var event = {};
        event.deltaTime = p.readVarInt();
        var eventTypeByte = p.readUInt8();
        if ((eventTypeByte & 0xf0) === 0xf0) {
            // system / meta event
            if (eventTypeByte === 0xff) {
                // meta event
                event.meta = true;
                var metatypeByte = p.readUInt8();
                var length = p.readVarInt();
                switch(metatypeByte){
                    case 0x00:
                        event.type = 'sequenceNumber';
                        if (length !== 2) throw "Expected length for sequenceNumber event is 2, got " + length;
                        event.number = p.readUInt16();
                        return event;
                    case 0x01:
                        event.type = 'text';
                        event.text = p.readString(length);
                        return event;
                    case 0x02:
                        event.type = 'copyrightNotice';
                        event.text = p.readString(length);
                        return event;
                    case 0x03:
                        event.type = 'trackName';
                        event.text = p.readString(length);
                        return event;
                    case 0x04:
                        event.type = 'instrumentName';
                        event.text = p.readString(length);
                        return event;
                    case 0x05:
                        event.type = 'lyrics';
                        event.text = p.readString(length);
                        return event;
                    case 0x06:
                        event.type = 'marker';
                        event.text = p.readString(length);
                        return event;
                    case 0x07:
                        event.type = 'cuePoint';
                        event.text = p.readString(length);
                        return event;
                    case 0x20:
                        event.type = 'channelPrefix';
                        if (length != 1) throw "Expected length for channelPrefix event is 1, got " + length;
                        event.channel = p.readUInt8();
                        return event;
                    case 0x21:
                        event.type = 'portPrefix';
                        if (length != 1) throw "Expected length for portPrefix event is 1, got " + length;
                        event.port = p.readUInt8();
                        return event;
                    case 0x2f:
                        event.type = 'endOfTrack';
                        if (length != 0) throw "Expected length for endOfTrack event is 0, got " + length;
                        return event;
                    case 0x51:
                        event.type = 'setTempo';
                        if (length != 3) throw "Expected length for setTempo event is 3, got " + length;
                        event.microsecondsPerBeat = p.readUInt24();
                        return event;
                    case 0x54:
                        event.type = 'smpteOffset';
                        if (length != 5) throw "Expected length for smpteOffset event is 5, got " + length;
                        var hourByte = p.readUInt8();
                        var FRAME_RATES = {
                            0x00: 24,
                            0x20: 25,
                            0x40: 29,
                            0x60: 30
                        };
                        event.frameRate = FRAME_RATES[hourByte & 0x60];
                        event.hour = hourByte & 0x1f;
                        event.min = p.readUInt8();
                        event.sec = p.readUInt8();
                        event.frame = p.readUInt8();
                        event.subFrame = p.readUInt8();
                        return event;
                    case 0x58:
                        event.type = 'timeSignature';
                        if (length != 2 && length != 4) throw "Expected length for timeSignature event is 4 or 2, got " + length;
                        event.numerator = p.readUInt8();
                        event.denominator = 1 << p.readUInt8();
                        if (length === 4) {
                            event.metronome = p.readUInt8();
                            event.thirtyseconds = p.readUInt8();
                        } else {
                            event.metronome = 0x24;
                            event.thirtyseconds = 0x08;
                        }
                        return event;
                    case 0x59:
                        event.type = 'keySignature';
                        if (length != 2) throw "Expected length for keySignature event is 2, got " + length;
                        event.key = p.readInt8();
                        event.scale = p.readUInt8();
                        return event;
                    case 0x7f:
                        event.type = 'sequencerSpecific';
                        event.data = p.readBytes(length);
                        return event;
                    default:
                        event.type = 'unknownMeta';
                        event.data = p.readBytes(length);
                        event.metatypeByte = metatypeByte;
                        return event;
                }
            } else if (eventTypeByte == 0xf0) {
                event.type = 'sysEx';
                var length = p.readVarInt();
                event.data = p.readBytes(length);
                return event;
            } else if (eventTypeByte == 0xf7) {
                event.type = 'endSysEx';
                var length = p.readVarInt();
                event.data = p.readBytes(length);
                return event;
            } else throw "Unrecognised MIDI event type byte: " + eventTypeByte;
        } else {
            // channel event
            var param1;
            if ((eventTypeByte & 0x80) === 0) {
                // running status - reuse lastEventTypeByte as the event type.
                // eventTypeByte is actually the first parameter
                if (lastEventTypeByte === null) throw "Running status byte encountered before status byte";
                param1 = eventTypeByte;
                eventTypeByte = lastEventTypeByte;
                event.running = true;
            } else {
                param1 = p.readUInt8();
                lastEventTypeByte = eventTypeByte;
            }
            var eventType = eventTypeByte >> 4;
            event.channel = eventTypeByte & 0x0f;
            switch(eventType){
                case 0x08:
                    event.type = 'noteOff';
                    event.noteNumber = param1;
                    event.velocity = p.readUInt8();
                    return event;
                case 0x09:
                    var velocity = p.readUInt8();
                    event.type = velocity === 0 ? 'noteOff' : 'noteOn';
                    event.noteNumber = param1;
                    event.velocity = velocity;
                    if (velocity === 0) event.byte9 = true;
                    return event;
                case 0x0a:
                    event.type = 'noteAftertouch';
                    event.noteNumber = param1;
                    event.amount = p.readUInt8();
                    return event;
                case 0x0b:
                    event.type = 'controller';
                    event.controllerType = param1;
                    event.value = p.readUInt8();
                    return event;
                case 0x0c:
                    event.type = 'programChange';
                    event.programNumber = param1;
                    return event;
                case 0x0d:
                    event.type = 'channelAftertouch';
                    event.amount = param1;
                    return event;
                case 0x0e:
                    event.type = 'pitchBend';
                    event.value = param1 + (p.readUInt8() << 7) - 0x2000;
                    return event;
                default:
                    throw "Unrecognised MIDI event type: " + eventType;
            }
        }
    }
}
function $d8b18a1ad1eb95b5$var$Parser(data) {
    this.buffer = data;
    this.bufferLen = this.buffer.length;
    this.pos = 0;
}
$d8b18a1ad1eb95b5$var$Parser.prototype.eof = function() {
    return this.pos >= this.bufferLen;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt8 = function() {
    var result = this.buffer[this.pos];
    this.pos += 1;
    return result;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt8 = function() {
    var u = this.readUInt8();
    if (u & 0x80) return u - 0x100;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt16 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8();
    return (b0 << 8) + b1;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt16 = function() {
    var u = this.readUInt16();
    if (u & 0x8000) return u - 0x10000;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt24 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8(), b2 = this.readUInt8();
    return (b0 << 16) + (b1 << 8) + b2;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt24 = function() {
    var u = this.readUInt24();
    if (u & 0x800000) return u - 0x1000000;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt32 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8(), b2 = this.readUInt8(), b3 = this.readUInt8();
    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readBytes = function(len) {
    var bytes = this.buffer.slice(this.pos, this.pos + len);
    this.pos += len;
    return bytes;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readString = function(len) {
    var bytes = this.readBytes(len);
    return String.fromCharCode.apply(null, bytes);
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readVarInt = function() {
    var result = 0;
    while(!this.eof()){
        var b = this.readUInt8();
        if (b & 0x80) {
            result += b & 0x7f;
            result <<= 7;
        } else // b is last byte
        return result + b;
    }
    // premature eof
    return result;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readChunk = function() {
    var id = this.readString(4);
    var length = this.readUInt32();
    var data = this.readBytes(length);
    return {
        id: id,
        length: length,
        data: data
    };
};
module.exports = $d8b18a1ad1eb95b5$var$parseMidi;

});

parcelRegister("ezd6o", function(module, exports) {
// data should be the same type of format returned by parseMidi
// for maximum compatibililty, returns an array of byte values, suitable for conversion to Buffer, Uint8Array, etc.
// opts:
// - running              reuse previous eventTypeByte when possible, to compress file
// - useByte9ForNoteOff   use 0x09 for noteOff when velocity is zero
function $a9ae7f5b8be739be$var$writeMidi(data, opts) {
    if (typeof data !== 'object') throw 'Invalid MIDI data';
    opts = opts || {};
    var header = data.header || {};
    var tracks = data.tracks || [];
    var i, len = tracks.length;
    var w = new $a9ae7f5b8be739be$var$Writer();
    $a9ae7f5b8be739be$var$writeHeader(w, header, len);
    for(i = 0; i < len; i++)$a9ae7f5b8be739be$var$writeTrack(w, tracks[i], opts);
    return w.buffer;
}
function $a9ae7f5b8be739be$var$writeHeader(w, header, numTracks) {
    var format = header.format == null ? 1 : header.format;
    var timeDivision = 128;
    if (header.timeDivision) timeDivision = header.timeDivision;
    else if (header.ticksPerFrame && header.framesPerSecond) timeDivision = -(header.framesPerSecond & 0xFF) << 8 | header.ticksPerFrame & 0xFF;
    else if (header.ticksPerBeat) timeDivision = header.ticksPerBeat & 0x7FFF;
    var h = new $a9ae7f5b8be739be$var$Writer();
    h.writeUInt16(format);
    h.writeUInt16(numTracks);
    h.writeUInt16(timeDivision);
    w.writeChunk('MThd', h.buffer);
}
function $a9ae7f5b8be739be$var$writeTrack(w, track, opts) {
    var t = new $a9ae7f5b8be739be$var$Writer();
    var i, len = track.length;
    var eventTypeByte = null;
    for(i = 0; i < len; i++){
        // Reuse last eventTypeByte when opts.running is set, or event.running is explicitly set on it.
        // parseMidi will set event.running for each event, so that we can get an exact copy by default.
        // Explicitly set opts.running to false, to override event.running and never reuse last eventTypeByte.
        if (opts.running === false || !opts.running && !track[i].running) eventTypeByte = null;
        eventTypeByte = $a9ae7f5b8be739be$var$writeEvent(t, track[i], eventTypeByte, opts.useByte9ForNoteOff);
    }
    w.writeChunk('MTrk', t.buffer);
}
function $a9ae7f5b8be739be$var$writeEvent(w, event, lastEventTypeByte, useByte9ForNoteOff) {
    var type = event.type;
    var deltaTime = event.deltaTime;
    var text = event.text || '';
    var data = event.data || [];
    var eventTypeByte = null;
    w.writeVarInt(deltaTime);
    switch(type){
        // meta events
        case 'sequenceNumber':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x00);
            w.writeVarInt(2);
            w.writeUInt16(event.number);
            break;
        case 'text':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x01);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'copyrightNotice':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x02);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'trackName':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x03);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'instrumentName':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x04);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'lyrics':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x05);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'marker':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x06);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'cuePoint':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x07);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case 'channelPrefix':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x20);
            w.writeVarInt(1);
            w.writeUInt8(event.channel);
            break;
        case 'portPrefix':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x21);
            w.writeVarInt(1);
            w.writeUInt8(event.port);
            break;
        case 'endOfTrack':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x2F);
            w.writeVarInt(0);
            break;
        case 'setTempo':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x51);
            w.writeVarInt(3);
            w.writeUInt24(event.microsecondsPerBeat);
            break;
        case 'smpteOffset':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x54);
            w.writeVarInt(5);
            var FRAME_RATES = {
                24: 0x00,
                25: 0x20,
                29: 0x40,
                30: 0x60
            };
            var hourByte = event.hour & 0x1F | FRAME_RATES[event.frameRate];
            w.writeUInt8(hourByte);
            w.writeUInt8(event.min);
            w.writeUInt8(event.sec);
            w.writeUInt8(event.frame);
            w.writeUInt8(event.subFrame);
            break;
        case 'timeSignature':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x58);
            w.writeVarInt(4);
            w.writeUInt8(event.numerator);
            var denominator = Math.floor(Math.log(event.denominator) / Math.LN2) & 0xFF;
            w.writeUInt8(denominator);
            w.writeUInt8(event.metronome);
            w.writeUInt8(event.thirtyseconds || 8);
            break;
        case 'keySignature':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x59);
            w.writeVarInt(2);
            w.writeInt8(event.key);
            w.writeUInt8(event.scale);
            break;
        case 'sequencerSpecific':
            w.writeUInt8(0xFF);
            w.writeUInt8(0x7F);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        case 'unknownMeta':
            if (event.metatypeByte != null) {
                w.writeUInt8(0xFF);
                w.writeUInt8(event.metatypeByte);
                w.writeVarInt(data.length);
                w.writeBytes(data);
            }
            break;
        // system-exclusive
        case 'sysEx':
            w.writeUInt8(0xF0);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        case 'endSysEx':
            w.writeUInt8(0xF7);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        // channel events
        case 'noteOff':
            // Use 0x90 when opts.useByte9ForNoteOff is set and velocity is zero, or when event.byte9 is explicitly set on it.
            // parseMidi will set event.byte9 for each event, so that we can get an exact copy by default.
            // Explicitly set opts.useByte9ForNoteOff to false, to override event.byte9 and always use 0x80 for noteOff events.
            var noteByte = useByte9ForNoteOff !== false && event.byte9 || useByte9ForNoteOff && event.velocity == 0 ? 0x90 : 0x80;
            eventTypeByte = noteByte | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.velocity);
            break;
        case 'noteOn':
            eventTypeByte = 0x90 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.velocity);
            break;
        case 'noteAftertouch':
            eventTypeByte = 0xA0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.amount);
            break;
        case 'controller':
            eventTypeByte = 0xB0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.controllerType);
            w.writeUInt8(event.value);
            break;
        case 'programChange':
            eventTypeByte = 0xC0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.programNumber);
            break;
        case 'channelAftertouch':
            eventTypeByte = 0xD0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.amount);
            break;
        case 'pitchBend':
            eventTypeByte = 0xE0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            var value14 = 0x2000 + event.value;
            var lsb14 = value14 & 0x7F;
            var msb14 = value14 >> 7 & 0x7F;
            w.writeUInt8(lsb14);
            w.writeUInt8(msb14);
            break;
        default:
            throw 'Unrecognized event type: ' + type;
    }
    return eventTypeByte;
}
function $a9ae7f5b8be739be$var$Writer() {
    this.buffer = [];
}
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt8 = function(v) {
    this.buffer.push(v & 0xFF);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt8 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt8;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt16 = function(v) {
    var b0 = v >> 8 & 0xFF, b1 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt16 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt16;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt24 = function(v) {
    var b0 = v >> 16 & 0xFF, b1 = v >> 8 & 0xFF, b2 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
    this.writeUInt8(b2);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt24 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt24;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt32 = function(v) {
    var b0 = v >> 24 & 0xFF, b1 = v >> 16 & 0xFF, b2 = v >> 8 & 0xFF, b3 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
    this.writeUInt8(b2);
    this.writeUInt8(b3);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt32 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt32;
$a9ae7f5b8be739be$var$Writer.prototype.writeBytes = function(arr) {
    this.buffer = this.buffer.concat(Array.prototype.slice.call(arr, 0));
};
$a9ae7f5b8be739be$var$Writer.prototype.writeString = function(str) {
    var i, len = str.length, arr = [];
    for(i = 0; i < len; i++)arr.push(str.codePointAt(i));
    this.writeBytes(arr);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeVarInt = function(v) {
    if (v < 0) throw "Cannot write negative variable-length integer";
    if (v <= 0x7F) this.writeUInt8(v);
    else {
        var i = v;
        var bytes = [];
        bytes.push(i & 0x7F);
        i >>= 7;
        while(i){
            var b = i & 0x7F | 0x80;
            bytes.push(b);
            i >>= 7;
        }
        this.writeBytes(bytes.reverse());
    }
};
$a9ae7f5b8be739be$var$Writer.prototype.writeChunk = function(id, data) {
    this.writeString(id);
    this.writeUInt32(data.length);
    this.writeBytes(data);
};
module.exports = $a9ae7f5b8be739be$var$writeMidi;

});

parcelRegister("2Tywo", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_setDefaults", () => _setDefaults);
$parcel$export(module.exports, "_removeLinkedListItem", () => _removeLinkedListItem);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "Timeline", () => Timeline);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "clamp", () => clamp);
$parcel$export(module.exports, "selector", () => selector);
$parcel$export(module.exports, "shuffle", () => shuffle);
$parcel$export(module.exports, "distribute", () => distribute);
$parcel$export(module.exports, "_roundModifier", () => _roundModifier);
$parcel$export(module.exports, "snap", () => snap);
$parcel$export(module.exports, "random", () => random);
$parcel$export(module.exports, "pipe", () => pipe);
$parcel$export(module.exports, "unitize", () => unitize);
$parcel$export(module.exports, "normalize", () => normalize);
$parcel$export(module.exports, "mapRange", () => mapRange);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapYoyo", () => wrapYoyo);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "interpolate", () => interpolate);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "splitColor", () => splitColor);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "Animation", () => Animation);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Power0", () => Power0);
$parcel$export(module.exports, "Power1", () => Power1);
$parcel$export(module.exports, "Power2", () => Power2);
$parcel$export(module.exports, "Power3", () => Power3);
$parcel$export(module.exports, "Power4", () => Power4);
$parcel$export(module.exports, "Linear", () => Linear);
$parcel$export(module.exports, "Quad", () => Quad);
$parcel$export(module.exports, "Cubic", () => Cubic);
$parcel$export(module.exports, "Quart", () => Quart);
$parcel$export(module.exports, "Quint", () => Quint);
$parcel$export(module.exports, "Strong", () => Strong);
$parcel$export(module.exports, "Elastic", () => Elastic);
$parcel$export(module.exports, "Back", () => Back);
$parcel$export(module.exports, "SteppedEase", () => SteppedEase);
$parcel$export(module.exports, "Bounce", () => Bounce);
$parcel$export(module.exports, "Sine", () => Sine);
$parcel$export(module.exports, "Expo", () => Expo);
$parcel$export(module.exports, "Circ", () => Circ);
$parcel$export(module.exports, "TweenMax", () => Tween);
$parcel$export(module.exports, "TweenLite", () => Tween);
$parcel$export(module.exports, "TimelineMax", () => Timeline);
$parcel$export(module.exports, "TimelineLite", () => Timeline);
$parcel$export(module.exports, "default", () => gsap);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.14.1
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.14.1";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

var $28735cb37928c976$exports = {};
"use strict";
var $28735cb37928c976$var$__awaiter = $28735cb37928c976$exports && $28735cb37928c976$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $28735cb37928c976$var$__generator = $28735cb37928c976$exports && $28735cb37928c976$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($28735cb37928c976$exports, "__esModule", {
    value: true
});
$28735cb37928c976$exports.Header = $28735cb37928c976$exports.Track = $28735cb37928c976$exports.Midi = void 0;
var $f4610896fa898662$export$2b5b68a498cfe902;
var $f4610896fa898662$export$77fcca795c2a5d6c;

$f4610896fa898662$export$2b5b68a498cfe902 = (parcelRequire("iBsb3"));

$f4610896fa898662$export$77fcca795c2a5d6c = (parcelRequire("ezd6o"));


var $ae5327bd0dc5627f$exports = {};
"use strict";
Object.defineProperty($ae5327bd0dc5627f$exports, "__esModule", {
    value: true
});
$ae5327bd0dc5627f$exports.Header = $ae5327bd0dc5627f$exports.keySignatureKeys = void 0;
var $43b0fba3852e64e0$exports = {};
"use strict";
Object.defineProperty($43b0fba3852e64e0$exports, "__esModule", {
    value: true
});
$43b0fba3852e64e0$exports.insert = $43b0fba3852e64e0$exports.search = void 0;
/**
 * Return the index of the element at or before the given property
 * @hidden
 */ function $43b0fba3852e64e0$var$search(array, value, prop) {
    if (prop === void 0) prop = "ticks";
    var beginning = 0;
    var len = array.length;
    var end = len;
    if (len > 0 && array[len - 1][prop] <= value) return len - 1;
    while(beginning < end){
        // calculate the midpoint for roughly equal partition
        var midPoint = Math.floor(beginning + (end - beginning) / 2);
        var event_1 = array[midPoint];
        var nextEvent = array[midPoint + 1];
        if (event_1[prop] === value) {
            // choose the last one that has the same value
            for(var i = midPoint; i < array.length; i++){
                var testEvent = array[i];
                if (testEvent[prop] === value) midPoint = i;
            }
            return midPoint;
        } else if (event_1[prop] < value && nextEvent[prop] > value) return midPoint;
        else if (event_1[prop] > value) // search lower
        end = midPoint;
        else if (event_1[prop] < value) // search upper
        beginning = midPoint + 1;
    }
    return -1;
}
$43b0fba3852e64e0$exports.search = $43b0fba3852e64e0$var$search;
/**
 * Does a binary search to insert the note
 * in the correct spot in the array
 * @hidden
 */ function $43b0fba3852e64e0$var$insert(array, event, prop) {
    if (prop === void 0) prop = "ticks";
    if (array.length) {
        var index = $43b0fba3852e64e0$var$search(array, event[prop], prop);
        array.splice(index + 1, 0, event);
    } else array.push(event);
}
$43b0fba3852e64e0$exports.insert = $43b0fba3852e64e0$var$insert;


var $ae5327bd0dc5627f$var$privatePPQMap = new WeakMap();
/**
 * @hidden
 */ $ae5327bd0dc5627f$exports.keySignatureKeys = [
    "Cb",
    "Gb",
    "Db",
    "Ab",
    "Eb",
    "Bb",
    "F",
    "C",
    "G",
    "D",
    "A",
    "E",
    "B",
    "F#",
    "C#"
];
/**
 * The parsed MIDI file header.
 */ var $ae5327bd0dc5627f$var$Header = /** @class */ function() {
    function Header(midiData) {
        var _this = this;
        /**
         * The array of all the tempo events.
         */ this.tempos = [];
        /**
         * The time signatures.
         */ this.timeSignatures = [];
        /**
         * The time signatures.
         */ this.keySignatures = [];
        /**
         * Additional meta events.
         */ this.meta = [];
        /**
         * The name of the MIDI file;
         */ this.name = "";
        // Look through all the tracks for tempo changes.
        $ae5327bd0dc5627f$var$privatePPQMap.set(this, 480);
        if (midiData) {
            $ae5327bd0dc5627f$var$privatePPQMap.set(this, midiData.header.ticksPerBeat);
            // Check time signature and tempo events from all of the tracks.
            midiData.tracks.forEach(function(track) {
                track.forEach(function(event) {
                    if (event.meta) {
                        if (event.type === "timeSignature") _this.timeSignatures.push({
                            ticks: event.absoluteTime,
                            timeSignature: [
                                event.numerator,
                                event.denominator
                            ]
                        });
                        else if (event.type === "setTempo") _this.tempos.push({
                            bpm: 60000000 / event.microsecondsPerBeat,
                            ticks: event.absoluteTime
                        });
                        else if (event.type === "keySignature") _this.keySignatures.push({
                            key: $ae5327bd0dc5627f$exports.keySignatureKeys[event.key + 7],
                            scale: event.scale === 0 ? "major" : "minor",
                            ticks: event.absoluteTime
                        });
                    }
                });
            });
            // Check the first track for other relevant data.
            var firstTrackCurrentTicks_1 = 0; // Used for absolute times.
            midiData.tracks[0].forEach(function(event) {
                firstTrackCurrentTicks_1 += event.deltaTime;
                if (event.meta) {
                    if (event.type === "trackName") _this.name = event.text;
                    else if (event.type === "text" || event.type === "cuePoint" || event.type === "marker" || event.type === "lyrics") _this.meta.push({
                        text: event.text,
                        ticks: firstTrackCurrentTicks_1,
                        type: event.type
                    });
                }
            });
            this.update();
        }
    }
    /**
     * This must be invoked after any changes are made to the tempo array
     * or the timeSignature array for the updated values to be reflected.
     */ Header.prototype.update = function() {
        var _this = this;
        var currentTime = 0;
        var lastEventBeats = 0;
        // Make sure it's sorted;
        this.tempos.sort(function(a, b) {
            return a.ticks - b.ticks;
        });
        this.tempos.forEach(function(event, index) {
            var lastBPM = index > 0 ? _this.tempos[index - 1].bpm : _this.tempos[0].bpm;
            var beats = event.ticks / _this.ppq - lastEventBeats;
            var elapsedSeconds = 60 / lastBPM * beats;
            event.time = elapsedSeconds + currentTime;
            currentTime = event.time;
            lastEventBeats += beats;
        });
        this.timeSignatures.sort(function(a, b) {
            return a.ticks - b.ticks;
        });
        this.timeSignatures.forEach(function(event, index) {
            var lastEvent = index > 0 ? _this.timeSignatures[index - 1] : _this.timeSignatures[0];
            var elapsedBeats = (event.ticks - lastEvent.ticks) / _this.ppq;
            var elapsedMeasures = elapsedBeats / lastEvent.timeSignature[0] / (lastEvent.timeSignature[1] / 4);
            lastEvent.measures = lastEvent.measures || 0;
            event.measures = elapsedMeasures + lastEvent.measures;
        });
    };
    /**
     * Convert ticks into seconds based on the tempo changes.
     */ Header.prototype.ticksToSeconds = function(ticks) {
        // Find the relevant position.
        var index = (0, $43b0fba3852e64e0$exports.search)(this.tempos, ticks);
        if (index !== -1) {
            var tempo = this.tempos[index];
            var tempoTime = tempo.time;
            var elapsedBeats = (ticks - tempo.ticks) / this.ppq;
            return tempoTime + 60 / tempo.bpm * elapsedBeats;
        } else {
            // Assume 120.
            var beats = ticks / this.ppq;
            return 0.5 * beats;
        }
    };
    /**
     * Convert ticks into measures based off of the time signatures.
     */ Header.prototype.ticksToMeasures = function(ticks) {
        var index = (0, $43b0fba3852e64e0$exports.search)(this.timeSignatures, ticks);
        if (index !== -1) {
            var timeSigEvent = this.timeSignatures[index];
            var elapsedBeats = (ticks - timeSigEvent.ticks) / this.ppq;
            return timeSigEvent.measures + elapsedBeats / (timeSigEvent.timeSignature[0] / timeSigEvent.timeSignature[1]) / 4;
        } else return ticks / this.ppq / 4;
    };
    Object.defineProperty(Header.prototype, "ppq", {
        /**
         * The number of ticks per quarter note.
         */ get: function() {
            return $ae5327bd0dc5627f$var$privatePPQMap.get(this);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Convert seconds to ticks based on the tempo events.
     */ Header.prototype.secondsToTicks = function(seconds) {
        // Find the relevant position.
        var index = (0, $43b0fba3852e64e0$exports.search)(this.tempos, seconds, "time");
        if (index !== -1) {
            var tempo = this.tempos[index];
            var tempoTime = tempo.time;
            var elapsedTime = seconds - tempoTime;
            var elapsedBeats = elapsedTime / (60 / tempo.bpm);
            return Math.round(tempo.ticks + elapsedBeats * this.ppq);
        } else {
            // Assume 120.
            var beats = seconds / 0.5;
            return Math.round(beats * this.ppq);
        }
    };
    /**
     * Convert the header into an object.
     */ Header.prototype.toJSON = function() {
        return {
            keySignatures: this.keySignatures,
            meta: this.meta,
            name: this.name,
            ppq: this.ppq,
            tempos: this.tempos.map(function(t) {
                return {
                    bpm: t.bpm,
                    ticks: t.ticks
                };
            }),
            timeSignatures: this.timeSignatures
        };
    };
    /**
     * Parse a header json object.
     */ Header.prototype.fromJSON = function(json) {
        this.name = json.name;
        // Clone all the attributes.
        this.tempos = json.tempos.map(function(t) {
            return Object.assign({}, t);
        });
        this.timeSignatures = json.timeSignatures.map(function(t) {
            return Object.assign({}, t);
        });
        this.keySignatures = json.keySignatures.map(function(t) {
            return Object.assign({}, t);
        });
        this.meta = json.meta.map(function(t) {
            return Object.assign({}, t);
        });
        $ae5327bd0dc5627f$var$privatePPQMap.set(this, json.ppq);
        this.update();
    };
    /**
     * Update the tempo of the midi to a single tempo. Will remove and replace
     * any other tempos currently set and update all of the event timing.
     * @param bpm The tempo in beats per second.
     */ Header.prototype.setTempo = function(bpm) {
        this.tempos = [
            {
                bpm: bpm,
                ticks: 0
            }
        ];
        this.update();
    };
    return Header;
}();
$ae5327bd0dc5627f$exports.Header = $ae5327bd0dc5627f$var$Header;


var $40651e7dcdad1bee$exports = {};
"use strict";
Object.defineProperty($40651e7dcdad1bee$exports, "__esModule", {
    value: true
});
$40651e7dcdad1bee$exports.Track = void 0;

var $5c2a91a28bf6dfbb$exports = {};
"use strict";
Object.defineProperty($5c2a91a28bf6dfbb$exports, "__esModule", {
    value: true
});
$5c2a91a28bf6dfbb$exports.ControlChange = $5c2a91a28bf6dfbb$exports.controlChangeIds = $5c2a91a28bf6dfbb$exports.controlChangeNames = void 0;
/**
 * A map of values to control change names
 * @hidden
 */ $5c2a91a28bf6dfbb$exports.controlChangeNames = {
    1: "modulationWheel",
    2: "breath",
    4: "footController",
    5: "portamentoTime",
    7: "volume",
    8: "balance",
    10: "pan",
    64: "sustain",
    65: "portamentoTime",
    66: "sostenuto",
    67: "softPedal",
    68: "legatoFootswitch",
    84: "portamentoControl"
};
/**
 * swap the keys and values
 * @hidden
 */ $5c2a91a28bf6dfbb$exports.controlChangeIds = Object.keys($5c2a91a28bf6dfbb$exports.controlChangeNames).reduce(function(obj, key) {
    obj[$5c2a91a28bf6dfbb$exports.controlChangeNames[key]] = key;
    return obj;
}, {});
var $5c2a91a28bf6dfbb$var$privateHeaderMap = new WeakMap();
var $5c2a91a28bf6dfbb$var$privateCCNumberMap = new WeakMap();
/**
 * Represents a control change event
 */ var $5c2a91a28bf6dfbb$var$ControlChange = /** @class */ function() {
    /**
     * @param event
     * @param header
     */ function ControlChange(event, header) {
        $5c2a91a28bf6dfbb$var$privateHeaderMap.set(this, header);
        $5c2a91a28bf6dfbb$var$privateCCNumberMap.set(this, event.controllerType);
        this.ticks = event.absoluteTime;
        this.value = event.value;
    }
    Object.defineProperty(ControlChange.prototype, "number", {
        /**
         * The controller number
         */ get: function() {
            return $5c2a91a28bf6dfbb$var$privateCCNumberMap.get(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlChange.prototype, "name", {
        /**
         * return the common name of the control number if it exists
         */ get: function() {
            if ($5c2a91a28bf6dfbb$exports.controlChangeNames[this.number]) return $5c2a91a28bf6dfbb$exports.controlChangeNames[this.number];
            else return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlChange.prototype, "time", {
        /**
         * The time of the event in seconds
         */ get: function() {
            var header = $5c2a91a28bf6dfbb$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $5c2a91a28bf6dfbb$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    ControlChange.prototype.toJSON = function() {
        return {
            number: this.number,
            ticks: this.ticks,
            time: this.time,
            value: this.value
        };
    };
    return ControlChange;
}();
$5c2a91a28bf6dfbb$exports.ControlChange = $5c2a91a28bf6dfbb$var$ControlChange;


var $0da2b741b9a6b187$exports = {};
"use strict";
Object.defineProperty($0da2b741b9a6b187$exports, "__esModule", {
    value: true
});
$0da2b741b9a6b187$exports.createControlChanges = void 0;

/**
 * Automatically creates an alias for named control values using Proxies
 * @hidden
 */ function $0da2b741b9a6b187$var$createControlChanges() {
    return new Proxy({}, {
        // tslint:disable-next-line: typedef
        get: function(target, handler) {
            if (target[handler]) return target[handler];
            else if ($5c2a91a28bf6dfbb$exports.controlChangeIds.hasOwnProperty(handler)) return target[$5c2a91a28bf6dfbb$exports.controlChangeIds[handler]];
        },
        // tslint:disable-next-line: typedef
        set: function(target, handler, value) {
            if ($5c2a91a28bf6dfbb$exports.controlChangeIds.hasOwnProperty(handler)) target[$5c2a91a28bf6dfbb$exports.controlChangeIds[handler]] = value;
            else target[handler] = value;
            return true;
        }
    });
}
$0da2b741b9a6b187$exports.createControlChanges = $0da2b741b9a6b187$var$createControlChanges;


var $14f891a148a8e503$exports = {};
"use strict";
Object.defineProperty($14f891a148a8e503$exports, "__esModule", {
    value: true
});
$14f891a148a8e503$exports.PitchBend = void 0;
var $14f891a148a8e503$var$privateHeaderMap = new WeakMap();
/**
 * Represents a pitch bend event.
 */ var $14f891a148a8e503$var$PitchBend = /** @class */ function() {
    /**
     * @param event
     * @param header
     */ function PitchBend(event, header) {
        $14f891a148a8e503$var$privateHeaderMap.set(this, header);
        this.ticks = event.absoluteTime;
        this.value = event.value;
    }
    Object.defineProperty(PitchBend.prototype, "time", {
        /**
         * The time of the event in seconds
         */ get: function() {
            var header = $14f891a148a8e503$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $14f891a148a8e503$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    PitchBend.prototype.toJSON = function() {
        return {
            ticks: this.ticks,
            time: this.time,
            value: this.value
        };
    };
    return PitchBend;
}();
$14f891a148a8e503$exports.PitchBend = $14f891a148a8e503$var$PitchBend;


var $30a9506e114bbf2a$exports = {};
"use strict";
Object.defineProperty($30a9506e114bbf2a$exports, "__esModule", {
    value: true
});
$30a9506e114bbf2a$exports.Instrument = void 0;
var $c35949daea318c57$exports = {};
"use strict";
Object.defineProperty($c35949daea318c57$exports, "__esModule", {
    value: true
});
$c35949daea318c57$exports.DrumKitByPatchID = $c35949daea318c57$exports.InstrumentFamilyByID = $c35949daea318c57$exports.instrumentByPatchID = void 0;
$c35949daea318c57$exports.instrumentByPatchID = [
    "acoustic grand piano",
    "bright acoustic piano",
    "electric grand piano",
    "honky-tonk piano",
    "electric piano 1",
    "electric piano 2",
    "harpsichord",
    "clavi",
    "celesta",
    "glockenspiel",
    "music box",
    "vibraphone",
    "marimba",
    "xylophone",
    "tubular bells",
    "dulcimer",
    "drawbar organ",
    "percussive organ",
    "rock organ",
    "church organ",
    "reed organ",
    "accordion",
    "harmonica",
    "tango accordion",
    "acoustic guitar (nylon)",
    "acoustic guitar (steel)",
    "electric guitar (jazz)",
    "electric guitar (clean)",
    "electric guitar (muted)",
    "overdriven guitar",
    "distortion guitar",
    "guitar harmonics",
    "acoustic bass",
    "electric bass (finger)",
    "electric bass (pick)",
    "fretless bass",
    "slap bass 1",
    "slap bass 2",
    "synth bass 1",
    "synth bass 2",
    "violin",
    "viola",
    "cello",
    "contrabass",
    "tremolo strings",
    "pizzicato strings",
    "orchestral harp",
    "timpani",
    "string ensemble 1",
    "string ensemble 2",
    "synthstrings 1",
    "synthstrings 2",
    "choir aahs",
    "voice oohs",
    "synth voice",
    "orchestra hit",
    "trumpet",
    "trombone",
    "tuba",
    "muted trumpet",
    "french horn",
    "brass section",
    "synthbrass 1",
    "synthbrass 2",
    "soprano sax",
    "alto sax",
    "tenor sax",
    "baritone sax",
    "oboe",
    "english horn",
    "bassoon",
    "clarinet",
    "piccolo",
    "flute",
    "recorder",
    "pan flute",
    "blown bottle",
    "shakuhachi",
    "whistle",
    "ocarina",
    "lead 1 (square)",
    "lead 2 (sawtooth)",
    "lead 3 (calliope)",
    "lead 4 (chiff)",
    "lead 5 (charang)",
    "lead 6 (voice)",
    "lead 7 (fifths)",
    "lead 8 (bass + lead)",
    "pad 1 (new age)",
    "pad 2 (warm)",
    "pad 3 (polysynth)",
    "pad 4 (choir)",
    "pad 5 (bowed)",
    "pad 6 (metallic)",
    "pad 7 (halo)",
    "pad 8 (sweep)",
    "fx 1 (rain)",
    "fx 2 (soundtrack)",
    "fx 3 (crystal)",
    "fx 4 (atmosphere)",
    "fx 5 (brightness)",
    "fx 6 (goblins)",
    "fx 7 (echoes)",
    "fx 8 (sci-fi)",
    "sitar",
    "banjo",
    "shamisen",
    "koto",
    "kalimba",
    "bag pipe",
    "fiddle",
    "shanai",
    "tinkle bell",
    "agogo",
    "steel drums",
    "woodblock",
    "taiko drum",
    "melodic tom",
    "synth drum",
    "reverse cymbal",
    "guitar fret noise",
    "breath noise",
    "seashore",
    "bird tweet",
    "telephone ring",
    "helicopter",
    "applause",
    "gunshot"
];
$c35949daea318c57$exports.InstrumentFamilyByID = [
    "piano",
    "chromatic percussion",
    "organ",
    "guitar",
    "bass",
    "strings",
    "ensemble",
    "brass",
    "reed",
    "pipe",
    "synth lead",
    "synth pad",
    "synth effects",
    "world",
    "percussive",
    "sound effects"
];
$c35949daea318c57$exports.DrumKitByPatchID = {
    0: "standard kit",
    8: "room kit",
    16: "power kit",
    24: "electronic kit",
    25: "tr-808 kit",
    32: "jazz kit",
    40: "brush kit",
    48: "orchestra kit",
    56: "sound fx kit"
};


/**
 * @hidden
 */ var $30a9506e114bbf2a$var$privateTrackMap = new WeakMap();
/**
 * Describes the MIDI instrument of a track.
 */ var $30a9506e114bbf2a$var$Instrument = /** @class */ function() {
    /**
     * @param trackData
     * @param track
     */ function Instrument(trackData, track) {
        /**
         * The instrument number. Defaults to 0.
         */ this.number = 0;
        $30a9506e114bbf2a$var$privateTrackMap.set(this, track);
        this.number = 0;
        if (trackData) {
            var programChange = trackData.find(function(e) {
                return e.type === "programChange";
            });
            // Set 'number' from 'programNumber' if exists.
            if (programChange) this.number = programChange.programNumber;
        }
    }
    Object.defineProperty(Instrument.prototype, "name", {
        /**
         * The common name of the instrument.
         */ get: function() {
            if (this.percussion) return $c35949daea318c57$exports.DrumKitByPatchID[this.number];
            else return $c35949daea318c57$exports.instrumentByPatchID[this.number];
        },
        set: function(n) {
            var patchNumber = $c35949daea318c57$exports.instrumentByPatchID.indexOf(n);
            if (patchNumber !== -1) this.number = patchNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Instrument.prototype, "family", {
        /**
         * The instrument family, e.g. "piano".
         */ get: function() {
            if (this.percussion) return "drums";
            else return $c35949daea318c57$exports.InstrumentFamilyByID[Math.floor(this.number / 8)];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Instrument.prototype, "percussion", {
        /**
         * If the instrument is a percussion instrument.
         */ get: function() {
            var track = $30a9506e114bbf2a$var$privateTrackMap.get(this);
            return track.channel === 9;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Convert it to JSON form.
     */ Instrument.prototype.toJSON = function() {
        return {
            family: this.family,
            number: this.number,
            name: this.name
        };
    };
    /**
     * Convert from JSON form.
     */ Instrument.prototype.fromJSON = function(json) {
        this.number = json.number;
    };
    return Instrument;
}();
$30a9506e114bbf2a$exports.Instrument = $30a9506e114bbf2a$var$Instrument;


var $27d9bef3f137e052$exports = {};
"use strict";
Object.defineProperty($27d9bef3f137e052$exports, "__esModule", {
    value: true
});
$27d9bef3f137e052$exports.Note = void 0;
/**
 * Convert a MIDI note into a pitch.
 */ function $27d9bef3f137e052$var$midiToPitch(midi) {
    var octave = Math.floor(midi / 12) - 1;
    return $27d9bef3f137e052$var$midiToPitchClass(midi) + octave.toString();
}
/**
 * Convert a MIDI note to a pitch class (just the pitch no octave).
 */ function $27d9bef3f137e052$var$midiToPitchClass(midi) {
    var scaleIndexToNote = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B"
    ];
    var note = midi % 12;
    return scaleIndexToNote[note];
}
/**
 * Convert a pitch class to a MIDI note.
 */ function $27d9bef3f137e052$var$pitchClassToMidi(pitch) {
    var scaleIndexToNote = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B"
    ];
    return scaleIndexToNote.indexOf(pitch);
}
/**
 * Convert a pitch to a MIDI number.
 */ // tslint:disable-next-line: only-arrow-functions typedef
var $27d9bef3f137e052$var$pitchToMidi = function() {
    var regexp = /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i;
    var noteToScaleIndex = {
        // tslint:disable-next-line: object-literal-sort-keys
        cbb: -2,
        cb: -1,
        c: 0,
        "c#": 1,
        cx: 2,
        dbb: 0,
        db: 1,
        d: 2,
        "d#": 3,
        dx: 4,
        ebb: 2,
        eb: 3,
        e: 4,
        "e#": 5,
        ex: 6,
        fbb: 3,
        fb: 4,
        f: 5,
        "f#": 6,
        fx: 7,
        gbb: 5,
        gb: 6,
        g: 7,
        "g#": 8,
        gx: 9,
        abb: 7,
        ab: 8,
        a: 9,
        "a#": 10,
        ax: 11,
        bbb: 9,
        bb: 10,
        b: 11,
        "b#": 12,
        bx: 13
    };
    return function(note) {
        var split = regexp.exec(note);
        var pitch = split[1];
        var octave = split[2];
        var index = noteToScaleIndex[pitch.toLowerCase()];
        return index + (parseInt(octave, 10) + 1) * 12;
    };
}();
var $27d9bef3f137e052$var$privateHeaderMap = new WeakMap();
/**
 * A Note consists of a `noteOn` and `noteOff` event.
 */ var $27d9bef3f137e052$var$Note = /** @class */ function() {
    function Note(noteOn, noteOff, header) {
        $27d9bef3f137e052$var$privateHeaderMap.set(this, header);
        this.midi = noteOn.midi;
        this.velocity = noteOn.velocity;
        this.noteOffVelocity = noteOff.velocity;
        this.ticks = noteOn.ticks;
        this.durationTicks = noteOff.ticks - noteOn.ticks;
    }
    Object.defineProperty(Note.prototype, "name", {
        /**
         * The note name and octave in scientific pitch notation, e.g. "C4".
         */ get: function() {
            return $27d9bef3f137e052$var$midiToPitch(this.midi);
        },
        set: function(n) {
            this.midi = $27d9bef3f137e052$var$pitchToMidi(n);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "octave", {
        /**
         * The notes octave number.
         */ get: function() {
            return Math.floor(this.midi / 12) - 1;
        },
        set: function(o) {
            var diff = o - this.octave;
            this.midi += diff * 12;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "pitch", {
        /**
         * The pitch class name. e.g. "A".
         */ get: function() {
            return $27d9bef3f137e052$var$midiToPitchClass(this.midi);
        },
        set: function(p) {
            this.midi = 12 * (this.octave + 1) + $27d9bef3f137e052$var$pitchClassToMidi(p);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "duration", {
        /**
         * The duration of the segment in seconds.
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks + this.durationTicks) - header.ticksToSeconds(this.ticks);
        },
        set: function(d) {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            var noteEndTicks = header.secondsToTicks(this.time + d);
            this.durationTicks = noteEndTicks - this.ticks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "time", {
        /**
         * The time of the event in seconds.
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "bars", {
        /**
         * The number of measures (and partial measures) to this beat.
         * Takes into account time signature changes.
         * @readonly
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToMeasures(this.ticks);
        },
        enumerable: false,
        configurable: true
    });
    Note.prototype.toJSON = function() {
        return {
            duration: this.duration,
            durationTicks: this.durationTicks,
            midi: this.midi,
            name: this.name,
            ticks: this.ticks,
            time: this.time,
            velocity: this.velocity
        };
    };
    return Note;
}();
$27d9bef3f137e052$exports.Note = $27d9bef3f137e052$var$Note;


var $40651e7dcdad1bee$var$privateHeaderMap = new WeakMap();
/**
 * A Track is a collection of 'notes' and 'controlChanges'.
 */ var $40651e7dcdad1bee$var$Track = /** @class */ function() {
    function Track(trackData, header) {
        var _this = this;
        /**
         * The name of the track.
         */ this.name = "";
        /**
         * The track's note events.
         */ this.notes = [];
        /**
         * The control change events.
         */ this.controlChanges = (0, $0da2b741b9a6b187$exports.createControlChanges)();
        /**
         * The pitch bend events.
         */ this.pitchBends = [];
        $40651e7dcdad1bee$var$privateHeaderMap.set(this, header);
        if (trackData) {
            // Get the name of the track.
            var nameEvent = trackData.find(function(e) {
                return e.type === "trackName";
            });
            // Set empty name if 'trackName' event isn't found.
            this.name = nameEvent ? nameEvent.text : "";
        }
        this.instrument = new $30a9506e114bbf2a$exports.Instrument(trackData, this);
        // Defaults to 0.
        this.channel = 0;
        if (trackData) {
            var noteOns = trackData.filter(function(event) {
                return event.type === "noteOn";
            });
            var noteOffs = trackData.filter(function(event) {
                return event.type === "noteOff";
            });
            var _loop_1 = function() {
                var currentNote = noteOns.shift();
                // Set the channel based on the note.
                this_1.channel = currentNote.channel;
                // Find the corresponding note off.
                var offIndex = noteOffs.findIndex(function(note) {
                    return note.noteNumber === currentNote.noteNumber && note.absoluteTime >= currentNote.absoluteTime;
                });
                if (offIndex !== -1) {
                    // Once it's got the note off, add it.
                    var noteOff = noteOffs.splice(offIndex, 1)[0];
                    this_1.addNote({
                        durationTicks: noteOff.absoluteTime - currentNote.absoluteTime,
                        midi: currentNote.noteNumber,
                        noteOffVelocity: noteOff.velocity / 127,
                        ticks: currentNote.absoluteTime,
                        velocity: currentNote.velocity / 127
                    });
                }
            };
            var this_1 = this;
            while(noteOns.length)_loop_1();
            var controlChanges = trackData.filter(function(event) {
                return event.type === "controller";
            });
            controlChanges.forEach(function(event) {
                _this.addCC({
                    number: event.controllerType,
                    ticks: event.absoluteTime,
                    value: event.value / 127
                });
            });
            var pitchBends = trackData.filter(function(event) {
                return event.type === "pitchBend";
            });
            pitchBends.forEach(function(event) {
                _this.addPitchBend({
                    ticks: event.absoluteTime,
                    // Scale the value between -2^13 to 2^13 to -2 to 2.
                    value: event.value / Math.pow(2, 13)
                });
            });
            var endOfTrackEvent = trackData.find(function(event) {
                return event.type === "endOfTrack";
            });
            this.endOfTrackTicks = endOfTrackEvent !== undefined ? endOfTrackEvent.absoluteTime : undefined;
        }
    }
    /**
     * Add a note to the notes array.
     * @param props The note properties to add.
     */ Track.prototype.addNote = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var note = new $27d9bef3f137e052$exports.Note({
            midi: 0,
            ticks: 0,
            velocity: 1
        }, {
            ticks: 0,
            velocity: 0
        }, header);
        Object.assign(note, props);
        (0, $43b0fba3852e64e0$exports.insert)(this.notes, note, "ticks");
        return this;
    };
    /**
     * Add a control change to the track.
     * @param props
     */ Track.prototype.addCC = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var cc = new $5c2a91a28bf6dfbb$exports.ControlChange({
            controllerType: props.number
        }, header);
        delete props.number;
        Object.assign(cc, props);
        if (!Array.isArray(this.controlChanges[cc.number])) this.controlChanges[cc.number] = [];
        (0, $43b0fba3852e64e0$exports.insert)(this.controlChanges[cc.number], cc, "ticks");
        return this;
    };
    /**
     * Add a control change to the track.
     */ Track.prototype.addPitchBend = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var pb = new $14f891a148a8e503$exports.PitchBend({}, header);
        Object.assign(pb, props);
        (0, $43b0fba3852e64e0$exports.insert)(this.pitchBends, pb, "ticks");
        return this;
    };
    Object.defineProperty(Track.prototype, "duration", {
        /**
         * The end time of the last event in the track.
         */ get: function() {
            if (!this.notes.length) return 0;
            var maxDuration = this.notes[this.notes.length - 1].time + this.notes[this.notes.length - 1].duration;
            for(var i = 0; i < this.notes.length - 1; i++){
                var duration = this.notes[i].time + this.notes[i].duration;
                if (maxDuration < duration) maxDuration = duration;
            }
            return maxDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Track.prototype, "durationTicks", {
        /**
         * The end time of the last event in the track in ticks.
         */ get: function() {
            if (!this.notes.length) return 0;
            var maxDuration = this.notes[this.notes.length - 1].ticks + this.notes[this.notes.length - 1].durationTicks;
            for(var i = 0; i < this.notes.length - 1; i++){
                var duration = this.notes[i].ticks + this.notes[i].durationTicks;
                if (maxDuration < duration) maxDuration = duration;
            }
            return maxDuration;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Assign the JSON values to this track.
     */ Track.prototype.fromJSON = function(json) {
        var _this = this;
        this.name = json.name;
        this.channel = json.channel;
        this.instrument = new $30a9506e114bbf2a$exports.Instrument(undefined, this);
        this.instrument.fromJSON(json.instrument);
        if (json.endOfTrackTicks !== undefined) this.endOfTrackTicks = json.endOfTrackTicks;
        for(var number in json.controlChanges)if (json.controlChanges[number]) json.controlChanges[number].forEach(function(cc) {
            _this.addCC({
                number: cc.number,
                ticks: cc.ticks,
                value: cc.value
            });
        });
        json.notes.forEach(function(n) {
            _this.addNote({
                durationTicks: n.durationTicks,
                midi: n.midi,
                ticks: n.ticks,
                velocity: n.velocity
            });
        });
    };
    /**
     * Convert the track into a JSON format.
     */ Track.prototype.toJSON = function() {
        // Convert all the CCs to JSON.
        var controlChanges = {};
        for(var i = 0; i < 127; i++)if (this.controlChanges.hasOwnProperty(i)) controlChanges[i] = this.controlChanges[i].map(function(c) {
            return c.toJSON();
        });
        var json = {
            channel: this.channel,
            controlChanges: controlChanges,
            pitchBends: this.pitchBends.map(function(pb) {
                return pb.toJSON();
            }),
            instrument: this.instrument.toJSON(),
            name: this.name,
            notes: this.notes.map(function(n) {
                return n.toJSON();
            })
        };
        if (this.endOfTrackTicks !== undefined) json.endOfTrackTicks = this.endOfTrackTicks;
        return json;
    };
    return Track;
}();
$40651e7dcdad1bee$exports.Track = $40651e7dcdad1bee$var$Track;


var $5a327199cea97b55$exports = {};
"use strict";
var $5a327199cea97b55$var$__spreadArray = $5a327199cea97b55$exports && $5a327199cea97b55$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($5a327199cea97b55$exports, "__esModule", {
    value: true
});
$5a327199cea97b55$exports.encode = void 0;


/**
 * Flatten an array indefinitely.
 */ function $6270266de553c402$export$bffa455ba8c619a6(array) {
    var result = [];
    $6270266de553c402$var$$flatten(array, result);
    return result;
}
/**
 * Internal flatten function recursively passes `result`.
 */ function $6270266de553c402$var$$flatten(array, result) {
    for(var i = 0; i < array.length; i++){
        var value = array[i];
        if (Array.isArray(value)) $6270266de553c402$var$$flatten(value, result);
        else result.push(value);
    }
}


function $5a327199cea97b55$var$encodeNote(note, channel) {
    return [
        {
            absoluteTime: note.ticks,
            channel: channel,
            deltaTime: 0,
            noteNumber: note.midi,
            type: "noteOn",
            velocity: Math.floor(note.velocity * 127)
        },
        {
            absoluteTime: note.ticks + note.durationTicks,
            channel: channel,
            deltaTime: 0,
            noteNumber: note.midi,
            type: "noteOff",
            velocity: Math.floor(note.noteOffVelocity * 127)
        }
    ];
}
function $5a327199cea97b55$var$encodeNotes(track) {
    return (0, $6270266de553c402$export$bffa455ba8c619a6)(track.notes.map(function(note) {
        return $5a327199cea97b55$var$encodeNote(note, track.channel);
    }));
}
function $5a327199cea97b55$var$encodeControlChange(cc, channel) {
    return {
        absoluteTime: cc.ticks,
        channel: channel,
        controllerType: cc.number,
        deltaTime: 0,
        type: "controller",
        value: Math.floor(cc.value * 127)
    };
}
function $5a327199cea97b55$var$encodeControlChanges(track) {
    var controlChanges = [];
    for(var i = 0; i < 127; i++)if (track.controlChanges.hasOwnProperty(i)) track.controlChanges[i].forEach(function(cc) {
        controlChanges.push($5a327199cea97b55$var$encodeControlChange(cc, track.channel));
    });
    return controlChanges;
}
function $5a327199cea97b55$var$encodePitchBend(pb, channel) {
    return {
        absoluteTime: pb.ticks,
        channel: channel,
        deltaTime: 0,
        type: "pitchBend",
        value: pb.value
    };
}
function $5a327199cea97b55$var$encodePitchBends(track) {
    var pitchBends = [];
    track.pitchBends.forEach(function(pb) {
        pitchBends.push($5a327199cea97b55$var$encodePitchBend(pb, track.channel));
    });
    return pitchBends;
}
function $5a327199cea97b55$var$encodeInstrument(track) {
    return {
        absoluteTime: 0,
        channel: track.channel,
        deltaTime: 0,
        programNumber: track.instrument.number,
        type: "programChange"
    };
}
function $5a327199cea97b55$var$encodeTrackName(name) {
    return {
        absoluteTime: 0,
        deltaTime: 0,
        meta: true,
        text: name,
        type: "trackName"
    };
}
function $5a327199cea97b55$var$encodeTempo(tempo) {
    return {
        absoluteTime: tempo.ticks,
        deltaTime: 0,
        meta: true,
        microsecondsPerBeat: Math.floor(60000000 / tempo.bpm),
        type: "setTempo"
    };
}
function $5a327199cea97b55$var$encodeTimeSignature(timeSig) {
    return {
        absoluteTime: timeSig.ticks,
        deltaTime: 0,
        denominator: timeSig.timeSignature[1],
        meta: true,
        metronome: 24,
        numerator: timeSig.timeSignature[0],
        thirtyseconds: 8,
        type: "timeSignature"
    };
}
// function encodeMeta(event: )
function $5a327199cea97b55$var$encodeKeySignature(keySig) {
    var keyIndex = $ae5327bd0dc5627f$exports.keySignatureKeys.indexOf(keySig.key);
    return {
        absoluteTime: keySig.ticks,
        deltaTime: 0,
        key: keyIndex + 7,
        meta: true,
        scale: keySig.scale === "major" ? 0 : 1,
        type: "keySignature"
    };
}
function $5a327199cea97b55$var$encodeText(textEvent) {
    return {
        absoluteTime: textEvent.ticks,
        deltaTime: 0,
        meta: true,
        text: textEvent.text,
        type: textEvent.type
    };
}
/**
 * Convert the MIDI object to an array.
 */ function $5a327199cea97b55$var$encode(midi) {
    var midiData = {
        header: {
            format: 1,
            numTracks: midi.tracks.length + 1,
            ticksPerBeat: midi.header.ppq
        },
        tracks: $5a327199cea97b55$var$__spreadArray([
            $5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray([
                // The name data.
                {
                    absoluteTime: 0,
                    deltaTime: 0,
                    meta: true,
                    text: midi.header.name,
                    type: "trackName"
                }
            ], midi.header.keySignatures.map(function(keySig) {
                return $5a327199cea97b55$var$encodeKeySignature(keySig);
            }), true), midi.header.meta.map(function(e) {
                return $5a327199cea97b55$var$encodeText(e);
            }), true), midi.header.tempos.map(function(tempo) {
                return $5a327199cea97b55$var$encodeTempo(tempo);
            }), true), midi.header.timeSignatures.map(function(timeSig) {
                return $5a327199cea97b55$var$encodeTimeSignature(timeSig);
            }), true)
        ], midi.tracks.map(function(track) {
            return $5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray([
                // Add the name
                $5a327199cea97b55$var$encodeTrackName(track.name),
                // the instrument
                $5a327199cea97b55$var$encodeInstrument(track)
            ], $5a327199cea97b55$var$encodeNotes(track), true), $5a327199cea97b55$var$encodeControlChanges(track), true), $5a327199cea97b55$var$encodePitchBends(track), true);
        }), true)
    };
    // Sort and set `deltaTime` of all of the tracks.
    midiData.tracks = midiData.tracks.map(function(track) {
        track = track.sort(function(a, b) {
            return a.absoluteTime - b.absoluteTime;
        });
        var lastTime = 0;
        track.forEach(function(note) {
            note.deltaTime = note.absoluteTime - lastTime;
            lastTime = note.absoluteTime;
            delete note.absoluteTime;
        });
        // End of track.
        track.push({
            deltaTime: 0,
            meta: true,
            type: "endOfTrack"
        });
        return track;
    });
    // Rreturn `midiData`.
    return new Uint8Array((0, $f4610896fa898662$export$77fcca795c2a5d6c)(midiData));
}
$5a327199cea97b55$exports.encode = $5a327199cea97b55$var$encode;


/**
 * The main midi parsing class.
 */ var $28735cb37928c976$var$Midi = /** @class */ function() {
    /**
     * Parse the midi data
     */ function Midi(midiArray) {
        var _this = this;
        // Parse the MIDI data if there is any.
        var midiData = null;
        if (midiArray) {
            // Transform midiArray to ArrayLike<number>
            // only if it's an ArrayBuffer.
            var midiArrayLike = midiArray instanceof ArrayBuffer ? new Uint8Array(midiArray) : midiArray;
            // Parse MIDI data.
            midiData = (0, $f4610896fa898662$export$2b5b68a498cfe902)(midiArrayLike);
            // Add the absolute times to each of the tracks.
            midiData.tracks.forEach(function(track) {
                var currentTicks = 0;
                track.forEach(function(event) {
                    currentTicks += event.deltaTime;
                    event.absoluteTime = currentTicks;
                });
            });
            // Ensure at most one instrument per track.
            midiData.tracks = $28735cb37928c976$var$splitTracks(midiData.tracks);
        }
        this.header = new $ae5327bd0dc5627f$exports.Header(midiData);
        this.tracks = [];
        // Parse MIDI data.
        if (midiArray) {
            // Format 0, everything is on the same track.
            this.tracks = midiData.tracks.map(function(trackData) {
                return new $40651e7dcdad1bee$exports.Track(trackData, _this.header);
            });
            // If it's format 1 and there are no notes on the first track, remove it.
            if (midiData.header.format === 1 && this.tracks[0].duration === 0) this.tracks.shift();
        }
    }
    /**
     * Download and parse the MIDI file. Returns a promise
     * which resolves to the generated MIDI file.
     * @param url The URL to fetch.
     */ Midi.fromUrl = function(url) {
        return $28735cb37928c976$var$__awaiter(this, void 0, void 0, function() {
            var response, arrayBuffer;
            return $28735cb37928c976$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(url)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.arrayBuffer()
                        ];
                    case 2:
                        arrayBuffer = _a.sent();
                        return [
                            2 /*return*/ ,
                            new Midi(arrayBuffer)
                        ];
                    case 3:
                        throw new Error("Could not load '".concat(url, "'"));
                }
            });
        });
    };
    Object.defineProperty(Midi.prototype, "name", {
        /**
         * The name of the midi file, taken from the first track.
         */ get: function() {
            return this.header.name;
        },
        set: function(n) {
            this.header.name = n;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Midi.prototype, "duration", {
        /**
         * The total length of the file in seconds.
         */ get: function() {
            // Get the max of the last note of all the tracks.
            var durations = this.tracks.map(function(t) {
                return t.duration;
            });
            return Math.max.apply(Math, durations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Midi.prototype, "durationTicks", {
        /**
         * The total length of the file in ticks.
         */ get: function() {
            // Get the max of the last note of all the tracks.
            var durationTicks = this.tracks.map(function(t) {
                return t.durationTicks;
            });
            return Math.max.apply(Math, durationTicks);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add a track to the MIDI file.
     */ Midi.prototype.addTrack = function() {
        var track = new $40651e7dcdad1bee$exports.Track(undefined, this.header);
        this.tracks.push(track);
        return track;
    };
    /**
     * Encode the MIDI as a Uint8Array.
     */ Midi.prototype.toArray = function() {
        return (0, $5a327199cea97b55$exports.encode)(this);
    };
    /**
     * Convert the MIDI object to JSON.
     */ Midi.prototype.toJSON = function() {
        return {
            header: this.header.toJSON(),
            tracks: this.tracks.map(function(track) {
                return track.toJSON();
            })
        };
    };
    /**
     * Parse a JSON representation of the object. Will overwrite the current
     * tracks and header.
     */ Midi.prototype.fromJSON = function(json) {
        var _this = this;
        this.header = new $ae5327bd0dc5627f$exports.Header();
        this.header.fromJSON(json.header);
        this.tracks = json.tracks.map(function(trackJSON) {
            var track = new $40651e7dcdad1bee$exports.Track(undefined, _this.header);
            track.fromJSON(trackJSON);
            return track;
        });
    };
    /**
     * Clone the entire object MIDI object.
     */ Midi.prototype.clone = function() {
        var midi = new Midi();
        midi.fromJSON(this.toJSON());
        return midi;
    };
    return Midi;
}();
$28735cb37928c976$exports.Midi = $28735cb37928c976$var$Midi;

Object.defineProperty($28735cb37928c976$exports, "Track", {
    enumerable: true,
    get: function() {
        return $40651e7dcdad1bee$exports.Track;
    }
});

Object.defineProperty($28735cb37928c976$exports, "Header", {
    enumerable: true,
    get: function() {
        return $ae5327bd0dc5627f$exports.Header;
    }
});
/**
 * Given a list of MIDI tracks, make sure that each channel corresponds to at
 * most one channel and at most one instrument. This means splitting up tracks
 * that contain more than one channel or instrument.
 */ function $28735cb37928c976$var$splitTracks(tracks) {
    var newTracks = [];
    for(var i = 0; i < tracks.length; i++){
        var defaultTrack = newTracks.length;
        // a map from [program, channel] tuples to new track numbers
        var trackMap = new Map();
        // a map from channel numbers to current program numbers
        var currentProgram = Array(16).fill(0);
        for(var _i = 0, _a = tracks[i]; _i < _a.length; _i++){
            var event_1 = _a[_i];
            var targetTrack = defaultTrack;
            // If the event has a channel, we need to find that channel's current
            // program number and the appropriate track for this [program, channel]
            // pair.
            var channel = event_1.channel;
            if (channel !== undefined) {
                if (event_1.type === "programChange") currentProgram[channel] = event_1.programNumber;
                var program = currentProgram[channel];
                var trackKey = "".concat(program, " ").concat(channel);
                if (trackMap.has(trackKey)) targetTrack = trackMap.get(trackKey);
                else {
                    targetTrack = defaultTrack + trackMap.size;
                    trackMap.set(trackKey, targetTrack);
                }
            }
            if (!newTracks[targetTrack]) newTracks.push([]);
            newTracks[targetTrack].push(event_1);
        }
    }
    return newTracks;
}


var $79372d29045e1680$exports = {};
/*! For license information please see Tone.js.LICENSE.txt */ !function(t1, e) {
    $79372d29045e1680$exports = e();
}("undefined" != typeof self ? self : $79372d29045e1680$exports, ()=>(()=>{
        var t1 = {
            382: function(t1, e, s1) {
                !function(t1, e, s1, n) {
                    "use strict";
                    var i = function(t1, e, s1) {
                        return {
                            endTime: e,
                            insertTime: s1,
                            type: "exponentialRampToValue",
                            value: t1
                        };
                    }, o = function(t1, e, s1) {
                        return {
                            endTime: e,
                            insertTime: s1,
                            type: "linearRampToValue",
                            value: t1
                        };
                    }, r = function(t1, e) {
                        return {
                            startTime: e,
                            type: "setValue",
                            value: t1
                        };
                    }, a = function(t1, e, s1) {
                        return {
                            duration: s1,
                            startTime: e,
                            type: "setValueCurve",
                            values: t1
                        };
                    }, c = function(t1, e, s1) {
                        var n = s1.startTime, i = s1.target, o = s1.timeConstant;
                        return i + (e - i) * Math.exp((n - t1) / o);
                    }, h = function(t1) {
                        return "exponentialRampToValue" === t1.type;
                    }, l = function(t1) {
                        return "linearRampToValue" === t1.type;
                    }, u = function(t1) {
                        return h(t1) || l(t1);
                    }, p = function(t1) {
                        return "setValue" === t1.type;
                    }, d = function(t1) {
                        return "setValueCurve" === t1.type;
                    }, f = function t1(e, s1, n, i) {
                        var o = e[s1];
                        return void 0 === o ? i : u(o) || p(o) ? o.value : d(o) ? o.values[o.values.length - 1] : c(n, t1(e, s1 - 1, o.startTime, i), o);
                    }, _ = function(t1, e, s1, n, i) {
                        return void 0 === s1 ? [
                            n.insertTime,
                            i
                        ] : u(s1) ? [
                            s1.endTime,
                            s1.value
                        ] : p(s1) ? [
                            s1.startTime,
                            s1.value
                        ] : d(s1) ? [
                            s1.startTime + s1.duration,
                            s1.values[s1.values.length - 1]
                        ] : [
                            s1.startTime,
                            f(t1, e - 1, s1.startTime, i)
                        ];
                    }, m = function(t1) {
                        return "cancelAndHold" === t1.type;
                    }, g = function(t1) {
                        return "cancelScheduledValues" === t1.type;
                    }, v = function(t1) {
                        return m(t1) || g(t1) ? t1.cancelTime : h(t1) || l(t1) ? t1.endTime : t1.startTime;
                    }, y = function(t1, e, s1, n) {
                        var i = n.endTime, o = n.value;
                        return s1 === o ? o : 0 < s1 && 0 < o || s1 < 0 && o < 0 ? s1 * Math.pow(o / s1, (t1 - e) / (i - e)) : 0;
                    }, x = function(t1, e, s1, n) {
                        return s1 + (t1 - e) / (n.endTime - e) * (n.value - s1);
                    }, w = function(t1, e) {
                        var s1 = e.duration, n = e.startTime, i = e.values;
                        return function(t1, e) {
                            var s1 = Math.floor(e), n = Math.ceil(e);
                            return s1 === n ? t1[s1] : (1 - (e - s1)) * t1[s1] + (1 - (n - e)) * t1[n];
                        }(i, (t1 - n) / s1 * (i.length - 1));
                    }, b = function(t1) {
                        return "setTarget" === t1.type;
                    }, T = function() {
                        return n(function t1(e) {
                            s1(this, t1), this._automationEvents = [], this._currenTime = 0, this._defaultValue = e;
                        }, [
                            {
                                key: Symbol.iterator,
                                value: function() {
                                    return this._automationEvents[Symbol.iterator]();
                                }
                            },
                            {
                                key: "add",
                                value: function(t1) {
                                    var e = v(t1);
                                    if (m(t1) || g(t1)) {
                                        var s1 = this._automationEvents.findIndex(function(s1) {
                                            return g(t1) && d(s1) ? s1.startTime + s1.duration >= e : v(s1) >= e;
                                        }), n = this._automationEvents[s1];
                                        if (-1 !== s1 && (this._automationEvents = this._automationEvents.slice(0, s1)), m(t1)) {
                                            var c = this._automationEvents[this._automationEvents.length - 1];
                                            if (void 0 !== n && u(n)) {
                                                if (void 0 !== c && b(c)) throw new Error("The internal list is malformed.");
                                                var p = void 0 === c ? n.insertTime : d(c) ? c.startTime + c.duration : v(c), f = void 0 === c ? this._defaultValue : d(c) ? c.values[c.values.length - 1] : c.value, _ = h(n) ? y(e, p, f, n) : x(e, p, f, n), w = h(n) ? i(_, e, this._currenTime) : o(_, e, this._currenTime);
                                                this._automationEvents.push(w);
                                            }
                                            if (void 0 !== c && b(c) && this._automationEvents.push(r(this.getValue(e), e)), void 0 !== c && d(c) && c.startTime + c.duration > e) {
                                                var T = e - c.startTime, S = (c.values.length - 1) / c.duration, k = Math.max(2, 1 + Math.ceil(T * S)), A = T / (k - 1) * S, C = c.values.slice(0, k);
                                                if (A < 1) for(var D = 1; D < k; D += 1){
                                                    var O = A * D % 1;
                                                    C[D] = c.values[D - 1] * (1 - O) + c.values[D] * O;
                                                }
                                                this._automationEvents[this._automationEvents.length - 1] = a(C, c.startTime, T);
                                            }
                                        }
                                    } else {
                                        var M = this._automationEvents.findIndex(function(t1) {
                                            return v(t1) > e;
                                        }), E = -1 === M ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[M - 1];
                                        if (void 0 !== E && d(E) && v(E) + E.duration > e) return !1;
                                        var R = h(t1) ? i(t1.value, t1.endTime, this._currenTime) : l(t1) ? o(t1.value, e, this._currenTime) : t1;
                                        if (-1 === M) this._automationEvents.push(R);
                                        else {
                                            if (d(t1) && e + t1.duration > v(this._automationEvents[M])) return !1;
                                            this._automationEvents.splice(M, 0, R);
                                        }
                                    }
                                    return !0;
                                }
                            },
                            {
                                key: "flush",
                                value: function(t1) {
                                    var e = this._automationEvents.findIndex(function(e) {
                                        return v(e) > t1;
                                    });
                                    if (e > 1) {
                                        var s1 = this._automationEvents.slice(e - 1), n = s1[0];
                                        b(n) && s1.unshift(r(f(this._automationEvents, e - 2, n.startTime, this._defaultValue), n.startTime)), this._automationEvents = s1;
                                    }
                                }
                            },
                            {
                                key: "getValue",
                                value: function(t1) {
                                    if (0 === this._automationEvents.length) return this._defaultValue;
                                    var s1 = this._automationEvents.findIndex(function(e) {
                                        return v(e) > t1;
                                    }), n = this._automationEvents[s1], i = (-1 === s1 ? this._automationEvents.length : s1) - 1, o = this._automationEvents[i];
                                    if (void 0 !== o && b(o) && (void 0 === n || !u(n) || n.insertTime > t1)) return c(t1, f(this._automationEvents, i - 1, o.startTime, this._defaultValue), o);
                                    if (void 0 !== o && p(o) && (void 0 === n || !u(n))) return o.value;
                                    if (void 0 !== o && d(o) && (void 0 === n || !u(n) || o.startTime + o.duration > t1)) return t1 < o.startTime + o.duration ? w(t1, o) : o.values[o.values.length - 1];
                                    if (void 0 !== o && u(o) && (void 0 === n || !u(n))) return o.value;
                                    if (void 0 !== n && h(n)) {
                                        var r = _(this._automationEvents, i, o, n, this._defaultValue), a = e(r, 2), m = a[0], g = a[1];
                                        return y(t1, m, g, n);
                                    }
                                    if (void 0 !== n && l(n)) {
                                        var T = _(this._automationEvents, i, o, n, this._defaultValue), S = e(T, 2), k = S[0], A = S[1];
                                        return x(t1, k, A, n);
                                    }
                                    return this._defaultValue;
                                }
                            }
                        ]);
                    }();
                    t1.AutomationEventList = T, t1.createCancelAndHoldAutomationEvent = function(t1) {
                        return {
                            cancelTime: t1,
                            type: "cancelAndHold"
                        };
                    }, t1.createCancelScheduledValuesAutomationEvent = function(t1) {
                        return {
                            cancelTime: t1,
                            type: "cancelScheduledValues"
                        };
                    }, t1.createExponentialRampToValueAutomationEvent = function(t1, e) {
                        return {
                            endTime: e,
                            type: "exponentialRampToValue",
                            value: t1
                        };
                    }, t1.createLinearRampToValueAutomationEvent = function(t1, e) {
                        return {
                            endTime: e,
                            type: "linearRampToValue",
                            value: t1
                        };
                    }, t1.createSetTargetAutomationEvent = function(t1, e, s1) {
                        return {
                            startTime: e,
                            target: t1,
                            timeConstant: s1,
                            type: "setTarget"
                        };
                    }, t1.createSetValueAutomationEvent = r, t1.createSetValueCurveAutomationEvent = a;
                }(e, s1(424), s1(690), s1(728));
            },
            897: (t1)=>{
                t1.exports = function(t1, e) {
                    (null == e || e > t1.length) && (e = t1.length);
                    for(var s1 = 0, n = new Array(e); s1 < e; s1++)n[s1] = t1[s1];
                    return n;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            372: (t1)=>{
                t1.exports = function(t1) {
                    if (Array.isArray(t1)) return t1;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            690: (t1)=>{
                t1.exports = function(t1, e) {
                    if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            728: (t1, e, s1)=>{
                var n = s1(62);
                function i(t1, e) {
                    for(var s1 = 0; s1 < e.length; s1++){
                        var i = e[s1];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t1, n(i.key), i);
                    }
                }
                t1.exports = function(t1, e, s1) {
                    return e && i(t1.prototype, e), s1 && i(t1, s1), Object.defineProperty(t1, "prototype", {
                        writable: !1
                    }), t1;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            872: (t1)=>{
                t1.exports = function(t1, e) {
                    var s1 = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                    if (null != s1) {
                        var n, i, o, r, a = [], c = !0, h = !1;
                        try {
                            if (o = (s1 = s1.call(t1)).next, 0 === e) {
                                if (Object(s1) !== s1) return;
                                c = !1;
                            } else for(; !(c = (n = o.call(s1)).done) && (a.push(n.value), a.length !== e); c = !0);
                        } catch (t1) {
                            h = !0, i = t1;
                        } finally{
                            try {
                                if (!c && null != s1.return && (r = s1.return(), Object(r) !== r)) return;
                            } finally{
                                if (h) throw i;
                            }
                        }
                        return a;
                    }
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            218: (t1)=>{
                t1.exports = function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            424: (t1, e, s1)=>{
                var n = s1(372), i = s1(872), o = s1(116), r = s1(218);
                t1.exports = function(t1, e) {
                    return n(t1) || i(t1, e) || o(t1, e) || r();
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            36: (t1, e, s1)=>{
                var n = s1(698).default;
                t1.exports = function(t1, e) {
                    if ("object" != n(t1) || !t1) return t1;
                    var s1 = t1[Symbol.toPrimitive];
                    if (void 0 !== s1) {
                        var i = s1.call(t1, e || "default");
                        if ("object" != n(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === e ? String : Number)(t1);
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            62: (t1, e, s1)=>{
                var n = s1(698).default, i = s1(36);
                t1.exports = function(t1) {
                    var e = i(t1, "string");
                    return "symbol" == n(e) ? e : e + "";
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            698: (t1)=>{
                function e(s1) {
                    return t1.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, t1.exports.__esModule = !0, t1.exports.default = t1.exports, e(s1);
                }
                t1.exports = e, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            116: (t1, e, s1)=>{
                var n = s1(897);
                t1.exports = function(t1, e) {
                    if (t1) {
                        if ("string" == typeof t1) return n(t1, e);
                        var s1 = Object.prototype.toString.call(t1).slice(8, -1);
                        return "Object" === s1 && t1.constructor && (s1 = t1.constructor.name), "Map" === s1 || "Set" === s1 ? Array.from(t1) : "Arguments" === s1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s1) ? n(t1, e) : void 0;
                    }
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            }
        }, e = {};
        function s1(n) {
            var i = e[n];
            if (void 0 !== i) return i.exports;
            var o = e[n] = {
                exports: {}
            };
            return t1[n].call(o.exports, o, o.exports, s1), o.exports;
        }
        s1.d = (t1, e)=>{
            for(var n in e)s1.o(e, n) && !s1.o(t1, n) && Object.defineProperty(t1, n, {
                enumerable: !0,
                get: e[n]
            });
        }, s1.o = (t1, e)=>Object.prototype.hasOwnProperty.call(t1, e), s1.r = (t1)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t1, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            s1.r(n), s1.d(n, {
                AMOscillator: ()=>$o,
                AMSynth: ()=>Cr,
                Abs: ()=>pr,
                Add: ()=>nr,
                AmplitudeEnvelope: ()=>Sr,
                Analyser: ()=>Xa,
                AudioToGain: ()=>Xo,
                AutoFilter: ()=>ua,
                AutoPanner: ()=>da,
                AutoWah: ()=>_a,
                BaseContext: ()=>Ci,
                BiquadFilter: ()=>Dr,
                BitCrusher: ()=>ga,
                Buffer: ()=>Dc,
                BufferSource: ()=>Mc,
                Buffers: ()=>Oc,
                Channel: ()=>sc,
                Chebyshev: ()=>ya,
                Chorus: ()=>Sa,
                Clock: ()=>vo,
                Compressor: ()=>cc,
                Context: ()=>Di,
                Convolver: ()=>fc,
                CrossFade: ()=>ca,
                DCMeter: ()=>Ja,
                Delay: ()=>yo,
                Destination: ()=>yc,
                Distortion: ()=>ka,
                Draw: ()=>Sc,
                DuoSynth: ()=>Rr,
                EQ3: ()=>dc,
                Emitter: ()=>Ai,
                Envelope: ()=>xr,
                FFT: ()=>Ha,
                FMOscillator: ()=>Ho,
                FMSynth: ()=>qr,
                FatOscillator: ()=>Ko,
                FeedbackCombFilter: ()=>Br,
                FeedbackDelay: ()=>Ca,
                Filter: ()=>Or,
                Follower: ()=>fa,
                Freeverb: ()=>Ra,
                Frequency: ()=>Ji,
                FrequencyClass: ()=>Yi,
                FrequencyEnvelope: ()=>Mr,
                FrequencyShifter: ()=>Oa,
                Gain: ()=>ho,
                GainToAudio: ()=>dr,
                Gate: ()=>hc,
                GrainPlayer: ()=>ur,
                GreaterThan: ()=>gr,
                GreaterThanZero: ()=>mr,
                IntervalTimeline: ()=>Co,
                JCReverb: ()=>Va,
                LFO: ()=>rr,
                Limiter: ()=>lc,
                Listener: ()=>bc,
                Loop: ()=>$r,
                LowpassCombFilter: ()=>Gr,
                Master: ()=>xc,
                MembraneSynth: ()=>Vr,
                Merge: ()=>wa,
                MetalSynth: ()=>Ir,
                Meter: ()=>$a,
                MidSideCompressor: ()=>uc,
                MidSideMerge: ()=>Ba,
                MidSideSplit: ()=>Wa,
                Midi: ()=>To,
                MidiClass: ()=>bo,
                Mono: ()=>nc,
                MonoSynth: ()=>Er,
                MultibandCompressor: ()=>pc,
                MultibandSplit: ()=>ic,
                Multiply: ()=>Yo,
                Negate: ()=>fr,
                Noise: ()=>Lo,
                NoiseSynth: ()=>Nr,
                Offline: ()=>xo,
                OfflineContext: ()=>qi,
                OmniOscillator: ()=>sr,
                OnePoleFilter: ()=>Ur,
                Oscillator: ()=>Zo,
                PWMOscillator: ()=>tr,
                PanVol: ()=>ec,
                Panner: ()=>pa,
                Panner3D: ()=>rc,
                Param: ()=>no,
                Part: ()=>Hr,
                Pattern: ()=>ra,
                Phaser: ()=>La,
                PingPongDelay: ()=>Pa,
                PitchShift: ()=>ja,
                Player: ()=>hr,
                Players: ()=>lr,
                PluckSynth: ()=>Qr,
                PolySynth: ()=>Zr,
                Pow: ()=>Fo,
                PulseOscillator: ()=>Jo,
                Recorder: ()=>ac,
                Reverb: ()=>za,
                Sampler: ()=>Xr,
                Scale: ()=>ir,
                ScaleExp: ()=>vr,
                Sequence: ()=>aa,
                Signal: ()=>po,
                Solo: ()=>tc,
                Split: ()=>xa,
                StateTimeline: ()=>so,
                StereoWidener: ()=>Ga,
                Subtract: ()=>_r,
                SyncedSignal: ()=>yr,
                Synth: ()=>kr,
                Ticks: ()=>ko,
                TicksClass: ()=>So,
                Time: ()=>Xi,
                TimeClass: ()=>Zi,
                Timeline: ()=>wi,
                ToneAudioBuffer: ()=>Ri,
                ToneAudioBuffers: ()=>wo,
                ToneAudioNode: ()=>io,
                ToneBufferSource: ()=>jo,
                ToneEvent: ()=>Yr,
                ToneOscillatorNode: ()=>Qo,
                Transport: ()=>gc,
                TransportTime: ()=>to,
                TransportTimeClass: ()=>Ki,
                Tremolo: ()=>Qa,
                Unit: ()=>e,
                UserMedia: ()=>Uo,
                Vibrato: ()=>Za,
                Volume: ()=>Oo,
                WaveShaper: ()=>qo,
                Waveform: ()=>Ka,
                Zero: ()=>or,
                connect: ()=>ro,
                connectSeries: ()=>oo,
                connectSignal: ()=>fo,
                context: ()=>Ac,
                dbToGain: ()=>ji,
                debug: ()=>t1,
                defaultArg: ()=>pi,
                disconnect: ()=>ao,
                fanIn: ()=>co,
                ftom: ()=>Bi,
                gainToDb: ()=>Li,
                getContext: ()=>Vi,
                getDestination: ()=>wc,
                getDraw: ()=>kc,
                getListener: ()=>Tc,
                getTransport: ()=>vc,
                immediate: ()=>mc,
                intervalToFrequencyRatio: ()=>zi,
                isArray: ()=>Ln,
                isBoolean: ()=>jn,
                isDefined: ()=>In,
                isFunction: ()=>Vn,
                isNote: ()=>Wn,
                isNumber: ()=>Nn,
                isObject: ()=>Pn,
                isString: ()=>zn,
                isUndef: ()=>Fn,
                loaded: ()=>Cc,
                mtof: ()=>Gi,
                now: ()=>_c,
                optionsFromArguments: ()=>ui,
                setContext: ()=>Ni,
                start: ()=>Pi,
                supported: ()=>qn,
                version: ()=>i
            });
            var t1 = {};
            s1.r(t1), s1.d(t1, {
                assert: ()=>Bn,
                assertContextRunning: ()=>Gn,
                assertRange: ()=>Un,
                assertUsedScheduleTime: ()=>Yn,
                enterScheduledCallback: ()=>Xn,
                log: ()=>Jn,
                setLogger: ()=>Hn,
                warn: ()=>Kn
            });
            var e = {};
            s1.r(e);
            const i = "14.9.17";
            var o = s1(382);
            const r = new WeakSet, a = new WeakMap, c = new WeakMap, h = new WeakMap, l = new WeakMap, u = new WeakMap, p = new WeakMap, d = new WeakMap, f = new WeakMap, _ = new WeakMap, m = {
                construct: ()=>m
            }, g = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/, v = (t1, e)=>{
                const s1 = [];
                let n = t1.replace(/^[\s]+/, ""), i = n.match(g);
                for(; null !== i;){
                    const t1 = i[1].slice(1, -1), o = i[0].replace(/([\s]+)?;?$/, "").replace(t1, new URL(t1, e).toString());
                    s1.push(o), n = n.slice(i[0].length).replace(/^[\s]+/, ""), i = n.match(g);
                }
                return [
                    s1.join(";"),
                    n
                ];
            }, y = (t1)=>{
                if (void 0 !== t1 && !Array.isArray(t1)) throw new TypeError("The parameterDescriptors property of given value for processorCtor is not an array.");
            }, x = (t1)=>{
                if (!((t1)=>{
                    try {
                        new new Proxy(t1, m);
                    } catch  {
                        return !1;
                    }
                    return !0;
                })(t1)) throw new TypeError("The given value for processorCtor should be a constructor.");
                if (null === t1.prototype || "object" != typeof t1.prototype) throw new TypeError("The given value for processorCtor should have a prototype.");
            }, w = (t1, e)=>{
                const s1 = t1.get(e);
                if (void 0 === s1) throw new Error("A value with the given key could not be found.");
                return s1;
            }, b = (t1, e)=>{
                const s1 = Array.from(t1).filter(e);
                if (s1.length > 1) throw Error("More than one element was found.");
                if (0 === s1.length) throw Error("No element was found.");
                const [n] = s1;
                return t1.delete(n), n;
            }, T = (t1, e, s1, n)=>{
                const i = w(t1, e), o = b(i, (t1)=>t1[0] === s1 && t1[1] === n);
                return 0 === i.size && t1.delete(e), o;
            }, S = (t1)=>w(p, t1), k = (t1)=>{
                if (r.has(t1)) throw new Error("The AudioNode is already stored.");
                r.add(t1), S(t1).forEach((t1)=>t1(!0));
            }, A = (t1)=>"port" in t1, C = (t1)=>{
                if (!r.has(t1)) throw new Error("The AudioNode is not stored.");
                r.delete(t1), S(t1).forEach((t1)=>t1(!1));
            }, D = (t1, e)=>{
                !A(t1) && e.every((t1)=>0 === t1.size) && C(t1);
            }, O = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                fftSize: 2048,
                maxDecibels: -30,
                minDecibels: -100,
                smoothingTimeConstant: .8
            }, M = (t1, e)=>t1.context === e, E = (t1)=>{
                try {
                    t1.copyToChannel(new Float32Array(1), 0, -1);
                } catch  {
                    return !1;
                }
                return !0;
            }, R = ()=>new DOMException("", "IndexSizeError"), q = (t1)=>{
                var e;
                t1.getChannelData = (e = t1.getChannelData, (s1)=>{
                    try {
                        return e.call(t1, s1);
                    } catch (t1) {
                        if (12 === t1.code) throw R();
                        throw t1;
                    }
                });
            }, F = {
                numberOfChannels: 1
            }, I = -340282346638528860000000000000000000000, V = -I, N = (t1)=>r.has(t1), P = {
                buffer: null,
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                loop: !1,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            }, j = (t1)=>w(a, t1), L = (t1)=>w(h, t1), z = (t1, e)=>{
                const { activeInputs: s1 } = j(t1);
                s1.forEach((s1)=>s1.forEach(([s1])=>{
                        e.includes(t1) || z(s1, [
                            ...e,
                            t1
                        ]);
                    }));
                const n = ((t1)=>"playbackRate" in t1)(t1) ? [
                    t1.playbackRate
                ] : A(t1) ? Array.from(t1.parameters.values()) : ((t1)=>"frequency" in t1 && "gain" in t1)(t1) ? [
                    t1.Q,
                    t1.detune,
                    t1.frequency,
                    t1.gain
                ] : ((t1)=>"offset" in t1)(t1) ? [
                    t1.offset
                ] : ((t1)=>!("frequency" in t1) && "gain" in t1)(t1) ? [
                    t1.gain
                ] : ((t1)=>"detune" in t1 && "frequency" in t1)(t1) ? [
                    t1.detune,
                    t1.frequency
                ] : ((t1)=>"pan" in t1)(t1) ? [
                    t1.pan
                ] : [];
                for (const t1 of n){
                    const s1 = L(t1);
                    void 0 !== s1 && s1.activeInputs.forEach(([t1])=>z(t1, e));
                }
                N(t1) && C(t1);
            }, W = (t1)=>{
                z(t1.destination, []);
            }, B = (t1)=>"context" in t1, U = (t1)=>B(t1[0]), G = (t1, e, s1, n)=>{
                for (const e of t1)if (s1(e)) {
                    if (n) return !1;
                    throw Error("The set contains at least one similar element.");
                }
                return t1.add(e), !0;
            }, Q = (t1, e, [s1, n], i)=>{
                G(t1, [
                    e,
                    s1,
                    n
                ], (t1)=>t1[0] === e && t1[1] === s1, i);
            }, Z = (t1, [e, s1, n], i)=>{
                const o = t1.get(e);
                void 0 === o ? t1.set(e, new Set([
                    [
                        s1,
                        n
                    ]
                ])) : G(o, [
                    s1,
                    n
                ], (t1)=>t1[0] === s1, i);
            }, X = (t1)=>"inputs" in t1, Y = (t1, e, s1, n)=>{
                if (X(e)) {
                    const i = e.inputs[n];
                    return t1.connect(i, s1, 0), [
                        i,
                        s1,
                        0
                    ];
                }
                return t1.connect(e, s1, n), [
                    e,
                    s1,
                    n
                ];
            }, $ = (t1, e, s1)=>{
                for (const n of t1)if (n[0] === e && n[1] === s1) return t1.delete(n), n;
                return null;
            }, H = (t1, e)=>{
                if (!S(t1).delete(e)) throw new Error("Missing the expected event listener.");
            }, J = (t1, e, s1)=>{
                const n = w(t1, e), i = b(n, (t1)=>t1[0] === s1);
                return 0 === n.size && t1.delete(e), i;
            }, K = (t1, e, s1, n)=>{
                X(e) ? t1.disconnect(e.inputs[n], s1, 0) : t1.disconnect(e, s1, n);
            }, tt = (t1)=>w(c, t1), et = (t1)=>w(l, t1), st = (t1)=>d.has(t1), nt = (t1)=>!r.has(t1), it = (t1, e)=>new Promise((s1)=>{
                    if (null !== e) s1(!0);
                    else {
                        const e = t1.createScriptProcessor(256, 1, 1), n = t1.createGain(), i = t1.createBuffer(1, 2, 44100), o = i.getChannelData(0);
                        o[0] = 1, o[1] = 1;
                        const r = t1.createBufferSource();
                        r.buffer = i, r.loop = !0, r.connect(e).connect(t1.destination), r.connect(n), r.disconnect(n), e.onaudioprocess = (n)=>{
                            const i = n.inputBuffer.getChannelData(0);
                            Array.prototype.some.call(i, (t1)=>1 === t1) ? s1(!0) : s1(!1), r.stop(), e.onaudioprocess = null, r.disconnect(e), e.disconnect(t1.destination);
                        }, r.start();
                    }
                }), ot = (t1, e)=>{
                const s1 = new Map;
                for (const e of t1)for (const t1 of e){
                    const e = s1.get(t1);
                    s1.set(t1, void 0 === e ? 1 : e + 1);
                }
                s1.forEach((t1, s1)=>e(s1, t1));
            }, rt = (t1)=>"context" in t1, at = (t1)=>{
                const e = new Map;
                t1.connect = ((t1)=>(s1, n = 0, i = 0)=>{
                        const o = rt(s1) ? t1(s1, n, i) : t1(s1, n), r = e.get(s1);
                        return void 0 === r ? e.set(s1, [
                            {
                                input: i,
                                output: n
                            }
                        ]) : r.every((t1)=>t1.input !== i || t1.output !== n) && r.push({
                            input: i,
                            output: n
                        }), o;
                    })(t1.connect.bind(t1)), t1.disconnect = ((s1)=>(n, i, o)=>{
                        if (s1.apply(t1), void 0 === n) e.clear();
                        else if ("number" == typeof n) for (const [t1, s1] of e){
                            const i = s1.filter((t1)=>t1.output !== n);
                            0 === i.length ? e.delete(t1) : e.set(t1, i);
                        }
                        else if (e.has(n)) {
                            if (void 0 === i) e.delete(n);
                            else {
                                const t1 = e.get(n);
                                if (void 0 !== t1) {
                                    const s1 = t1.filter((t1)=>t1.output !== i && (t1.input !== o || void 0 === o));
                                    0 === s1.length ? e.delete(n) : e.set(n, s1);
                                }
                            }
                        }
                        for (const [s1, n] of e)n.forEach((e)=>{
                            rt(s1) ? t1.connect(s1, e.output, e.input) : t1.connect(s1, e.output);
                        });
                    })(t1.disconnect);
            }, ct = (t1, e, s1, n, i)=>{
                const [o, r] = ((t1, e, s1, n)=>{
                    const { activeInputs: i, passiveInputs: o } = j(e), r = $(i[n], t1, s1);
                    return null === r ? [
                        T(o, t1, s1, n)[2],
                        !1
                    ] : [
                        r[2],
                        !0
                    ];
                })(t1, s1, n, i);
                if (null !== o && (H(t1, o), !r || e || st(t1) || K(tt(t1), tt(s1), n, i)), N(s1)) {
                    const { activeInputs: t1 } = j(s1);
                    D(s1, t1);
                }
            }, ht = (t1, e, s1, n)=>{
                const [i, o] = ((t1, e, s1)=>{
                    const { activeInputs: n, passiveInputs: i } = L(e), o = $(n, t1, s1);
                    return null === o ? [
                        J(i, t1, s1)[1],
                        !1
                    ] : [
                        o[2],
                        !0
                    ];
                })(t1, s1, n);
                null !== i && (H(t1, i), !o || e || st(t1) || tt(t1).disconnect(et(s1), n));
            };
            class lt {
                constructor(t1){
                    this._map = new Map(t1);
                }
                get size() {
                    return this._map.size;
                }
                entries() {
                    return this._map.entries();
                }
                forEach(t1, e = null) {
                    return this._map.forEach((s1, n)=>t1.call(e, s1, n, this));
                }
                get(t1) {
                    return this._map.get(t1);
                }
                has(t1) {
                    return this._map.has(t1);
                }
                keys() {
                    return this._map.keys();
                }
                values() {
                    return this._map.values();
                }
            }
            const ut = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                numberOfInputs: 1,
                numberOfOutputs: 1,
                parameterData: {},
                processorOptions: {}
            };
            function pt(t1, e, s1, n, i) {
                if ("function" == typeof t1.copyFromChannel) 0 === e[s1].byteLength && (e[s1] = new Float32Array(128)), t1.copyFromChannel(e[s1], n, i);
                else {
                    const o = t1.getChannelData(n);
                    if (0 === e[s1].byteLength) e[s1] = o.slice(i, i + 128);
                    else {
                        const t1 = new Float32Array(o.buffer, i * Float32Array.BYTES_PER_ELEMENT, 128);
                        e[s1].set(t1);
                    }
                }
            }
            const dt = (t1, e, s1, n, i)=>{
                "function" == typeof t1.copyToChannel ? 0 !== e[s1].byteLength && t1.copyToChannel(e[s1], n, i) : 0 !== e[s1].byteLength && t1.getChannelData(n).set(e[s1], i);
            }, ft = (t1, e)=>{
                const s1 = [];
                for(let n = 0; n < t1; n += 1){
                    const t1 = [], i = "number" == typeof e ? e : e[n];
                    for(let e = 0; e < i; e += 1)t1.push(new Float32Array(128));
                    s1.push(t1);
                }
                return s1;
            }, _t = async (t1, e, s1, n, i, o, r)=>{
                const a = null === e ? 128 * Math.ceil(t1.context.length / 128) : e.length, c = n.channelCount * n.numberOfInputs, h = i.reduce((t1, e)=>t1 + e, 0), l = 0 === h ? null : s1.createBuffer(h, a, s1.sampleRate);
                if (void 0 === o) throw new Error("Missing the processor constructor.");
                const u = j(t1), p = await ((t1, e)=>{
                    const s1 = w(_, t1), n = tt(e);
                    return w(s1, n);
                })(s1, t1), d = ft(n.numberOfInputs, n.channelCount), f = ft(n.numberOfOutputs, i), m = Array.from(t1.parameters.keys()).reduce((t1, e)=>({
                        ...t1,
                        [e]: new Float32Array(128)
                    }), {});
                for(let h = 0; h < a; h += 128){
                    if (n.numberOfInputs > 0 && null !== e) for(let t1 = 0; t1 < n.numberOfInputs; t1 += 1)for(let s1 = 0; s1 < n.channelCount; s1 += 1)pt(e, d[t1], s1, s1, h);
                    void 0 !== o.parameterDescriptors && null !== e && o.parameterDescriptors.forEach(({ name: t1 }, s1)=>{
                        pt(e, m, t1, c + s1, h);
                    });
                    for(let t1 = 0; t1 < n.numberOfInputs; t1 += 1)for(let e = 0; e < i[t1]; e += 1)0 === f[t1][e].byteLength && (f[t1][e] = new Float32Array(128));
                    try {
                        const t1 = d.map((t1, e)=>0 === u.activeInputs[e].size ? [] : t1), e = r(h / s1.sampleRate, s1.sampleRate, ()=>p.process(t1, f, m));
                        if (null !== l) for(let t1 = 0, e = 0; t1 < n.numberOfOutputs; t1 += 1){
                            for(let s1 = 0; s1 < i[t1]; s1 += 1)dt(l, f[t1], s1, e + s1, h);
                            e += i[t1];
                        }
                        if (!e) break;
                    } catch (e) {
                        t1.dispatchEvent(new ErrorEvent("processorerror", {
                            colno: e.colno,
                            filename: e.filename,
                            lineno: e.lineno,
                            message: e.message
                        }));
                        break;
                    }
                }
                return l;
            }, mt = {
                Q: 1,
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                detune: 0,
                frequency: 350,
                gain: 0,
                type: "lowpass"
            }, gt = {
                channelCount: 1,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                numberOfInputs: 6
            }, vt = {
                channelCount: 6,
                channelCountMode: "explicit",
                channelInterpretation: "discrete",
                numberOfOutputs: 6
            }, yt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                offset: 1
            }, xt = {
                buffer: null,
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                disableNormalization: !1
            }, wt = (t1)=>{
                const { port1: e, port2: s1 } = new MessageChannel;
                return new Promise((n)=>{
                    const i = ()=>{
                        s1.onmessage = null, e.close(), s1.close(), n();
                    };
                    s1.onmessage = ()=>i();
                    try {
                        e.postMessage(t1, [
                            t1
                        ]);
                    } catch  {} finally{
                        i();
                    }
                });
            }, bt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                delayTime: 0,
                maxDelayTime: 1
            }, Tt = (t1, e, s1)=>{
                const n = e[s1];
                if (void 0 === n) throw t1();
                return n;
            }, St = {
                attack: .003,
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                knee: 30,
                ratio: 12,
                release: .25,
                threshold: -24
            }, kt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                gain: 1
            }, At = ()=>new DOMException("", "InvalidStateError"), Ct = ()=>new DOMException("", "InvalidAccessError"), Dt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers"
            }, Ot = (t1, e, s1, n, i, o, r, a, c, h, l)=>{
                const u = h.length;
                let p = a;
                for(let a = 0; a < u; a += 1){
                    let u = s1[0] * h[a];
                    for(let e = 1; e < i; e += 1){
                        const n = p - e & c - 1;
                        u += s1[e] * o[n], u -= t1[e] * r[n];
                    }
                    for(let t1 = i; t1 < n; t1 += 1)u += s1[t1] * o[p - t1 & c - 1];
                    for(let s1 = i; s1 < e; s1 += 1)u -= t1[s1] * r[p - s1 & c - 1];
                    o[p] = h[a], r[p] = u, p = p + 1 & c - 1, l[a] = u;
                }
                return p;
            }, Mt = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers"
            }, Et = (t1)=>{
                const e = new Uint32Array([
                    1179011410,
                    40,
                    1163280727,
                    544501094,
                    16,
                    131073,
                    44100,
                    176400,
                    1048580,
                    1635017060,
                    4,
                    0
                ]);
                try {
                    const s1 = t1.decodeAudioData(e.buffer, ()=>{});
                    return void 0 !== s1 && (s1.catch(()=>{}), !0);
                } catch  {}
                return !1;
            }, Rt = (t1, e, s1)=>{
                const n = e[s1];
                void 0 !== n && n !== t1[s1] && (t1[s1] = n);
            }, qt = (t1, e)=>{
                Rt(t1, e, "channelCount"), Rt(t1, e, "channelCountMode"), Rt(t1, e, "channelInterpretation");
            }, Ft = (t1)=>"function" == typeof t1.getFloatTimeDomainData, It = (t1, e, s1)=>{
                const n = e[s1];
                void 0 !== n && n !== t1[s1].value && (t1[s1].value = n);
            }, Vt = (t1)=>{
                t1.start = ((e)=>(s1 = 0, n = 0, i)=>{
                        if ("number" == typeof i && i < 0 || n < 0 || s1 < 0) throw new RangeError("The parameters can't be negative.");
                        e.call(t1, s1, n, i);
                    })(t1.start);
            }, Nt = (t1)=>{
                var e;
                t1.stop = (e = t1.stop, (s1 = 0)=>{
                    if (s1 < 0) throw new RangeError("The parameter can't be negative.");
                    e.call(t1, s1);
                });
            }, Pt = (t1, e)=>null === t1 ? 512 : Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(t1 * e))))), jt = (t1, e)=>{
                const s1 = t1.createBiquadFilter();
                return qt(s1, e), It(s1, e, "Q"), It(s1, e, "detune"), It(s1, e, "frequency"), It(s1, e, "gain"), Rt(s1, e, "type"), s1;
            }, Lt = (t1, e)=>{
                const s1 = t1.createChannelSplitter(e.numberOfOutputs);
                return qt(s1, e), ((t1)=>{
                    const e = t1.numberOfOutputs;
                    Object.defineProperty(t1, "channelCount", {
                        get: ()=>e,
                        set: (t1)=>{
                            if (t1 !== e) throw At();
                        }
                    }), Object.defineProperty(t1, "channelCountMode", {
                        get: ()=>"explicit",
                        set: (t1)=>{
                            if ("explicit" !== t1) throw At();
                        }
                    }), Object.defineProperty(t1, "channelInterpretation", {
                        get: ()=>"discrete",
                        set: (t1)=>{
                            if ("discrete" !== t1) throw At();
                        }
                    });
                })(s1), s1;
            }, zt = (t1, e)=>(t1.connect = e.connect.bind(e), t1.disconnect = e.disconnect.bind(e), t1), Wt = (t1, e)=>{
                const s1 = t1.createDelay(e.maxDelayTime);
                return qt(s1, e), It(s1, e, "delayTime"), s1;
            }, Bt = (t1, e)=>{
                const s1 = t1.createGain();
                return qt(s1, e), It(s1, e, "gain"), s1;
            };
            function Ut(t1, e) {
                const s1 = e[0] * e[0] + e[1] * e[1];
                return [
                    (t1[0] * e[0] + t1[1] * e[1]) / s1,
                    (t1[1] * e[0] - t1[0] * e[1]) / s1
                ];
            }
            function Gt(t1, e) {
                let s1 = [
                    0,
                    0
                ];
                for(let o = t1.length - 1; o >= 0; o -= 1)i = e, s1 = [
                    (n = s1)[0] * i[0] - n[1] * i[1],
                    n[0] * i[1] + n[1] * i[0]
                ], s1[0] += t1[o];
                var n, i;
                return s1;
            }
            const Qt = (t1, e, s1, n)=>t1.createScriptProcessor(e, s1, n), Zt = ()=>new DOMException("", "NotSupportedError"), Xt = {
                numberOfChannels: 1
            }, Yt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                detune: 0,
                frequency: 440,
                periodicWave: void 0,
                type: "sine"
            }, $t = {
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                coneInnerAngle: 360,
                coneOuterAngle: 360,
                coneOuterGain: 0,
                distanceModel: "inverse",
                maxDistance: 1e4,
                orientationX: 1,
                orientationY: 0,
                orientationZ: 0,
                panningModel: "equalpower",
                positionX: 0,
                positionY: 0,
                positionZ: 0,
                refDistance: 1,
                rolloffFactor: 1
            }, Ht = {
                disableNormalization: !1
            }, Jt = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                pan: 0
            }, Kt = ()=>new DOMException("", "UnknownError"), te = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                curve: null,
                oversample: "none"
            }, ee = (t1, e, s1)=>void 0 === t1.copyFromChannel ? t1.getChannelData(s1)[0] : (t1.copyFromChannel(e, s1), e[0]), se = (t1)=>{
                if (null === t1) return !1;
                const e = t1.length;
                return e % 2 != 0 ? 0 !== t1[Math.floor(e / 2)] : t1[e / 2 - 1] + t1[e / 2] !== 0;
            }, ne = (t1, e, s1, n)=>{
                let i = t1;
                for(; !i.hasOwnProperty(e);)i = Object.getPrototypeOf(i);
                const { get: o, set: r } = Object.getOwnPropertyDescriptor(i, e);
                Object.defineProperty(t1, e, {
                    get: s1(o),
                    set: n(r)
                });
            }, ie = (t1, e, s1)=>{
                try {
                    t1.setValueAtTime(e, s1);
                } catch (n) {
                    if (9 !== n.code) throw n;
                    ie(t1, e, s1 + 1e-7);
                }
            }, oe = (t1)=>{
                const e = t1.createOscillator();
                try {
                    e.start(-1);
                } catch (t1) {
                    return t1 instanceof RangeError;
                }
                return !1;
            }, re = (t1)=>{
                const e = t1.createBuffer(1, 1, 44100), s1 = t1.createBufferSource();
                s1.buffer = e, s1.start(), s1.stop();
                try {
                    return s1.stop(), !0;
                } catch  {
                    return !1;
                }
            }, ae = (t1)=>{
                const e = t1.createOscillator();
                try {
                    e.stop(-1);
                } catch (t1) {
                    return t1 instanceof RangeError;
                }
                return !1;
            }, ce = ()=>{
                try {
                    new DOMException;
                } catch  {
                    return !1;
                }
                return !0;
            }, he = ()=>new Promise((t1)=>{
                    const e = new ArrayBuffer(0), { port1: s1, port2: n } = new MessageChannel;
                    s1.onmessage = ({ data: e })=>t1(null !== e), n.postMessage(e, [
                        e
                    ]);
                }), le = (t1, e)=>{
                const s1 = e.createGain();
                t1.connect(s1);
                const n = ((e)=>()=>{
                        e.call(t1, s1), t1.removeEventListener("ended", n);
                    })(t1.disconnect);
                t1.addEventListener("ended", n), zt(t1, s1), t1.stop = ((e)=>{
                    let n = !1;
                    return (i = 0)=>{
                        if (n) try {
                            e.call(t1, i);
                        } catch  {
                            s1.gain.setValueAtTime(0, i);
                        }
                        else e.call(t1, i), n = !0;
                    };
                })(t1.stop);
            }, ue = (t1, e)=>(s1)=>{
                    const n = {
                        value: t1
                    };
                    return Object.defineProperties(s1, {
                        currentTarget: n,
                        target: n
                    }), "function" == typeof e ? e.call(t1, s1) : e.handleEvent.call(t1, s1);
                }, pe = ((t1)=>(e, s1, [n, i, o], r)=>{
                    t1(e[i], [
                        s1,
                        n,
                        o
                    ], (t1)=>t1[0] === s1 && t1[1] === n, r);
                })(G), de = ((t1)=>(e, s1, [n, i, o], r)=>{
                    const a = e.get(n);
                    void 0 === a ? e.set(n, new Set([
                        [
                            i,
                            s1,
                            o
                        ]
                    ])) : t1(a, [
                        i,
                        s1,
                        o
                    ], (t1)=>t1[0] === i && t1[1] === s1, r);
                })(G), fe = ((t1)=>(e, s1, n, i)=>t1(e[i], (t1)=>t1[0] === s1 && t1[1] === n))(b), _e = new WeakMap, me = ((t1)=>(e)=>{
                    var s1;
                    return null !== (s1 = t1.get(e)) && void 0 !== s1 ? s1 : 0;
                })(_e), ge = (ve = new Map, ye = new WeakMap, (t1, e)=>{
                const s1 = ye.get(t1);
                if (void 0 !== s1) return s1;
                const n = ve.get(t1);
                if (void 0 !== n) return n;
                try {
                    const s1 = e();
                    return s1 instanceof Promise ? (ve.set(t1, s1), s1.catch(()=>!1).then((e)=>(ve.delete(t1), ye.set(t1, e), e))) : (ye.set(t1, s1), s1);
                } catch  {
                    return ye.set(t1, !1), !1;
                }
            });
            var ve, ye;
            const xe = "undefined" == typeof window ? null : window, we = ((t1, e)=>(s1, n)=>{
                    const i = s1.createAnalyser();
                    if (qt(i, n), !(n.maxDecibels > n.minDecibels)) throw e();
                    return Rt(i, n, "fftSize"), Rt(i, n, "maxDecibels"), Rt(i, n, "minDecibels"), Rt(i, n, "smoothingTimeConstant"), t1(Ft, ()=>Ft(i)) || ((t1)=>{
                        t1.getFloatTimeDomainData = (e)=>{
                            const s1 = new Uint8Array(e.length);
                            t1.getByteTimeDomainData(s1);
                            const n = Math.max(s1.length, t1.fftSize);
                            for(let t1 = 0; t1 < n; t1 += 1)e[t1] = .0078125 * (s1[t1] - 128);
                            return e;
                        };
                    })(i), i;
                })(ge, R), be = ((t1)=>(e)=>{
                    const s1 = t1(e);
                    if (null === s1.renderer) throw new Error("Missing the renderer of the given AudioNode in the audio graph.");
                    return s1.renderer;
                })(j), Te = ((t1, e, s1)=>async (n, i, o)=>{
                    const r = t1(n);
                    await Promise.all(r.activeInputs.map((t1, r)=>Array.from(t1).map(async ([t1, a])=>{
                            const c = e(t1), h = await c.render(t1, i), l = n.context.destination;
                            s1(t1) || n === l && s1(n) || h.connect(o, a, r);
                        })).reduce((t1, e)=>[
                            ...t1,
                            ...e
                        ], []));
                })(j, be, st), Se = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        fftSize: r.fftSize,
                                        maxDecibels: r.maxDecibels,
                                        minDecibels: r.minDecibels,
                                        smoothingTimeConstant: r.smoothingTimeConstant
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(we, tt, Te), ke = (Ae = u, (t1)=>{
                const e = Ae.get(t1);
                if (void 0 === e) throw At();
                return e;
            });
            var Ae;
            const Ce = ((t1)=>null === t1 ? null : t1.hasOwnProperty("OfflineAudioContext") ? t1.OfflineAudioContext : t1.hasOwnProperty("webkitOfflineAudioContext") ? t1.webkitOfflineAudioContext : null)(xe), De = ((t1)=>(e)=>null !== t1 && e instanceof t1)(Ce), Oe = new WeakMap, Me = ((t1)=>class {
                    constructor(t1){
                        this._nativeEventTarget = t1, this._listeners = new WeakMap;
                    }
                    addEventListener(e, s1, n) {
                        if (null !== s1) {
                            let i = this._listeners.get(s1);
                            void 0 === i && (i = t1(this, s1), "function" == typeof s1 && this._listeners.set(s1, i)), this._nativeEventTarget.addEventListener(e, i, n);
                        }
                    }
                    dispatchEvent(t1) {
                        return this._nativeEventTarget.dispatchEvent(t1);
                    }
                    removeEventListener(t1, e, s1) {
                        const n = null === e ? void 0 : this._listeners.get(e);
                        this._nativeEventTarget.removeEventListener(t1, void 0 === n ? null : n, s1);
                    }
                })(ue), Ee = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioContext") ? t1.AudioContext : t1.hasOwnProperty("webkitAudioContext") ? t1.webkitAudioContext : null)(xe), Re = ((t1)=>(e)=>null !== t1 && e instanceof t1)(Ee), qe = ((t1)=>(e)=>null !== t1 && "function" == typeof t1.AudioNode && e instanceof t1.AudioNode)(xe), Fe = ((t1)=>(e)=>null !== t1 && "function" == typeof t1.AudioParam && e instanceof t1.AudioParam)(xe), Ie = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioWorkletNode") ? t1.AudioWorkletNode : null)(xe), Ve = ((t1, e, s1, n, i, o, r, a, h, l, u, d, f, _, m, g)=>class extends l {
                    constructor(e, n, i, o){
                        super(i), this._context = e, this._nativeAudioNode = i;
                        const r = u(e);
                        d(r) && !0 !== s1(it, ()=>it(r, g)) && at(i), c.set(this, i), p.set(this, new Set), "closed" !== e.state && n && k(this), t1(this, o, i);
                    }
                    get channelCount() {
                        return this._nativeAudioNode.channelCount;
                    }
                    set channelCount(t1) {
                        this._nativeAudioNode.channelCount = t1;
                    }
                    get channelCountMode() {
                        return this._nativeAudioNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        this._nativeAudioNode.channelCountMode = t1;
                    }
                    get channelInterpretation() {
                        return this._nativeAudioNode.channelInterpretation;
                    }
                    set channelInterpretation(t1) {
                        this._nativeAudioNode.channelInterpretation = t1;
                    }
                    get context() {
                        return this._context;
                    }
                    get numberOfInputs() {
                        return this._nativeAudioNode.numberOfInputs;
                    }
                    get numberOfOutputs() {
                        return this._nativeAudioNode.numberOfOutputs;
                    }
                    connect(t1, s1 = 0, a = 0) {
                        if (s1 < 0 || s1 >= this._nativeAudioNode.numberOfOutputs) throw i();
                        const c = u(this._context), l = m(c);
                        if (f(t1) || _(t1)) throw o();
                        if (B(t1)) {
                            const i = tt(t1);
                            try {
                                const e = Y(this._nativeAudioNode, i, s1, a), n = nt(this);
                                (l || n) && this._nativeAudioNode.disconnect(...e), "closed" !== this.context.state && !n && nt(t1) && k(t1);
                            } catch (t1) {
                                if (12 === t1.code) throw o();
                                throw t1;
                            }
                            if (e(this, t1, s1, a, l)) {
                                const e = h([
                                    this
                                ], t1);
                                ot(e, n(l));
                            }
                            return t1;
                        }
                        const p = et(t1);
                        if ("playbackRate" === p.name && 1024 === p.maxValue) throw r();
                        try {
                            this._nativeAudioNode.connect(p, s1), (l || nt(this)) && this._nativeAudioNode.disconnect(p, s1);
                        } catch (t1) {
                            if (12 === t1.code) throw o();
                            throw t1;
                        }
                        if (((t1, e, s1, n)=>{
                            const { activeInputs: i, passiveInputs: o } = L(e), { outputs: r } = j(t1), a = S(t1), c = (r)=>{
                                const a = tt(t1), c = et(e);
                                if (r) {
                                    const e = J(o, t1, s1);
                                    Q(i, t1, e, !1), n || st(t1) || a.connect(c, s1);
                                } else {
                                    const e = ((t1, e, s1)=>b(t1, (t1)=>t1[0] === e && t1[1] === s1))(i, t1, s1);
                                    Z(o, e, !1), n || st(t1) || a.disconnect(c, s1);
                                }
                            };
                            return !!G(r, [
                                e,
                                s1
                            ], (t1)=>t1[0] === e && t1[1] === s1, !0) && (a.add(c), N(t1) ? Q(i, t1, [
                                s1,
                                c
                            ], !0) : Z(o, [
                                t1,
                                s1,
                                c
                            ], !0), !0);
                        })(this, t1, s1, l)) {
                            const e = h([
                                this
                            ], t1);
                            ot(e, n(l));
                        }
                    }
                    disconnect(t1, e, s1) {
                        let n;
                        const r = u(this._context), c = m(r);
                        if (void 0 === t1) n = ((t1, e)=>{
                            const s1 = j(t1), n = [];
                            for (const i of s1.outputs)U(i) ? ct(t1, e, ...i) : ht(t1, e, ...i), n.push(i[0]);
                            return s1.outputs.clear(), n;
                        })(this, c);
                        else if ("number" == typeof t1) {
                            if (t1 < 0 || t1 >= this.numberOfOutputs) throw i();
                            n = ((t1, e, s1)=>{
                                const n = j(t1), i = [];
                                for (const o of n.outputs)o[1] === s1 && (U(o) ? ct(t1, e, ...o) : ht(t1, e, ...o), i.push(o[0]), n.outputs.delete(o));
                                return i;
                            })(this, c, t1);
                        } else {
                            if (void 0 !== e && (e < 0 || e >= this.numberOfOutputs)) throw i();
                            if (B(t1) && void 0 !== s1 && (s1 < 0 || s1 >= t1.numberOfInputs)) throw i();
                            if (n = ((t1, e, s1, n, i)=>{
                                const o = j(t1);
                                return Array.from(o.outputs).filter((t1)=>!(t1[0] !== s1 || void 0 !== n && t1[1] !== n || void 0 !== i && t1[2] !== i)).map((s1)=>(U(s1) ? ct(t1, e, ...s1) : ht(t1, e, ...s1), o.outputs.delete(s1), s1[0]));
                            })(this, c, t1, e, s1), 0 === n.length) throw o();
                        }
                        for (const t1 of n){
                            const e = h([
                                this
                            ], t1);
                            ot(e, a);
                        }
                    }
                })((Ne = a, (t1, e, s1)=>{
                const n = [];
                for(let t1 = 0; t1 < s1.numberOfInputs; t1 += 1)n.push(new Set);
                Ne.set(t1, {
                    activeInputs: n,
                    outputs: new Set,
                    passiveInputs: new WeakMap,
                    renderer: e
                });
            }), ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>{
                const d = new WeakMap;
                return (f, _, m, g, v)=>{
                    const { activeInputs: y, passiveInputs: x } = o(_), { outputs: w } = o(f), b = a(f), S = (o)=>{
                        const a = c(_), h = c(f);
                        if (o) {
                            const e = T(x, f, m, g);
                            t1(y, f, e, !1), v || u(f) || s1(h, a, m, g), p(_) && k(_);
                        } else {
                            const t1 = n(y, f, m, g);
                            e(x, g, t1, !1), v || u(f) || i(h, a, m, g);
                            const s1 = r(_);
                            if (0 === s1) l(_) && D(_, y);
                            else {
                                const t1 = d.get(_);
                                void 0 !== t1 && clearTimeout(t1), d.set(_, setTimeout(()=>{
                                    l(_) && D(_, y);
                                }, 1e3 * s1));
                            }
                        }
                    };
                    return !!h(w, [
                        _,
                        m,
                        g
                    ], (t1)=>t1[0] === _ && t1[1] === m && t1[2] === g, !0) && (b.add(S), l(f) ? t1(y, f, [
                        m,
                        g,
                        S
                    ], !0) : e(x, g, [
                        f,
                        m,
                        S
                    ], !0), !0);
                };
            })(pe, de, Y, fe, K, j, me, S, tt, G, N, st, nt), ge, ((t1, e, s1, n, i, o)=>(r)=>(a, c)=>{
                        const h = t1.get(a);
                        if (void 0 === h) {
                            if (!r && o(a)) {
                                const t1 = n(a), { outputs: o } = s1(a);
                                for (const s1 of o)if (U(s1)) {
                                    const i = n(s1[0]);
                                    e(t1, i, s1[1], s1[2]);
                                } else {
                                    const e = i(s1[0]);
                                    t1.disconnect(e, s1[1]);
                                }
                            }
                            t1.set(a, c);
                        } else t1.set(a, h + c);
                    })(d, K, j, tt, et, N), R, Ct, Zt, ((t1, e, s1, n, i, o, r, a)=>(c, h)=>{
                    const l = e.get(c);
                    if (void 0 === l) throw new Error("Missing the expected cycle count.");
                    const u = o(c.context), p = a(u);
                    if (l === h) {
                        if (e.delete(c), !p && r(c)) {
                            const e = n(c), { outputs: o } = s1(c);
                            for (const s1 of o)if (U(s1)) {
                                const i = n(s1[0]);
                                t1(e, i, s1[1], s1[2]);
                            } else {
                                const t1 = i(s1[0]);
                                e.connect(t1, s1[1]);
                            }
                        }
                    } else e.set(c, l - h);
                })(Y, d, j, tt, et, ke, N, De), ((t1, e, s1)=>function n(i, o) {
                    const r = B(o) ? o : s1(t1, o);
                    if (((t1)=>"delayTime" in t1)(r)) return [];
                    if (i[0] === r) return [
                        i
                    ];
                    if (i.includes(r)) return [];
                    const { outputs: a } = e(r);
                    return Array.from(a).map((t1)=>n([
                            ...i,
                            r
                        ], t1[0])).reduce((t1, e)=>t1.concat(e), []);
                })(Oe, j, w), Me, ke, Re, qe, Fe, De, Ie);
            var Ne;
            const Pe = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, s1){
                        const r = i(t1), a = {
                            ...O,
                            ...s1
                        }, c = n(r, a);
                        super(t1, !1, c, o(r) ? e() : null), this._nativeAnalyserNode = c;
                    }
                    get fftSize() {
                        return this._nativeAnalyserNode.fftSize;
                    }
                    set fftSize(t1) {
                        this._nativeAnalyserNode.fftSize = t1;
                    }
                    get frequencyBinCount() {
                        return this._nativeAnalyserNode.frequencyBinCount;
                    }
                    get maxDecibels() {
                        return this._nativeAnalyserNode.maxDecibels;
                    }
                    set maxDecibels(t1) {
                        const e = this._nativeAnalyserNode.maxDecibels;
                        if (this._nativeAnalyserNode.maxDecibels = t1, !(t1 > this._nativeAnalyserNode.minDecibels)) throw this._nativeAnalyserNode.maxDecibels = e, s1();
                    }
                    get minDecibels() {
                        return this._nativeAnalyserNode.minDecibels;
                    }
                    set minDecibels(t1) {
                        const e = this._nativeAnalyserNode.minDecibels;
                        if (this._nativeAnalyserNode.minDecibels = t1, !(this._nativeAnalyserNode.maxDecibels > t1)) throw this._nativeAnalyserNode.minDecibels = e, s1();
                    }
                    get smoothingTimeConstant() {
                        return this._nativeAnalyserNode.smoothingTimeConstant;
                    }
                    set smoothingTimeConstant(t1) {
                        this._nativeAnalyserNode.smoothingTimeConstant = t1;
                    }
                    getByteFrequencyData(t1) {
                        this._nativeAnalyserNode.getByteFrequencyData(t1);
                    }
                    getByteTimeDomainData(t1) {
                        this._nativeAnalyserNode.getByteTimeDomainData(t1);
                    }
                    getFloatFrequencyData(t1) {
                        this._nativeAnalyserNode.getFloatFrequencyData(t1);
                    }
                    getFloatTimeDomainData(t1) {
                        this._nativeAnalyserNode.getFloatTimeDomainData(t1);
                    }
                })(Ve, Se, R, we, ke, De), je = new WeakSet, Le = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioBuffer") ? t1.AudioBuffer : null)(xe), ze = (We = new Uint32Array(1), (t1)=>(We[0] = t1, We[0]));
            var We;
            const Be = ((t1, e)=>(s1)=>{
                    s1.copyFromChannel = (n, i, o = 0)=>{
                        const r = t1(o), a = t1(i);
                        if (a >= s1.numberOfChannels) throw e();
                        const c = s1.length, h = s1.getChannelData(a), l = n.length;
                        for(let t1 = r < 0 ? -r : 0; t1 + r < c && t1 < l; t1 += 1)n[t1] = h[t1 + r];
                    }, s1.copyToChannel = (n, i, o = 0)=>{
                        const r = t1(o), a = t1(i);
                        if (a >= s1.numberOfChannels) throw e();
                        const c = s1.length, h = s1.getChannelData(a), l = n.length;
                        for(let t1 = r < 0 ? -r : 0; t1 + r < c && t1 < l; t1 += 1)h[t1 + r] = n[t1];
                    };
                })(ze, R), Ue = ((t1)=>(e)=>{
                    e.copyFromChannel = ((s1)=>(n, i, o = 0)=>{
                            const r = t1(o), a = t1(i);
                            if (r < e.length) return s1.call(e, n, a, r);
                        })(e.copyFromChannel), e.copyToChannel = ((s1)=>(n, i, o = 0)=>{
                            const r = t1(o), a = t1(i);
                            if (r < e.length) return s1.call(e, n, a, r);
                        })(e.copyToChannel);
                })(ze), Ge = ((t1, e, s1, n, i, o, r, a)=>{
                let c = null;
                return class h {
                    constructor(h){
                        if (null === i) throw new Error("Missing the native OfflineAudioContext constructor.");
                        const { length: l, numberOfChannels: u, sampleRate: p } = {
                            ...F,
                            ...h
                        };
                        null === c && (c = new i(1, 1, 44100));
                        const d = null !== n && e(o, o) ? new n({
                            length: l,
                            numberOfChannels: u,
                            sampleRate: p
                        }) : c.createBuffer(u, l, p);
                        if (0 === d.numberOfChannels) throw s1();
                        return "function" != typeof d.copyFromChannel ? (r(d), q(d)) : e(E, ()=>E(d)) || a(d), t1.add(d), d;
                    }
                    static [Symbol.hasInstance](e) {
                        return null !== e && "object" == typeof e && Object.getPrototypeOf(e) === h.prototype || t1.has(e);
                    }
                };
            })(je, ge, Zt, Le, Ce, ((t1)=>()=>{
                    if (null === t1) return !1;
                    try {
                        new t1({
                            length: 1,
                            sampleRate: 44100
                        });
                    } catch  {
                        return !1;
                    }
                    return !0;
                })(Le), Be, Ue), Qe = ((t1)=>(e, s1)=>{
                    const n = t1(e, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    });
                    s1.connect(n).connect(e.destination);
                    const i = ()=>{
                        s1.removeEventListener("ended", i), s1.disconnect(n), n.disconnect();
                    };
                    s1.addEventListener("ended", i);
                })(Bt), Ze = ((t1, e, s1)=>async (n, i, o)=>{
                    const r = e(n);
                    await Promise.all(Array.from(r.activeInputs).map(async ([e, n])=>{
                        const r = t1(e), a = await r.render(e, i);
                        s1(e) || a.connect(o, n);
                    }));
                })(be, L, st), Xe = ((t1)=>(e, s1, n)=>t1(s1, e, n))(Ze), Ye = ((t1, e, s1, n, i, o, r, a, c, h, l)=>(c, u)=>{
                    const p = c.createBufferSource();
                    return qt(p, u), It(p, u, "playbackRate"), Rt(p, u, "buffer"), Rt(p, u, "loop"), Rt(p, u, "loopEnd"), Rt(p, u, "loopStart"), e(s1, ()=>s1(c)) || ((t1)=>{
                        t1.start = ((e)=>{
                            let s1 = !1;
                            return (n = 0, i = 0, o)=>{
                                if (s1) throw At();
                                e.call(t1, n, i, o), s1 = !0;
                            };
                        })(t1.start);
                    })(p), e(n, ()=>n(c)) || ((t1)=>{
                        t1.start = ((e)=>(s1 = 0, n = 0, i)=>{
                                const o = t1.buffer, r = null === o ? n : Math.min(o.duration, n);
                                null !== o && r > o.duration - .5 / t1.context.sampleRate ? e.call(t1, s1, 0, 0) : e.call(t1, s1, r, i);
                            })(t1.start);
                    })(p), e(i, ()=>i(c)) || h(p, c), e(o, ()=>o(c)) || Vt(p), e(r, ()=>r(c)) || l(p, c), e(a, ()=>a(c)) || Nt(p), t1(c, p), p;
                })(Qe, ge, (t1)=>{
                const e = t1.createBufferSource();
                e.start();
                try {
                    e.start();
                } catch  {
                    return !0;
                }
                return !1;
            }, (t1)=>{
                const e = t1.createBufferSource(), s1 = t1.createBuffer(1, 1, 44100);
                e.buffer = s1;
                try {
                    e.start(0, 1);
                } catch  {
                    return !1;
                }
                return !0;
            }, (t1)=>{
                const e = t1.createBufferSource();
                e.start();
                try {
                    e.stop();
                } catch  {
                    return !1;
                }
                return !0;
            }, oe, re, ae, 0, ((t1)=>(e, s1)=>{
                    const n = s1.createBuffer(1, 1, 44100);
                    null === e.buffer && (e.buffer = n), t1(e, "buffer", (t1)=>()=>{
                            const s1 = t1.call(e);
                            return s1 === n ? null : s1;
                        }, (t1)=>(s1)=>t1.call(e, null === s1 ? n : s1));
                })(ne), le), $e = ((t1, e)=>(s1, n, i)=>(t1(n).replay(i), e(n, s1, i)))(((t1)=>(e)=>{
                    const s1 = t1(e);
                    if (null === s1.renderer) throw new Error("Missing the renderer of the given AudioParam in the audio graph.");
                    return s1.renderer;
                })(L), Ze), He = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null;
                    return {
                        set start (t){
                            r = t;
                        },
                        set stop (t){
                            a = t;
                        },
                        render (c, h) {
                            const l = o.get(h);
                            return void 0 !== l ? Promise.resolve(l) : (async (c, h)=>{
                                let l = s1(c);
                                const u = M(l, h);
                                if (!u) {
                                    const t1 = {
                                        buffer: l.buffer,
                                        channelCount: l.channelCount,
                                        channelCountMode: l.channelCountMode,
                                        channelInterpretation: l.channelInterpretation,
                                        loop: l.loop,
                                        loopEnd: l.loopEnd,
                                        loopStart: l.loopStart,
                                        playbackRate: l.playbackRate.value
                                    };
                                    l = e(h, t1), null !== r && l.start(...r), null !== a && l.stop(a);
                                }
                                return o.set(h, l), u ? await t1(h, c.playbackRate, l.playbackRate) : await n(h, c.playbackRate, l.playbackRate), await i(c, h, l), l;
                            })(c, h);
                        }
                    };
                })(Xe, Ye, tt, $e, Te), Je = ((t1, e, s1, n, i, r, a, c, h, l, u, p, d)=>(n, f, _, m = null, g = null)=>{
                    const v = _.value, y = new o.AutomationEventList(v), x = f ? ((t1)=>({
                            replay (e) {
                                for (const s1 of t1)if ("exponentialRampToValue" === s1.type) {
                                    const { endTime: t1, value: n } = s1;
                                    e.exponentialRampToValueAtTime(n, t1);
                                } else if ("linearRampToValue" === s1.type) {
                                    const { endTime: t1, value: n } = s1;
                                    e.linearRampToValueAtTime(n, t1);
                                } else if ("setTarget" === s1.type) {
                                    const { startTime: t1, target: n, timeConstant: i } = s1;
                                    e.setTargetAtTime(n, t1, i);
                                } else if ("setValue" === s1.type) {
                                    const { startTime: t1, value: n } = s1;
                                    e.setValueAtTime(n, t1);
                                } else {
                                    if ("setValueCurve" !== s1.type) throw new Error("Can't apply an unknown automation.");
                                    {
                                        const { duration: t1, startTime: n, values: i } = s1;
                                        e.setValueCurveAtTime(i, n, t1);
                                    }
                                }
                            }
                        }))(y) : null, w = {
                        get defaultValue () {
                            return v;
                        },
                        get maxValue () {
                            return null === m ? _.maxValue : m;
                        },
                        get minValue () {
                            return null === g ? _.minValue : g;
                        },
                        get value () {
                            return _.value;
                        },
                        set value (t){
                            _.value = t, w.setValueAtTime(t, n.context.currentTime);
                        },
                        cancelAndHoldAtTime (t1) {
                            if ("function" == typeof _.cancelAndHoldAtTime) null === x && y.flush(n.context.currentTime), y.add(i(t1)), _.cancelAndHoldAtTime(t1);
                            else {
                                const e = Array.from(y).pop();
                                null === x && y.flush(n.context.currentTime), y.add(i(t1));
                                const s1 = Array.from(y).pop();
                                _.cancelScheduledValues(t1), e !== s1 && void 0 !== s1 && ("exponentialRampToValue" === s1.type ? _.exponentialRampToValueAtTime(s1.value, s1.endTime) : "linearRampToValue" === s1.type ? _.linearRampToValueAtTime(s1.value, s1.endTime) : "setValue" === s1.type ? _.setValueAtTime(s1.value, s1.startTime) : "setValueCurve" === s1.type && _.setValueCurveAtTime(s1.values, s1.startTime, s1.duration));
                            }
                            return w;
                        },
                        cancelScheduledValues: (t1)=>(null === x && y.flush(n.context.currentTime), y.add(r(t1)), _.cancelScheduledValues(t1), w),
                        exponentialRampToValueAtTime (t1, e) {
                            if (0 === t1) throw new RangeError;
                            if (!Number.isFinite(e) || e < 0) throw new RangeError;
                            const s1 = n.context.currentTime;
                            return null === x && y.flush(s1), 0 === Array.from(y).length && (y.add(l(v, s1)), _.setValueAtTime(v, s1)), y.add(a(t1, e)), _.exponentialRampToValueAtTime(t1, e), w;
                        },
                        linearRampToValueAtTime (t1, e) {
                            const s1 = n.context.currentTime;
                            return null === x && y.flush(s1), 0 === Array.from(y).length && (y.add(l(v, s1)), _.setValueAtTime(v, s1)), y.add(c(t1, e)), _.linearRampToValueAtTime(t1, e), w;
                        },
                        setTargetAtTime: (t1, e, s1)=>(null === x && y.flush(n.context.currentTime), y.add(h(t1, e, s1)), _.setTargetAtTime(t1, e, s1), w),
                        setValueAtTime: (t1, e)=>(null === x && y.flush(n.context.currentTime), y.add(l(t1, e)), _.setValueAtTime(t1, e), w),
                        setValueCurveAtTime (t1, e, s1) {
                            const i = t1 instanceof Float32Array ? t1 : new Float32Array(t1);
                            if (null !== p && "webkitAudioContext" === p.name) {
                                const t1 = e + s1, o = n.context.sampleRate, r = Math.ceil(e * o), a = Math.floor(t1 * o), c = a - r, h = new Float32Array(c);
                                for(let t1 = 0; t1 < c; t1 += 1){
                                    const n = (i.length - 1) / s1 * ((r + t1) / o - e), a = Math.floor(n), c = Math.ceil(n);
                                    h[t1] = a === c ? i[a] : (1 - (n - a)) * i[a] + (1 - (c - n)) * i[c];
                                }
                                null === x && y.flush(n.context.currentTime), y.add(u(h, e, s1)), _.setValueCurveAtTime(h, e, s1);
                                const l = a / o;
                                l < t1 && d(w, h[h.length - 1], l), d(w, i[i.length - 1], t1);
                            } else null === x && y.flush(n.context.currentTime), y.add(u(i, e, s1)), _.setValueCurveAtTime(i, e, s1);
                            return w;
                        }
                    };
                    return s1.set(w, _), e.set(w, n), t1(w, x), w;
                })((Ke = h, (t1, e)=>{
                Ke.set(t1, {
                    activeInputs: new Set,
                    passiveInputs: new WeakMap,
                    renderer: e
                });
            }), Oe, l, 0, o.createCancelAndHoldAutomationEvent, o.createCancelScheduledValuesAutomationEvent, o.createExponentialRampToValueAutomationEvent, o.createLinearRampToValueAutomationEvent, o.createSetTargetAutomationEvent, o.createSetValueAutomationEvent, o.createSetValueCurveAutomationEvent, Ee, ie);
            var Ke;
            const ts = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, n){
                        const a = o(t1), c = {
                            ...P,
                            ...n
                        }, h = i(a, c), l = r(a), u = l ? e() : null;
                        super(t1, !1, h, u), this._audioBufferSourceNodeRenderer = u, this._isBufferNullified = !1, this._isBufferSet = null !== c.buffer, this._nativeAudioBufferSourceNode = h, this._onended = null, this._playbackRate = s1(this, l, h.playbackRate, V, I);
                    }
                    get buffer() {
                        return this._isBufferNullified ? null : this._nativeAudioBufferSourceNode.buffer;
                    }
                    set buffer(t1) {
                        if (this._nativeAudioBufferSourceNode.buffer = t1, null !== t1) {
                            if (this._isBufferSet) throw n();
                            this._isBufferSet = !0;
                        }
                    }
                    get loop() {
                        return this._nativeAudioBufferSourceNode.loop;
                    }
                    set loop(t1) {
                        this._nativeAudioBufferSourceNode.loop = t1;
                    }
                    get loopEnd() {
                        return this._nativeAudioBufferSourceNode.loopEnd;
                    }
                    set loopEnd(t1) {
                        this._nativeAudioBufferSourceNode.loopEnd = t1;
                    }
                    get loopStart() {
                        return this._nativeAudioBufferSourceNode.loopStart;
                    }
                    set loopStart(t1) {
                        this._nativeAudioBufferSourceNode.loopStart = t1;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? a(this, t1) : null;
                        this._nativeAudioBufferSourceNode.onended = e;
                        const s1 = this._nativeAudioBufferSourceNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get playbackRate() {
                        return this._playbackRate;
                    }
                    start(t1 = 0, e = 0, s1) {
                        if (this._nativeAudioBufferSourceNode.start(t1, e, s1), null !== this._audioBufferSourceNodeRenderer && (this._audioBufferSourceNodeRenderer.start = void 0 === s1 ? [
                            t1,
                            e
                        ] : [
                            t1,
                            e,
                            s1
                        ]), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeAudioBufferSourceNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeAudioBufferSourceNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeAudioBufferSourceNode.stop(t1), null !== this._audioBufferSourceNodeRenderer && (this._audioBufferSourceNodeRenderer.stop = t1);
                    }
                })(Ve, He, Je, At, Ye, ke, De, ue), es = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, e){
                        const s1 = o(t1), n = r(s1), c = i(s1, e, n);
                        super(t1, !1, c, n ? ((t1)=>{
                            const e = new WeakMap;
                            return {
                                render (s1, n) {
                                    const i = e.get(n);
                                    return void 0 !== i ? Promise.resolve(i) : (async (s1, n)=>{
                                        const i = n.destination;
                                        return e.set(n, i), await t1(s1, n, i), i;
                                    })(s1, n);
                                }
                            };
                        })(a) : null), this._isNodeOfNativeOfflineAudioContext = n, this._nativeAudioDestinationNode = c;
                    }
                    get channelCount() {
                        return this._nativeAudioDestinationNode.channelCount;
                    }
                    set channelCount(t1) {
                        if (this._isNodeOfNativeOfflineAudioContext) throw n();
                        if (t1 > this._nativeAudioDestinationNode.maxChannelCount) throw s1();
                        this._nativeAudioDestinationNode.channelCount = t1;
                    }
                    get channelCountMode() {
                        return this._nativeAudioDestinationNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        if (this._isNodeOfNativeOfflineAudioContext) throw n();
                        this._nativeAudioDestinationNode.channelCountMode = t1;
                    }
                    get maxChannelCount() {
                        return this._nativeAudioDestinationNode.maxChannelCount;
                    }
                })(Ve, 0, R, At, ((t1, e)=>(s1, n, i)=>{
                    const o = s1.destination;
                    if (o.channelCount !== n) try {
                        o.channelCount = n;
                    } catch  {}
                    i && "explicit" !== o.channelCountMode && (o.channelCountMode = "explicit"), 0 === o.maxChannelCount && Object.defineProperty(o, "maxChannelCount", {
                        value: n
                    });
                    const r = t1(s1, {
                        channelCount: n,
                        channelCountMode: o.channelCountMode,
                        channelInterpretation: o.channelInterpretation,
                        gain: 1
                    });
                    return e(r, "channelCount", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e);
                            try {
                                o.channelCount = e;
                            } catch (t1) {
                                if (e > o.maxChannelCount) throw t1;
                            }
                        }), e(r, "channelCountMode", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e), o.channelCountMode = e;
                        }), e(r, "channelInterpretation", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e), o.channelInterpretation = e;
                        }), Object.defineProperty(r, "maxChannelCount", {
                        get: ()=>o.maxChannelCount
                    }), r.connect(o), r;
                })(Bt, ne), ke, De, Te), ss = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        Q: c.Q.value,
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        detune: c.detune.value,
                                        frequency: c.frequency.value,
                                        gain: c.gain.value,
                                        type: c.type
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? (await t1(a, r.Q, c.Q), await t1(a, r.detune, c.detune), await t1(a, r.frequency, c.frequency), await t1(a, r.gain, c.gain)) : (await n(a, r.Q, c.Q), await n(a, r.detune, c.detune), await n(a, r.frequency, c.frequency), await n(a, r.gain, c.gain)), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, jt, tt, $e, Te), ns = ((t1)=>(e, s1)=>t1.set(e, s1))(_e), is = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, n){
                        const c = o(t1), h = {
                            ...mt,
                            ...n
                        }, l = i(c, h), u = r(c);
                        super(t1, !1, l, u ? s1() : null), this._Q = e(this, u, l.Q, V, I), this._detune = e(this, u, l.detune, 1200 * Math.log2(V), -1200 * Math.log2(V)), this._frequency = e(this, u, l.frequency, t1.sampleRate / 2, 0), this._gain = e(this, u, l.gain, 40 * Math.log10(V), I), this._nativeBiquadFilterNode = l, a(this, 1);
                    }
                    get detune() {
                        return this._detune;
                    }
                    get frequency() {
                        return this._frequency;
                    }
                    get gain() {
                        return this._gain;
                    }
                    get Q() {
                        return this._Q;
                    }
                    get type() {
                        return this._nativeBiquadFilterNode.type;
                    }
                    set type(t1) {
                        this._nativeBiquadFilterNode.type = t1;
                    }
                    getFrequencyResponse(t1, e, s1) {
                        try {
                            this._nativeBiquadFilterNode.getFrequencyResponse(t1, e, s1);
                        } catch (t1) {
                            if (11 === t1.code) throw n();
                            throw t1;
                        }
                        if (t1.length !== e.length || e.length !== s1.length) throw n();
                    }
                })(Ve, Je, ss, Ct, jt, ke, De, ns), os = ((t1, e)=>(s1, n, i)=>{
                    const o = new Set;
                    return s1.connect = ((i)=>(r, a = 0, c = 0)=>{
                            const h = 0 === o.size;
                            if (e(r)) return i.call(s1, r, a, c), t1(o, [
                                r,
                                a,
                                c
                            ], (t1)=>t1[0] === r && t1[1] === a && t1[2] === c, !0), h && n(), r;
                            i.call(s1, r, a), t1(o, [
                                r,
                                a
                            ], (t1)=>t1[0] === r && t1[1] === a, !0), h && n();
                        })(s1.connect), s1.disconnect = ((t1)=>(n, r, a)=>{
                            const c = o.size > 0;
                            if (void 0 === n) t1.apply(s1), o.clear();
                            else if ("number" == typeof n) {
                                t1.call(s1, n);
                                for (const t1 of o)t1[1] === n && o.delete(t1);
                            } else {
                                e(n) ? t1.call(s1, n, r, a) : t1.call(s1, n, r);
                                for (const t1 of o)t1[0] !== n || void 0 !== r && t1[1] !== r || void 0 !== a && t1[2] !== a || o.delete(t1);
                            }
                            const h = 0 === o.size;
                            c && h && i();
                        })(s1.disconnect), s1;
                })(G, qe), rs = ((t1, e)=>(s1, n)=>{
                    n.channelCount = 1, n.channelCountMode = "explicit", Object.defineProperty(n, "channelCount", {
                        get: ()=>1,
                        set: ()=>{
                            throw t1();
                        }
                    }), Object.defineProperty(n, "channelCountMode", {
                        get: ()=>"explicit",
                        set: ()=>{
                            throw t1();
                        }
                    });
                    const i = s1.createBufferSource();
                    e(n, ()=>{
                        const t1 = n.numberOfInputs;
                        for(let e = 0; e < t1; e += 1)i.connect(n, 0, e);
                    }, ()=>i.disconnect(n));
                })(At, os), as = ((t1, e)=>(s1, n)=>{
                    const i = s1.createChannelMerger(n.numberOfInputs);
                    return null !== t1 && "webkitAudioContext" === t1.name && e(s1, i), qt(i, n), i;
                })(Ee, rs), cs = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        numberOfInputs: r.numberOfInputs
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(as, tt, Te), hs = ((t1, e, s1, n, i)=>class extends t1 {
                    constructor(t1, o){
                        const r = n(t1), a = {
                            ...gt,
                            ...o
                        };
                        super(t1, !1, s1(r, a), i(r) ? e() : null);
                    }
                })(Ve, cs, as, ke, De), ls = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        numberOfOutputs: r.numberOfOutputs
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(Lt, tt, Te), us = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, o){
                        const r = n(t1), a = ((t1)=>({
                                ...t1,
                                channelCount: t1.numberOfOutputs
                            }))({
                            ...vt,
                            ...o
                        });
                        super(t1, !1, s1(r, a), i(r) ? e() : null);
                    }
                })(Ve, ls, Lt, ke, De), ps = ((t1, e, s1, n)=>(i, { offset: o, ...r })=>{
                    const a = i.createBuffer(1, 2, 44100), c = e(i, {
                        buffer: null,
                        channelCount: 2,
                        channelCountMode: "max",
                        channelInterpretation: "speakers",
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        playbackRate: 1
                    }), h = s1(i, {
                        ...r,
                        gain: o
                    }), l = a.getChannelData(0);
                    l[0] = 1, l[1] = 1, c.buffer = a, c.loop = !0;
                    const u = {
                        get bufferSize () {},
                        get channelCount () {
                            return h.channelCount;
                        },
                        set channelCount (t){
                            h.channelCount = t;
                        },
                        get channelCountMode () {
                            return h.channelCountMode;
                        },
                        set channelCountMode (t){
                            h.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return h.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            h.channelInterpretation = t;
                        },
                        get context () {
                            return h.context;
                        },
                        get inputs () {
                            return [];
                        },
                        get numberOfInputs () {
                            return c.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return h.numberOfOutputs;
                        },
                        get offset () {
                            return h.gain;
                        },
                        get onended () {
                            return c.onended;
                        },
                        set onended (t){
                            c.onended = t;
                        },
                        addEventListener: (...t1)=>c.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>c.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>c.removeEventListener(t1[0], t1[1], t1[2]),
                        start (t1 = 0) {
                            c.start.call(c, t1);
                        },
                        stop (t1 = 0) {
                            c.stop.call(c, t1);
                        }
                    };
                    return t1(i, c), n(zt(u, h), ()=>c.connect(h), ()=>c.disconnect(h));
                })(Qe, Ye, Bt, os), ds = ((t1, e, s1, n, i)=>(o, r)=>{
                    if (void 0 === o.createConstantSource) return s1(o, r);
                    const a = o.createConstantSource();
                    return qt(a, r), It(a, r, "offset"), e(n, ()=>n(o)) || Vt(a), e(i, ()=>i(o)) || Nt(a), t1(o, a), a;
                })(Qe, ge, ps, oe, ae), fs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null;
                    return {
                        set start (t){
                            r = t;
                        },
                        set stop (t){
                            a = t;
                        },
                        render (c, h) {
                            const l = o.get(h);
                            return void 0 !== l ? Promise.resolve(l) : (async (c, h)=>{
                                let l = s1(c);
                                const u = M(l, h);
                                if (!u) {
                                    const t1 = {
                                        channelCount: l.channelCount,
                                        channelCountMode: l.channelCountMode,
                                        channelInterpretation: l.channelInterpretation,
                                        offset: l.offset.value
                                    };
                                    l = e(h, t1), null !== r && l.start(r), null !== a && l.stop(a);
                                }
                                return o.set(h, l), u ? await t1(h, c.offset, l.offset) : await n(h, c.offset, l.offset), await i(c, h, l), l;
                            })(c, h);
                        }
                    };
                })(Xe, ds, tt, $e, Te), _s = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...yt,
                            ...r
                        }, h = n(a, c), l = o(a), u = l ? s1() : null;
                        super(t1, !1, h, u), this._constantSourceNodeRenderer = u, this._nativeConstantSourceNode = h, this._offset = e(this, l, h.offset, V, I), this._onended = null;
                    }
                    get offset() {
                        return this._offset;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? r(this, t1) : null;
                        this._nativeConstantSourceNode.onended = e;
                        const s1 = this._nativeConstantSourceNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    start(t1 = 0) {
                        if (this._nativeConstantSourceNode.start(t1), null !== this._constantSourceNodeRenderer && (this._constantSourceNodeRenderer.start = t1), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeConstantSourceNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeConstantSourceNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeConstantSourceNode.stop(t1), null !== this._constantSourceNodeRenderer && (this._constantSourceNodeRenderer.stop = t1);
                    }
                })(Ve, Je, fs, ds, ke, De, ue), ms = ((t1, e)=>(s1, n)=>{
                    const i = s1.createConvolver();
                    if (qt(i, n), n.disableNormalization === i.normalize && (i.normalize = !n.disableNormalization), Rt(i, n, "buffer"), n.channelCount > 2) throw t1();
                    if (e(i, "channelCount", (t1)=>()=>t1.call(i), (e)=>(s1)=>{
                            if (s1 > 2) throw t1();
                            return e.call(i, s1);
                        }), "max" === n.channelCountMode) throw t1();
                    return e(i, "channelCountMode", (t1)=>()=>t1.call(i), (e)=>(s1)=>{
                            if ("max" === s1) throw t1();
                            return e.call(i, s1);
                        }), i;
                })(Zt, ne), gs = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        buffer: r.buffer,
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        disableNormalization: !r.normalize
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), X(r) ? await s1(i, o, r.inputs[0]) : await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(ms, tt, Te), vs = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = n(t1), c = {
                            ...xt,
                            ...r
                        }, h = s1(a, c);
                        super(t1, !1, h, i(a) ? e() : null), this._isBufferNullified = !1, this._nativeConvolverNode = h, null !== c.buffer && o(this, c.buffer.duration);
                    }
                    get buffer() {
                        return this._isBufferNullified ? null : this._nativeConvolverNode.buffer;
                    }
                    set buffer(t1) {
                        if (this._nativeConvolverNode.buffer = t1, null === t1 && null !== this._nativeConvolverNode.buffer) {
                            const t1 = this._nativeConvolverNode.context;
                            this._nativeConvolverNode.buffer = t1.createBuffer(1, 1, t1.sampleRate), this._isBufferNullified = !0, o(this, 0);
                        } else this._isBufferNullified = !1, o(this, null === this._nativeConvolverNode.buffer ? 0 : this._nativeConvolverNode.buffer.duration);
                    }
                    get normalize() {
                        return this._nativeConvolverNode.normalize;
                    }
                    set normalize(t1) {
                        this._nativeConvolverNode.normalize = t1;
                    }
                })(Ve, gs, ms, ke, De, ns), ys = ((t1, e, s1, n, i)=>(o)=>{
                    const r = new WeakMap;
                    return {
                        render (a, c) {
                            const h = r.get(c);
                            return void 0 !== h ? Promise.resolve(h) : (async (a, c)=>{
                                let h = s1(a);
                                const l = M(h, c);
                                if (!l) {
                                    const t1 = {
                                        channelCount: h.channelCount,
                                        channelCountMode: h.channelCountMode,
                                        channelInterpretation: h.channelInterpretation,
                                        delayTime: h.delayTime.value,
                                        maxDelayTime: o
                                    };
                                    h = e(c, t1);
                                }
                                return r.set(c, h), l ? await t1(c, a.delayTime, h.delayTime) : await n(c, a.delayTime, h.delayTime), await i(a, c, h), h;
                            })(a, c);
                        }
                    };
                })(Xe, Wt, tt, $e, Te), xs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, a){
                        const c = i(t1), h = {
                            ...bt,
                            ...a
                        }, l = n(c, h), u = o(c);
                        super(t1, !1, l, u ? s1(h.maxDelayTime) : null), this._delayTime = e(this, u, l.delayTime), r(this, h.maxDelayTime);
                    }
                    get delayTime() {
                        return this._delayTime;
                    }
                })(Ve, Je, ys, Wt, ke, De, ns), ws = ((t1)=>(e, s1)=>{
                    const n = e.createDynamicsCompressor();
                    if (qt(n, s1), s1.channelCount > 2) throw t1();
                    if ("max" === s1.channelCountMode) throw t1();
                    return It(n, s1, "attack"), It(n, s1, "knee"), It(n, s1, "ratio"), It(n, s1, "release"), It(n, s1, "threshold"), n;
                })(Zt), bs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        attack: c.attack.value,
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        knee: c.knee.value,
                                        ratio: c.ratio.value,
                                        release: c.release.value,
                                        threshold: c.threshold.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? (await t1(a, r.attack, c.attack), await t1(a, r.knee, c.knee), await t1(a, r.ratio, c.ratio), await t1(a, r.release, c.release), await t1(a, r.threshold, c.threshold)) : (await n(a, r.attack, c.attack), await n(a, r.knee, c.knee), await n(a, r.ratio, c.ratio), await n(a, r.release, c.release), await n(a, r.threshold, c.threshold)), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, ws, tt, $e, Te), Ts = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, i){
                        const c = o(t1), h = {
                            ...St,
                            ...i
                        }, l = n(c, h), u = r(c);
                        super(t1, !1, l, u ? s1() : null), this._attack = e(this, u, l.attack), this._knee = e(this, u, l.knee), this._nativeDynamicsCompressorNode = l, this._ratio = e(this, u, l.ratio), this._release = e(this, u, l.release), this._threshold = e(this, u, l.threshold), a(this, .006);
                    }
                    get attack() {
                        return this._attack;
                    }
                    get channelCount() {
                        return this._nativeDynamicsCompressorNode.channelCount;
                    }
                    set channelCount(t1) {
                        const e = this._nativeDynamicsCompressorNode.channelCount;
                        if (this._nativeDynamicsCompressorNode.channelCount = t1, t1 > 2) throw this._nativeDynamicsCompressorNode.channelCount = e, i();
                    }
                    get channelCountMode() {
                        return this._nativeDynamicsCompressorNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        const e = this._nativeDynamicsCompressorNode.channelCountMode;
                        if (this._nativeDynamicsCompressorNode.channelCountMode = t1, "max" === t1) throw this._nativeDynamicsCompressorNode.channelCountMode = e, i();
                    }
                    get knee() {
                        return this._knee;
                    }
                    get ratio() {
                        return this._ratio;
                    }
                    get reduction() {
                        return "number" == typeof this._nativeDynamicsCompressorNode.reduction.value ? this._nativeDynamicsCompressorNode.reduction.value : this._nativeDynamicsCompressorNode.reduction;
                    }
                    get release() {
                        return this._release;
                    }
                    get threshold() {
                        return this._threshold;
                    }
                })(Ve, Je, bs, ws, Zt, ke, De, ns), Ss = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        gain: c.gain.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? await t1(a, r.gain, c.gain) : await n(a, r.gain, c.gain), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, Bt, tt, $e, Te), ks = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...kt,
                            ...r
                        }, h = n(a, c), l = o(a);
                        super(t1, !1, h, l ? s1() : null), this._gain = e(this, l, h.gain, V, I);
                    }
                    get gain() {
                        return this._gain;
                    }
                })(Ve, Je, Ss, Bt, ke, De), As = ((t1, e, s1, n)=>(i, o, { channelCount: r, channelCountMode: a, channelInterpretation: c, feedback: h, feedforward: l })=>{
                    const u = Pt(o, i.sampleRate), p = h instanceof Float64Array ? h : new Float64Array(h), d = l instanceof Float64Array ? l : new Float64Array(l), f = p.length, _ = d.length, m = Math.min(f, _);
                    if (0 === f || f > 20) throw n();
                    if (0 === p[0]) throw e();
                    if (0 === _ || _ > 20) throw n();
                    if (0 === d[0]) throw e();
                    if (1 !== p[0]) {
                        for(let t1 = 0; t1 < _; t1 += 1)d[t1] /= p[0];
                        for(let t1 = 1; t1 < f; t1 += 1)p[t1] /= p[0];
                    }
                    const g = s1(i, u, r, r);
                    g.channelCount = r, g.channelCountMode = a, g.channelInterpretation = c;
                    const v = [], y = [], x = [];
                    for(let t1 = 0; t1 < r; t1 += 1){
                        v.push(0);
                        const t1 = new Float32Array(32), e = new Float32Array(32);
                        t1.fill(0), e.fill(0), y.push(t1), x.push(e);
                    }
                    g.onaudioprocess = (t1)=>{
                        const e = t1.inputBuffer, s1 = t1.outputBuffer, n = e.numberOfChannels;
                        for(let t1 = 0; t1 < n; t1 += 1){
                            const n = e.getChannelData(t1), i = s1.getChannelData(t1);
                            v[t1] = Ot(p, f, d, _, m, y[t1], x[t1], v[t1], 32, n, i);
                        }
                    };
                    const w = i.sampleRate / 2;
                    return zt({
                        get bufferSize () {
                            return u;
                        },
                        get channelCount () {
                            return g.channelCount;
                        },
                        set channelCount (t){
                            g.channelCount = t;
                        },
                        get channelCountMode () {
                            return g.channelCountMode;
                        },
                        set channelCountMode (t){
                            g.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return g.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            g.channelInterpretation = t;
                        },
                        get context () {
                            return g.context;
                        },
                        get inputs () {
                            return [
                                g
                            ];
                        },
                        get numberOfInputs () {
                            return g.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return g.numberOfOutputs;
                        },
                        addEventListener: (...t1)=>g.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>g.dispatchEvent(t1[0]),
                        getFrequencyResponse (e, s1, n) {
                            if (e.length !== s1.length || s1.length !== n.length) throw t1();
                            const i = e.length;
                            for(let t1 = 0; t1 < i; t1 += 1){
                                const i = -Math.PI * (e[t1] / w), o = [
                                    Math.cos(i),
                                    Math.sin(i)
                                ], r = Ut(Gt(d, o), Gt(p, o));
                                s1[t1] = Math.sqrt(r[0] * r[0] + r[1] * r[1]), n[t1] = Math.atan2(r[1], r[0]);
                            }
                        },
                        removeEventListener: (...t1)=>g.removeEventListener(t1[0], t1[1], t1[2])
                    }, g);
                })(Ct, At, Qt, Zt), Cs = ((t1, e, s1, n)=>(i)=>t1(Et, ()=>Et(i)) ? Promise.resolve(t1(n, n)).then((t1)=>{
                        if (!t1) {
                            const t1 = s1(i, 512, 0, 1);
                            i.oncomplete = ()=>{
                                t1.onaudioprocess = null, t1.disconnect();
                            }, t1.onaudioprocess = ()=>i.currentTime, t1.connect(i.destination);
                        }
                        return i.startRendering();
                    }) : new Promise((t1)=>{
                        const s1 = e(i, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            gain: 0
                        });
                        i.oncomplete = (e)=>{
                            s1.disconnect(), t1(e.renderedBuffer);
                        }, s1.connect(i.destination), i.startRendering();
                    }))(ge, Bt, Qt, ((t1, e)=>()=>{
                    if (null === e) return Promise.resolve(!1);
                    const s1 = new e(1, 1, 44100), n = t1(s1, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    });
                    return new Promise((t1)=>{
                        s1.oncomplete = ()=>{
                            n.disconnect(), t1(0 !== s1.currentTime);
                        }, s1.startRendering();
                    });
                })(Bt, Ce)), Ds = ((t1, e, s1, n, i)=>(o, r)=>{
                    const a = new WeakMap;
                    let c = null;
                    return {
                        render (h, l) {
                            const u = a.get(l);
                            return void 0 !== u ? Promise.resolve(u) : (async (h, l)=>{
                                let u = null, p = e(h);
                                const d = M(p, l);
                                if (void 0 === l.createIIRFilter ? u = t1(l, {
                                    buffer: null,
                                    channelCount: 2,
                                    channelCountMode: "max",
                                    channelInterpretation: "speakers",
                                    loop: !1,
                                    loopEnd: 0,
                                    loopStart: 0,
                                    playbackRate: 1
                                }) : d || (p = l.createIIRFilter(r, o)), a.set(l, null === u ? p : u), null !== u) {
                                    if (null === c) {
                                        if (null === s1) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = new s1(h.context.destination.channelCount, h.context.length, l.sampleRate);
                                        c = (async ()=>(await n(h, t1, t1.destination), ((t1, e, s1, n)=>{
                                                const i = s1 instanceof Float64Array ? s1 : new Float64Array(s1), o = n instanceof Float64Array ? n : new Float64Array(n), r = i.length, a = o.length, c = Math.min(r, a);
                                                if (1 !== i[0]) {
                                                    for(let t1 = 0; t1 < r; t1 += 1)o[t1] /= i[0];
                                                    for(let t1 = 1; t1 < a; t1 += 1)i[t1] /= i[0];
                                                }
                                                const h = new Float32Array(32), l = new Float32Array(32), u = e.createBuffer(t1.numberOfChannels, t1.length, t1.sampleRate), p = t1.numberOfChannels;
                                                for(let e = 0; e < p; e += 1){
                                                    const s1 = t1.getChannelData(e), n = u.getChannelData(e);
                                                    h.fill(0), l.fill(0), Ot(i, r, o, a, c, h, l, 0, 32, s1, n);
                                                }
                                                return u;
                                            })(await i(t1), l, o, r)))();
                                    }
                                    const t1 = await c;
                                    return u.buffer = t1, u.start(0), u;
                                }
                                return await n(h, l, p), p;
                            })(h, l);
                        }
                    };
                })(Ye, tt, Ce, Te, Cs), Os = ((t1)=>(e, s1, n)=>{
                    if (void 0 === e.createIIRFilter) return t1(e, s1, n);
                    const i = e.createIIRFilter(n.feedforward, n.feedback);
                    return qt(i, n), i;
                })(As), Ms = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = n(t1), c = i(a), h = {
                            ...Dt,
                            ...r
                        }, l = e(a, c ? null : t1.baseLatency, h);
                        super(t1, !1, l, c ? s1(h.feedback, h.feedforward) : null), ((t1)=>{
                            var e;
                            t1.getFrequencyResponse = (e = t1.getFrequencyResponse, (s1, n, i)=>{
                                if (s1.length !== n.length || n.length !== i.length) throw Ct();
                                return e.call(t1, s1, n, i);
                            });
                        })(l), this._nativeIIRFilterNode = l, o(this, 1);
                    }
                    getFrequencyResponse(t1, e, s1) {
                        return this._nativeIIRFilterNode.getFrequencyResponse(t1, e, s1);
                    }
                })(Ve, Os, Ds, ke, De, ns), Es = ((t1, e, s1, n, i, o, r, a)=>(c, h)=>{
                    const l = h.listener, { forwardX: u, forwardY: p, forwardZ: d, positionX: f, positionY: _, positionZ: m, upX: g, upY: v, upZ: y } = void 0 === l.forwardX ? (()=>{
                        const u = new Float32Array(1), p = e(h, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "speakers",
                            numberOfInputs: 9
                        }), d = r(h);
                        let f = !1, _ = [
                            0,
                            0,
                            -1,
                            0,
                            1,
                            0
                        ], m = [
                            0,
                            0,
                            0
                        ];
                        const g = ()=>{
                            if (f) return;
                            f = !0;
                            const t1 = n(h, 256, 9, 0);
                            t1.onaudioprocess = ({ inputBuffer: t1 })=>{
                                const e = [
                                    o(t1, u, 0),
                                    o(t1, u, 1),
                                    o(t1, u, 2),
                                    o(t1, u, 3),
                                    o(t1, u, 4),
                                    o(t1, u, 5)
                                ];
                                e.some((t1, e)=>t1 !== _[e]) && (l.setOrientation(...e), _ = e);
                                const s1 = [
                                    o(t1, u, 6),
                                    o(t1, u, 7),
                                    o(t1, u, 8)
                                ];
                                s1.some((t1, e)=>t1 !== m[e]) && (l.setPosition(...s1), m = s1);
                            }, p.connect(t1);
                        }, v = (t1)=>(e)=>{
                                e !== _[t1] && (_[t1] = e, l.setOrientation(..._));
                            }, y = (t1)=>(e)=>{
                                e !== m[t1] && (m[t1] = e, l.setPosition(...m));
                            }, x = (e, n, o)=>{
                            const r = s1(h, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                offset: n
                            });
                            r.connect(p, 0, e), r.start(), Object.defineProperty(r.offset, "defaultValue", {
                                get: ()=>n
                            });
                            const l = t1({
                                context: c
                            }, d, r.offset, V, I);
                            var u, f, _, m, v, y, x;
                            return a(l, "value", (t1)=>()=>t1.call(l), (t1)=>(e)=>{
                                    try {
                                        t1.call(l, e);
                                    } catch (t1) {
                                        if (9 !== t1.code) throw t1;
                                    }
                                    g(), d && o(e);
                                }), l.cancelAndHoldAtTime = (u = l.cancelAndHoldAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = u.apply(l, t1);
                                return g(), e;
                            }), l.cancelScheduledValues = (f = l.cancelScheduledValues, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = f.apply(l, t1);
                                return g(), e;
                            }), l.exponentialRampToValueAtTime = (_ = l.exponentialRampToValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = _.apply(l, t1);
                                return g(), e;
                            }), l.linearRampToValueAtTime = (m = l.linearRampToValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = m.apply(l, t1);
                                return g(), e;
                            }), l.setTargetAtTime = (v = l.setTargetAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = v.apply(l, t1);
                                return g(), e;
                            }), l.setValueAtTime = (y = l.setValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = y.apply(l, t1);
                                return g(), e;
                            }), l.setValueCurveAtTime = (x = l.setValueCurveAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = x.apply(l, t1);
                                return g(), e;
                            }), l;
                        };
                        return {
                            forwardX: x(0, 0, v(0)),
                            forwardY: x(1, 0, v(1)),
                            forwardZ: x(2, -1, v(2)),
                            positionX: x(6, 0, y(0)),
                            positionY: x(7, 0, y(1)),
                            positionZ: x(8, 0, y(2)),
                            upX: x(3, 0, v(3)),
                            upY: x(4, 1, v(4)),
                            upZ: x(5, 0, v(5))
                        };
                    })() : l;
                    return {
                        get forwardX () {
                            return u;
                        },
                        get forwardY () {
                            return p;
                        },
                        get forwardZ () {
                            return d;
                        },
                        get positionX () {
                            return f;
                        },
                        get positionY () {
                            return _;
                        },
                        get positionZ () {
                            return m;
                        },
                        get upX () {
                            return g;
                        },
                        get upY () {
                            return v;
                        },
                        get upZ () {
                            return y;
                        }
                    };
                })(Je, as, ds, Qt, Zt, ee, De, ne), Rs = new WeakMap, qs = ((t1, e, s1, n, i, o)=>class extends s1 {
                    constructor(s1, o){
                        super(s1), this._nativeContext = s1, u.set(this, s1), n(s1) && i.set(s1, new Set), this._destination = new t1(this, o), this._listener = e(this, s1), this._onstatechange = null;
                    }
                    get currentTime() {
                        return this._nativeContext.currentTime;
                    }
                    get destination() {
                        return this._destination;
                    }
                    get listener() {
                        return this._listener;
                    }
                    get onstatechange() {
                        return this._onstatechange;
                    }
                    set onstatechange(t1) {
                        const e = "function" == typeof t1 ? o(this, t1) : null;
                        this._nativeContext.onstatechange = e;
                        const s1 = this._nativeContext.onstatechange;
                        this._onstatechange = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get sampleRate() {
                        return this._nativeContext.sampleRate;
                    }
                    get state() {
                        return this._nativeContext.state;
                    }
                })(es, Es, Me, De, Rs, ue), Fs = ((t1, e, s1, n, i, o)=>(r, a)=>{
                    const c = r.createOscillator();
                    return qt(c, a), It(c, a, "detune"), It(c, a, "frequency"), void 0 !== a.periodicWave ? c.setPeriodicWave(a.periodicWave) : Rt(c, a, "type"), e(s1, ()=>s1(r)) || Vt(c), e(n, ()=>n(r)) || o(c, r), e(i, ()=>i(r)) || Nt(c), t1(r, c), c;
                })(Qe, ge, oe, re, ae, le), Is = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null, c = null;
                    return {
                        set periodicWave (t){
                            r = t;
                        },
                        set start (t){
                            a = t;
                        },
                        set stop (t){
                            c = t;
                        },
                        render (h, l) {
                            const u = o.get(l);
                            return void 0 !== u ? Promise.resolve(u) : (async (h, l)=>{
                                let u = s1(h);
                                const p = M(u, l);
                                if (!p) {
                                    const t1 = {
                                        channelCount: u.channelCount,
                                        channelCountMode: u.channelCountMode,
                                        channelInterpretation: u.channelInterpretation,
                                        detune: u.detune.value,
                                        frequency: u.frequency.value,
                                        periodicWave: null === r ? void 0 : r,
                                        type: u.type
                                    };
                                    u = e(l, t1), null !== a && u.start(a), null !== c && u.stop(c);
                                }
                                return o.set(l, u), p ? (await t1(l, h.detune, u.detune), await t1(l, h.frequency, u.frequency)) : (await n(l, h.detune, u.detune), await n(l, h.frequency, u.frequency)), await i(h, l, u), u;
                            })(h, l);
                        }
                    };
                })(Xe, Fs, tt, $e, Te), Vs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...Yt,
                            ...r
                        }, h = s1(a, c), l = o(a), u = l ? n() : null, p = t1.sampleRate / 2;
                        super(t1, !1, h, u), this._detune = e(this, l, h.detune, 153600, -153600), this._frequency = e(this, l, h.frequency, p, -p), this._nativeOscillatorNode = h, this._onended = null, this._oscillatorNodeRenderer = u, null !== this._oscillatorNodeRenderer && void 0 !== c.periodicWave && (this._oscillatorNodeRenderer.periodicWave = c.periodicWave);
                    }
                    get detune() {
                        return this._detune;
                    }
                    get frequency() {
                        return this._frequency;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? r(this, t1) : null;
                        this._nativeOscillatorNode.onended = e;
                        const s1 = this._nativeOscillatorNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get type() {
                        return this._nativeOscillatorNode.type;
                    }
                    set type(t1) {
                        this._nativeOscillatorNode.type = t1, null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.periodicWave = null);
                    }
                    setPeriodicWave(t1) {
                        this._nativeOscillatorNode.setPeriodicWave(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.periodicWave = t1);
                    }
                    start(t1 = 0) {
                        if (this._nativeOscillatorNode.start(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.start = t1), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeOscillatorNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeOscillatorNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeOscillatorNode.stop(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.stop = t1);
                    }
                })(Ve, Je, Fs, Is, ke, De, ue), Ns = ((t1)=>(e, s1)=>{
                    const n = t1(e, {
                        buffer: null,
                        channelCount: 2,
                        channelCountMode: "max",
                        channelInterpretation: "speakers",
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        playbackRate: 1
                    }), i = e.createBuffer(1, 2, 44100);
                    return n.buffer = i, n.loop = !0, n.connect(s1), n.start(), ()=>{
                        n.stop(), n.disconnect(s1);
                    };
                })(Ye), Ps = ((t1, e, s1, n, i)=>(o, { curve: r, oversample: a, ...c })=>{
                    const h = o.createWaveShaper(), l = o.createWaveShaper();
                    qt(h, c), qt(l, c);
                    const u = s1(o, {
                        ...c,
                        gain: 1
                    }), p = s1(o, {
                        ...c,
                        gain: -1
                    }), d = s1(o, {
                        ...c,
                        gain: 1
                    }), f = s1(o, {
                        ...c,
                        gain: -1
                    });
                    let _ = null, m = !1, g = null;
                    const v = {
                        get bufferSize () {},
                        get channelCount () {
                            return h.channelCount;
                        },
                        set channelCount (t){
                            u.channelCount = t, p.channelCount = t, h.channelCount = t, d.channelCount = t, l.channelCount = t, f.channelCount = t;
                        },
                        get channelCountMode () {
                            return h.channelCountMode;
                        },
                        set channelCountMode (t){
                            u.channelCountMode = t, p.channelCountMode = t, h.channelCountMode = t, d.channelCountMode = t, l.channelCountMode = t, f.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return h.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            u.channelInterpretation = t, p.channelInterpretation = t, h.channelInterpretation = t, d.channelInterpretation = t, l.channelInterpretation = t, f.channelInterpretation = t;
                        },
                        get context () {
                            return h.context;
                        },
                        get curve () {
                            return g;
                        },
                        set curve (s){
                            if (null !== s && s.length < 2) throw e();
                            if (null === s) h.curve = s, l.curve = s;
                            else {
                                const t1 = s.length, e = new Float32Array(t1 + 2 - t1 % 2), n = new Float32Array(t1 + 2 - t1 % 2);
                                e[0] = s[0], n[0] = -s[t1 - 1];
                                const i = Math.ceil((t1 + 1) / 2), o = (t1 + 1) / 2 - 1;
                                for(let r = 1; r < i; r += 1){
                                    const a = r / i * o, c = Math.floor(a), h = Math.ceil(a);
                                    e[r] = c === h ? s[c] : (1 - (a - c)) * s[c] + (1 - (h - a)) * s[h], n[r] = c === h ? -s[t1 - 1 - c] : -(1 - (a - c)) * s[t1 - 1 - c] - (1 - (h - a)) * s[t1 - 1 - h];
                                }
                                e[i] = t1 % 2 == 1 ? s[i - 1] : (s[i - 2] + s[i - 1]) / 2, h.curve = e, l.curve = n;
                            }
                            g = s, m && (n(g) && null === _ ? _ = t1(o, u) : null !== _ && (_(), _ = null));
                        },
                        get inputs () {
                            return [
                                u
                            ];
                        },
                        get numberOfInputs () {
                            return h.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return h.numberOfOutputs;
                        },
                        get oversample () {
                            return h.oversample;
                        },
                        set oversample (t){
                            h.oversample = t, l.oversample = t;
                        },
                        addEventListener: (...t1)=>u.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>u.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>u.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    return null !== r && (v.curve = r instanceof Float32Array ? r : new Float32Array(r)), a !== v.oversample && (v.oversample = a), i(zt(v, d), ()=>{
                        u.connect(h).connect(d), u.connect(p).connect(l).connect(f).connect(d), m = !0, n(g) && (_ = t1(o, u));
                    }, ()=>{
                        u.disconnect(h), h.disconnect(d), u.disconnect(p), p.disconnect(l), l.disconnect(f), f.disconnect(d), m = !1, null !== _ && (_(), _ = null);
                    });
                })(Ns, At, Bt, se, os), js = ((t1, e, s1, n, i, o, r)=>(a, c)=>{
                    const h = a.createWaveShaper();
                    if (null !== o && "webkitAudioContext" === o.name && void 0 === a.createGain().gain.automationRate) return s1(a, c);
                    qt(h, c);
                    const l = null === c.curve || c.curve instanceof Float32Array ? c.curve : new Float32Array(c.curve);
                    if (null !== l && l.length < 2) throw e();
                    Rt(h, {
                        curve: l
                    }, "curve"), Rt(h, c, "oversample");
                    let u = null, p = !1;
                    return r(h, "curve", (t1)=>()=>t1.call(h), (e)=>(s1)=>(e.call(h, s1), p && (n(s1) && null === u ? u = t1(a, h) : n(s1) || null === u || (u(), u = null)), s1)), i(h, ()=>{
                        p = !0, n(h.curve) && (u = t1(a, h));
                    }, ()=>{
                        p = !1, null !== u && (u(), u = null);
                    });
                })(Ns, At, Ps, se, os, Ee, ne), Ls = ((t1, e, s1, n, i, o, r, a, c, h)=>(l, { coneInnerAngle: u, coneOuterAngle: p, coneOuterGain: d, distanceModel: f, maxDistance: _, orientationX: m, orientationY: g, orientationZ: v, panningModel: y, positionX: x, positionY: w, positionZ: b, refDistance: T, rolloffFactor: S, ...k })=>{
                    const A = l.createPanner();
                    if (k.channelCount > 2) throw r();
                    if ("max" === k.channelCountMode) throw r();
                    qt(A, k);
                    const C = {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete"
                    }, D = s1(l, {
                        ...C,
                        channelInterpretation: "speakers",
                        numberOfInputs: 6
                    }), O = n(l, {
                        ...k,
                        gain: 1
                    }), M = n(l, {
                        ...C,
                        gain: 1
                    }), E = n(l, {
                        ...C,
                        gain: 0
                    }), R = n(l, {
                        ...C,
                        gain: 0
                    }), q = n(l, {
                        ...C,
                        gain: 0
                    }), F = n(l, {
                        ...C,
                        gain: 0
                    }), I = n(l, {
                        ...C,
                        gain: 0
                    }), V = i(l, 256, 6, 1), N = o(l, {
                        ...C,
                        curve: new Float32Array([
                            1,
                            1
                        ]),
                        oversample: "none"
                    });
                    let P = [
                        m,
                        g,
                        v
                    ], j = [
                        x,
                        w,
                        b
                    ];
                    const L = new Float32Array(1);
                    V.onaudioprocess = ({ inputBuffer: t1 })=>{
                        const e = [
                            c(t1, L, 0),
                            c(t1, L, 1),
                            c(t1, L, 2)
                        ];
                        e.some((t1, e)=>t1 !== P[e]) && (A.setOrientation(...e), P = e);
                        const s1 = [
                            c(t1, L, 3),
                            c(t1, L, 4),
                            c(t1, L, 5)
                        ];
                        s1.some((t1, e)=>t1 !== j[e]) && (A.setPosition(...s1), j = s1);
                    }, Object.defineProperty(E.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(R.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(q.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(F.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(I.gain, "defaultValue", {
                        get: ()=>0
                    });
                    const z = {
                        get bufferSize () {},
                        get channelCount () {
                            return A.channelCount;
                        },
                        set channelCount (t){
                            if (t > 2) throw r();
                            O.channelCount = t, A.channelCount = t;
                        },
                        get channelCountMode () {
                            return A.channelCountMode;
                        },
                        set channelCountMode (t){
                            if ("max" === t) throw r();
                            O.channelCountMode = t, A.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return A.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            O.channelInterpretation = t, A.channelInterpretation = t;
                        },
                        get coneInnerAngle () {
                            return A.coneInnerAngle;
                        },
                        set coneInnerAngle (t){
                            A.coneInnerAngle = t;
                        },
                        get coneOuterAngle () {
                            return A.coneOuterAngle;
                        },
                        set coneOuterAngle (t){
                            A.coneOuterAngle = t;
                        },
                        get coneOuterGain () {
                            return A.coneOuterGain;
                        },
                        set coneOuterGain (t){
                            if (t < 0 || t > 1) throw e();
                            A.coneOuterGain = t;
                        },
                        get context () {
                            return A.context;
                        },
                        get distanceModel () {
                            return A.distanceModel;
                        },
                        set distanceModel (t){
                            A.distanceModel = t;
                        },
                        get inputs () {
                            return [
                                O
                            ];
                        },
                        get maxDistance () {
                            return A.maxDistance;
                        },
                        set maxDistance (t){
                            if (t < 0) throw new RangeError;
                            A.maxDistance = t;
                        },
                        get numberOfInputs () {
                            return A.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return A.numberOfOutputs;
                        },
                        get orientationX () {
                            return M.gain;
                        },
                        get orientationY () {
                            return E.gain;
                        },
                        get orientationZ () {
                            return R.gain;
                        },
                        get panningModel () {
                            return A.panningModel;
                        },
                        set panningModel (t){
                            A.panningModel = t;
                        },
                        get positionX () {
                            return q.gain;
                        },
                        get positionY () {
                            return F.gain;
                        },
                        get positionZ () {
                            return I.gain;
                        },
                        get refDistance () {
                            return A.refDistance;
                        },
                        set refDistance (t){
                            if (t < 0) throw new RangeError;
                            A.refDistance = t;
                        },
                        get rolloffFactor () {
                            return A.rolloffFactor;
                        },
                        set rolloffFactor (t){
                            if (t < 0) throw new RangeError;
                            A.rolloffFactor = t;
                        },
                        addEventListener: (...t1)=>O.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>O.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>O.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    return u !== z.coneInnerAngle && (z.coneInnerAngle = u), p !== z.coneOuterAngle && (z.coneOuterAngle = p), d !== z.coneOuterGain && (z.coneOuterGain = d), f !== z.distanceModel && (z.distanceModel = f), _ !== z.maxDistance && (z.maxDistance = _), m !== z.orientationX.value && (z.orientationX.value = m), g !== z.orientationY.value && (z.orientationY.value = g), v !== z.orientationZ.value && (z.orientationZ.value = v), y !== z.panningModel && (z.panningModel = y), x !== z.positionX.value && (z.positionX.value = x), w !== z.positionY.value && (z.positionY.value = w), b !== z.positionZ.value && (z.positionZ.value = b), T !== z.refDistance && (z.refDistance = T), S !== z.rolloffFactor && (z.rolloffFactor = S), 1 === P[0] && 0 === P[1] && 0 === P[2] || A.setOrientation(...P), 0 === j[0] && 0 === j[1] && 0 === j[2] || A.setPosition(...j), h(zt(z, A), ()=>{
                        O.connect(A), t1(O, N, 0, 0), N.connect(M).connect(D, 0, 0), N.connect(E).connect(D, 0, 1), N.connect(R).connect(D, 0, 2), N.connect(q).connect(D, 0, 3), N.connect(F).connect(D, 0, 4), N.connect(I).connect(D, 0, 5), D.connect(V).connect(l.destination);
                    }, ()=>{
                        O.disconnect(A), a(O, N, 0, 0), N.disconnect(M), M.disconnect(D), N.disconnect(E), E.disconnect(D), N.disconnect(R), R.disconnect(D), N.disconnect(q), q.disconnect(D), N.disconnect(F), F.disconnect(D), N.disconnect(I), I.disconnect(D), D.disconnect(V), V.disconnect(l.destination);
                    });
                })(Y, At, as, Bt, Qt, js, Zt, K, ee, os), zs = ((t1)=>(e, s1)=>{
                    const n = e.createPanner();
                    return void 0 === n.orientationX ? t1(e, s1) : (qt(n, s1), It(n, s1, "orientationX"), It(n, s1, "orientationY"), It(n, s1, "orientationZ"), It(n, s1, "positionX"), It(n, s1, "positionY"), It(n, s1, "positionZ"), Rt(n, s1, "coneInnerAngle"), Rt(n, s1, "coneOuterAngle"), Rt(n, s1, "coneOuterGain"), Rt(n, s1, "distanceModel"), Rt(n, s1, "maxDistance"), Rt(n, s1, "panningModel"), Rt(n, s1, "refDistance"), Rt(n, s1, "rolloffFactor"), n);
                })(Ls), Ws = ((t1, e, s1, n, i, o, r, a, c, h)=>()=>{
                    const l = new WeakMap;
                    let u = null;
                    return {
                        render (p, d) {
                            const f = l.get(d);
                            return void 0 !== f ? Promise.resolve(f) : (async (p, d)=>{
                                let f = null, _ = o(p);
                                const m = {
                                    channelCount: _.channelCount,
                                    channelCountMode: _.channelCountMode,
                                    channelInterpretation: _.channelInterpretation
                                }, g = {
                                    ...m,
                                    coneInnerAngle: _.coneInnerAngle,
                                    coneOuterAngle: _.coneOuterAngle,
                                    coneOuterGain: _.coneOuterGain,
                                    distanceModel: _.distanceModel,
                                    maxDistance: _.maxDistance,
                                    panningModel: _.panningModel,
                                    refDistance: _.refDistance,
                                    rolloffFactor: _.rolloffFactor
                                }, v = M(_, d);
                                if ("bufferSize" in _) f = n(d, {
                                    ...m,
                                    gain: 1
                                });
                                else if (!v) {
                                    const t1 = {
                                        ...g,
                                        orientationX: _.orientationX.value,
                                        orientationY: _.orientationY.value,
                                        orientationZ: _.orientationZ.value,
                                        positionX: _.positionX.value,
                                        positionY: _.positionY.value,
                                        positionZ: _.positionZ.value
                                    };
                                    _ = i(d, t1);
                                }
                                if (l.set(d, null === f ? _ : f), null !== f) {
                                    if (null === u) {
                                        if (null === r) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = new r(6, p.context.length, d.sampleRate), n = e(t1, {
                                            channelCount: 1,
                                            channelCountMode: "explicit",
                                            channelInterpretation: "speakers",
                                            numberOfInputs: 6
                                        });
                                        n.connect(t1.destination), u = (async ()=>{
                                            const e = await Promise.all([
                                                p.orientationX,
                                                p.orientationY,
                                                p.orientationZ,
                                                p.positionX,
                                                p.positionY,
                                                p.positionZ
                                            ].map(async (e, n)=>{
                                                const i = s1(t1, {
                                                    channelCount: 1,
                                                    channelCountMode: "explicit",
                                                    channelInterpretation: "discrete",
                                                    offset: 0 === n ? 1 : 0
                                                });
                                                return await a(t1, e, i.offset), i;
                                            }));
                                            for(let t1 = 0; t1 < 6; t1 += 1)e[t1].connect(n, 0, t1), e[t1].start(0);
                                            return h(t1);
                                        })();
                                    }
                                    const t1 = await u, o = n(d, {
                                        ...m,
                                        gain: 1
                                    });
                                    await c(p, d, o);
                                    const l = [];
                                    for(let e = 0; e < t1.numberOfChannels; e += 1)l.push(t1.getChannelData(e));
                                    let _ = [
                                        l[0][0],
                                        l[1][0],
                                        l[2][0]
                                    ], v = [
                                        l[3][0],
                                        l[4][0],
                                        l[5][0]
                                    ], y = n(d, {
                                        ...m,
                                        gain: 1
                                    }), x = i(d, {
                                        ...g,
                                        orientationX: _[0],
                                        orientationY: _[1],
                                        orientationZ: _[2],
                                        positionX: v[0],
                                        positionY: v[1],
                                        positionZ: v[2]
                                    });
                                    o.connect(y).connect(x.inputs[0]), x.connect(f);
                                    for(let e = 128; e < t1.length; e += 128){
                                        const t1 = [
                                            l[0][e],
                                            l[1][e],
                                            l[2][e]
                                        ], s1 = [
                                            l[3][e],
                                            l[4][e],
                                            l[5][e]
                                        ];
                                        if (t1.some((t1, e)=>t1 !== _[e]) || s1.some((t1, e)=>t1 !== v[e])) {
                                            _ = t1, v = s1;
                                            const r = e / d.sampleRate;
                                            y.gain.setValueAtTime(0, r), y = n(d, {
                                                ...m,
                                                gain: 0
                                            }), x = i(d, {
                                                ...g,
                                                orientationX: _[0],
                                                orientationY: _[1],
                                                orientationZ: _[2],
                                                positionX: v[0],
                                                positionY: v[1],
                                                positionZ: v[2]
                                            }), y.gain.setValueAtTime(1, r), o.connect(y).connect(x.inputs[0]), x.connect(f);
                                        }
                                    }
                                    return f;
                                }
                                return v ? (await t1(d, p.orientationX, _.orientationX), await t1(d, p.orientationY, _.orientationY), await t1(d, p.orientationZ, _.orientationZ), await t1(d, p.positionX, _.positionX), await t1(d, p.positionY, _.positionY), await t1(d, p.positionZ, _.positionZ)) : (await a(d, p.orientationX, _.orientationX), await a(d, p.orientationY, _.orientationY), await a(d, p.orientationZ, _.orientationZ), await a(d, p.positionX, _.positionX), await a(d, p.positionY, _.positionY), await a(d, p.positionZ, _.positionZ)), X(_) ? await c(p, d, _.inputs[0]) : await c(p, d, _), _;
                            })(p, d);
                        }
                    };
                })(Xe, as, ds, Bt, zs, tt, Ce, $e, Te, Cs), Bs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, a){
                        const c = i(t1), h = {
                            ...$t,
                            ...a
                        }, l = s1(c, h), u = o(c);
                        super(t1, !1, l, u ? n() : null), this._nativePannerNode = l, this._orientationX = e(this, u, l.orientationX, V, I), this._orientationY = e(this, u, l.orientationY, V, I), this._orientationZ = e(this, u, l.orientationZ, V, I), this._positionX = e(this, u, l.positionX, V, I), this._positionY = e(this, u, l.positionY, V, I), this._positionZ = e(this, u, l.positionZ, V, I), r(this, 1);
                    }
                    get coneInnerAngle() {
                        return this._nativePannerNode.coneInnerAngle;
                    }
                    set coneInnerAngle(t1) {
                        this._nativePannerNode.coneInnerAngle = t1;
                    }
                    get coneOuterAngle() {
                        return this._nativePannerNode.coneOuterAngle;
                    }
                    set coneOuterAngle(t1) {
                        this._nativePannerNode.coneOuterAngle = t1;
                    }
                    get coneOuterGain() {
                        return this._nativePannerNode.coneOuterGain;
                    }
                    set coneOuterGain(t1) {
                        this._nativePannerNode.coneOuterGain = t1;
                    }
                    get distanceModel() {
                        return this._nativePannerNode.distanceModel;
                    }
                    set distanceModel(t1) {
                        this._nativePannerNode.distanceModel = t1;
                    }
                    get maxDistance() {
                        return this._nativePannerNode.maxDistance;
                    }
                    set maxDistance(t1) {
                        this._nativePannerNode.maxDistance = t1;
                    }
                    get orientationX() {
                        return this._orientationX;
                    }
                    get orientationY() {
                        return this._orientationY;
                    }
                    get orientationZ() {
                        return this._orientationZ;
                    }
                    get panningModel() {
                        return this._nativePannerNode.panningModel;
                    }
                    set panningModel(t1) {
                        this._nativePannerNode.panningModel = t1;
                    }
                    get positionX() {
                        return this._positionX;
                    }
                    get positionY() {
                        return this._positionY;
                    }
                    get positionZ() {
                        return this._positionZ;
                    }
                    get refDistance() {
                        return this._nativePannerNode.refDistance;
                    }
                    set refDistance(t1) {
                        this._nativePannerNode.refDistance = t1;
                    }
                    get rolloffFactor() {
                        return this._nativePannerNode.rolloffFactor;
                    }
                    set rolloffFactor(t1) {
                        this._nativePannerNode.rolloffFactor = t1;
                    }
                })(Ve, Je, zs, Ws, ke, De, ns), Us = ((t1)=>(e, { disableNormalization: s1, imag: n, real: i })=>{
                    const o = n instanceof Float32Array ? n : new Float32Array(n), r = i instanceof Float32Array ? i : new Float32Array(i), a = e.createPeriodicWave(r, o, {
                        disableNormalization: s1
                    });
                    if (Array.from(n).length < 2) throw t1();
                    return a;
                })(R), Gs = ((t1, e, s1, n)=>class n {
                    constructor(n, i){
                        const o = e(n), r = ((t1)=>{
                            const { imag: e, real: s1 } = t1;
                            return void 0 === e ? void 0 === s1 ? {
                                ...t1,
                                imag: [
                                    0,
                                    0
                                ],
                                real: [
                                    0,
                                    0
                                ]
                            } : {
                                ...t1,
                                imag: Array.from(s1, ()=>0),
                                real: s1
                            } : void 0 === s1 ? {
                                ...t1,
                                imag: e,
                                real: Array.from(e, ()=>0)
                            } : {
                                ...t1,
                                imag: e,
                                real: s1
                            };
                        })({
                            ...Ht,
                            ...i
                        }), a = t1(o, r);
                        return s1.add(a), a;
                    }
                    static [Symbol.hasInstance](t1) {
                        return null !== t1 && "object" == typeof t1 && Object.getPrototypeOf(t1) === n.prototype || s1.has(t1);
                    }
                })(Us, ke, new WeakSet), Qs = ((t1, e, s1, n, i, o)=>{
                const r = 16385, a = new Float32Array([
                    1,
                    1
                ]), c = Math.PI / 2, h = {
                    channelCount: 1,
                    channelCountMode: "explicit",
                    channelInterpretation: "discrete"
                }, l = {
                    ...h,
                    oversample: "none"
                }, u = (t1, o, u, p, d)=>{
                    if (1 === o) return ((t1, e, i, o)=>{
                        const u = new Float32Array(r), p = new Float32Array(r);
                        for(let t1 = 0; t1 < r; t1 += 1){
                            const e = t1 / 16384 * c;
                            u[t1] = Math.cos(e), p[t1] = Math.sin(e);
                        }
                        const d = s1(t1, {
                            ...h,
                            gain: 0
                        }), f = n(t1, {
                            ...l,
                            curve: u
                        }), _ = n(t1, {
                            ...l,
                            curve: a
                        }), m = s1(t1, {
                            ...h,
                            gain: 0
                        }), g = n(t1, {
                            ...l,
                            curve: p
                        });
                        return {
                            connectGraph () {
                                e.connect(d), e.connect(void 0 === _.inputs ? _ : _.inputs[0]), e.connect(m), _.connect(i), i.connect(void 0 === f.inputs ? f : f.inputs[0]), i.connect(void 0 === g.inputs ? g : g.inputs[0]), f.connect(d.gain), g.connect(m.gain), d.connect(o, 0, 0), m.connect(o, 0, 1);
                            },
                            disconnectGraph () {
                                e.disconnect(d), e.disconnect(void 0 === _.inputs ? _ : _.inputs[0]), e.disconnect(m), _.disconnect(i), i.disconnect(void 0 === f.inputs ? f : f.inputs[0]), i.disconnect(void 0 === g.inputs ? g : g.inputs[0]), f.disconnect(d.gain), g.disconnect(m.gain), d.disconnect(o, 0, 0), m.disconnect(o, 0, 1);
                            }
                        };
                    })(t1, u, p, d);
                    if (2 === o) return ((t1, i, o, u)=>{
                        const p = new Float32Array(r), d = new Float32Array(r), f = new Float32Array(r), _ = new Float32Array(r), m = Math.floor(8192.5);
                        for(let t1 = 0; t1 < r; t1 += 1)if (t1 > m) {
                            const e = (t1 - m) / (16384 - m) * c;
                            p[t1] = Math.cos(e), d[t1] = Math.sin(e), f[t1] = 0, _[t1] = 1;
                        } else {
                            const e = t1 / (16384 - m) * c;
                            p[t1] = 1, d[t1] = 0, f[t1] = Math.cos(e), _[t1] = Math.sin(e);
                        }
                        const g = e(t1, {
                            channelCount: 2,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            numberOfOutputs: 2
                        }), v = s1(t1, {
                            ...h,
                            gain: 0
                        }), y = n(t1, {
                            ...l,
                            curve: p
                        }), x = s1(t1, {
                            ...h,
                            gain: 0
                        }), w = n(t1, {
                            ...l,
                            curve: d
                        }), b = n(t1, {
                            ...l,
                            curve: a
                        }), T = s1(t1, {
                            ...h,
                            gain: 0
                        }), S = n(t1, {
                            ...l,
                            curve: f
                        }), k = s1(t1, {
                            ...h,
                            gain: 0
                        }), A = n(t1, {
                            ...l,
                            curve: _
                        });
                        return {
                            connectGraph () {
                                i.connect(g), i.connect(void 0 === b.inputs ? b : b.inputs[0]), g.connect(v, 0), g.connect(x, 0), g.connect(T, 1), g.connect(k, 1), b.connect(o), o.connect(void 0 === y.inputs ? y : y.inputs[0]), o.connect(void 0 === w.inputs ? w : w.inputs[0]), o.connect(void 0 === S.inputs ? S : S.inputs[0]), o.connect(void 0 === A.inputs ? A : A.inputs[0]), y.connect(v.gain), w.connect(x.gain), S.connect(T.gain), A.connect(k.gain), v.connect(u, 0, 0), T.connect(u, 0, 0), x.connect(u, 0, 1), k.connect(u, 0, 1);
                            },
                            disconnectGraph () {
                                i.disconnect(g), i.disconnect(void 0 === b.inputs ? b : b.inputs[0]), g.disconnect(v, 0), g.disconnect(x, 0), g.disconnect(T, 1), g.disconnect(k, 1), b.disconnect(o), o.disconnect(void 0 === y.inputs ? y : y.inputs[0]), o.disconnect(void 0 === w.inputs ? w : w.inputs[0]), o.disconnect(void 0 === S.inputs ? S : S.inputs[0]), o.disconnect(void 0 === A.inputs ? A : A.inputs[0]), y.disconnect(v.gain), w.disconnect(x.gain), S.disconnect(T.gain), A.disconnect(k.gain), v.disconnect(u, 0, 0), T.disconnect(u, 0, 0), x.disconnect(u, 0, 1), k.disconnect(u, 0, 1);
                            }
                        };
                    })(t1, u, p, d);
                    throw i();
                };
                return (e, { channelCount: n, channelCountMode: r, pan: a, ...c })=>{
                    if ("max" === r) throw i();
                    const h = t1(e, {
                        ...c,
                        channelCount: 1,
                        channelCountMode: r,
                        numberOfInputs: 2
                    }), l = s1(e, {
                        ...c,
                        channelCount: n,
                        channelCountMode: r,
                        gain: 1
                    }), p = s1(e, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: a
                    });
                    let { connectGraph: d, disconnectGraph: f } = u(e, n, l, p, h);
                    Object.defineProperty(p.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(p.gain, "maxValue", {
                        get: ()=>1
                    }), Object.defineProperty(p.gain, "minValue", {
                        get: ()=>-1
                    });
                    const _ = {
                        get bufferSize () {},
                        get channelCount () {
                            return l.channelCount;
                        },
                        set channelCount (t){
                            l.channelCount !== t && (m && f(), { connectGraph: d, disconnectGraph: f } = u(e, t, l, p, h), m && d()), l.channelCount = t;
                        },
                        get channelCountMode () {
                            return l.channelCountMode;
                        },
                        set channelCountMode (t){
                            if ("clamped-max" === t || "max" === t) throw i();
                            l.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return l.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            l.channelInterpretation = t;
                        },
                        get context () {
                            return l.context;
                        },
                        get inputs () {
                            return [
                                l
                            ];
                        },
                        get numberOfInputs () {
                            return l.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return l.numberOfOutputs;
                        },
                        get pan () {
                            return p.gain;
                        },
                        addEventListener: (...t1)=>l.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>l.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>l.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    let m = !1;
                    return o(zt(_, h), ()=>{
                        d(), m = !0;
                    }, ()=>{
                        f(), m = !1;
                    });
                };
            })(as, Lt, Bt, js, Zt, os), Zs = ((t1, e)=>(s1, n)=>{
                    const i = n.channelCountMode;
                    if ("clamped-max" === i) throw e();
                    if (void 0 === s1.createStereoPanner) return t1(s1, n);
                    const o = s1.createStereoPanner();
                    return qt(o, n), It(o, n, "pan"), Object.defineProperty(o, "channelCountMode", {
                        get: ()=>i,
                        set: (t1)=>{
                            if (t1 !== i) throw e();
                        }
                    }), o;
                })(Qs, Zt), Xs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        pan: c.pan.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? await t1(a, r.pan, c.pan) : await n(a, r.pan, c.pan), X(c) ? await i(r, a, c.inputs[0]) : await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, Zs, tt, $e, Te), Ys = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...Jt,
                            ...r
                        }, h = s1(a, c), l = o(a);
                        super(t1, !1, h, l ? n() : null), this._pan = e(this, l, h.pan);
                    }
                    get pan() {
                        return this._pan;
                    }
                })(Ve, Je, Zs, Xs, ke, De), $s = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        curve: r.curve,
                                        oversample: r.oversample
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), X(r) ? await s1(i, o, r.inputs[0]) : await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(js, tt, Te), Hs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, e){
                        const a = i(t1), c = {
                            ...te,
                            ...e
                        }, h = s1(a, c);
                        super(t1, !0, h, o(a) ? n() : null), this._isCurveNullified = !1, this._nativeWaveShaperNode = h, r(this, 1);
                    }
                    get curve() {
                        return this._isCurveNullified ? null : this._nativeWaveShaperNode.curve;
                    }
                    set curve(t1) {
                        if (null === t1) this._isCurveNullified = !0, this._nativeWaveShaperNode.curve = new Float32Array([
                            0,
                            0
                        ]);
                        else {
                            if (t1.length < 2) throw e();
                            this._isCurveNullified = !1, this._nativeWaveShaperNode.curve = t1;
                        }
                    }
                    get oversample() {
                        return this._nativeWaveShaperNode.oversample;
                    }
                    set oversample(t1) {
                        this._nativeWaveShaperNode.oversample = t1;
                    }
                })(Ve, At, js, $s, ke, De, ns), Js = ((t1)=>null !== t1 && t1.isSecureContext)(xe), Ks = ((t1)=>(e, s1, n)=>{
                    Object.defineProperties(t1, {
                        currentFrame: {
                            configurable: !0,
                            get: ()=>Math.round(e * s1)
                        },
                        currentTime: {
                            configurable: !0,
                            get: ()=>e
                        }
                    });
                    try {
                        return n();
                    } finally{
                        null !== t1 && (delete t1.currentFrame, delete t1.currentTime);
                    }
                })(xe), tn = new WeakMap, en = ((t1, e)=>(s1)=>{
                    let n = t1.get(s1);
                    if (void 0 !== n) return n;
                    if (null === e) throw new Error("Missing the native OfflineAudioContext constructor.");
                    return n = new e(1, 1, 44100), t1.set(s1, n), n;
                })(tn, Ce), sn = Js ? ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>{
                let d = 0;
                return (_, m, g = {
                    credentials: "omit"
                })=>{
                    const w = l.get(_);
                    if (void 0 !== w && w.has(m)) return Promise.resolve();
                    const b = h.get(_);
                    if (void 0 !== b) {
                        const t1 = b.get(m);
                        if (void 0 !== t1) return t1;
                    }
                    const T = o(_), S = void 0 === T.audioWorklet ? i(m).then(([t1, e])=>{
                        const [n, i] = v(t1, e);
                        return s1(`${n};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${i}\n})})(window,'_AWGS')`);
                    }).then(()=>{
                        const t1 = p._AWGS.pop();
                        if (void 0 === t1) throw new SyntaxError;
                        n(T.currentTime, T.sampleRate, ()=>t1(class {
                            }, void 0, (t1, s1)=>{
                                if ("" === t1.trim()) throw e();
                                const n = f.get(T);
                                if (void 0 !== n) {
                                    if (n.has(t1)) throw e();
                                    x(s1), y(s1.parameterDescriptors), n.set(t1, s1);
                                } else x(s1), y(s1.parameterDescriptors), f.set(T, new Map([
                                    [
                                        t1,
                                        s1
                                    ]
                                ]));
                            }, T.sampleRate, void 0, void 0));
                    }) : Promise.all([
                        i(m),
                        Promise.resolve(t1(u, u))
                    ]).then(([[t1, e], s1])=>{
                        const n = d + 1;
                        d = n;
                        const [i, o] = v(t1, e), h = new Blob([
                            `${i};((AudioWorkletProcessor,registerProcessor)=>{${o}\n})(${s1 ? "AudioWorkletProcessor" : "class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}"},(n,p)=>registerProcessor(n,class extends p{${s1 ? "" : "__c = (a) => a.forEach(e=>this.__b.add(e.buffer));"}process(i,o,p){${s1 ? "" : "i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));"}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${n}',class extends AudioWorkletProcessor{process(){return !1}})`
                        ], {
                            type: "application/javascript; charset=utf-8"
                        }), l = URL.createObjectURL(h);
                        return T.audioWorklet.addModule(l, g).then(()=>{
                            if (a(T)) return T;
                            const t1 = r(T);
                            return t1.audioWorklet.addModule(l, g).then(()=>t1);
                        }).then((t1)=>{
                            if (null === c) throw new SyntaxError;
                            try {
                                new c(t1, `__sac${n}`);
                            } catch  {
                                throw new SyntaxError;
                            }
                        }).finally(()=>URL.revokeObjectURL(l));
                    });
                    return void 0 === b ? h.set(_, new Map([
                        [
                            m,
                            S
                        ]
                    ])) : b.set(m, S), S.then(()=>{
                        const t1 = l.get(_);
                        void 0 === t1 ? l.set(_, new Set([
                            m
                        ])) : t1.add(m);
                    }).finally(()=>{
                        const t1 = h.get(_);
                        void 0 !== t1 && t1.delete(m);
                    }), S;
                };
            })(ge, Zt, ((t1)=>(e)=>new Promise((s1, n)=>{
                        if (null === t1) return void n(new SyntaxError);
                        const i = t1.document.head;
                        if (null === i) n(new SyntaxError);
                        else {
                            const o = t1.document.createElement("script"), r = new Blob([
                                e
                            ], {
                                type: "application/javascript"
                            }), a = URL.createObjectURL(r), c = t1.onerror, h = ()=>{
                                t1.onerror = c, URL.revokeObjectURL(a);
                            };
                            t1.onerror = (e, s1, i, o, r)=>s1 === a || s1 === t1.location.href && 1 === i && 1 === o ? (h(), n(r), !1) : null !== c ? c(e, s1, i, o, r) : void 0, o.onerror = ()=>{
                                h(), n(new SyntaxError);
                            }, o.onload = ()=>{
                                h(), s1();
                            }, o.src = a, o.type = "module", i.appendChild(o);
                        }
                    }))(xe), Ks, async (t1)=>{
                try {
                    const e = await fetch(t1);
                    if (e.ok) return [
                        await e.text(),
                        e.url
                    ];
                } catch  {}
                throw new DOMException("", "AbortError");
            }, ke, en, De, Ie, new WeakMap, new WeakMap, ((t1, e)=>async ()=>{
                    if (null === t1) return !0;
                    if (null === e) return !1;
                    const s1 = new Blob([
                        'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
                    ], {
                        type: "application/javascript; charset=utf-8"
                    }), n = new e(1, 128, 44100), i = URL.createObjectURL(s1);
                    let o = !1, r = !1;
                    try {
                        await n.audioWorklet.addModule(i);
                        const e = new t1(n, "a", {
                            numberOfOutputs: 0
                        }), s1 = n.createOscillator();
                        e.port.onmessage = ()=>o = !0, e.onprocessorerror = ()=>r = !0, s1.connect(e), s1.start(0), await n.startRendering(), await new Promise((t1)=>setTimeout(t1));
                    } catch  {} finally{
                        URL.revokeObjectURL(i);
                    }
                    return o && !r;
                })(Ie, Ce), xe) : void 0, nn = ((t1, e)=>(s1)=>t1(s1) || e(s1))(Re, De), on = ((t1, e, s1, n, i, o, r, a, c, h, l)=>(s1, n)=>{
                    const u = r(s1) ? s1 : o(s1);
                    if (i.has(n)) {
                        const t1 = new DOMException("", "DataCloneError");
                        return Promise.reject(t1);
                    }
                    try {
                        i.add(n);
                    } catch  {}
                    return e(c, ()=>c(u)) ? u.decodeAudioData(n).then((s1)=>(wt(n).catch(()=>{}), e(a, ()=>a(s1)) || l(s1), t1.add(s1), s1)) : new Promise((e, s1)=>{
                        const i = async ()=>{
                            try {
                                await wt(n);
                            } catch  {}
                        }, o = (t1)=>{
                            s1(t1), i();
                        };
                        try {
                            u.decodeAudioData(n, (s1)=>{
                                "function" != typeof s1.copyFromChannel && (h(s1), q(s1)), t1.add(s1), i().then(()=>e(s1));
                            }, (t1)=>{
                                o(null === t1 ? new DOMException("", "EncodingError") : t1);
                            });
                        } catch (t1) {
                            o(t1);
                        }
                    });
                })(je, ge, 0, 0, new WeakSet, ke, nn, E, Et, Be, Ue), rn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _, m, g, v, y)=>class extends f {
                    constructor(e, s1){
                        super(e, s1), this._nativeContext = e, this._audioWorklet = void 0 === t1 ? void 0 : {
                            addModule: (e, s1)=>t1(this, e, s1)
                        };
                    }
                    get audioWorklet() {
                        return this._audioWorklet;
                    }
                    createAnalyser() {
                        return new e(this);
                    }
                    createBiquadFilter() {
                        return new i(this);
                    }
                    createBuffer(t1, e, n) {
                        return new s1({
                            length: e,
                            numberOfChannels: t1,
                            sampleRate: n
                        });
                    }
                    createBufferSource() {
                        return new n(this);
                    }
                    createChannelMerger(t1 = 6) {
                        return new o(this, {
                            numberOfInputs: t1
                        });
                    }
                    createChannelSplitter(t1 = 6) {
                        return new r(this, {
                            numberOfOutputs: t1
                        });
                    }
                    createConstantSource() {
                        return new a(this);
                    }
                    createConvolver() {
                        return new c(this);
                    }
                    createDelay(t1 = 1) {
                        return new l(this, {
                            maxDelayTime: t1
                        });
                    }
                    createDynamicsCompressor() {
                        return new u(this);
                    }
                    createGain() {
                        return new p(this);
                    }
                    createIIRFilter(t1, e) {
                        return new d(this, {
                            feedback: e,
                            feedforward: t1
                        });
                    }
                    createOscillator() {
                        return new _(this);
                    }
                    createPanner() {
                        return new m(this);
                    }
                    createPeriodicWave(t1, e, s1 = {
                        disableNormalization: !1
                    }) {
                        return new g(this, {
                            ...s1,
                            imag: e,
                            real: t1
                        });
                    }
                    createStereoPanner() {
                        return new v(this);
                    }
                    createWaveShaper() {
                        return new y(this);
                    }
                    decodeAudioData(t1, e, s1) {
                        return h(this._nativeContext, t1).then((t1)=>("function" == typeof e && e(t1), t1), (t1)=>{
                            throw "function" == typeof s1 && s1(t1), t1;
                        });
                    }
                })(sn, Pe, Ge, ts, is, hs, us, _s, vs, on, xs, Ts, ks, Ms, qs, Vs, Bs, Gs, Ys, Hs), an = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1), o = ((t1, e)=>t1.createMediaElementSource(e.mediaElement))(i, e);
                        if (n(i)) throw TypeError();
                        super(t1, !0, o, null), this._nativeMediaElementAudioSourceNode = o;
                    }
                    get mediaElement() {
                        return this._nativeMediaElementAudioSourceNode.mediaElement;
                    }
                })(Ve, 0, ke, De), cn = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1);
                        if (n(i)) throw new TypeError;
                        const o = ((t1, e)=>{
                            const s1 = t1.createMediaStreamDestination();
                            return qt(s1, e), 1 === s1.numberOfOutputs && Object.defineProperty(s1, "numberOfOutputs", {
                                get: ()=>0
                            }), s1;
                        })(i, {
                            ...Mt,
                            ...e
                        });
                        super(t1, !1, o, null), this._nativeMediaStreamAudioDestinationNode = o;
                    }
                    get stream() {
                        return this._nativeMediaStreamAudioDestinationNode.stream;
                    }
                })(Ve, 0, ke, De), hn = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1), o = ((t1, { mediaStream: e })=>{
                            const s1 = e.getAudioTracks();
                            s1.sort((t1, e)=>t1.id < e.id ? -1 : t1.id > e.id ? 1 : 0);
                            const n = s1.slice(0, 1), i = t1.createMediaStreamSource(new MediaStream(n));
                            return Object.defineProperty(i, "mediaStream", {
                                value: e
                            }), i;
                        })(i, e);
                        if (n(i)) throw new TypeError;
                        super(t1, !0, o, null), this._nativeMediaStreamAudioSourceNode = o;
                    }
                    get mediaStream() {
                        return this._nativeMediaStreamAudioSourceNode.mediaStream;
                    }
                })(Ve, 0, ke, De), ln = ((t1, e)=>(s1, { mediaStreamTrack: n })=>{
                    if ("function" == typeof s1.createMediaStreamTrackSource) return s1.createMediaStreamTrackSource(n);
                    const i = new MediaStream([
                        n
                    ]), o = s1.createMediaStreamSource(i);
                    if ("audio" !== n.kind) throw t1();
                    if (e(s1)) throw new TypeError;
                    return o;
                })(At, De), un = ((t1, e, s1)=>class extends t1 {
                    constructor(t1, n){
                        const i = s1(t1);
                        super(t1, !0, e(i, n), null);
                    }
                })(Ve, ln, ke), pn = ((t1, e, s1, n, i, o, r, a, c)=>class extends t1 {
                    constructor(t1 = {}){
                        if (null === c) throw new Error("Missing the native AudioContext constructor.");
                        let e;
                        try {
                            e = new c(t1);
                        } catch (t1) {
                            if (12 === t1.code && "sampleRate is not in range" === t1.message) throw s1();
                            throw t1;
                        }
                        if (null === e) throw n();
                        if (!((t1)=>void 0 === t1 || "number" == typeof t1 || "string" == typeof t1 && ("balanced" === t1 || "interactive" === t1 || "playback" === t1))(t1.latencyHint)) throw new TypeError(`The provided value '${t1.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
                        if (void 0 !== t1.sampleRate && e.sampleRate !== t1.sampleRate) throw s1();
                        super(e, 2);
                        const { latencyHint: i } = t1, { sampleRate: o } = e;
                        if (this._baseLatency = "number" == typeof e.baseLatency ? e.baseLatency : "balanced" === i ? 512 / o : "interactive" === i || void 0 === i ? 256 / o : "playback" === i ? 1024 / o : 128 * Math.max(2, Math.min(128, Math.round(i * o / 128))) / o, this._nativeAudioContext = e, "webkitAudioContext" === c.name ? (this._nativeGainNode = e.createGain(), this._nativeOscillatorNode = e.createOscillator(), this._nativeGainNode.gain.value = 1e-37, this._nativeOscillatorNode.connect(this._nativeGainNode).connect(e.destination), this._nativeOscillatorNode.start()) : (this._nativeGainNode = null, this._nativeOscillatorNode = null), this._state = null, "running" === e.state) {
                            this._state = "suspended";
                            const t1 = ()=>{
                                "suspended" === this._state && (this._state = null), e.removeEventListener("statechange", t1);
                            };
                            e.addEventListener("statechange", t1);
                        }
                    }
                    get baseLatency() {
                        return this._baseLatency;
                    }
                    get state() {
                        return null !== this._state ? this._state : this._nativeAudioContext.state;
                    }
                    close() {
                        return "closed" === this.state ? this._nativeAudioContext.close().then(()=>{
                            throw e();
                        }) : ("suspended" === this._state && (this._state = null), this._nativeAudioContext.close().then(()=>{
                            null !== this._nativeGainNode && null !== this._nativeOscillatorNode && (this._nativeOscillatorNode.stop(), this._nativeGainNode.disconnect(), this._nativeOscillatorNode.disconnect()), W(this);
                        }));
                    }
                    createMediaElementSource(t1) {
                        return new i(this, {
                            mediaElement: t1
                        });
                    }
                    createMediaStreamDestination() {
                        return new o(this);
                    }
                    createMediaStreamSource(t1) {
                        return new r(this, {
                            mediaStream: t1
                        });
                    }
                    createMediaStreamTrackSource(t1) {
                        return new a(this, {
                            mediaStreamTrack: t1
                        });
                    }
                    resume() {
                        return "suspended" === this._state ? new Promise((t1, e)=>{
                            const s1 = ()=>{
                                this._nativeAudioContext.removeEventListener("statechange", s1), "running" === this._nativeAudioContext.state ? t1() : this.resume().then(t1, e);
                            };
                            this._nativeAudioContext.addEventListener("statechange", s1);
                        }) : this._nativeAudioContext.resume().catch((t1)=>{
                            if (void 0 === t1 || 15 === t1.code) throw e();
                            throw t1;
                        });
                    }
                    suspend() {
                        return this._nativeAudioContext.suspend().catch((t1)=>{
                            if (void 0 === t1) throw e();
                            throw t1;
                        });
                    }
                })(rn, At, Zt, Kt, an, cn, hn, un, Ee), dn = ((t1)=>(e)=>{
                    const s1 = t1.get(e);
                    if (void 0 === s1) throw new Error("The context has no set of AudioWorkletNodes.");
                    return s1;
                })(Rs), fn = ((t1)=>(e, s1)=>{
                    t1(e).add(s1);
                })(dn), _n = ((t1)=>(e, s1, n = 0, i = 0)=>{
                    const o = e[n];
                    if (void 0 === o) throw t1();
                    return rt(s1) ? o.connect(s1, 0, i) : o.connect(s1, 0);
                })(R), mn = ((t1)=>(e, s1)=>{
                    t1(e).delete(s1);
                })(dn), gn = ((t1)=>(e, s1, n, i = 0)=>void 0 === s1 ? e.forEach((t1)=>t1.disconnect()) : "number" == typeof s1 ? Tt(t1, e, s1).disconnect() : rt(s1) ? void 0 === n ? e.forEach((t1)=>t1.disconnect(s1)) : void 0 === i ? Tt(t1, e, n).disconnect(s1, 0) : Tt(t1, e, n).disconnect(s1, 0, i) : void 0 === n ? e.forEach((t1)=>t1.disconnect(s1)) : Tt(t1, e, n).disconnect(s1, 0))(R), vn = new WeakMap, yn = ((t1, e)=>(s1)=>e(t1, s1))(vn, w), xn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>(d, f, m, g)=>{
                    if (0 === g.numberOfInputs && 0 === g.numberOfOutputs) throw c();
                    const v = Array.isArray(g.outputChannelCount) ? g.outputChannelCount : Array.from(g.outputChannelCount);
                    if (v.some((t1)=>t1 < 1)) throw c();
                    if (v.length !== g.numberOfOutputs) throw e();
                    if ("explicit" !== g.channelCountMode) throw c();
                    const y = g.channelCount * g.numberOfInputs, x = v.reduce((t1, e)=>t1 + e, 0), w = void 0 === m.parameterDescriptors ? 0 : m.parameterDescriptors.length;
                    if (y + w > 6 || x > 6) throw c();
                    const b = new MessageChannel, T = [], S = [];
                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)T.push(r(d, {
                        channelCount: g.channelCount,
                        channelCountMode: g.channelCountMode,
                        channelInterpretation: g.channelInterpretation,
                        gain: 1
                    })), S.push(i(d, {
                        channelCount: g.channelCount,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        numberOfOutputs: g.channelCount
                    }));
                    const k = [];
                    if (void 0 !== m.parameterDescriptors) for (const { defaultValue: t1, maxValue: e, minValue: s1, name: n } of m.parameterDescriptors){
                        const i = o(d, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            offset: void 0 !== g.parameterData[n] ? g.parameterData[n] : void 0 === t1 ? 0 : t1
                        });
                        Object.defineProperties(i.offset, {
                            defaultValue: {
                                get: ()=>void 0 === t1 ? 0 : t1
                            },
                            maxValue: {
                                get: ()=>void 0 === e ? V : e
                            },
                            minValue: {
                                get: ()=>void 0 === s1 ? I : s1
                            }
                        }), k.push(i);
                    }
                    const A = n(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "speakers",
                        numberOfInputs: Math.max(1, y + w)
                    }), C = Pt(f, d.sampleRate), D = a(d, C, y + w, Math.max(1, x)), O = i(d, {
                        channelCount: Math.max(1, x),
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        numberOfOutputs: Math.max(1, x)
                    }), M = [];
                    for(let t1 = 0; t1 < g.numberOfOutputs; t1 += 1)M.push(n(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "speakers",
                        numberOfInputs: v[t1]
                    }));
                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                        T[t1].connect(S[t1]);
                        for(let e = 0; e < g.channelCount; e += 1)S[t1].connect(A, e, t1 * g.channelCount + e);
                    }
                    const E = new lt(void 0 === m.parameterDescriptors ? [] : m.parameterDescriptors.map(({ name: t1 }, e)=>{
                        const s1 = k[e];
                        return s1.connect(A, 0, y + e), s1.start(0), [
                            t1,
                            s1.offset
                        ];
                    }));
                    A.connect(D);
                    let R = g.channelInterpretation, q = null;
                    const F = 0 === g.numberOfOutputs ? [
                        D
                    ] : M, N = {
                        get bufferSize () {
                            return C;
                        },
                        get channelCount () {
                            return g.channelCount;
                        },
                        set channelCount (t){
                            throw s1();
                        },
                        get channelCountMode () {
                            return g.channelCountMode;
                        },
                        set channelCountMode (t){
                            throw s1();
                        },
                        get channelInterpretation () {
                            return R;
                        },
                        set channelInterpretation (t){
                            for (const e of T)e.channelInterpretation = t;
                            R = t;
                        },
                        get context () {
                            return D.context;
                        },
                        get inputs () {
                            return T;
                        },
                        get numberOfInputs () {
                            return g.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return g.numberOfOutputs;
                        },
                        get onprocessorerror () {
                            return q;
                        },
                        set onprocessorerror (t){
                            "function" == typeof q && N.removeEventListener("processorerror", q), q = "function" == typeof t ? t : null, "function" == typeof q && N.addEventListener("processorerror", q);
                        },
                        get parameters () {
                            return E;
                        },
                        get port () {
                            return b.port2;
                        },
                        addEventListener: (...t1)=>D.addEventListener(t1[0], t1[1], t1[2]),
                        connect: t1.bind(null, F),
                        disconnect: h.bind(null, F),
                        dispatchEvent: (...t1)=>D.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>D.removeEventListener(t1[0], t1[1], t1[2])
                    }, P = new Map;
                    var j, L;
                    b.port1.addEventListener = (j = b.port1.addEventListener, (...t1)=>{
                        if ("message" === t1[0]) {
                            const e = "function" == typeof t1[1] ? t1[1] : "object" == typeof t1[1] && null !== t1[1] && "function" == typeof t1[1].handleEvent ? t1[1].handleEvent : null;
                            if (null !== e) {
                                const s1 = P.get(t1[1]);
                                void 0 !== s1 ? t1[1] = s1 : (t1[1] = (t1)=>{
                                    l(d.currentTime, d.sampleRate, ()=>e(t1));
                                }, P.set(e, t1[1]));
                            }
                        }
                        return j.call(b.port1, t1[0], t1[1], t1[2]);
                    }), b.port1.removeEventListener = (L = b.port1.removeEventListener, (...t1)=>{
                        if ("message" === t1[0]) {
                            const e = P.get(t1[1]);
                            void 0 !== e && (P.delete(t1[1]), t1[1] = e);
                        }
                        return L.call(b.port1, t1[0], t1[1], t1[2]);
                    });
                    let z = null;
                    Object.defineProperty(b.port1, "onmessage", {
                        get: ()=>z,
                        set: (t1)=>{
                            "function" == typeof z && b.port1.removeEventListener("message", z), z = "function" == typeof t1 ? t1 : null, "function" == typeof z && (b.port1.addEventListener("message", z), b.port1.start());
                        }
                    }), m.prototype.port = b.port1;
                    let W = null;
                    const B = ((t1, e, s1, n)=>{
                        let i = _.get(t1);
                        void 0 === i && (i = new WeakMap, _.set(t1, i));
                        const o = (async (t1, e)=>{
                            const s1 = await ((t1)=>new Promise((e, s1)=>{
                                    const { port1: n, port2: i } = new MessageChannel;
                                    n.onmessage = ({ data: t1 })=>{
                                        n.close(), i.close(), e(t1);
                                    }, n.onmessageerror = ({ data: t1 })=>{
                                        n.close(), i.close(), s1(t1);
                                    }, i.postMessage(t1);
                                }))(e);
                            return new t1(s1);
                        })(s1, n);
                        return i.set(e, o), o;
                    })(d, N, m, g);
                    B.then((t1)=>W = t1);
                    const U = ft(g.numberOfInputs, g.channelCount), G = ft(g.numberOfOutputs, v), Q = void 0 === m.parameterDescriptors ? [] : m.parameterDescriptors.reduce((t1, { name: e })=>({
                            ...t1,
                            [e]: new Float32Array(128)
                        }), {});
                    let Z = !0;
                    const X = ()=>{
                        g.numberOfOutputs > 0 && D.disconnect(O);
                        for(let t1 = 0, e = 0; t1 < g.numberOfOutputs; t1 += 1){
                            const s1 = M[t1];
                            for(let n = 0; n < v[t1]; n += 1)O.disconnect(s1, e + n, n);
                            e += v[t1];
                        }
                    }, Y = new Map;
                    D.onaudioprocess = ({ inputBuffer: t1, outputBuffer: e })=>{
                        if (null !== W) {
                            const s1 = u(N);
                            for(let n = 0; n < C; n += 128){
                                for(let e = 0; e < g.numberOfInputs; e += 1)for(let s1 = 0; s1 < g.channelCount; s1 += 1)pt(t1, U[e], s1, s1, n);
                                void 0 !== m.parameterDescriptors && m.parameterDescriptors.forEach(({ name: e }, s1)=>{
                                    pt(t1, Q, e, y + s1, n);
                                });
                                for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)for(let e = 0; e < v[t1]; e += 1)0 === G[t1][e].byteLength && (G[t1][e] = new Float32Array(128));
                                try {
                                    const t1 = U.map((t1, e)=>{
                                        if (s1[e].size > 0) return Y.set(e, C / 128), t1;
                                        const n = Y.get(e);
                                        return void 0 === n ? [] : (t1.every((t1)=>t1.every((t1)=>0 === t1)) && (1 === n ? Y.delete(e) : Y.set(e, n - 1)), t1);
                                    }), i = l(d.currentTime + n / d.sampleRate, d.sampleRate, ()=>W.process(t1, G, Q));
                                    Z = i;
                                    for(let t1 = 0, s1 = 0; t1 < g.numberOfOutputs; t1 += 1){
                                        for(let i = 0; i < v[t1]; i += 1)dt(e, G[t1], i, s1 + i, n);
                                        s1 += v[t1];
                                    }
                                } catch (t1) {
                                    Z = !1, N.dispatchEvent(new ErrorEvent("processorerror", {
                                        colno: t1.colno,
                                        filename: t1.filename,
                                        lineno: t1.lineno,
                                        message: t1.message
                                    }));
                                }
                                if (!Z) {
                                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                                        T[t1].disconnect(S[t1]);
                                        for(let e = 0; e < g.channelCount; e += 1)S[n].disconnect(A, e, t1 * g.channelCount + e);
                                    }
                                    if (void 0 !== m.parameterDescriptors) {
                                        const t1 = m.parameterDescriptors.length;
                                        for(let e = 0; e < t1; e += 1){
                                            const t1 = k[e];
                                            t1.disconnect(A, 0, y + e), t1.stop();
                                        }
                                    }
                                    A.disconnect(D), D.onaudioprocess = null, $ ? X() : K();
                                    break;
                                }
                            }
                        }
                    };
                    let $ = !1;
                    const H = r(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    }), J = ()=>D.connect(H).connect(d.destination), K = ()=>{
                        D.disconnect(H), H.disconnect();
                    };
                    return J(), p(N, ()=>{
                        if (Z) {
                            K(), g.numberOfOutputs > 0 && D.connect(O);
                            for(let t1 = 0, e = 0; t1 < g.numberOfOutputs; t1 += 1){
                                const s1 = M[t1];
                                for(let n = 0; n < v[t1]; n += 1)O.connect(s1, e + n, n);
                                e += v[t1];
                            }
                        }
                        $ = !0;
                    }, ()=>{
                        Z && (J(), X()), $ = !1;
                    });
                })(_n, R, At, as, Lt, ds, Bt, Qt, Zt, gn, Ks, yn, os), wn = ((t1, e, s1, n, i)=>(o, r, a, c, h, l)=>{
                    if (null !== a) try {
                        const e = new a(o, c, l), n = new Map;
                        let r = null;
                        if (Object.defineProperties(e, {
                            channelCount: {
                                get: ()=>l.channelCount,
                                set: ()=>{
                                    throw t1();
                                }
                            },
                            channelCountMode: {
                                get: ()=>"explicit",
                                set: ()=>{
                                    throw t1();
                                }
                            },
                            onprocessorerror: {
                                get: ()=>r,
                                set: (t1)=>{
                                    "function" == typeof r && e.removeEventListener("processorerror", r), r = "function" == typeof t1 ? t1 : null, "function" == typeof r && e.addEventListener("processorerror", r);
                                }
                            }
                        }), e.addEventListener = (p = e.addEventListener, (...t1)=>{
                            if ("processorerror" === t1[0]) {
                                const e = "function" == typeof t1[1] ? t1[1] : "object" == typeof t1[1] && null !== t1[1] && "function" == typeof t1[1].handleEvent ? t1[1].handleEvent : null;
                                if (null !== e) {
                                    const s1 = n.get(t1[1]);
                                    void 0 !== s1 ? t1[1] = s1 : (t1[1] = (s1)=>{
                                        "error" === s1.type ? (Object.defineProperties(s1, {
                                            type: {
                                                value: "processorerror"
                                            }
                                        }), e(s1)) : e(new ErrorEvent(t1[0], {
                                            ...s1
                                        }));
                                    }, n.set(e, t1[1]));
                                }
                            }
                            return p.call(e, "error", t1[1], t1[2]), p.call(e, ...t1);
                        }), e.removeEventListener = (u = e.removeEventListener, (...t1)=>{
                            if ("processorerror" === t1[0]) {
                                const e = n.get(t1[1]);
                                void 0 !== e && (n.delete(t1[1]), t1[1] = e);
                            }
                            return u.call(e, "error", t1[1], t1[2]), u.call(e, t1[0], t1[1], t1[2]);
                        }), 0 !== l.numberOfOutputs) {
                            const t1 = s1(o, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                gain: 0
                            });
                            return e.connect(t1).connect(o.destination), i(e, ()=>t1.disconnect(), ()=>t1.connect(o.destination));
                        }
                        return e;
                    } catch (t1) {
                        if (11 === t1.code) throw n();
                        throw t1;
                    }
                    var u, p;
                    if (void 0 === h) throw n();
                    return ((t1)=>{
                        const { port1: e } = new MessageChannel;
                        try {
                            e.postMessage(t1);
                        } finally{
                            e.close();
                        }
                    })(l), e(o, r, h, l);
                })(At, xn, Bt, Zt, os), bn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _)=>(m, g, v)=>{
                    const y = new WeakMap;
                    let x = null;
                    return {
                        render (w, b) {
                            a(b, w);
                            const T = y.get(b);
                            return void 0 !== T ? Promise.resolve(T) : (async (a, w)=>{
                                let b = l(a), T = null;
                                const S = M(b, w), k = Array.isArray(g.outputChannelCount) ? g.outputChannelCount : Array.from(g.outputChannelCount);
                                if (null === u) {
                                    const t1 = k.reduce((t1, e)=>t1 + e, 0), s1 = i(w, {
                                        channelCount: Math.max(1, t1),
                                        channelCountMode: "explicit",
                                        channelInterpretation: "discrete",
                                        numberOfOutputs: Math.max(1, t1)
                                    }), o = [];
                                    for(let t1 = 0; t1 < a.numberOfOutputs; t1 += 1)o.push(n(w, {
                                        channelCount: 1,
                                        channelCountMode: "explicit",
                                        channelInterpretation: "speakers",
                                        numberOfInputs: k[t1]
                                    }));
                                    const h = r(w, {
                                        channelCount: g.channelCount,
                                        channelCountMode: g.channelCountMode,
                                        channelInterpretation: g.channelInterpretation,
                                        gain: 1
                                    });
                                    h.connect = e.bind(null, o), h.disconnect = c.bind(null, o), T = [
                                        s1,
                                        o,
                                        h
                                    ];
                                } else S || (b = new u(w, m));
                                if (y.set(w, null === T ? b : T[2]), null !== T) {
                                    if (null === x) {
                                        if (void 0 === v) throw new Error("Missing the processor constructor.");
                                        if (null === p) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = a.channelCount * a.numberOfInputs, e = void 0 === v.parameterDescriptors ? 0 : v.parameterDescriptors.length, s1 = t1 + e, c = async ()=>{
                                            const c = new p(s1, 128 * Math.ceil(a.context.length / 128), w.sampleRate), h = [], l = [];
                                            for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)h.push(r(c, {
                                                channelCount: g.channelCount,
                                                channelCountMode: g.channelCountMode,
                                                channelInterpretation: g.channelInterpretation,
                                                gain: 1
                                            })), l.push(i(c, {
                                                channelCount: g.channelCount,
                                                channelCountMode: "explicit",
                                                channelInterpretation: "discrete",
                                                numberOfOutputs: g.channelCount
                                            }));
                                            const u = await Promise.all(Array.from(a.parameters.values()).map(async (t1)=>{
                                                const e = o(c, {
                                                    channelCount: 1,
                                                    channelCountMode: "explicit",
                                                    channelInterpretation: "discrete",
                                                    offset: t1.value
                                                });
                                                return await d(c, t1, e.offset), e;
                                            })), m = n(c, {
                                                channelCount: 1,
                                                channelCountMode: "explicit",
                                                channelInterpretation: "speakers",
                                                numberOfInputs: Math.max(1, t1 + e)
                                            });
                                            for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                                                h[t1].connect(l[t1]);
                                                for(let e = 0; e < g.channelCount; e += 1)l[t1].connect(m, e, t1 * g.channelCount + e);
                                            }
                                            for (const [e, s1] of u.entries())s1.connect(m, 0, t1 + e), s1.start(0);
                                            return m.connect(c.destination), await Promise.all(h.map((t1)=>f(a, c, t1))), _(c);
                                        };
                                        x = _t(a, 0 === s1 ? null : await c(), w, g, k, v, h);
                                    }
                                    const t1 = await x, e = s1(w, {
                                        buffer: null,
                                        channelCount: 2,
                                        channelCountMode: "max",
                                        channelInterpretation: "speakers",
                                        loop: !1,
                                        loopEnd: 0,
                                        loopStart: 0,
                                        playbackRate: 1
                                    }), [c, l, u] = T;
                                    null !== t1 && (e.buffer = t1, e.start(0)), e.connect(c);
                                    for(let t1 = 0, e = 0; t1 < a.numberOfOutputs; t1 += 1){
                                        const s1 = l[t1];
                                        for(let n = 0; n < k[t1]; n += 1)c.connect(s1, e + n, n);
                                        e += k[t1];
                                    }
                                    return u;
                                }
                                if (S) for (const [e, s1] of a.parameters.entries())await t1(w, s1, b.parameters.get(e));
                                else for (const [t1, e] of a.parameters.entries())await d(w, e, b.parameters.get(t1));
                                return await f(a, w, b), b;
                            })(w, b);
                        }
                    };
                })(Xe, _n, Ye, as, Lt, ds, Bt, mn, gn, Ks, tt, Ie, Ce, $e, Te, Cs), Tn = ((t1)=>(e)=>t1.get(e))(tn), Sn = ((t1)=>(e, s1)=>{
                    t1.set(e, s1);
                })(vn), kn = Js ? ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d)=>class extends e {
                    constructor(e, l, p){
                        var d;
                        const _ = a(e), m = c(_), g = ((t1)=>({
                                ...t1,
                                outputChannelCount: void 0 !== t1.outputChannelCount ? t1.outputChannelCount : 1 === t1.numberOfInputs && 1 === t1.numberOfOutputs ? [
                                    t1.channelCount
                                ] : Array.from({
                                    length: t1.numberOfOutputs
                                }, ()=>1)
                            }))({
                            ...ut,
                            ...p
                        });
                        ((t1)=>{
                            const { port1: e, port2: s1 } = new MessageChannel;
                            try {
                                e.postMessage(t1);
                            } finally{
                                e.close(), s1.close();
                            }
                        })(g);
                        const v = f.get(_), y = null == v ? void 0 : v.get(l), x = m || "closed" !== _.state ? _ : null !== (d = r(_)) && void 0 !== d ? d : _, w = i(x, m ? null : e.baseLatency, h, l, y, g);
                        super(e, !0, w, m ? n(l, g, y) : null);
                        const b = [];
                        w.parameters.forEach((t1, e)=>{
                            const n = s1(this, m, t1);
                            b.push([
                                e,
                                n
                            ]);
                        }), this._nativeAudioWorkletNode = w, this._onprocessorerror = null, this._parameters = new lt(b), m && t1(_, this);
                        const { activeInputs: T } = o(this);
                        u(w, T);
                    }
                    get onprocessorerror() {
                        return this._onprocessorerror;
                    }
                    set onprocessorerror(t1) {
                        const e = "function" == typeof t1 ? d(this, t1) : null;
                        this._nativeAudioWorkletNode.onprocessorerror = e;
                        const s1 = this._nativeAudioWorkletNode.onprocessorerror;
                        this._onprocessorerror = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get parameters() {
                        return null === this._parameters ? this._nativeAudioWorkletNode.parameters : this._parameters;
                    }
                    get port() {
                        return this._nativeAudioWorkletNode.port;
                    }
                })(fn, Ve, Je, bn, wn, j, Tn, ke, De, Ie, 0, Sn, 0, ue) : void 0, An = ((t1, e)=>(s1, n, i)=>{
                    if (null === e) throw new Error("Missing the native OfflineAudioContext constructor.");
                    try {
                        return new e(s1, n, i);
                    } catch (e) {
                        if ("SyntaxError" === e.name) throw t1();
                        throw e;
                    }
                })(Zt, Ce), Cn = ((t1, e, s1, n, i, o, r, a)=>(c, h)=>s1(c).render(c, h).then(()=>Promise.all(Array.from(n(h)).map((t1)=>s1(t1).render(t1, h)))).then(()=>i(h)).then((s1)=>("function" != typeof s1.copyFromChannel ? (r(s1), q(s1)) : e(o, ()=>o(s1)) || a(s1), t1.add(s1), s1)))(je, ge, be, dn, Cs, E, Be, Ue), Dn = ((t1, e, s1, n, i)=>class extends t1 {
                    constructor(t1, s1, i){
                        let o;
                        if ("number" == typeof t1 && void 0 !== s1 && void 0 !== i) o = {
                            length: s1,
                            numberOfChannels: t1,
                            sampleRate: i
                        };
                        else {
                            if ("object" != typeof t1) throw new Error("The given parameters are not valid.");
                            o = t1;
                        }
                        const { length: r, numberOfChannels: a, sampleRate: c } = {
                            ...Xt,
                            ...o
                        }, h = n(a, r, c);
                        e(Et, ()=>Et(h)) || h.addEventListener("statechange", (()=>{
                            let t1 = 0;
                            const e = (s1)=>{
                                "running" === this._state && (t1 > 0 ? (h.removeEventListener("statechange", e), s1.stopImmediatePropagation(), this._waitForThePromiseToSettle(s1)) : t1 += 1);
                            };
                            return e;
                        })()), super(h, a), this._length = r, this._nativeOfflineAudioContext = h, this._state = null;
                    }
                    get length() {
                        return void 0 === this._nativeOfflineAudioContext.length ? this._length : this._nativeOfflineAudioContext.length;
                    }
                    get state() {
                        return null === this._state ? this._nativeOfflineAudioContext.state : this._state;
                    }
                    startRendering() {
                        return "running" === this._state ? Promise.reject(s1()) : (this._state = "running", i(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                            this._state = null, W(this);
                        }));
                    }
                    _waitForThePromiseToSettle(t1) {
                        null === this._state ? this._nativeOfflineAudioContext.dispatchEvent(t1) : setTimeout(()=>this._waitForThePromiseToSettle(t1));
                    }
                })(rn, ge, At, An, Cn), On = ((t1, e)=>(s1)=>{
                    const n = t1.get(s1);
                    return e(n) || e(s1);
                })(u, Re), Mn = ((t1, e)=>(s1)=>t1.has(s1) || e(s1))(c, qe), En = ((t1, e)=>(s1)=>t1.has(s1) || e(s1))(l, Fe), Rn = ((t1, e)=>(s1)=>{
                    const n = t1.get(s1);
                    return e(n) || e(s1);
                })(u, De), qn = ()=>(async (t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _)=>!!(t1(e, e) && t1(s1, s1) && t1(i, i) && t1(o, o) && t1(a, a) && t1(c, c) && t1(h, h) && t1(l, l) && t1(u, u) && t1(p, p) && t1(d, d)) && (await Promise.all([
                        t1(n, n),
                        t1(r, r),
                        t1(f, f),
                        t1(_, _)
                    ])).every((t1)=>t1))(ge, ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createBuffer(1, 1, 44100);
                        if (void 0 === e.copyToChannel) return !0;
                        const s1 = new Float32Array(2);
                        try {
                            e.copyFromChannel(s1, 0, 0);
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        if (void 0 !== t1.prototype && void 0 !== t1.prototype.close) return !0;
                        const e = new t1, s1 = void 0 !== e.close;
                        try {
                            e.close();
                        } catch  {}
                        return s1;
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return Promise.resolve(!1);
                        const e = new t1(1, 1, 44100);
                        return new Promise((t1)=>{
                            let s1 = !0;
                            const n = (n)=>{
                                s1 && (s1 = !1, e.startRendering(), t1(n instanceof TypeError));
                            };
                            let i;
                            try {
                                i = e.decodeAudioData(null, ()=>{}, n);
                            } catch (t1) {
                                n(t1);
                            }
                            void 0 !== i && i.catch(n);
                        });
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        let e;
                        try {
                            e = new t1({
                                latencyHint: "balanced"
                            });
                        } catch  {
                            return !1;
                        }
                        return e.close(), !0;
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createGain(), s1 = e.connect(e) === e;
                        return e.disconnect(e), s1;
                    })(Ce), ((t1, e)=>async ()=>{
                        if (null === t1) return !0;
                        if (null === e) return !1;
                        const s1 = new Blob([
                            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
                        ], {
                            type: "application/javascript; charset=utf-8"
                        }), n = new MessageChannel, i = new e(1, 128, 44100), o = URL.createObjectURL(s1);
                        let r = !1;
                        try {
                            await i.audioWorklet.addModule(o);
                            const e = new t1(i, "a", {
                                numberOfOutputs: 0
                            }), s1 = i.createOscillator();
                            await new Promise((t1)=>{
                                e.port.onmessage = ()=>t1(), e.port.postMessage(n.port2, [
                                    n.port2
                                ]);
                            }), e.port.onmessage = ()=>r = !0, s1.connect(e), s1.start(0), await i.startRendering(), r = await new Promise((t1)=>{
                                n.port1.onmessage = ({ data: e })=>t1(1 === e), n.port1.postMessage(0);
                            });
                        } catch  {} finally{
                            n.port1.close(), URL.revokeObjectURL(o);
                        }
                        return r;
                    })(Ie, Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createChannelMerger();
                        if ("max" === e.channelCountMode) return !0;
                        try {
                            e.channelCount = 2;
                        } catch  {
                            return !0;
                        }
                        return !1;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100);
                        return void 0 === e.createConstantSource || e.createConstantSource().offset.maxValue !== Number.POSITIVE_INFINITY;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100), s1 = e.createConvolver();
                        s1.buffer = e.createBuffer(1, 1, e.sampleRate);
                        try {
                            s1.buffer = e.createBuffer(1, 1, e.sampleRate);
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createConvolver();
                        try {
                            e.channelCount = 1;
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ce, ((t1)=>()=>null !== t1 && t1.hasOwnProperty("isSecureContext"))(xe), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1;
                        try {
                            return e.createMediaStreamSource(new MediaStream), !1;
                        } catch (t1) {
                            return !0;
                        } finally{
                            e.close();
                        }
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return Promise.resolve(!1);
                        const e = new t1(1, 1, 44100);
                        if (void 0 === e.createStereoPanner) return Promise.resolve(!0);
                        if (void 0 === e.createConstantSource) return Promise.resolve(!0);
                        const s1 = e.createConstantSource(), n = e.createStereoPanner();
                        return s1.channelCount = 1, s1.offset.value = 1, n.channelCount = 1, s1.start(), s1.connect(n).connect(e.destination), e.startRendering().then((t1)=>1 !== t1.getChannelData(0)[0]);
                    })(Ce), he);
            function Fn(t1) {
                return void 0 === t1;
            }
            function In(t1) {
                return void 0 !== t1;
            }
            function Vn(t1) {
                return "function" == typeof t1;
            }
            function Nn(t1) {
                return "number" == typeof t1;
            }
            function Pn(t1) {
                return "[object Object]" === Object.prototype.toString.call(t1) && t1.constructor === Object;
            }
            function jn(t1) {
                return "boolean" == typeof t1;
            }
            function Ln(t1) {
                return Array.isArray(t1);
            }
            function zn(t1) {
                return "string" == typeof t1;
            }
            function Wn(t1) {
                return zn(t1) && /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(t1);
            }
            function Bn(t1, e) {
                if (!t1) throw new Error(e);
            }
            function Un(t1, e, s1 = 1 / 0) {
                if (!(e <= t1 && t1 <= s1)) throw new RangeError(`Value must be within [${e}, ${s1}], got: ${t1}`);
            }
            function Gn(t1) {
                t1.isOffline || "running" === t1.state || Kn('The AudioContext is "suspended". Invoke Tone.start() from a user action to start the audio.');
            }
            let Qn = !1, Zn = !1;
            function Xn(t1) {
                Qn = t1;
            }
            function Yn(t1) {
                Fn(t1) && Qn && !Zn && (Zn = !0, Kn("Events scheduled inside of scheduled callbacks should use the passed in scheduling time. See https://github.com/Tonejs/Tone.js/wiki/Accurate-Timing"));
            }
            let $n = console;
            function Hn(t1) {
                $n = t1;
            }
            function Jn(...t1) {
                $n.log(...t1);
            }
            function Kn(...t1) {
                $n.warn(...t1);
            }
            const ti = "object" == typeof self ? self : null, ei = ti && (ti.hasOwnProperty("AudioContext") || ti.hasOwnProperty("webkitAudioContext"));
            function si(t1, e, s1, n) {
                var i, o = arguments.length, r = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, s1) : n;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(t1, e, s1, n);
                else for(var a = t1.length - 1; a >= 0; a--)(i = t1[a]) && (r = (o < 3 ? i(r) : o > 3 ? i(e, s1, r) : i(e, s1)) || r);
                return o > 3 && r && Object.defineProperty(e, s1, r), r;
            }
            function ni(t1, e, s1, n) {
                return new (s1 || (s1 = Promise))(function(i, o) {
                    function r(t1) {
                        try {
                            c(n.next(t1));
                        } catch (t1) {
                            o(t1);
                        }
                    }
                    function a(t1) {
                        try {
                            c(n.throw(t1));
                        } catch (t1) {
                            o(t1);
                        }
                    }
                    function c(t1) {
                        var e;
                        t1.done ? i(t1.value) : (e = t1.value, e instanceof s1 ? e : new s1(function(t1) {
                            t1(e);
                        })).then(r, a);
                    }
                    c((n = n.apply(t1, e || [])).next());
                });
            }
            Object.create, Object.create, "function" == typeof SuppressedError && SuppressedError;
            class ii {
                constructor(t1, e, s1, n){
                    this._callback = t1, this._type = e, this._minimumUpdateInterval = Math.max(128 / (n || 44100), .001), this.updateInterval = s1, this._createClock();
                }
                _createWorker() {
                    const t1 = new Blob([
                        `\n\t\t\t// the initial timeout time\n\t\t\tlet timeoutTime =  ${(1e3 * this._updateInterval).toFixed(1)};\n\t\t\t// onmessage callback\n\t\t\tself.onmessage = function(msg){\n\t\t\t\ttimeoutTime = parseInt(msg.data);\n\t\t\t};\n\t\t\t// the tick function which posts a message\n\t\t\t// and schedules a new tick\n\t\t\tfunction tick(){\n\t\t\t\tsetTimeout(tick, timeoutTime);\n\t\t\t\tself.postMessage('tick');\n\t\t\t}\n\t\t\t// call tick initially\n\t\t\ttick();\n\t\t\t`
                    ], {
                        type: "text/javascript"
                    }), e = URL.createObjectURL(t1), s1 = new Worker(e);
                    s1.onmessage = this._callback.bind(this), this._worker = s1;
                }
                _createTimeout() {
                    this._timeout = setTimeout(()=>{
                        this._createTimeout(), this._callback();
                    }, 1e3 * this._updateInterval);
                }
                _createClock() {
                    if ("worker" === this._type) try {
                        this._createWorker();
                    } catch (t1) {
                        this._type = "timeout", this._createClock();
                    }
                    else "timeout" === this._type && this._createTimeout();
                }
                _disposeClock() {
                    this._timeout && clearTimeout(this._timeout), this._worker && (this._worker.terminate(), this._worker.onmessage = null);
                }
                get updateInterval() {
                    return this._updateInterval;
                }
                set updateInterval(t1) {
                    var e;
                    this._updateInterval = Math.max(t1, this._minimumUpdateInterval), "worker" === this._type && (null === (e = this._worker) || void 0 === e || e.postMessage(1e3 * this._updateInterval));
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._disposeClock(), this._type = t1, this._createClock();
                }
                dispose() {
                    this._disposeClock();
                }
            }
            function oi(t1) {
                return En(t1);
            }
            function ri(t1) {
                return Mn(t1);
            }
            function ai(t1) {
                return Rn(t1);
            }
            function ci(t1) {
                return On(t1);
            }
            function hi(t1, e) {
                return "value" === t1 || oi(e) || ri(e) || function(t1) {
                    return t1 instanceof Ge;
                }(e);
            }
            function li(t1, ...e) {
                if (!e.length) return t1;
                const s1 = e.shift();
                if (Pn(t1) && Pn(s1)) for(const e in s1)hi(e, s1[e]) ? t1[e] = s1[e] : Pn(s1[e]) ? (t1[e] || Object.assign(t1, {
                    [e]: {}
                }), li(t1[e], s1[e])) : Object.assign(t1, {
                    [e]: s1[e]
                });
                return li(t1, ...e);
            }
            function ui(t1, e, s1 = [], n) {
                const i = {}, o = Array.from(e);
                if (Pn(o[0]) && n && !Reflect.has(o[0], n) && (Object.keys(o[0]).some((e)=>Reflect.has(t1, e)) || (li(i, {
                    [n]: o[0]
                }), s1.splice(s1.indexOf(n), 1), o.shift())), 1 === o.length && Pn(o[0])) li(i, o[0]);
                else for(let t1 = 0; t1 < s1.length; t1++)In(o[t1]) && (i[s1[t1]] = o[t1]);
                return li(t1, i);
            }
            function pi(t1, e) {
                return Fn(t1) ? e : t1;
            }
            function di(t1, e) {
                return e.forEach((e)=>{
                    Reflect.has(t1, e) && delete t1[e];
                }), t1;
            }
            class fi {
                constructor(){
                    this.debug = !1, this._wasDisposed = !1;
                }
                static getDefaults() {
                    return {};
                }
                log(...t1) {
                    (this.debug || ti && this.toString() === ti.TONE_DEBUG_CLASS) && Jn(this, ...t1);
                }
                dispose() {
                    return this._wasDisposed = !0, this;
                }
                get disposed() {
                    return this._wasDisposed;
                }
                toString() {
                    return this.name;
                }
            }
            fi.version = i;
            const _i = 1e-6;
            function mi(t1, e) {
                return t1 > e + _i;
            }
            function gi(t1, e) {
                return mi(t1, e) || yi(t1, e);
            }
            function vi(t1, e) {
                return t1 + _i < e;
            }
            function yi(t1, e) {
                return Math.abs(t1 - e) < _i;
            }
            function xi(t1, e, s1) {
                return Math.max(Math.min(t1, s1), e);
            }
            class wi extends fi {
                constructor(){
                    super(), this.name = "Timeline", this._timeline = [];
                    const t1 = ui(wi.getDefaults(), arguments, [
                        "memory"
                    ]);
                    this.memory = t1.memory, this.increasing = t1.increasing;
                }
                static getDefaults() {
                    return {
                        memory: 1 / 0,
                        increasing: !1
                    };
                }
                get length() {
                    return this._timeline.length;
                }
                add(t1) {
                    if (Bn(Reflect.has(t1, "time"), "Timeline: events must have a time attribute"), t1.time = t1.time.valueOf(), this.increasing && this.length) {
                        const e = this._timeline[this.length - 1];
                        Bn(gi(t1.time, e.time), "The time must be greater than or equal to the last scheduled time"), this._timeline.push(t1);
                    } else {
                        const e = this._search(t1.time);
                        this._timeline.splice(e + 1, 0, t1);
                    }
                    if (this.length > this.memory) {
                        const t1 = this.length - this.memory;
                        this._timeline.splice(0, t1);
                    }
                    return this;
                }
                remove(t1) {
                    const e = this._timeline.indexOf(t1);
                    return -1 !== e && this._timeline.splice(e, 1), this;
                }
                get(t1, e = "time") {
                    const s1 = this._search(t1, e);
                    return -1 !== s1 ? this._timeline[s1] : null;
                }
                peek() {
                    return this._timeline[0];
                }
                shift() {
                    return this._timeline.shift();
                }
                getAfter(t1, e = "time") {
                    const s1 = this._search(t1, e);
                    return s1 + 1 < this._timeline.length ? this._timeline[s1 + 1] : null;
                }
                getBefore(t1) {
                    const e = this._timeline.length;
                    if (e > 0 && this._timeline[e - 1].time < t1) return this._timeline[e - 1];
                    const s1 = this._search(t1);
                    return s1 - 1 >= 0 ? this._timeline[s1 - 1] : null;
                }
                cancel(t1) {
                    if (this._timeline.length > 1) {
                        let e = this._search(t1);
                        if (e >= 0) {
                            if (yi(this._timeline[e].time, t1)) {
                                for(let s1 = e; s1 >= 0 && yi(this._timeline[s1].time, t1); s1--)e = s1;
                                this._timeline = this._timeline.slice(0, e);
                            } else this._timeline = this._timeline.slice(0, e + 1);
                        } else this._timeline = [];
                    } else 1 === this._timeline.length && gi(this._timeline[0].time, t1) && (this._timeline = []);
                    return this;
                }
                cancelBefore(t1) {
                    const e = this._search(t1);
                    return e >= 0 && (this._timeline = this._timeline.slice(e + 1)), this;
                }
                previousEvent(t1) {
                    const e = this._timeline.indexOf(t1);
                    return e > 0 ? this._timeline[e - 1] : null;
                }
                _search(t1, e = "time") {
                    if (0 === this._timeline.length) return -1;
                    let s1 = 0;
                    const n = this._timeline.length;
                    let i = n;
                    if (n > 0 && this._timeline[n - 1][e] <= t1) return n - 1;
                    for(; s1 < i;){
                        let n = Math.floor(s1 + (i - s1) / 2);
                        const o = this._timeline[n], r = this._timeline[n + 1];
                        if (yi(o[e], t1)) {
                            for(let s1 = n; s1 < this._timeline.length && yi(this._timeline[s1][e], t1); s1++)n = s1;
                            return n;
                        }
                        if (vi(o[e], t1) && mi(r[e], t1)) return n;
                        mi(o[e], t1) ? i = n : s1 = n + 1;
                    }
                    return -1;
                }
                _iterate(t1, e = 0, s1 = this._timeline.length - 1) {
                    this._timeline.slice(e, s1 + 1).forEach(t1);
                }
                forEach(t1) {
                    return this._iterate(t1), this;
                }
                forEachBefore(t1, e) {
                    const s1 = this._search(t1);
                    return -1 !== s1 && this._iterate(e, 0, s1), this;
                }
                forEachAfter(t1, e) {
                    const s1 = this._search(t1);
                    return this._iterate(e, s1 + 1), this;
                }
                forEachBetween(t1, e, s1) {
                    let n = this._search(t1), i = this._search(e);
                    return -1 !== n && -1 !== i ? (this._timeline[n].time !== t1 && (n += 1), this._timeline[i].time === e && (i -= 1), this._iterate(s1, n, i)) : -1 === n && this._iterate(s1, 0, i), this;
                }
                forEachFrom(t1, e) {
                    let s1 = this._search(t1);
                    for(; s1 >= 0 && this._timeline[s1].time >= t1;)s1--;
                    return this._iterate(e, s1 + 1), this;
                }
                forEachAtTime(t1, e) {
                    const s1 = this._search(t1);
                    if (-1 !== s1 && yi(this._timeline[s1].time, t1)) {
                        let n = s1;
                        for(let e = s1; e >= 0 && yi(this._timeline[e].time, t1); e--)n = e;
                        this._iterate((t1)=>{
                            e(t1);
                        }, n, s1);
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), this._timeline = [], this;
                }
            }
            const bi = [];
            function Ti(t1) {
                bi.push(t1);
            }
            const Si = [];
            function ki(t1) {
                Si.push(t1);
            }
            class Ai extends fi {
                constructor(){
                    super(...arguments), this.name = "Emitter";
                }
                on(t1, e) {
                    return t1.split(/\W+/).forEach((t1)=>{
                        Fn(this._events) && (this._events = {}), this._events.hasOwnProperty(t1) || (this._events[t1] = []), this._events[t1].push(e);
                    }), this;
                }
                once(t1, e) {
                    const s1 = (...n)=>{
                        e(...n), this.off(t1, s1);
                    };
                    return this.on(t1, s1), this;
                }
                off(t1, e) {
                    return t1.split(/\W+/).forEach((t1)=>{
                        if (Fn(this._events) && (this._events = {}), this._events.hasOwnProperty(t1)) {
                            if (Fn(e)) this._events[t1] = [];
                            else {
                                const s1 = this._events[t1];
                                for(let t1 = s1.length - 1; t1 >= 0; t1--)s1[t1] === e && s1.splice(t1, 1);
                            }
                        }
                    }), this;
                }
                emit(t1, ...e) {
                    if (this._events && this._events.hasOwnProperty(t1)) {
                        const s1 = this._events[t1].slice(0);
                        for(let t1 = 0, n = s1.length; t1 < n; t1++)s1[t1].apply(this, e);
                    }
                    return this;
                }
                static mixin(t1) {
                    [
                        "on",
                        "once",
                        "off",
                        "emit"
                    ].forEach((e)=>{
                        const s1 = Object.getOwnPropertyDescriptor(Ai.prototype, e);
                        Object.defineProperty(t1.prototype, e, s1);
                    });
                }
                dispose() {
                    return super.dispose(), this._events = void 0, this;
                }
            }
            class Ci extends Ai {
                constructor(){
                    super(...arguments), this.isOffline = !1;
                }
                toJSON() {
                    return {};
                }
            }
            class Di extends Ci {
                constructor(){
                    var t1, e;
                    super(), this.name = "Context", this._constants = new Map, this._timeouts = new wi, this._timeoutIds = 0, this._initialized = !1, this._closeStarted = !1, this.isOffline = !1, this._workletPromise = null;
                    const s1 = ui(Di.getDefaults(), arguments, [
                        "context"
                    ]);
                    s1.context ? (this._context = s1.context, this._latencyHint = (null === (t1 = arguments[0]) || void 0 === t1 ? void 0 : t1.latencyHint) || "") : (this._context = function(t1) {
                        return new pn(t1);
                    }({
                        latencyHint: s1.latencyHint
                    }), this._latencyHint = s1.latencyHint), this._ticker = new ii(this.emit.bind(this, "tick"), s1.clockSource, s1.updateInterval, this._context.sampleRate), this.on("tick", this._timeoutLoop.bind(this)), this._context.onstatechange = ()=>{
                        this.emit("statechange", this.state);
                    }, this[(null === (e = arguments[0]) || void 0 === e ? void 0 : e.hasOwnProperty("updateInterval")) ? "_lookAhead" : "lookAhead"] = s1.lookAhead;
                }
                static getDefaults() {
                    return {
                        clockSource: "worker",
                        latencyHint: "interactive",
                        lookAhead: .1,
                        updateInterval: .05
                    };
                }
                initialize() {
                    var t1;
                    return this._initialized || (t1 = this, bi.forEach((e)=>e(t1)), this._initialized = !0), this;
                }
                createAnalyser() {
                    return this._context.createAnalyser();
                }
                createOscillator() {
                    return this._context.createOscillator();
                }
                createBufferSource() {
                    return this._context.createBufferSource();
                }
                createBiquadFilter() {
                    return this._context.createBiquadFilter();
                }
                createBuffer(t1, e, s1) {
                    return this._context.createBuffer(t1, e, s1);
                }
                createChannelMerger(t1) {
                    return this._context.createChannelMerger(t1);
                }
                createChannelSplitter(t1) {
                    return this._context.createChannelSplitter(t1);
                }
                createConstantSource() {
                    return this._context.createConstantSource();
                }
                createConvolver() {
                    return this._context.createConvolver();
                }
                createDelay(t1) {
                    return this._context.createDelay(t1);
                }
                createDynamicsCompressor() {
                    return this._context.createDynamicsCompressor();
                }
                createGain() {
                    return this._context.createGain();
                }
                createIIRFilter(t1, e) {
                    return this._context.createIIRFilter(t1, e);
                }
                createPanner() {
                    return this._context.createPanner();
                }
                createPeriodicWave(t1, e, s1) {
                    return this._context.createPeriodicWave(t1, e, s1);
                }
                createStereoPanner() {
                    return this._context.createStereoPanner();
                }
                createWaveShaper() {
                    return this._context.createWaveShaper();
                }
                createMediaStreamSource(t1) {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaStreamSource(t1);
                }
                createMediaElementSource(t1) {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaElementSource(t1);
                }
                createMediaStreamDestination() {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaStreamDestination();
                }
                decodeAudioData(t1) {
                    return this._context.decodeAudioData(t1);
                }
                get currentTime() {
                    return this._context.currentTime;
                }
                get state() {
                    return this._context.state;
                }
                get sampleRate() {
                    return this._context.sampleRate;
                }
                get listener() {
                    return this.initialize(), this._listener;
                }
                set listener(t1) {
                    Bn(!this._initialized, "The listener cannot be set after initialization."), this._listener = t1;
                }
                get transport() {
                    return this.initialize(), this._transport;
                }
                set transport(t1) {
                    Bn(!this._initialized, "The transport cannot be set after initialization."), this._transport = t1;
                }
                get draw() {
                    return this.initialize(), this._draw;
                }
                set draw(t1) {
                    Bn(!this._initialized, "Draw cannot be set after initialization."), this._draw = t1;
                }
                get destination() {
                    return this.initialize(), this._destination;
                }
                set destination(t1) {
                    Bn(!this._initialized, "The destination cannot be set after initialization."), this._destination = t1;
                }
                createAudioWorkletNode(t1, e) {
                    return function(t1, e, s1) {
                        return Bn(In(kn), "This node only works in a secure context (https or localhost)"), new kn(t1, e, s1);
                    }(this.rawContext, t1, e);
                }
                addAudioWorkletModule(t1) {
                    return ni(this, void 0, void 0, function*() {
                        Bn(In(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)"), this._workletPromise || (this._workletPromise = this.rawContext.audioWorklet.addModule(t1)), yield this._workletPromise;
                    });
                }
                workletsAreReady() {
                    return ni(this, void 0, void 0, function*() {
                        (yield this._workletPromise) ? this._workletPromise : Promise.resolve();
                    });
                }
                get updateInterval() {
                    return this._ticker.updateInterval;
                }
                set updateInterval(t1) {
                    this._ticker.updateInterval = t1;
                }
                get clockSource() {
                    return this._ticker.type;
                }
                set clockSource(t1) {
                    this._ticker.type = t1;
                }
                get lookAhead() {
                    return this._lookAhead;
                }
                set lookAhead(t1) {
                    this._lookAhead = t1, this.updateInterval = t1 ? t1 / 2 : .01;
                }
                get latencyHint() {
                    return this._latencyHint;
                }
                get rawContext() {
                    return this._context;
                }
                now() {
                    return this._context.currentTime + this._lookAhead;
                }
                immediate() {
                    return this._context.currentTime;
                }
                resume() {
                    return ci(this._context) ? this._context.resume() : Promise.resolve();
                }
                close() {
                    return ni(this, void 0, void 0, function*() {
                        var t1;
                        ci(this._context) && "closed" !== this.state && !this._closeStarted && (this._closeStarted = !0, yield this._context.close()), this._initialized && (t1 = this, Si.forEach((e)=>e(t1)));
                    });
                }
                getConstant(t1) {
                    if (this._constants.has(t1)) return this._constants.get(t1);
                    {
                        const e = this._context.createBuffer(1, 128, this._context.sampleRate), s1 = e.getChannelData(0);
                        for(let e = 0; e < s1.length; e++)s1[e] = t1;
                        const n = this._context.createBufferSource();
                        return n.channelCount = 1, n.channelCountMode = "explicit", n.buffer = e, n.loop = !0, n.start(0), this._constants.set(t1, n), n;
                    }
                }
                dispose() {
                    return super.dispose(), this._ticker.dispose(), this._timeouts.dispose(), Object.keys(this._constants).map((t1)=>this._constants[t1].disconnect()), this.close(), this;
                }
                _timeoutLoop() {
                    const t1 = this.now();
                    let e = this._timeouts.peek();
                    for(; this._timeouts.length && e && e.time <= t1;)e.callback(), this._timeouts.shift(), e = this._timeouts.peek();
                }
                setTimeout(t1, e) {
                    this._timeoutIds++;
                    const s1 = this.now();
                    return this._timeouts.add({
                        callback: t1,
                        id: this._timeoutIds,
                        time: s1 + e
                    }), this._timeoutIds;
                }
                clearTimeout(t1) {
                    return this._timeouts.forEach((e)=>{
                        e.id === t1 && this._timeouts.remove(e);
                    }), this;
                }
                clearInterval(t1) {
                    return this.clearTimeout(t1);
                }
                setInterval(t1, e) {
                    const s1 = ++this._timeoutIds, n = ()=>{
                        const i = this.now();
                        this._timeouts.add({
                            callback: ()=>{
                                t1(), n();
                            },
                            id: s1,
                            time: i + e
                        });
                    };
                    return n(), s1;
                }
            }
            function Oi(t1, e) {
                Ln(e) ? e.forEach((e)=>Oi(t1, e)) : Object.defineProperty(t1, e, {
                    enumerable: !0,
                    writable: !1
                });
            }
            function Mi(t1, e) {
                Ln(e) ? e.forEach((e)=>Mi(t1, e)) : Object.defineProperty(t1, e, {
                    writable: !0
                });
            }
            const Ei = ()=>{};
            class Ri extends fi {
                constructor(){
                    super(), this.name = "ToneAudioBuffer", this.onload = Ei;
                    const t1 = ui(Ri.getDefaults(), arguments, [
                        "url",
                        "onload",
                        "onerror"
                    ]);
                    this.reverse = t1.reverse, this.onload = t1.onload, zn(t1.url) ? this.load(t1.url).catch(t1.onerror) : t1.url && this.set(t1.url);
                }
                static getDefaults() {
                    return {
                        onerror: Ei,
                        onload: Ei,
                        reverse: !1
                    };
                }
                get sampleRate() {
                    return this._buffer ? this._buffer.sampleRate : Vi().sampleRate;
                }
                set(t1) {
                    return t1 instanceof Ri ? t1.loaded ? this._buffer = t1.get() : t1.onload = ()=>{
                        this.set(t1), this.onload(this);
                    } : this._buffer = t1, this._reversed && this._reverse(), this;
                }
                get() {
                    return this._buffer;
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = Ri.load(t1).then((t1)=>{
                            this.set(t1), this.onload(this);
                        });
                        Ri.downloads.push(e);
                        try {
                            yield e;
                        } finally{
                            const t1 = Ri.downloads.indexOf(e);
                            Ri.downloads.splice(t1, 1);
                        }
                        return this;
                    });
                }
                dispose() {
                    return super.dispose(), this._buffer = void 0, this;
                }
                fromArray(t1) {
                    const e = Ln(t1) && t1[0].length > 0, s1 = e ? t1.length : 1, n = e ? t1[0].length : t1.length, i = Vi(), o = i.createBuffer(s1, n, i.sampleRate), r = e || 1 !== s1 ? t1 : [
                        t1
                    ];
                    for(let t1 = 0; t1 < s1; t1++)o.copyToChannel(r[t1], t1);
                    return this._buffer = o, this;
                }
                toMono(t1) {
                    if (Nn(t1)) this.fromArray(this.toArray(t1));
                    else {
                        let t1 = new Float32Array(this.length);
                        const e = this.numberOfChannels;
                        for(let s1 = 0; s1 < e; s1++){
                            const e = this.toArray(s1);
                            for(let s1 = 0; s1 < e.length; s1++)t1[s1] += e[s1];
                        }
                        t1 = t1.map((t1)=>t1 / e), this.fromArray(t1);
                    }
                    return this;
                }
                toArray(t1) {
                    if (Nn(t1)) return this.getChannelData(t1);
                    if (1 === this.numberOfChannels) return this.toArray(0);
                    {
                        const t1 = [];
                        for(let e = 0; e < this.numberOfChannels; e++)t1[e] = this.getChannelData(e);
                        return t1;
                    }
                }
                getChannelData(t1) {
                    return this._buffer ? this._buffer.getChannelData(t1) : new Float32Array(0);
                }
                slice(t1, e = this.duration) {
                    Bn(this.loaded, "Buffer is not loaded");
                    const s1 = Math.floor(t1 * this.sampleRate), n = Math.floor(e * this.sampleRate);
                    Bn(s1 < n, "The start time must be less than the end time");
                    const i = n - s1, o = Vi().createBuffer(this.numberOfChannels, i, this.sampleRate);
                    for(let t1 = 0; t1 < this.numberOfChannels; t1++)o.copyToChannel(this.getChannelData(t1).subarray(s1, n), t1);
                    return new Ri(o);
                }
                _reverse() {
                    if (this.loaded) for(let t1 = 0; t1 < this.numberOfChannels; t1++)this.getChannelData(t1).reverse();
                    return this;
                }
                get loaded() {
                    return this.length > 0;
                }
                get duration() {
                    return this._buffer ? this._buffer.duration : 0;
                }
                get length() {
                    return this._buffer ? this._buffer.length : 0;
                }
                get numberOfChannels() {
                    return this._buffer ? this._buffer.numberOfChannels : 0;
                }
                get reverse() {
                    return this._reversed;
                }
                set reverse(t1) {
                    this._reversed !== t1 && (this._reversed = t1, this._reverse());
                }
                static fromArray(t1) {
                    return (new Ri).fromArray(t1);
                }
                static fromUrl(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = new Ri;
                        return yield e.load(t1);
                    });
                }
                static load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = t1.match(/\[([^\]\[]+\|.+)\]$/);
                        if (e) {
                            const s1 = e[1].split("|");
                            let n = s1[0];
                            for (const t1 of s1)if (Ri.supportsType(t1)) {
                                n = t1;
                                break;
                            }
                            t1 = t1.replace(e[0], n);
                        }
                        const s1 = "" === Ri.baseUrl || Ri.baseUrl.endsWith("/") ? Ri.baseUrl : Ri.baseUrl + "/", n = document.createElement("a");
                        n.href = s1 + t1, n.pathname = (n.pathname + n.hash).split("/").map(encodeURIComponent).join("/");
                        const i = yield fetch(n.href);
                        if (!i.ok) throw new Error(`could not load url: ${t1}`);
                        const o = yield i.arrayBuffer();
                        return yield Vi().decodeAudioData(o);
                    });
                }
                static supportsType(t1) {
                    const e = t1.split("."), s1 = e[e.length - 1];
                    return "" !== document.createElement("audio").canPlayType("audio/" + s1);
                }
                static loaded() {
                    return ni(this, void 0, void 0, function*() {
                        for(yield Promise.resolve(); Ri.downloads.length;)yield Ri.downloads[0];
                    });
                }
            }
            Ri.baseUrl = "", Ri.downloads = [];
            class qi extends Di {
                constructor(){
                    var t1, e, s1;
                    super({
                        clockSource: "offline",
                        context: ai(arguments[0]) ? arguments[0] : (t1 = arguments[0], e = arguments[1] * arguments[2], s1 = arguments[2], new Dn(t1, e, s1)),
                        lookAhead: 0,
                        updateInterval: ai(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
                    }), this.name = "OfflineContext", this._currentTime = 0, this.isOffline = !0, this._duration = ai(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
                }
                now() {
                    return this._currentTime;
                }
                get currentTime() {
                    return this._currentTime;
                }
                _renderClock(t1) {
                    return ni(this, void 0, void 0, function*() {
                        let e = 0;
                        for(; this._duration - this._currentTime >= 0;){
                            this.emit("tick"), this._currentTime += 128 / this.sampleRate, e++;
                            const s1 = Math.floor(this.sampleRate / 128);
                            t1 && e % s1 == 0 && (yield new Promise((t1)=>setTimeout(t1, 1)));
                        }
                    });
                }
                render(t1 = !0) {
                    return ni(this, void 0, void 0, function*() {
                        yield this.workletsAreReady(), yield this._renderClock(t1);
                        const e = yield this._context.startRendering();
                        return new Ri(e);
                    });
                }
                close() {
                    return Promise.resolve();
                }
            }
            const Fi = new class extends Ci {
                constructor(){
                    super(...arguments), this.lookAhead = 0, this.latencyHint = 0, this.isOffline = !1;
                }
                createAnalyser() {
                    return {};
                }
                createOscillator() {
                    return {};
                }
                createBufferSource() {
                    return {};
                }
                createBiquadFilter() {
                    return {};
                }
                createBuffer(t1, e, s1) {
                    return {};
                }
                createChannelMerger(t1) {
                    return {};
                }
                createChannelSplitter(t1) {
                    return {};
                }
                createConstantSource() {
                    return {};
                }
                createConvolver() {
                    return {};
                }
                createDelay(t1) {
                    return {};
                }
                createDynamicsCompressor() {
                    return {};
                }
                createGain() {
                    return {};
                }
                createIIRFilter(t1, e) {
                    return {};
                }
                createPanner() {
                    return {};
                }
                createPeriodicWave(t1, e, s1) {
                    return {};
                }
                createStereoPanner() {
                    return {};
                }
                createWaveShaper() {
                    return {};
                }
                createMediaStreamSource(t1) {
                    return {};
                }
                createMediaElementSource(t1) {
                    return {};
                }
                createMediaStreamDestination() {
                    return {};
                }
                decodeAudioData(t1) {
                    return Promise.resolve({});
                }
                createAudioWorkletNode(t1, e) {
                    return {};
                }
                get rawContext() {
                    return {};
                }
                addAudioWorkletModule(t1) {
                    return ni(this, void 0, void 0, function*() {
                        return Promise.resolve();
                    });
                }
                resume() {
                    return Promise.resolve();
                }
                setTimeout(t1, e) {
                    return 0;
                }
                clearTimeout(t1) {
                    return this;
                }
                setInterval(t1, e) {
                    return 0;
                }
                clearInterval(t1) {
                    return this;
                }
                getConstant(t1) {
                    return {};
                }
                get currentTime() {
                    return 0;
                }
                get state() {
                    return {};
                }
                get sampleRate() {
                    return 0;
                }
                get listener() {
                    return {};
                }
                get transport() {
                    return {};
                }
                get draw() {
                    return {};
                }
                set draw(t1) {}
                get destination() {
                    return {};
                }
                set destination(t1) {}
                now() {
                    return 0;
                }
                immediate() {
                    return 0;
                }
            };
            let Ii = Fi;
            function Vi() {
                return Ii === Fi && ei && Ni(new Di), Ii;
            }
            function Ni(t1, e = !1) {
                e && Ii.dispose(), Ii = ci(t1) ? new Di(t1) : ai(t1) ? new qi(t1) : t1;
            }
            function Pi() {
                return Ii.resume();
            }
            if (ti && !ti.TONE_SILENCE_LOGGING) {
                let t1 = "v";
                "dev" === i && (t1 = "");
                const e = ` * Tone.js ${t1}${i} * `;
                console.log(`%c${e}`, "background: #000; color: #fff");
            }
            function ji(t1) {
                return Math.pow(10, t1 / 20);
            }
            function Li(t1) {
                return Math.log(t1) / Math.LN10 * 20;
            }
            function zi(t1) {
                return Math.pow(2, t1 / 12);
            }
            let Wi = 440;
            function Bi(t1) {
                return Math.round(Ui(t1));
            }
            function Ui(t1) {
                return 69 + 12 * Math.log2(t1 / Wi);
            }
            function Gi(t1) {
                return Wi * Math.pow(2, (t1 - 69) / 12);
            }
            class Qi extends fi {
                constructor(t1, e, s1){
                    super(), this.defaultUnits = "s", this._val = e, this._units = s1, this.context = t1, this._expressions = this._getExpressions();
                }
                _getExpressions() {
                    return {
                        hz: {
                            method: (t1)=>this._frequencyToUnits(parseFloat(t1)),
                            regexp: /^(\d+(?:\.\d+)?)hz$/i
                        },
                        i: {
                            method: (t1)=>this._ticksToUnits(parseInt(t1, 10)),
                            regexp: /^(\d+)i$/i
                        },
                        m: {
                            method: (t1)=>this._beatsToUnits(parseInt(t1, 10) * this._getTimeSignature()),
                            regexp: /^(\d+)m$/i
                        },
                        n: {
                            method: (t1, e)=>{
                                const s1 = parseInt(t1, 10), n = "." === e ? 1.5 : 1;
                                return 1 === s1 ? this._beatsToUnits(this._getTimeSignature()) * n : this._beatsToUnits(4 / s1) * n;
                            },
                            regexp: /^(\d+)n(\.?)$/i
                        },
                        number: {
                            method: (t1)=>this._expressions[this.defaultUnits].method.call(this, t1),
                            regexp: /^(\d+(?:\.\d+)?)$/
                        },
                        s: {
                            method: (t1)=>this._secondsToUnits(parseFloat(t1)),
                            regexp: /^(\d+(?:\.\d+)?)s$/
                        },
                        samples: {
                            method: (t1)=>parseInt(t1, 10) / this.context.sampleRate,
                            regexp: /^(\d+)samples$/
                        },
                        t: {
                            method: (t1)=>{
                                const e = parseInt(t1, 10);
                                return this._beatsToUnits(8 / (3 * Math.floor(e)));
                            },
                            regexp: /^(\d+)t$/i
                        },
                        tr: {
                            method: (t1, e, s1)=>{
                                let n = 0;
                                return t1 && "0" !== t1 && (n += this._beatsToUnits(this._getTimeSignature() * parseFloat(t1))), e && "0" !== e && (n += this._beatsToUnits(parseFloat(e))), s1 && "0" !== s1 && (n += this._beatsToUnits(parseFloat(s1) / 4)), n;
                            },
                            regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/
                        }
                    };
                }
                valueOf() {
                    if (this._val instanceof Qi && this.fromType(this._val), Fn(this._val)) return this._noArg();
                    if (zn(this._val) && Fn(this._units)) {
                        for(const t1 in this._expressions)if (this._expressions[t1].regexp.test(this._val.trim())) {
                            this._units = t1;
                            break;
                        }
                    } else if (Pn(this._val)) {
                        let t1 = 0;
                        for(const e in this._val)if (In(this._val[e])) {
                            const s1 = this._val[e];
                            t1 += new this.constructor(this.context, e).valueOf() * s1;
                        }
                        return t1;
                    }
                    if (In(this._units)) {
                        const t1 = this._expressions[this._units], e = this._val.toString().trim().match(t1.regexp);
                        return e ? t1.method.apply(this, e.slice(1)) : t1.method.call(this, this._val);
                    }
                    return zn(this._val) ? parseFloat(this._val) : this._val;
                }
                _frequencyToUnits(t1) {
                    return 1 / t1;
                }
                _beatsToUnits(t1) {
                    return 60 / this._getBpm() * t1;
                }
                _secondsToUnits(t1) {
                    return t1;
                }
                _ticksToUnits(t1) {
                    return t1 * this._beatsToUnits(1) / this._getPPQ();
                }
                _noArg() {
                    return this._now();
                }
                _getBpm() {
                    return this.context.transport.bpm.value;
                }
                _getTimeSignature() {
                    return this.context.transport.timeSignature;
                }
                _getPPQ() {
                    return this.context.transport.PPQ;
                }
                fromType(t1) {
                    switch(this._units = void 0, this.defaultUnits){
                        case "s":
                            this._val = t1.toSeconds();
                            break;
                        case "i":
                            this._val = t1.toTicks();
                            break;
                        case "hz":
                            this._val = t1.toFrequency();
                            break;
                        case "midi":
                            this._val = t1.toMidi();
                    }
                    return this;
                }
                toFrequency() {
                    return 1 / this.toSeconds();
                }
                toSamples() {
                    return this.toSeconds() * this.context.sampleRate;
                }
                toMilliseconds() {
                    return 1e3 * this.toSeconds();
                }
            }
            class Zi extends Qi {
                constructor(){
                    super(...arguments), this.name = "TimeClass";
                }
                _getExpressions() {
                    return Object.assign(super._getExpressions(), {
                        now: {
                            method: (t1)=>this._now() + new this.constructor(this.context, t1).valueOf(),
                            regexp: /^\+(.+)/
                        },
                        quantize: {
                            method: (t1)=>{
                                const e = new Zi(this.context, t1).valueOf();
                                return this._secondsToUnits(this.context.transport.nextSubdivision(e));
                            },
                            regexp: /^@(.+)/
                        }
                    });
                }
                quantize(t1, e = 1) {
                    const s1 = new this.constructor(this.context, t1).valueOf(), n = this.valueOf();
                    return n + (Math.round(n / s1) * s1 - n) * e;
                }
                toNotation() {
                    const t1 = this.toSeconds(), e = [
                        "1m"
                    ];
                    for(let t1 = 1; t1 < 9; t1++){
                        const s1 = Math.pow(2, t1);
                        e.push(s1 + "n."), e.push(s1 + "n"), e.push(s1 + "t");
                    }
                    e.push("0");
                    let s1 = e[0], n = new Zi(this.context, e[0]).toSeconds();
                    return e.forEach((e)=>{
                        const i = new Zi(this.context, e).toSeconds();
                        Math.abs(i - t1) < Math.abs(n - t1) && (s1 = e, n = i);
                    }), s1;
                }
                toBarsBeatsSixteenths() {
                    const t1 = this._beatsToUnits(1);
                    let e = this.valueOf() / t1;
                    e = parseFloat(e.toFixed(4));
                    const s1 = Math.floor(e / this._getTimeSignature());
                    let n = e % 1 * 4;
                    e = Math.floor(e) % this._getTimeSignature();
                    const i = n.toString();
                    return i.length > 3 && (n = parseFloat(parseFloat(i).toFixed(3))), [
                        s1,
                        e,
                        n
                    ].join(":");
                }
                toTicks() {
                    const t1 = this._beatsToUnits(1);
                    return this.valueOf() / t1 * this._getPPQ();
                }
                toSeconds() {
                    return this.valueOf();
                }
                toMidi() {
                    return Bi(this.toFrequency());
                }
                _now() {
                    return this.context.now();
                }
            }
            function Xi(t1, e) {
                return new Zi(Vi(), t1, e);
            }
            class Yi extends Zi {
                constructor(){
                    super(...arguments), this.name = "Frequency", this.defaultUnits = "hz";
                }
                static get A4() {
                    return Wi;
                }
                static set A4(t1) {
                    !function(t1) {
                        Wi = t1;
                    }(t1);
                }
                _getExpressions() {
                    return Object.assign({}, super._getExpressions(), {
                        midi: {
                            regexp: /^(\d+(?:\.\d+)?midi)/,
                            method (t1) {
                                return "midi" === this.defaultUnits ? t1 : Yi.mtof(t1);
                            }
                        },
                        note: {
                            regexp: /^([a-g]{1}(?:b|#|##|x|bb|###|#x|x#|bbb)?)(-?[0-9]+)/i,
                            method (t1, e) {
                                const s1 = $i[t1.toLowerCase()] + 12 * (parseInt(e, 10) + 1);
                                return "midi" === this.defaultUnits ? s1 : Yi.mtof(s1);
                            }
                        },
                        tr: {
                            regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                            method (t1, e, s1) {
                                let n = 1;
                                return t1 && "0" !== t1 && (n *= this._beatsToUnits(this._getTimeSignature() * parseFloat(t1))), e && "0" !== e && (n *= this._beatsToUnits(parseFloat(e))), s1 && "0" !== s1 && (n *= this._beatsToUnits(parseFloat(s1) / 4)), n;
                            }
                        }
                    });
                }
                transpose(t1) {
                    return new Yi(this.context, this.valueOf() * zi(t1));
                }
                harmonize(t1) {
                    return t1.map((t1)=>this.transpose(t1));
                }
                toMidi() {
                    return Bi(this.valueOf());
                }
                toNote() {
                    const t1 = this.toFrequency(), e = Math.log2(t1 / Yi.A4);
                    let s1 = Math.round(12 * e) + 57;
                    const n = Math.floor(s1 / 12);
                    return n < 0 && (s1 += -12 * n), Hi[s1 % 12] + n.toString();
                }
                toSeconds() {
                    return 1 / super.toSeconds();
                }
                toTicks() {
                    const t1 = this._beatsToUnits(1), e = this.valueOf() / t1;
                    return Math.floor(e * this._getPPQ());
                }
                _noArg() {
                    return 0;
                }
                _frequencyToUnits(t1) {
                    return t1;
                }
                _ticksToUnits(t1) {
                    return 1 / (60 * t1 / (this._getBpm() * this._getPPQ()));
                }
                _beatsToUnits(t1) {
                    return 1 / super._beatsToUnits(t1);
                }
                _secondsToUnits(t1) {
                    return 1 / t1;
                }
                static mtof(t1) {
                    return Gi(t1);
                }
                static ftom(t1) {
                    return Bi(t1);
                }
            }
            const $i = {
                cbbb: -3,
                cbb: -2,
                cb: -1,
                c: 0,
                "c#": 1,
                cx: 2,
                "c##": 2,
                "c###": 3,
                "cx#": 3,
                "c#x": 3,
                dbbb: -1,
                dbb: 0,
                db: 1,
                d: 2,
                "d#": 3,
                dx: 4,
                "d##": 4,
                "d###": 5,
                "dx#": 5,
                "d#x": 5,
                ebbb: 1,
                ebb: 2,
                eb: 3,
                e: 4,
                "e#": 5,
                ex: 6,
                "e##": 6,
                "e###": 7,
                "ex#": 7,
                "e#x": 7,
                fbbb: 2,
                fbb: 3,
                fb: 4,
                f: 5,
                "f#": 6,
                fx: 7,
                "f##": 7,
                "f###": 8,
                "fx#": 8,
                "f#x": 8,
                gbbb: 4,
                gbb: 5,
                gb: 6,
                g: 7,
                "g#": 8,
                gx: 9,
                "g##": 9,
                "g###": 10,
                "gx#": 10,
                "g#x": 10,
                abbb: 6,
                abb: 7,
                ab: 8,
                a: 9,
                "a#": 10,
                ax: 11,
                "a##": 11,
                "a###": 12,
                "ax#": 12,
                "a#x": 12,
                bbbb: 8,
                bbb: 9,
                bb: 10,
                b: 11,
                "b#": 12,
                bx: 13,
                "b##": 13,
                "b###": 14,
                "bx#": 14,
                "b#x": 14
            }, Hi = [
                "C",
                "C#",
                "D",
                "D#",
                "E",
                "F",
                "F#",
                "G",
                "G#",
                "A",
                "A#",
                "B"
            ];
            function Ji(t1, e) {
                return new Yi(Vi(), t1, e);
            }
            class Ki extends Zi {
                constructor(){
                    super(...arguments), this.name = "TransportTime";
                }
                _now() {
                    return this.context.transport.seconds;
                }
            }
            function to(t1, e) {
                return new Ki(Vi(), t1, e);
            }
            class eo extends fi {
                constructor(){
                    super();
                    const t1 = ui(eo.getDefaults(), arguments, [
                        "context"
                    ]);
                    this.defaultContext ? this.context = this.defaultContext : this.context = t1.context;
                }
                static getDefaults() {
                    return {
                        context: Vi()
                    };
                }
                now() {
                    return this.context.currentTime + this.context.lookAhead;
                }
                immediate() {
                    return this.context.currentTime;
                }
                get sampleTime() {
                    return 1 / this.context.sampleRate;
                }
                get blockTime() {
                    return 128 / this.context.sampleRate;
                }
                toSeconds(t1) {
                    return Yn(t1), new Zi(this.context, t1).toSeconds();
                }
                toFrequency(t1) {
                    return new Yi(this.context, t1).toFrequency();
                }
                toTicks(t1) {
                    return new Ki(this.context, t1).toTicks();
                }
                _getPartialProperties(t1) {
                    const e = this.get();
                    return Object.keys(e).forEach((s1)=>{
                        Fn(t1[s1]) && delete e[s1];
                    }), e;
                }
                get() {
                    const t1 = this.constructor.getDefaults();
                    return Object.keys(t1).forEach((e)=>{
                        if (Reflect.has(this, e)) {
                            const s1 = this[e];
                            In(s1) && In(s1.value) && In(s1.setValueAtTime) ? t1[e] = s1.value : s1 instanceof eo ? t1[e] = s1._getPartialProperties(t1[e]) : Ln(s1) || Nn(s1) || zn(s1) || jn(s1) ? t1[e] = s1 : delete t1[e];
                        }
                    }), t1;
                }
                set(t1) {
                    return Object.keys(t1).forEach((e)=>{
                        Reflect.has(this, e) && In(this[e]) && (this[e] && In(this[e].value) && In(this[e].setValueAtTime) ? this[e].value !== t1[e] && (this[e].value = t1[e]) : this[e] instanceof eo ? this[e].set(t1[e]) : this[e] = t1[e]);
                    }), this;
                }
            }
            class so extends wi {
                constructor(t1 = "stopped"){
                    super(), this.name = "StateTimeline", this._initial = t1, this.setStateAtTime(this._initial, 0);
                }
                getValueAtTime(t1) {
                    const e = this.get(t1);
                    return null !== e ? e.state : this._initial;
                }
                setStateAtTime(t1, e, s1) {
                    return Un(e, 0), this.add(Object.assign({}, s1, {
                        state: t1,
                        time: e
                    })), this;
                }
                getLastState(t1, e) {
                    for(let s1 = this._search(e); s1 >= 0; s1--){
                        const e = this._timeline[s1];
                        if (e.state === t1) return e;
                    }
                }
                getNextState(t1, e) {
                    const s1 = this._search(e);
                    if (-1 !== s1) for(let e = s1; e < this._timeline.length; e++){
                        const s1 = this._timeline[e];
                        if (s1.state === t1) return s1;
                    }
                }
            }
            class no extends eo {
                constructor(){
                    super(ui(no.getDefaults(), arguments, [
                        "param",
                        "units",
                        "convert"
                    ])), this.name = "Param", this.overridden = !1, this._minOutput = 1e-7;
                    const t1 = ui(no.getDefaults(), arguments, [
                        "param",
                        "units",
                        "convert"
                    ]);
                    for(Bn(In(t1.param) && (oi(t1.param) || t1.param instanceof no), "param must be an AudioParam"); !oi(t1.param);)t1.param = t1.param._param;
                    this._swappable = !!In(t1.swappable) && t1.swappable, this._swappable ? (this.input = this.context.createGain(), this._param = t1.param, this.input.connect(this._param)) : this._param = this.input = t1.param, this._events = new wi(1e3), this._initialValue = this._param.defaultValue, this.units = t1.units, this.convert = t1.convert, this._minValue = t1.minValue, this._maxValue = t1.maxValue, In(t1.value) && t1.value !== this._toType(this._initialValue) && this.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        convert: !0,
                        units: "number"
                    });
                }
                get value() {
                    const t1 = this.now();
                    return this.getValueAtTime(t1);
                }
                set value(t1) {
                    this.cancelScheduledValues(this.now()), this.setValueAtTime(t1, this.now());
                }
                get minValue() {
                    return In(this._minValue) ? this._minValue : "time" === this.units || "frequency" === this.units || "normalRange" === this.units || "positive" === this.units || "transportTime" === this.units || "ticks" === this.units || "bpm" === this.units || "hertz" === this.units || "samples" === this.units ? 0 : "audioRange" === this.units ? -1 : "decibels" === this.units ? -1 / 0 : this._param.minValue;
                }
                get maxValue() {
                    return In(this._maxValue) ? this._maxValue : "normalRange" === this.units || "audioRange" === this.units ? 1 : this._param.maxValue;
                }
                _is(t1, e) {
                    return this.units === e;
                }
                _assertRange(t1) {
                    return In(this.maxValue) && In(this.minValue) && Un(t1, this._fromType(this.minValue), this._fromType(this.maxValue)), t1;
                }
                _fromType(t1) {
                    return this.convert && !this.overridden ? this._is(t1, "time") ? this.toSeconds(t1) : this._is(t1, "decibels") ? ji(t1) : this._is(t1, "frequency") ? this.toFrequency(t1) : t1 : this.overridden ? 0 : t1;
                }
                _toType(t1) {
                    return this.convert && "decibels" === this.units ? Li(t1) : t1;
                }
                setValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e), n = this._fromType(t1);
                    return Bn(isFinite(n) && isFinite(s1), `Invalid argument(s) to setValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._assertRange(n), this.log(this.units, "setValueAtTime", t1, s1), this._events.add({
                        time: s1,
                        type: "setValueAtTime",
                        value: n
                    }), this._param.setValueAtTime(n, s1), this;
                }
                getValueAtTime(t1) {
                    const e = Math.max(this.toSeconds(t1), 0), s1 = this._events.getAfter(e), n = this._events.get(e);
                    let i = this._initialValue;
                    if (null === n) i = this._initialValue;
                    else if ("setTargetAtTime" !== n.type || null !== s1 && "setValueAtTime" !== s1.type) {
                        if (null === s1) i = n.value;
                        else if ("linearRampToValueAtTime" === s1.type || "exponentialRampToValueAtTime" === s1.type) {
                            let t1 = n.value;
                            if ("setTargetAtTime" === n.type) {
                                const e = this._events.getBefore(n.time);
                                t1 = null === e ? this._initialValue : e.value;
                            }
                            i = "linearRampToValueAtTime" === s1.type ? this._linearInterpolate(n.time, t1, s1.time, s1.value, e) : this._exponentialInterpolate(n.time, t1, s1.time, s1.value, e);
                        } else i = n.value;
                    } else {
                        const t1 = this._events.getBefore(n.time);
                        let s1;
                        s1 = null === t1 ? this._initialValue : t1.value, "setTargetAtTime" === n.type && (i = this._exponentialApproach(n.time, s1, n.value, n.constant, e));
                    }
                    return this._toType(i);
                }
                setRampPoint(t1) {
                    t1 = this.toSeconds(t1);
                    let e = this.getValueAtTime(t1);
                    return this.cancelAndHoldAtTime(t1), 0 === this._fromType(e) && (e = this._toType(this._minOutput)), this.setValueAtTime(e, t1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = this._fromType(t1), n = this.toSeconds(e);
                    return Bn(isFinite(s1) && isFinite(n), `Invalid argument(s) to linearRampToValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._assertRange(s1), this._events.add({
                        time: n,
                        type: "linearRampToValueAtTime",
                        value: s1
                    }), this.log(this.units, "linearRampToValueAtTime", t1, n), this._param.linearRampToValueAtTime(s1, n), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    let s1 = this._fromType(t1);
                    s1 = yi(s1, 0) ? this._minOutput : s1, this._assertRange(s1);
                    const n = this.toSeconds(e);
                    return Bn(isFinite(s1) && isFinite(n), `Invalid argument(s) to exponentialRampToValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._events.add({
                        time: n,
                        type: "exponentialRampToValueAtTime",
                        value: s1
                    }), this.log(this.units, "exponentialRampToValueAtTime", t1, n), this._param.exponentialRampToValueAtTime(s1, n), this;
                }
                exponentialRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.exponentialRampToValueAtTime(t1, s1 + this.toSeconds(e)), this;
                }
                linearRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.linearRampToValueAtTime(t1, s1 + this.toSeconds(e)), this;
                }
                targetRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.exponentialApproachValueAtTime(t1, s1, e), this;
                }
                exponentialApproachValueAtTime(t1, e, s1) {
                    e = this.toSeconds(e), s1 = this.toSeconds(s1);
                    const n = Math.log(s1 + 1) / Math.log(200);
                    return this.setTargetAtTime(t1, e, n), this.cancelAndHoldAtTime(e + .9 * s1), this.linearRampToValueAtTime(t1, e + s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    const n = this._fromType(t1);
                    Bn(isFinite(s1) && s1 > 0, "timeConstant must be a number greater than 0");
                    const i = this.toSeconds(e);
                    return this._assertRange(n), Bn(isFinite(n) && isFinite(i), `Invalid argument(s) to setTargetAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._events.add({
                        constant: s1,
                        time: i,
                        type: "setTargetAtTime",
                        value: n
                    }), this.log(this.units, "setTargetAtTime", t1, i, s1), this._param.setTargetAtTime(n, i, s1), this;
                }
                setValueCurveAtTime(t1, e, s1, n = 1) {
                    s1 = this.toSeconds(s1), e = this.toSeconds(e);
                    const i = this._fromType(t1[0]) * n;
                    this.setValueAtTime(this._toType(i), e);
                    const o = s1 / (t1.length - 1);
                    for(let s1 = 1; s1 < t1.length; s1++){
                        const i = this._fromType(t1[s1]) * n;
                        this.linearRampToValueAtTime(this._toType(i), e + s1 * o);
                    }
                    return this;
                }
                cancelScheduledValues(t1) {
                    const e = this.toSeconds(t1);
                    return Bn(isFinite(e), `Invalid argument to cancelScheduledValues: ${JSON.stringify(t1)}`), this._events.cancel(e), this._param.cancelScheduledValues(e), this.log(this.units, "cancelScheduledValues", e), this;
                }
                cancelAndHoldAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._fromType(this.getValueAtTime(e));
                    Bn(isFinite(e), `Invalid argument to cancelAndHoldAtTime: ${JSON.stringify(t1)}`), this.log(this.units, "cancelAndHoldAtTime", e, "value=" + s1);
                    const n = this._events.get(e), i = this._events.getAfter(e);
                    return n && yi(n.time, e) ? i ? (this._param.cancelScheduledValues(i.time), this._events.cancel(i.time)) : (this._param.cancelAndHoldAtTime(e), this._events.cancel(e + this.sampleTime)) : i && (this._param.cancelScheduledValues(i.time), this._events.cancel(i.time), "linearRampToValueAtTime" === i.type ? this.linearRampToValueAtTime(this._toType(s1), e) : "exponentialRampToValueAtTime" === i.type && this.exponentialRampToValueAtTime(this._toType(s1), e)), this._events.add({
                        time: e,
                        type: "setValueAtTime",
                        value: s1
                    }), this._param.setValueAtTime(s1, e), this;
                }
                rampTo(t1, e = .1, s1) {
                    return "frequency" === this.units || "bpm" === this.units || "decibels" === this.units ? this.exponentialRampTo(t1, e, s1) : this.linearRampTo(t1, e, s1), this;
                }
                apply(t1) {
                    const e = this.context.currentTime;
                    t1.setValueAtTime(this.getValueAtTime(e), e);
                    const s1 = this._events.get(e);
                    if (s1 && "setTargetAtTime" === s1.type) {
                        const n = this._events.getAfter(s1.time), i = n ? n.time : e + 2, o = (i - e) / 10;
                        for(let s1 = e; s1 < i; s1 += o)t1.linearRampToValueAtTime(this.getValueAtTime(s1), s1);
                    }
                    return this._events.forEachAfter(this.context.currentTime, (e)=>{
                        "cancelScheduledValues" === e.type ? t1.cancelScheduledValues(e.time) : "setTargetAtTime" === e.type ? t1.setTargetAtTime(e.value, e.time, e.constant) : t1[e.type](e.value, e.time);
                    }), this;
                }
                setParam(t1) {
                    Bn(this._swappable, "The Param must be assigned as 'swappable' in the constructor");
                    const e = this.input;
                    return e.disconnect(this._param), this.apply(t1), this._param = t1, e.connect(this._param), this;
                }
                dispose() {
                    return super.dispose(), this._events.dispose(), this;
                }
                get defaultValue() {
                    return this._toType(this._param.defaultValue);
                }
                _exponentialApproach(t1, e, s1, n, i) {
                    return s1 + (e - s1) * Math.exp(-(i - t1) / n);
                }
                _linearInterpolate(t1, e, s1, n, i) {
                    return e + (i - t1) / (s1 - t1) * (n - e);
                }
                _exponentialInterpolate(t1, e, s1, n, i) {
                    return e * Math.pow(n / e, (i - t1) / (s1 - t1));
                }
            }
            class io extends eo {
                constructor(){
                    super(...arguments), this._internalChannels = [];
                }
                get numberOfInputs() {
                    return In(this.input) ? oi(this.input) || this.input instanceof no ? 1 : this.input.numberOfInputs : 0;
                }
                get numberOfOutputs() {
                    return In(this.output) ? this.output.numberOfOutputs : 0;
                }
                _isAudioNode(t1) {
                    return In(t1) && (t1 instanceof io || ri(t1));
                }
                _getInternalNodes() {
                    const t1 = this._internalChannels.slice(0);
                    return this._isAudioNode(this.input) && t1.push(this.input), this._isAudioNode(this.output) && this.input !== this.output && t1.push(this.output), t1;
                }
                _setChannelProperties(t1) {
                    this._getInternalNodes().forEach((e)=>{
                        e.channelCount = t1.channelCount, e.channelCountMode = t1.channelCountMode, e.channelInterpretation = t1.channelInterpretation;
                    });
                }
                _getChannelProperties() {
                    const t1 = this._getInternalNodes();
                    Bn(t1.length > 0, "ToneAudioNode does not have any internal nodes");
                    const e = t1[0];
                    return {
                        channelCount: e.channelCount,
                        channelCountMode: e.channelCountMode,
                        channelInterpretation: e.channelInterpretation
                    };
                }
                get channelCount() {
                    return this._getChannelProperties().channelCount;
                }
                set channelCount(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelCount: t1
                    }));
                }
                get channelCountMode() {
                    return this._getChannelProperties().channelCountMode;
                }
                set channelCountMode(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelCountMode: t1
                    }));
                }
                get channelInterpretation() {
                    return this._getChannelProperties().channelInterpretation;
                }
                set channelInterpretation(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelInterpretation: t1
                    }));
                }
                connect(t1, e = 0, s1 = 0) {
                    return ro(this, t1, e, s1), this;
                }
                toDestination() {
                    return this.connect(this.context.destination), this;
                }
                toMaster() {
                    return Kn("toMaster() has been renamed toDestination()"), this.toDestination();
                }
                disconnect(t1, e = 0, s1 = 0) {
                    return ao(this, t1, e, s1), this;
                }
                chain(...t1) {
                    return oo(this, ...t1), this;
                }
                fan(...t1) {
                    return t1.forEach((t1)=>this.connect(t1)), this;
                }
                dispose() {
                    return super.dispose(), In(this.input) && (this.input instanceof io ? this.input.dispose() : ri(this.input) && this.input.disconnect()), In(this.output) && (this.output instanceof io ? this.output.dispose() : ri(this.output) && this.output.disconnect()), this._internalChannels = [], this;
                }
            }
            function oo(...t1) {
                const e = t1.shift();
                t1.reduce((t1, e)=>(t1 instanceof io ? t1.connect(e) : ri(t1) && ro(t1, e), e), e);
            }
            function ro(t1, e, s1 = 0, n = 0) {
                for(Bn(In(t1), "Cannot connect from undefined node"), Bn(In(e), "Cannot connect to undefined node"), (e instanceof io || ri(e)) && Bn(e.numberOfInputs > 0, "Cannot connect to node with no inputs"), Bn(t1.numberOfOutputs > 0, "Cannot connect from node with no outputs"); e instanceof io || e instanceof no;)In(e.input) && (e = e.input);
                for(; t1 instanceof io;)In(t1.output) && (t1 = t1.output);
                oi(e) ? t1.connect(e, s1) : t1.connect(e, s1, n);
            }
            function ao(t1, e, s1 = 0, n = 0) {
                if (In(e)) for(; e instanceof io;)e = e.input;
                for(; !ri(t1);)In(t1.output) && (t1 = t1.output);
                oi(e) ? t1.disconnect(e, s1) : ri(e) ? t1.disconnect(e, s1, n) : t1.disconnect();
            }
            function co(...t1) {
                const e = t1.pop();
                In(e) && t1.forEach((t1)=>ro(t1, e));
            }
            class ho extends io {
                constructor(){
                    super(ui(ho.getDefaults(), arguments, [
                        "gain",
                        "units"
                    ])), this.name = "Gain", this._gainNode = this.context.createGain(), this.input = this._gainNode, this.output = this._gainNode;
                    const t1 = ui(ho.getDefaults(), arguments, [
                        "gain",
                        "units"
                    ]);
                    this.gain = new no({
                        context: this.context,
                        convert: t1.convert,
                        param: this._gainNode.gain,
                        units: t1.units,
                        value: t1.gain,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), Oi(this, "gain");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        convert: !0,
                        gain: 1,
                        units: "gain"
                    });
                }
                dispose() {
                    return super.dispose(), this._gainNode.disconnect(), this.gain.dispose(), this;
                }
            }
            class lo extends io {
                constructor(t1){
                    super(t1), this.onended = Ei, this._startTime = -1, this._stopTime = -1, this._timeout = -1, this.output = new ho({
                        context: this.context,
                        gain: 0
                    }), this._gainNode = this.output, this.getStateAtTime = function(t1) {
                        const e = this.toSeconds(t1);
                        return -1 !== this._startTime && e >= this._startTime && (-1 === this._stopTime || e <= this._stopTime) ? "started" : "stopped";
                    }, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut, this._curve = t1.curve, this.onended = t1.onended;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        curve: "linear",
                        fadeIn: 0,
                        fadeOut: 0,
                        onended: Ei
                    });
                }
                _startGain(t1, e = 1) {
                    Bn(-1 === this._startTime, "Source cannot be started more than once");
                    const s1 = this.toSeconds(this._fadeIn);
                    return this._startTime = t1 + s1, this._startTime = Math.max(this._startTime, this.context.currentTime), s1 > 0 ? (this._gainNode.gain.setValueAtTime(0, t1), "linear" === this._curve ? this._gainNode.gain.linearRampToValueAtTime(e, t1 + s1) : this._gainNode.gain.exponentialApproachValueAtTime(e, t1, s1)) : this._gainNode.gain.setValueAtTime(e, t1), this;
                }
                stop(t1) {
                    return this.log("stop", t1), this._stopGain(this.toSeconds(t1)), this;
                }
                _stopGain(t1) {
                    Bn(-1 !== this._startTime, "'start' must be called before 'stop'"), this.cancelStop();
                    const e = this.toSeconds(this._fadeOut);
                    return this._stopTime = this.toSeconds(t1) + e, this._stopTime = Math.max(this._stopTime, this.now()), e > 0 ? "linear" === this._curve ? this._gainNode.gain.linearRampTo(0, e, t1) : this._gainNode.gain.targetRampTo(0, e, t1) : (this._gainNode.gain.cancelAndHoldAtTime(t1), this._gainNode.gain.setValueAtTime(0, t1)), this.context.clearTimeout(this._timeout), this._timeout = this.context.setTimeout(()=>{
                        const t1 = "exponential" === this._curve ? 2 * e : 0;
                        this._stopSource(this.now() + t1), this._onended();
                    }, this._stopTime - this.context.currentTime), this;
                }
                _onended() {
                    if (this.onended !== Ei && (this.onended(this), this.onended = Ei, !this.context.isOffline)) {
                        const t1 = ()=>this.dispose();
                        void 0 !== window.requestIdleCallback ? window.requestIdleCallback(t1) : setTimeout(t1, 1e3);
                    }
                }
                get state() {
                    return this.getStateAtTime(this.now());
                }
                cancelStop() {
                    return this.log("cancelStop"), Bn(-1 !== this._startTime, "Source is not started"), this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime), this.context.clearTimeout(this._timeout), this._stopTime = -1, this;
                }
                dispose() {
                    return super.dispose(), this._gainNode.dispose(), this.onended = Ei, this;
                }
            }
            class uo extends lo {
                constructor(){
                    super(ui(uo.getDefaults(), arguments, [
                        "offset"
                    ])), this.name = "ToneConstantSource", this._source = this.context.createConstantSource();
                    const t1 = ui(uo.getDefaults(), arguments, [
                        "offset"
                    ]);
                    ro(this._source, this._gainNode), this.offset = new no({
                        context: this.context,
                        convert: t1.convert,
                        param: this._source.offset,
                        units: t1.units,
                        value: t1.offset,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    });
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        convert: !0,
                        offset: 1,
                        units: "number"
                    });
                }
                start(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("start", e), this._startGain(e), this._source.start(e), this;
                }
                _stopSource(t1) {
                    this._source.stop(t1);
                }
                dispose() {
                    return super.dispose(), "started" === this.state && this.stop(), this._source.disconnect(), this.offset.dispose(), this;
                }
            }
            class po extends io {
                constructor(){
                    super(ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ])), this.name = "Signal", this.override = !0;
                    const t1 = ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ]);
                    this.output = this._constantSource = new uo({
                        context: this.context,
                        convert: t1.convert,
                        offset: t1.value,
                        units: t1.units,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), this._constantSource.start(0), this.input = this._param = this._constantSource.offset;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        convert: !0,
                        units: "number",
                        value: 0
                    });
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
                dispose() {
                    return super.dispose(), this._param.dispose(), this._constantSource.dispose(), this;
                }
                setValueAtTime(t1, e) {
                    return this._param.setValueAtTime(t1, e), this;
                }
                getValueAtTime(t1) {
                    return this._param.getValueAtTime(t1);
                }
                setRampPoint(t1) {
                    return this._param.setRampPoint(t1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    return this._param.linearRampToValueAtTime(t1, e), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    return this._param.exponentialRampToValueAtTime(t1, e), this;
                }
                exponentialRampTo(t1, e, s1) {
                    return this._param.exponentialRampTo(t1, e, s1), this;
                }
                linearRampTo(t1, e, s1) {
                    return this._param.linearRampTo(t1, e, s1), this;
                }
                targetRampTo(t1, e, s1) {
                    return this._param.targetRampTo(t1, e, s1), this;
                }
                exponentialApproachValueAtTime(t1, e, s1) {
                    return this._param.exponentialApproachValueAtTime(t1, e, s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    return this._param.setTargetAtTime(t1, e, s1), this;
                }
                setValueCurveAtTime(t1, e, s1, n) {
                    return this._param.setValueCurveAtTime(t1, e, s1, n), this;
                }
                cancelScheduledValues(t1) {
                    return this._param.cancelScheduledValues(t1), this;
                }
                cancelAndHoldAtTime(t1) {
                    return this._param.cancelAndHoldAtTime(t1), this;
                }
                rampTo(t1, e, s1) {
                    return this._param.rampTo(t1, e, s1), this;
                }
                get value() {
                    return this._param.value;
                }
                set value(t1) {
                    this._param.value = t1;
                }
                get convert() {
                    return this._param.convert;
                }
                set convert(t1) {
                    this._param.convert = t1;
                }
                get units() {
                    return this._param.units;
                }
                get overridden() {
                    return this._param.overridden;
                }
                set overridden(t1) {
                    this._param.overridden = t1;
                }
                get maxValue() {
                    return this._param.maxValue;
                }
                get minValue() {
                    return this._param.minValue;
                }
                apply(t1) {
                    return this._param.apply(t1), this;
                }
            }
            function fo(t1, e, s1, n) {
                (e instanceof no || oi(e) || e instanceof po && e.override) && (e.cancelScheduledValues(0), e.setValueAtTime(0, 0), e instanceof po && (e.overridden = !0)), ro(t1, e, s1, n);
            }
            class _o extends no {
                constructor(){
                    super(ui(_o.getDefaults(), arguments, [
                        "value"
                    ])), this.name = "TickParam", this._events = new wi(1 / 0), this._multiplier = 1;
                    const t1 = ui(_o.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._multiplier = t1.multiplier, this._events.cancel(0), this._events.add({
                        ticks: 0,
                        time: 0,
                        type: "setValueAtTime",
                        value: this._fromType(t1.value)
                    }), this.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(no.getDefaults(), {
                        multiplier: 1,
                        units: "hertz",
                        value: 1
                    });
                }
                setTargetAtTime(t1, e, s1) {
                    e = this.toSeconds(e), this.setRampPoint(e);
                    const n = this._fromType(t1), i = this._events.get(e), o = Math.round(Math.max(1 / s1, 1));
                    for(let t1 = 0; t1 <= o; t1++){
                        const o = s1 * t1 + e, r = this._exponentialApproach(i.time, i.value, n, s1, o);
                        this.linearRampToValueAtTime(this._toType(r), o);
                    }
                    return this;
                }
                setValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e);
                    super.setValueAtTime(t1, e);
                    const n = this._events.get(s1), i = this._events.previousEvent(n), o = this._getTicksUntilEvent(i, s1);
                    return n.ticks = Math.max(o, 0), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e);
                    super.linearRampToValueAtTime(t1, e);
                    const n = this._events.get(s1), i = this._events.previousEvent(n), o = this._getTicksUntilEvent(i, s1);
                    return n.ticks = Math.max(o, 0), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    e = this.toSeconds(e);
                    const s1 = this._fromType(t1), n = this._events.get(e), i = Math.round(Math.max(10 * (e - n.time), 1)), o = (e - n.time) / i;
                    for(let t1 = 0; t1 <= i; t1++){
                        const i = o * t1 + n.time, r = this._exponentialInterpolate(n.time, n.value, e, s1, i);
                        this.linearRampToValueAtTime(this._toType(r), i);
                    }
                    return this;
                }
                _getTicksUntilEvent(t1, e) {
                    if (null === t1) t1 = {
                        ticks: 0,
                        time: 0,
                        type: "setValueAtTime",
                        value: 0
                    };
                    else if (Fn(t1.ticks)) {
                        const e = this._events.previousEvent(t1);
                        t1.ticks = this._getTicksUntilEvent(e, t1.time);
                    }
                    const s1 = this._fromType(this.getValueAtTime(t1.time));
                    let n = this._fromType(this.getValueAtTime(e));
                    const i = this._events.get(e);
                    return i && i.time === e && "setValueAtTime" === i.type && (n = this._fromType(this.getValueAtTime(e - this.sampleTime))), .5 * (e - t1.time) * (s1 + n) + t1.ticks;
                }
                getTicksAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._events.get(e);
                    return Math.max(this._getTicksUntilEvent(s1, e), 0);
                }
                getDurationOfTicks(t1, e) {
                    const s1 = this.toSeconds(e), n = this.getTicksAtTime(e);
                    return this.getTimeOfTick(n + t1) - s1;
                }
                getTimeOfTick(t1) {
                    const e = this._events.get(t1, "ticks"), s1 = this._events.getAfter(t1, "ticks");
                    if (e && e.ticks === t1) return e.time;
                    if (e && s1 && "linearRampToValueAtTime" === s1.type && e.value !== s1.value) {
                        const n = this._fromType(this.getValueAtTime(e.time)), i = (this._fromType(this.getValueAtTime(s1.time)) - n) / (s1.time - e.time), o = Math.sqrt(Math.pow(n, 2) - 2 * i * (e.ticks - t1)), r = (-n + o) / i, a = (-n - o) / i;
                        return (r > 0 ? r : a) + e.time;
                    }
                    return e ? 0 === e.value ? 1 / 0 : e.time + (t1 - e.ticks) / e.value : t1 / this._initialValue;
                }
                ticksToTime(t1, e) {
                    return this.getDurationOfTicks(t1, e);
                }
                timeToTicks(t1, e) {
                    const s1 = this.toSeconds(e), n = this.toSeconds(t1), i = this.getTicksAtTime(s1);
                    return this.getTicksAtTime(s1 + n) - i;
                }
                _fromType(t1) {
                    return "bpm" === this.units && this.multiplier ? 1 / (60 / t1 / this.multiplier) : super._fromType(t1);
                }
                _toType(t1) {
                    return "bpm" === this.units && this.multiplier ? t1 / this.multiplier * 60 : super._toType(t1);
                }
                get multiplier() {
                    return this._multiplier;
                }
                set multiplier(t1) {
                    const e = this.value;
                    this._multiplier = t1, this.cancelScheduledValues(0), this.setValueAtTime(e, 0);
                }
            }
            class mo extends po {
                constructor(){
                    super(ui(mo.getDefaults(), arguments, [
                        "value"
                    ])), this.name = "TickSignal";
                    const t1 = ui(mo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this.input = this._param = new _o({
                        context: this.context,
                        convert: t1.convert,
                        multiplier: t1.multiplier,
                        param: this._constantSource.offset,
                        units: t1.units,
                        value: t1.value
                    });
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        multiplier: 1,
                        units: "hertz",
                        value: 1
                    });
                }
                ticksToTime(t1, e) {
                    return this._param.ticksToTime(t1, e);
                }
                timeToTicks(t1, e) {
                    return this._param.timeToTicks(t1, e);
                }
                getTimeOfTick(t1) {
                    return this._param.getTimeOfTick(t1);
                }
                getDurationOfTicks(t1, e) {
                    return this._param.getDurationOfTicks(t1, e);
                }
                getTicksAtTime(t1) {
                    return this._param.getTicksAtTime(t1);
                }
                get multiplier() {
                    return this._param.multiplier;
                }
                set multiplier(t1) {
                    this._param.multiplier = t1;
                }
                dispose() {
                    return super.dispose(), this._param.dispose(), this;
                }
            }
            class go extends eo {
                constructor(){
                    super(ui(go.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "TickSource", this._state = new so, this._tickOffset = new wi, this._ticksAtTime = new wi, this._secondsAtTime = new wi;
                    const t1 = ui(go.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this.frequency = new mo({
                        context: this.context,
                        units: t1.units,
                        value: t1.frequency
                    }), Oi(this, "frequency"), this._state.setStateAtTime("stopped", 0), this.setTicksAtTime(0, 0);
                }
                static getDefaults() {
                    return Object.assign({
                        frequency: 1,
                        units: "hertz"
                    }, eo.getDefaults());
                }
                get state() {
                    return this.getStateAtTime(this.now());
                }
                start(t1, e) {
                    const s1 = this.toSeconds(t1);
                    return "started" !== this._state.getValueAtTime(s1) && (this._state.setStateAtTime("started", s1), In(e) && this.setTicksAtTime(e, s1), this._ticksAtTime.cancel(s1), this._secondsAtTime.cancel(s1)), this;
                }
                stop(t1) {
                    const e = this.toSeconds(t1);
                    if ("stopped" === this._state.getValueAtTime(e)) {
                        const t1 = this._state.get(e);
                        t1 && t1.time > 0 && (this._tickOffset.cancel(t1.time), this._state.cancel(t1.time));
                    }
                    return this._state.cancel(e), this._state.setStateAtTime("stopped", e), this.setTicksAtTime(0, e), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e), this;
                }
                pause(t1) {
                    const e = this.toSeconds(t1);
                    return "started" === this._state.getValueAtTime(e) && (this._state.setStateAtTime("paused", e), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e)), this;
                }
                cancel(t1) {
                    return t1 = this.toSeconds(t1), this._state.cancel(t1), this._tickOffset.cancel(t1), this._ticksAtTime.cancel(t1), this._secondsAtTime.cancel(t1), this;
                }
                getTicksAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._state.getLastState("stopped", e), n = this._ticksAtTime.get(e), i = {
                        state: "paused",
                        time: e
                    };
                    this._state.add(i);
                    let o = n || s1, r = n ? n.ticks : 0, a = null;
                    return this._state.forEachBetween(o.time, e + this.sampleTime, (t1)=>{
                        let e = o.time;
                        const s1 = this._tickOffset.get(t1.time);
                        s1 && s1.time >= o.time && (r = s1.ticks, e = s1.time), "started" === o.state && "started" !== t1.state && (r += this.frequency.getTicksAtTime(t1.time) - this.frequency.getTicksAtTime(e), t1.time !== i.time && (a = {
                            state: t1.state,
                            time: t1.time,
                            ticks: r
                        })), o = t1;
                    }), this._state.remove(i), a && this._ticksAtTime.add(a), r;
                }
                get ticks() {
                    return this.getTicksAtTime(this.now());
                }
                set ticks(t1) {
                    this.setTicksAtTime(t1, this.now());
                }
                get seconds() {
                    return this.getSecondsAtTime(this.now());
                }
                set seconds(t1) {
                    const e = this.now(), s1 = this.frequency.timeToTicks(t1, e);
                    this.setTicksAtTime(s1, e);
                }
                getSecondsAtTime(t1) {
                    t1 = this.toSeconds(t1);
                    const e = this._state.getLastState("stopped", t1), s1 = {
                        state: "paused",
                        time: t1
                    };
                    this._state.add(s1);
                    const n = this._secondsAtTime.get(t1);
                    let i = n || e, o = n ? n.seconds : 0, r = null;
                    return this._state.forEachBetween(i.time, t1 + this.sampleTime, (t1)=>{
                        let e = i.time;
                        const n = this._tickOffset.get(t1.time);
                        n && n.time >= i.time && (o = n.seconds, e = n.time), "started" === i.state && "started" !== t1.state && (o += t1.time - e, t1.time !== s1.time && (r = {
                            state: t1.state,
                            time: t1.time,
                            seconds: o
                        })), i = t1;
                    }), this._state.remove(s1), r && this._secondsAtTime.add(r), o;
                }
                setTicksAtTime(t1, e) {
                    return e = this.toSeconds(e), this._tickOffset.cancel(e), this._tickOffset.add({
                        seconds: this.frequency.getDurationOfTicks(t1, e),
                        ticks: t1,
                        time: e
                    }), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e), this;
                }
                getStateAtTime(t1) {
                    return t1 = this.toSeconds(t1), this._state.getValueAtTime(t1);
                }
                getTimeOfTick(t1, e = this.now()) {
                    const s1 = this._tickOffset.get(e), n = this._state.get(e), i = Math.max(s1.time, n.time), o = this.frequency.getTicksAtTime(i) + t1 - s1.ticks;
                    return this.frequency.getTimeOfTick(o);
                }
                forEachTickBetween(t1, e, s1) {
                    let n = this._state.get(t1);
                    this._state.forEachBetween(t1, e, (e)=>{
                        n && "started" === n.state && "started" !== e.state && this.forEachTickBetween(Math.max(n.time, t1), e.time - this.sampleTime, s1), n = e;
                    });
                    let i = null;
                    if (n && "started" === n.state) {
                        const o = Math.max(n.time, t1), r = this.frequency.getTicksAtTime(o), a = r - this.frequency.getTicksAtTime(n.time);
                        let c = Math.ceil(a) - a;
                        c = yi(c, 1) ? 0 : c;
                        let h = this.frequency.getTimeOfTick(r + c);
                        for(; h < e;){
                            try {
                                s1(h, Math.round(this.getTicksAtTime(h)));
                            } catch (t1) {
                                i = t1;
                                break;
                            }
                            h += this.frequency.getDurationOfTicks(1, h);
                        }
                    }
                    if (i) throw i;
                    return this;
                }
                dispose() {
                    return super.dispose(), this._state.dispose(), this._tickOffset.dispose(), this._ticksAtTime.dispose(), this._secondsAtTime.dispose(), this.frequency.dispose(), this;
                }
            }
            class vo extends eo {
                constructor(){
                    super(ui(vo.getDefaults(), arguments, [
                        "callback",
                        "frequency"
                    ])), this.name = "Clock", this.callback = Ei, this._lastUpdate = 0, this._state = new so("stopped"), this._boundLoop = this._loop.bind(this);
                    const t1 = ui(vo.getDefaults(), arguments, [
                        "callback",
                        "frequency"
                    ]);
                    this.callback = t1.callback, this._tickSource = new go({
                        context: this.context,
                        frequency: t1.frequency,
                        units: t1.units
                    }), this._lastUpdate = 0, this.frequency = this._tickSource.frequency, Oi(this, "frequency"), this._state.setStateAtTime("stopped", 0), this.context.on("tick", this._boundLoop);
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        callback: Ei,
                        frequency: 1,
                        units: "hertz"
                    });
                }
                get state() {
                    return this._state.getValueAtTime(this.now());
                }
                start(t1, e) {
                    Gn(this.context);
                    const s1 = this.toSeconds(t1);
                    return this.log("start", s1), "started" !== this._state.getValueAtTime(s1) && (this._state.setStateAtTime("started", s1), this._tickSource.start(s1, e), s1 < this._lastUpdate && this.emit("start", s1, e)), this;
                }
                stop(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("stop", e), this._state.cancel(e), this._state.setStateAtTime("stopped", e), this._tickSource.stop(e), e < this._lastUpdate && this.emit("stop", e), this;
                }
                pause(t1) {
                    const e = this.toSeconds(t1);
                    return "started" === this._state.getValueAtTime(e) && (this._state.setStateAtTime("paused", e), this._tickSource.pause(e), e < this._lastUpdate && this.emit("pause", e)), this;
                }
                get ticks() {
                    return Math.ceil(this.getTicksAtTime(this.now()));
                }
                set ticks(t1) {
                    this._tickSource.ticks = t1;
                }
                get seconds() {
                    return this._tickSource.seconds;
                }
                set seconds(t1) {
                    this._tickSource.seconds = t1;
                }
                getSecondsAtTime(t1) {
                    return this._tickSource.getSecondsAtTime(t1);
                }
                setTicksAtTime(t1, e) {
                    return this._tickSource.setTicksAtTime(t1, e), this;
                }
                getTimeOfTick(t1, e = this.now()) {
                    return this._tickSource.getTimeOfTick(t1, e);
                }
                getTicksAtTime(t1) {
                    return this._tickSource.getTicksAtTime(t1);
                }
                nextTickTime(t1, e) {
                    const s1 = this.toSeconds(e), n = this.getTicksAtTime(s1);
                    return this._tickSource.getTimeOfTick(n + t1, s1);
                }
                _loop() {
                    const t1 = this._lastUpdate, e = this.now();
                    this._lastUpdate = e, this.log("loop", t1, e), t1 !== e && (this._state.forEachBetween(t1, e, (t1)=>{
                        switch(t1.state){
                            case "started":
                                const e = this._tickSource.getTicksAtTime(t1.time);
                                this.emit("start", t1.time, e);
                                break;
                            case "stopped":
                                0 !== t1.time && this.emit("stop", t1.time);
                                break;
                            case "paused":
                                this.emit("pause", t1.time);
                        }
                    }), this._tickSource.forEachTickBetween(t1, e, (t1, e)=>{
                        this.callback(t1, e);
                    }));
                }
                getStateAtTime(t1) {
                    const e = this.toSeconds(t1);
                    return this._state.getValueAtTime(e);
                }
                dispose() {
                    return super.dispose(), this.context.off("tick", this._boundLoop), this._tickSource.dispose(), this._state.dispose(), this;
                }
            }
            Ai.mixin(vo);
            class yo extends io {
                constructor(){
                    super(ui(yo.getDefaults(), arguments, [
                        "delayTime",
                        "maxDelay"
                    ])), this.name = "Delay";
                    const t1 = ui(yo.getDefaults(), arguments, [
                        "delayTime",
                        "maxDelay"
                    ]), e = this.toSeconds(t1.maxDelay);
                    this._maxDelay = Math.max(e, this.toSeconds(t1.delayTime)), this._delayNode = this.input = this.output = this.context.createDelay(e), this.delayTime = new no({
                        context: this.context,
                        param: this._delayNode.delayTime,
                        units: "time",
                        value: t1.delayTime,
                        minValue: 0,
                        maxValue: this.maxDelay
                    }), Oi(this, "delayTime");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        delayTime: 0,
                        maxDelay: 1
                    });
                }
                get maxDelay() {
                    return this._maxDelay;
                }
                dispose() {
                    return super.dispose(), this._delayNode.disconnect(), this.delayTime.dispose(), this;
                }
            }
            function xo(t1, e, s1 = 2, n = Vi().sampleRate) {
                return ni(this, void 0, void 0, function*() {
                    const i = Vi(), o = new qi(s1, e, n);
                    Ni(o), yield t1(o);
                    const r = o.render();
                    Ni(i);
                    const a = yield r;
                    return new Ri(a);
                });
            }
            class wo extends fi {
                constructor(){
                    super(), this.name = "ToneAudioBuffers", this._buffers = new Map, this._loadingCount = 0;
                    const t1 = ui(wo.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls");
                    this.baseUrl = t1.baseUrl, Object.keys(t1.urls).forEach((e)=>{
                        this._loadingCount++;
                        const s1 = t1.urls[e];
                        this.add(e, s1, this._bufferLoaded.bind(this, t1.onload), t1.onerror);
                    });
                }
                static getDefaults() {
                    return {
                        baseUrl: "",
                        onerror: Ei,
                        onload: Ei,
                        urls: {}
                    };
                }
                has(t1) {
                    return this._buffers.has(t1.toString());
                }
                get(t1) {
                    return Bn(this.has(t1), `ToneAudioBuffers has no buffer named: ${t1}`), this._buffers.get(t1.toString());
                }
                _bufferLoaded(t1) {
                    this._loadingCount--, 0 === this._loadingCount && t1 && t1();
                }
                get loaded() {
                    return Array.from(this._buffers).every(([t1, e])=>e.loaded);
                }
                add(t1, e, s1 = Ei, n = Ei) {
                    return zn(e) ? (this.baseUrl && "data:audio/" === e.trim().substring(0, 11).toLowerCase() && (this.baseUrl = ""), this._buffers.set(t1.toString(), new Ri(this.baseUrl + e, s1, n))) : this._buffers.set(t1.toString(), new Ri(e, s1, n)), this;
                }
                dispose() {
                    return super.dispose(), this._buffers.forEach((t1)=>t1.dispose()), this._buffers.clear(), this;
                }
            }
            class bo extends Yi {
                constructor(){
                    super(...arguments), this.name = "MidiClass", this.defaultUnits = "midi";
                }
                _frequencyToUnits(t1) {
                    return Bi(super._frequencyToUnits(t1));
                }
                _ticksToUnits(t1) {
                    return Bi(super._ticksToUnits(t1));
                }
                _beatsToUnits(t1) {
                    return Bi(super._beatsToUnits(t1));
                }
                _secondsToUnits(t1) {
                    return Bi(super._secondsToUnits(t1));
                }
                toMidi() {
                    return this.valueOf();
                }
                toFrequency() {
                    return Gi(this.toMidi());
                }
                transpose(t1) {
                    return new bo(this.context, this.toMidi() + t1);
                }
            }
            function To(t1, e) {
                return new bo(Vi(), t1, e);
            }
            class So extends Ki {
                constructor(){
                    super(...arguments), this.name = "Ticks", this.defaultUnits = "i";
                }
                _now() {
                    return this.context.transport.ticks;
                }
                _beatsToUnits(t1) {
                    return this._getPPQ() * t1;
                }
                _secondsToUnits(t1) {
                    return Math.floor(t1 / (60 / this._getBpm()) * this._getPPQ());
                }
                _ticksToUnits(t1) {
                    return t1;
                }
                toTicks() {
                    return this.valueOf();
                }
                toSeconds() {
                    return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
                }
            }
            function ko(t1, e) {
                return new So(Vi(), t1, e);
            }
            class Ao extends eo {
                constructor(){
                    super(...arguments), this.name = "Draw", this.expiration = .25, this.anticipation = .008, this._events = new wi, this._boundDrawLoop = this._drawLoop.bind(this), this._animationFrame = -1;
                }
                schedule(t1, e) {
                    return this._events.add({
                        callback: t1,
                        time: this.toSeconds(e)
                    }), 1 === this._events.length && (this._animationFrame = requestAnimationFrame(this._boundDrawLoop)), this;
                }
                cancel(t1) {
                    return this._events.cancel(this.toSeconds(t1)), this;
                }
                _drawLoop() {
                    const t1 = this.context.currentTime;
                    for(; this._events.length && this._events.peek().time - this.anticipation <= t1;){
                        const e = this._events.shift();
                        e && t1 - e.time <= this.expiration && e.callback();
                    }
                    this._events.length > 0 && (this._animationFrame = requestAnimationFrame(this._boundDrawLoop));
                }
                dispose() {
                    return super.dispose(), this._events.dispose(), cancelAnimationFrame(this._animationFrame), this;
                }
            }
            Ti((t1)=>{
                t1.draw = new Ao({
                    context: t1
                });
            }), ki((t1)=>{
                t1.draw.dispose();
            });
            class Co extends fi {
                constructor(){
                    super(...arguments), this.name = "IntervalTimeline", this._root = null, this._length = 0;
                }
                add(t1) {
                    Bn(In(t1.time), "Events must have a time property"), Bn(In(t1.duration), "Events must have a duration parameter"), t1.time = t1.time.valueOf();
                    let e = new Do(t1.time, t1.time + t1.duration, t1);
                    for(null === this._root ? this._root = e : this._root.insert(e), this._length++; null !== e;)e.updateHeight(), e.updateMax(), this._rebalance(e), e = e.parent;
                    return this;
                }
                remove(t1) {
                    if (null !== this._root) {
                        const e = [];
                        this._root.search(t1.time, e);
                        for (const s1 of e)if (s1.event === t1) {
                            this._removeNode(s1), this._length--;
                            break;
                        }
                    }
                    return this;
                }
                get length() {
                    return this._length;
                }
                cancel(t1) {
                    return this.forEachFrom(t1, (t1)=>this.remove(t1)), this;
                }
                _setRoot(t1) {
                    this._root = t1, null !== this._root && (this._root.parent = null);
                }
                _replaceNodeInParent(t1, e) {
                    null !== t1.parent ? (t1.isLeftChild() ? t1.parent.left = e : t1.parent.right = e, this._rebalance(t1.parent)) : this._setRoot(e);
                }
                _removeNode(t1) {
                    if (null === t1.left && null === t1.right) this._replaceNodeInParent(t1, null);
                    else if (null === t1.right) this._replaceNodeInParent(t1, t1.left);
                    else if (null === t1.left) this._replaceNodeInParent(t1, t1.right);
                    else {
                        let e, s1 = null;
                        if (t1.getBalance() > 0) {
                            if (null === t1.left.right) e = t1.left, e.right = t1.right, s1 = e;
                            else {
                                for(e = t1.left.right; null !== e.right;)e = e.right;
                                e.parent && (e.parent.right = e.left, s1 = e.parent, e.left = t1.left, e.right = t1.right);
                            }
                        } else if (null === t1.right.left) e = t1.right, e.left = t1.left, s1 = e;
                        else {
                            for(e = t1.right.left; null !== e.left;)e = e.left;
                            e.parent && (e.parent.left = e.right, s1 = e.parent, e.left = t1.left, e.right = t1.right);
                        }
                        null !== t1.parent ? t1.isLeftChild() ? t1.parent.left = e : t1.parent.right = e : this._setRoot(e), s1 && this._rebalance(s1);
                    }
                    t1.dispose();
                }
                _rotateLeft(t1) {
                    const e = t1.parent, s1 = t1.isLeftChild(), n = t1.right;
                    n && (t1.right = n.left, n.left = t1), null !== e ? s1 ? e.left = n : e.right = n : this._setRoot(n);
                }
                _rotateRight(t1) {
                    const e = t1.parent, s1 = t1.isLeftChild(), n = t1.left;
                    n && (t1.left = n.right, n.right = t1), null !== e ? s1 ? e.left = n : e.right = n : this._setRoot(n);
                }
                _rebalance(t1) {
                    const e = t1.getBalance();
                    e > 1 && t1.left ? t1.left.getBalance() < 0 ? this._rotateLeft(t1.left) : this._rotateRight(t1) : e < -1 && t1.right && (t1.right.getBalance() > 0 ? this._rotateRight(t1.right) : this._rotateLeft(t1));
                }
                get(t1) {
                    if (null !== this._root) {
                        const e = [];
                        if (this._root.search(t1, e), e.length > 0) {
                            let t1 = e[0];
                            for(let s1 = 1; s1 < e.length; s1++)e[s1].low > t1.low && (t1 = e[s1]);
                            return t1.event;
                        }
                    }
                    return null;
                }
                forEach(t1) {
                    if (null !== this._root) {
                        const e = [];
                        this._root.traverse((t1)=>e.push(t1)), e.forEach((e)=>{
                            e.event && t1(e.event);
                        });
                    }
                    return this;
                }
                forEachAtTime(t1, e) {
                    if (null !== this._root) {
                        const s1 = [];
                        this._root.search(t1, s1), s1.forEach((t1)=>{
                            t1.event && e(t1.event);
                        });
                    }
                    return this;
                }
                forEachFrom(t1, e) {
                    if (null !== this._root) {
                        const s1 = [];
                        this._root.searchAfter(t1, s1), s1.forEach((t1)=>{
                            t1.event && e(t1.event);
                        });
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), null !== this._root && this._root.traverse((t1)=>t1.dispose()), this._root = null, this;
                }
            }
            class Do {
                constructor(t1, e, s1){
                    this._left = null, this._right = null, this.parent = null, this.height = 0, this.event = s1, this.low = t1, this.high = e, this.max = this.high;
                }
                insert(t1) {
                    t1.low <= this.low ? null === this.left ? this.left = t1 : this.left.insert(t1) : null === this.right ? this.right = t1 : this.right.insert(t1);
                }
                search(t1, e) {
                    t1 > this.max || (null !== this.left && this.left.search(t1, e), this.low <= t1 && this.high > t1 && e.push(this), this.low > t1 || null !== this.right && this.right.search(t1, e));
                }
                searchAfter(t1, e) {
                    this.low >= t1 && (e.push(this), null !== this.left && this.left.searchAfter(t1, e)), null !== this.right && this.right.searchAfter(t1, e);
                }
                traverse(t1) {
                    t1(this), null !== this.left && this.left.traverse(t1), null !== this.right && this.right.traverse(t1);
                }
                updateHeight() {
                    null !== this.left && null !== this.right ? this.height = Math.max(this.left.height, this.right.height) + 1 : null !== this.right ? this.height = this.right.height + 1 : null !== this.left ? this.height = this.left.height + 1 : this.height = 0;
                }
                updateMax() {
                    this.max = this.high, null !== this.left && (this.max = Math.max(this.max, this.left.max)), null !== this.right && (this.max = Math.max(this.max, this.right.max));
                }
                getBalance() {
                    let t1 = 0;
                    return null !== this.left && null !== this.right ? t1 = this.left.height - this.right.height : null !== this.left ? t1 = this.left.height + 1 : null !== this.right && (t1 = -(this.right.height + 1)), t1;
                }
                isLeftChild() {
                    return null !== this.parent && this.parent.left === this;
                }
                get left() {
                    return this._left;
                }
                set left(t1) {
                    this._left = t1, null !== t1 && (t1.parent = this), this.updateHeight(), this.updateMax();
                }
                get right() {
                    return this._right;
                }
                set right(t1) {
                    this._right = t1, null !== t1 && (t1.parent = this), this.updateHeight(), this.updateMax();
                }
                dispose() {
                    this.parent = null, this._left = null, this._right = null, this.event = null;
                }
            }
            class Oo extends io {
                constructor(){
                    super(ui(Oo.getDefaults(), arguments, [
                        "volume"
                    ])), this.name = "Volume";
                    const t1 = ui(Oo.getDefaults(), arguments, [
                        "volume"
                    ]);
                    this.input = this.output = new ho({
                        context: this.context,
                        gain: t1.volume,
                        units: "decibels"
                    }), this.volume = this.output.gain, Oi(this, "volume"), this._unmutedVolume = t1.volume, this.mute = t1.mute;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                get mute() {
                    return this.volume.value === -1 / 0;
                }
                set mute(t1) {
                    !this.mute && t1 ? (this._unmutedVolume = this.volume.value, this.volume.value = -1 / 0) : this.mute && !t1 && (this.volume.value = this._unmutedVolume);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.volume.dispose(), this;
                }
            }
            class Mo extends io {
                constructor(){
                    super(ui(Mo.getDefaults(), arguments)), this.name = "Destination", this.input = new Oo({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.volume = this.input.volume;
                    const t1 = ui(Mo.getDefaults(), arguments);
                    oo(this.input, this.output, this.context.rawContext.destination), this.mute = t1.mute, this._internalChannels = [
                        this.input,
                        this.context.rawContext.destination,
                        this.output
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                get mute() {
                    return this.input.mute;
                }
                set mute(t1) {
                    this.input.mute = t1;
                }
                chain(...t1) {
                    return this.input.disconnect(), t1.unshift(this.input), t1.push(this.output), oo(...t1), this;
                }
                get maxChannelCount() {
                    return this.context.rawContext.destination.maxChannelCount;
                }
                dispose() {
                    return super.dispose(), this.volume.dispose(), this;
                }
            }
            Ti((t1)=>{
                t1.destination = new Mo({
                    context: t1
                });
            }), ki((t1)=>{
                t1.destination.dispose();
            });
            class Eo extends fi {
                constructor(t1){
                    super(), this.name = "TimelineValue", this._timeline = new wi({
                        memory: 10
                    }), this._initialValue = t1;
                }
                set(t1, e) {
                    return this._timeline.add({
                        value: t1,
                        time: e
                    }), this;
                }
                get(t1) {
                    const e = this._timeline.get(t1);
                    return e ? e.value : this._initialValue;
                }
            }
            class Ro extends io {
                constructor(){
                    super(Object.assign(ui(Ro.getDefaults(), arguments, [
                        "context"
                    ])));
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
            }
            class qo extends Ro {
                constructor(){
                    super(Object.assign(ui(qo.getDefaults(), arguments, [
                        "mapping",
                        "length"
                    ]))), this.name = "WaveShaper", this._shaper = this.context.createWaveShaper(), this.input = this._shaper, this.output = this._shaper;
                    const t1 = ui(qo.getDefaults(), arguments, [
                        "mapping",
                        "length"
                    ]);
                    Ln(t1.mapping) || t1.mapping instanceof Float32Array ? this.curve = Float32Array.from(t1.mapping) : Vn(t1.mapping) && this.setMap(t1.mapping, t1.length);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        length: 1024
                    });
                }
                setMap(t1, e = 1024) {
                    const s1 = new Float32Array(e);
                    for(let n = 0, i = e; n < i; n++){
                        const e = n / (i - 1) * 2 - 1;
                        s1[n] = t1(e, n);
                    }
                    return this.curve = s1, this;
                }
                get curve() {
                    return this._shaper.curve;
                }
                set curve(t1) {
                    this._shaper.curve = t1;
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    Bn([
                        "none",
                        "2x",
                        "4x"
                    ].some((e)=>e.includes(t1)), "oversampling must be either 'none', '2x', or '4x'"), this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.disconnect(), this;
                }
            }
            class Fo extends Ro {
                constructor(){
                    super(Object.assign(ui(Fo.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "Pow";
                    const t1 = ui(Fo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._exponentScaler = this.input = this.output = new qo({
                        context: this.context,
                        mapping: this._expFunc(t1.value),
                        length: 8192
                    }), this._exponent = t1.value;
                }
                static getDefaults() {
                    return Object.assign(Ro.getDefaults(), {
                        value: 1
                    });
                }
                _expFunc(t1) {
                    return (e)=>Math.pow(Math.abs(e), t1);
                }
                get value() {
                    return this._exponent;
                }
                set value(t1) {
                    this._exponent = t1, this._exponentScaler.setMap(this._expFunc(this._exponent));
                }
                dispose() {
                    return super.dispose(), this._exponentScaler.dispose(), this;
                }
            }
            class Io {
                constructor(t1, e){
                    this.id = Io._eventId++, this._remainderTime = 0;
                    const s1 = Object.assign(Io.getDefaults(), e);
                    this.transport = t1, this.callback = s1.callback, this._once = s1.once, this.time = Math.floor(s1.time), this._remainderTime = s1.time - this.time;
                }
                static getDefaults() {
                    return {
                        callback: Ei,
                        once: !1,
                        time: 0
                    };
                }
                get floatTime() {
                    return this.time + this._remainderTime;
                }
                invoke(t1) {
                    if (this.callback) {
                        const e = this.transport.bpm.getDurationOfTicks(1, t1);
                        this.callback(t1 + this._remainderTime * e), this._once && this.transport.clear(this.id);
                    }
                }
                dispose() {
                    return this.callback = void 0, this;
                }
            }
            Io._eventId = 0;
            class Vo extends Io {
                constructor(t1, e){
                    super(t1, e), this._currentId = -1, this._nextId = -1, this._nextTick = this.time, this._boundRestart = this._restart.bind(this);
                    const s1 = Object.assign(Vo.getDefaults(), e);
                    this.duration = s1.duration, this._interval = s1.interval, this._nextTick = s1.time, this.transport.on("start", this._boundRestart), this.transport.on("loopStart", this._boundRestart), this.transport.on("ticks", this._boundRestart), this.context = this.transport.context, this._restart();
                }
                static getDefaults() {
                    return Object.assign({}, Io.getDefaults(), {
                        duration: 1 / 0,
                        interval: 1,
                        once: !1
                    });
                }
                invoke(t1) {
                    this._createEvents(t1), super.invoke(t1);
                }
                _createEvent() {
                    return vi(this._nextTick, this.floatTime + this.duration) ? this.transport.scheduleOnce(this.invoke.bind(this), new So(this.context, this._nextTick).toSeconds()) : -1;
                }
                _createEvents(t1) {
                    vi(this._nextTick + this._interval, this.floatTime + this.duration) && (this._nextTick += this._interval, this._currentId = this._nextId, this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new So(this.context, this._nextTick).toSeconds()));
                }
                _restart(t1) {
                    this.transport.clear(this._currentId), this.transport.clear(this._nextId), this._nextTick = this.floatTime;
                    const e = this.transport.getTicksAtTime(t1);
                    mi(e, this.time) && (this._nextTick = this.floatTime + Math.ceil((e - this.floatTime) / this._interval) * this._interval), this._currentId = this._createEvent(), this._nextTick += this._interval, this._nextId = this._createEvent();
                }
                dispose() {
                    return super.dispose(), this.transport.clear(this._currentId), this.transport.clear(this._nextId), this.transport.off("start", this._boundRestart), this.transport.off("loopStart", this._boundRestart), this.transport.off("ticks", this._boundRestart), this;
                }
            }
            class No extends eo {
                constructor(){
                    super(ui(No.getDefaults(), arguments)), this.name = "Transport", this._loop = new Eo(!1), this._loopStart = 0, this._loopEnd = 0, this._scheduledEvents = {}, this._timeline = new wi, this._repeatedEvents = new Co, this._syncedSignals = [], this._swingAmount = 0;
                    const t1 = ui(No.getDefaults(), arguments);
                    this._ppq = t1.ppq, this._clock = new vo({
                        callback: this._processTick.bind(this),
                        context: this.context,
                        frequency: 0,
                        units: "bpm"
                    }), this._bindClockEvents(), this.bpm = this._clock.frequency, this._clock.frequency.multiplier = t1.ppq, this.bpm.setValueAtTime(t1.bpm, 0), Oi(this, "bpm"), this._timeSignature = t1.timeSignature, this._swingTicks = t1.ppq / 2;
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        bpm: 120,
                        loopEnd: "4m",
                        loopStart: 0,
                        ppq: 192,
                        swing: 0,
                        swingSubdivision: "8n",
                        timeSignature: 4
                    });
                }
                _processTick(t1, e) {
                    if (this._loop.get(t1) && e >= this._loopEnd && (this.emit("loopEnd", t1), this._clock.setTicksAtTime(this._loopStart, t1), e = this._loopStart, this.emit("loopStart", t1, this._clock.getSecondsAtTime(t1)), this.emit("loop", t1)), this._swingAmount > 0 && e % this._ppq != 0 && e % (2 * this._swingTicks) != 0) {
                        const s1 = e % (2 * this._swingTicks) / (2 * this._swingTicks), n = Math.sin(s1 * Math.PI) * this._swingAmount;
                        t1 += new So(this.context, 2 * this._swingTicks / 3).toSeconds() * n;
                    }
                    Xn(!0), this._timeline.forEachAtTime(e, (e)=>e.invoke(t1)), Xn(!1);
                }
                schedule(t1, e) {
                    const s1 = new Io(this, {
                        callback: t1,
                        time: new Ki(this.context, e).toTicks()
                    });
                    return this._addEvent(s1, this._timeline);
                }
                scheduleRepeat(t1, e, s1, n = 1 / 0) {
                    const i = new Vo(this, {
                        callback: t1,
                        duration: new Zi(this.context, n).toTicks(),
                        interval: new Zi(this.context, e).toTicks(),
                        time: new Ki(this.context, s1).toTicks()
                    });
                    return this._addEvent(i, this._repeatedEvents);
                }
                scheduleOnce(t1, e) {
                    const s1 = new Io(this, {
                        callback: t1,
                        once: !0,
                        time: new Ki(this.context, e).toTicks()
                    });
                    return this._addEvent(s1, this._timeline);
                }
                clear(t1) {
                    if (this._scheduledEvents.hasOwnProperty(t1)) {
                        const e = this._scheduledEvents[t1.toString()];
                        e.timeline.remove(e.event), e.event.dispose(), delete this._scheduledEvents[t1.toString()];
                    }
                    return this;
                }
                _addEvent(t1, e) {
                    return this._scheduledEvents[t1.id.toString()] = {
                        event: t1,
                        timeline: e
                    }, e.add(t1), t1.id;
                }
                cancel(t1 = 0) {
                    const e = this.toTicks(t1);
                    return this._timeline.forEachFrom(e, (t1)=>this.clear(t1.id)), this._repeatedEvents.forEachFrom(e, (t1)=>this.clear(t1.id)), this;
                }
                _bindClockEvents() {
                    this._clock.on("start", (t1, e)=>{
                        e = new So(this.context, e).toSeconds(), this.emit("start", t1, e);
                    }), this._clock.on("stop", (t1)=>{
                        this.emit("stop", t1);
                    }), this._clock.on("pause", (t1)=>{
                        this.emit("pause", t1);
                    });
                }
                get state() {
                    return this._clock.getStateAtTime(this.now());
                }
                start(t1, e) {
                    let s1;
                    return this.context.resume(), In(e) && (s1 = this.toTicks(e)), this._clock.start(t1, s1), this;
                }
                stop(t1) {
                    return this._clock.stop(t1), this;
                }
                pause(t1) {
                    return this._clock.pause(t1), this;
                }
                toggle(t1) {
                    return t1 = this.toSeconds(t1), "started" !== this._clock.getStateAtTime(t1) ? this.start(t1) : this.stop(t1), this;
                }
                get timeSignature() {
                    return this._timeSignature;
                }
                set timeSignature(t1) {
                    Ln(t1) && (t1 = t1[0] / t1[1] * 4), this._timeSignature = t1;
                }
                get loopStart() {
                    return new Zi(this.context, this._loopStart, "i").toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1);
                }
                get loopEnd() {
                    return new Zi(this.context, this._loopEnd, "i").toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1);
                }
                get loop() {
                    return this._loop.get(this.now());
                }
                set loop(t1) {
                    this._loop.set(t1, this.now());
                }
                setLoopPoints(t1, e) {
                    return this.loopStart = t1, this.loopEnd = e, this;
                }
                get swing() {
                    return this._swingAmount;
                }
                set swing(t1) {
                    this._swingAmount = t1;
                }
                get swingSubdivision() {
                    return new So(this.context, this._swingTicks).toNotation();
                }
                set swingSubdivision(t1) {
                    this._swingTicks = this.toTicks(t1);
                }
                get position() {
                    const t1 = this.now(), e = this._clock.getTicksAtTime(t1);
                    return new So(this.context, e).toBarsBeatsSixteenths();
                }
                set position(t1) {
                    const e = this.toTicks(t1);
                    this.ticks = e;
                }
                get seconds() {
                    return this._clock.seconds;
                }
                set seconds(t1) {
                    const e = this.now(), s1 = this._clock.frequency.timeToTicks(t1, e);
                    this.ticks = s1;
                }
                get progress() {
                    if (this.loop) {
                        const t1 = this.now();
                        return (this._clock.getTicksAtTime(t1) - this._loopStart) / (this._loopEnd - this._loopStart);
                    }
                    return 0;
                }
                get ticks() {
                    return this._clock.ticks;
                }
                set ticks(t1) {
                    if (this._clock.ticks !== t1) {
                        const e = this.now();
                        if ("started" === this.state) {
                            const s1 = this._clock.getTicksAtTime(e), n = e + this._clock.frequency.getDurationOfTicks(Math.ceil(s1) - s1, e);
                            this.emit("stop", n), this._clock.setTicksAtTime(t1, n), this.emit("start", n, this._clock.getSecondsAtTime(n));
                        } else this.emit("ticks", e), this._clock.setTicksAtTime(t1, e);
                    }
                }
                getTicksAtTime(t1) {
                    return this._clock.getTicksAtTime(t1);
                }
                getSecondsAtTime(t1) {
                    return this._clock.getSecondsAtTime(t1);
                }
                get PPQ() {
                    return this._clock.frequency.multiplier;
                }
                set PPQ(t1) {
                    this._clock.frequency.multiplier = t1;
                }
                nextSubdivision(t1) {
                    if (t1 = this.toTicks(t1), "started" !== this.state) return 0;
                    {
                        const e = this.now(), s1 = t1 - this.getTicksAtTime(e) % t1;
                        return this._clock.nextTickTime(s1, e);
                    }
                }
                syncSignal(t1, e) {
                    const s1 = this.now();
                    let n = this.bpm, i = 1 / (60 / n.getValueAtTime(s1) / this.PPQ), o = [];
                    if ("time" === t1.units) {
                        const t1 = 1 / 64 / i, e = new ho(t1), s1 = new Fo(-1), r = new ho(t1);
                        n.chain(e, s1, r), n = r, i = 1 / i, o = [
                            e,
                            s1,
                            r
                        ];
                    }
                    e || (e = 0 !== t1.getValueAtTime(s1) ? t1.getValueAtTime(s1) / i : 0);
                    const r = new ho(e);
                    return n.connect(r), r.connect(t1._param), o.push(r), this._syncedSignals.push({
                        initial: t1.value,
                        nodes: o,
                        signal: t1
                    }), t1.value = 0, this;
                }
                unsyncSignal(t1) {
                    for(let e = this._syncedSignals.length - 1; e >= 0; e--){
                        const s1 = this._syncedSignals[e];
                        s1.signal === t1 && (s1.nodes.forEach((t1)=>t1.dispose()), s1.signal.value = s1.initial, this._syncedSignals.splice(e, 1));
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), this._clock.dispose(), Mi(this, "bpm"), this._timeline.dispose(), this._repeatedEvents.dispose(), this;
                }
            }
            Ai.mixin(No), Ti((t1)=>{
                t1.transport = new No({
                    context: t1
                });
            }), ki((t1)=>{
                t1.transport.dispose();
            });
            class Po extends io {
                constructor(t1){
                    super(t1), this.input = void 0, this._state = new so("stopped"), this._synced = !1, this._scheduled = [], this._syncedStart = Ei, this._syncedStop = Ei, this._state.memory = 100, this._state.increasing = !0, this._volume = this.output = new Oo({
                        context: this.context,
                        mute: t1.mute,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this.onstop = t1.onstop;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        onstop: Ei,
                        volume: 0
                    });
                }
                get state() {
                    return this._synced ? "started" === this.context.transport.state ? this._state.getValueAtTime(this.context.transport.seconds) : "stopped" : this._state.getValueAtTime(this.now());
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                _clampToCurrentTime(t1) {
                    return this._synced ? t1 : Math.max(t1, this.context.currentTime);
                }
                start(t1, e, s1) {
                    let n = Fn(t1) && this._synced ? this.context.transport.seconds : this.toSeconds(t1);
                    if (n = this._clampToCurrentTime(n), this._synced || "started" !== this._state.getValueAtTime(n)) {
                        if (this.log("start", n), this._state.setStateAtTime("started", n), this._synced) {
                            const t1 = this._state.get(n);
                            t1 && (t1.offset = this.toSeconds(pi(e, 0)), t1.duration = s1 ? this.toSeconds(s1) : void 0);
                            const i = this.context.transport.schedule((t1)=>{
                                this._start(t1, e, s1);
                            }, n);
                            this._scheduled.push(i), "started" === this.context.transport.state && this.context.transport.getSecondsAtTime(this.immediate()) > n && this._syncedStart(this.now(), this.context.transport.seconds);
                        } else Gn(this.context), this._start(n, e, s1);
                    } else Bn(mi(n, this._state.get(n).time), "Start time must be strictly greater than previous start time"), this._state.cancel(n), this._state.setStateAtTime("started", n), this.log("restart", n), this.restart(n, e, s1);
                    return this;
                }
                stop(t1) {
                    let e = Fn(t1) && this._synced ? this.context.transport.seconds : this.toSeconds(t1);
                    if (e = this._clampToCurrentTime(e), "started" === this._state.getValueAtTime(e) || In(this._state.getNextState("started", e))) {
                        if (this.log("stop", e), this._synced) {
                            const t1 = this.context.transport.schedule(this._stop.bind(this), e);
                            this._scheduled.push(t1);
                        } else this._stop(e);
                        this._state.cancel(e), this._state.setStateAtTime("stopped", e);
                    }
                    return this;
                }
                restart(t1, e, s1) {
                    return t1 = this.toSeconds(t1), "started" === this._state.getValueAtTime(t1) && (this._state.cancel(t1), this._restart(t1, e, s1)), this;
                }
                sync() {
                    return this._synced || (this._synced = !0, this._syncedStart = (t1, e)=>{
                        if (mi(e, 0)) {
                            const s1 = this._state.get(e);
                            if (s1 && "started" === s1.state && s1.time !== e) {
                                const n = e - this.toSeconds(s1.time);
                                let i;
                                s1.duration && (i = this.toSeconds(s1.duration) - n), this._start(t1, this.toSeconds(s1.offset) + n, i);
                            }
                        }
                    }, this._syncedStop = (t1)=>{
                        const e = this.context.transport.getSecondsAtTime(Math.max(t1 - this.sampleTime, 0));
                        "started" === this._state.getValueAtTime(e) && this._stop(t1);
                    }, this.context.transport.on("start", this._syncedStart), this.context.transport.on("loopStart", this._syncedStart), this.context.transport.on("stop", this._syncedStop), this.context.transport.on("pause", this._syncedStop), this.context.transport.on("loopEnd", this._syncedStop)), this;
                }
                unsync() {
                    return this._synced && (this.context.transport.off("stop", this._syncedStop), this.context.transport.off("pause", this._syncedStop), this.context.transport.off("loopEnd", this._syncedStop), this.context.transport.off("start", this._syncedStart), this.context.transport.off("loopStart", this._syncedStart)), this._synced = !1, this._scheduled.forEach((t1)=>this.context.transport.clear(t1)), this._scheduled = [], this._state.cancel(0), this._stop(0), this;
                }
                dispose() {
                    return super.dispose(), this.onstop = Ei, this.unsync(), this._volume.dispose(), this._state.dispose(), this;
                }
            }
            class jo extends lo {
                constructor(){
                    super(ui(jo.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "ToneBufferSource", this._source = this.context.createBufferSource(), this._internalChannels = [
                        this._source
                    ], this._sourceStarted = !1, this._sourceStopped = !1;
                    const t1 = ui(jo.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    ro(this._source, this._gainNode), this._source.onended = ()=>this._stopSource(), this.playbackRate = new no({
                        context: this.context,
                        param: this._source.playbackRate,
                        units: "positive",
                        value: t1.playbackRate
                    }), this.loop = t1.loop, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this._buffer = new Ri(t1.url, t1.onload, t1.onerror), this._internalChannels.push(this._source);
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        url: new Ri,
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        onload: Ei,
                        onerror: Ei,
                        playbackRate: 1
                    });
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1;
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1;
                }
                get curve() {
                    return this._curve;
                }
                set curve(t1) {
                    this._curve = t1;
                }
                start(t1, e, s1, n = 1) {
                    Bn(this.buffer.loaded, "buffer is either not set or not loaded");
                    const i = this.toSeconds(t1);
                    this._startGain(i, n), e = this.loop ? pi(e, this.loopStart) : pi(e, 0);
                    let o = Math.max(this.toSeconds(e), 0);
                    if (this.loop) {
                        const t1 = this.toSeconds(this.loopEnd) || this.buffer.duration, e = this.toSeconds(this.loopStart), s1 = t1 - e;
                        gi(o, t1) && (o = (o - e) % s1 + e), yi(o, this.buffer.duration) && (o = 0);
                    }
                    if (this._source.buffer = this.buffer.get(), this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration, vi(o, this.buffer.duration) && (this._sourceStarted = !0, this._source.start(i, o)), In(s1)) {
                        let t1 = this.toSeconds(s1);
                        t1 = Math.max(t1, 0), this.stop(i + t1);
                    }
                    return this;
                }
                _stopSource(t1) {
                    !this._sourceStopped && this._sourceStarted && (this._sourceStopped = !0, this._source.stop(this.toSeconds(t1)), this._onended());
                }
                get loopStart() {
                    return this._source.loopStart;
                }
                set loopStart(t1) {
                    this._source.loopStart = this.toSeconds(t1);
                }
                get loopEnd() {
                    return this._source.loopEnd;
                }
                set loopEnd(t1) {
                    this._source.loopEnd = this.toSeconds(t1);
                }
                get buffer() {
                    return this._buffer;
                }
                set buffer(t1) {
                    this._buffer.set(t1);
                }
                get loop() {
                    return this._source.loop;
                }
                set loop(t1) {
                    this._source.loop = t1, this._sourceStarted && this.cancelStop();
                }
                dispose() {
                    return super.dispose(), this._source.onended = null, this._source.disconnect(), this._buffer.dispose(), this.playbackRate.dispose(), this;
                }
            }
            class Lo extends Po {
                constructor(){
                    super(ui(Lo.getDefaults(), arguments, [
                        "type"
                    ])), this.name = "Noise", this._source = null;
                    const t1 = ui(Lo.getDefaults(), arguments, [
                        "type"
                    ]);
                    this._playbackRate = t1.playbackRate, this.type = t1.type, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        fadeIn: 0,
                        fadeOut: 0,
                        playbackRate: 1,
                        type: "white"
                    });
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    if (Bn(t1 in Bo, "Noise: invalid type: " + t1), this._type !== t1 && (this._type = t1, "started" === this.state)) {
                        const t1 = this.now();
                        this._stop(t1), this._start(t1);
                    }
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._source && (this._source.playbackRate.value = t1);
                }
                _start(t1) {
                    const e = Bo[this._type];
                    this._source = new jo({
                        url: e,
                        context: this.context,
                        fadeIn: this._fadeIn,
                        fadeOut: this._fadeOut,
                        loop: !0,
                        onended: ()=>this.onstop(this),
                        playbackRate: this._playbackRate
                    }).connect(this.output), this._source.start(this.toSeconds(t1), Math.random() * (e.duration - .001));
                }
                _stop(t1) {
                    this._source && (this._source.stop(this.toSeconds(t1)), this._source = null);
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1, this._source && (this._source.fadeIn = this._fadeIn);
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1, this._source && (this._source.fadeOut = this._fadeOut);
                }
                _restart(t1) {
                    this._stop(t1), this._start(t1);
                }
                dispose() {
                    return super.dispose(), this._source && this._source.disconnect(), this;
                }
            }
            const zo = 220500, Wo = {
                brown: null,
                pink: null,
                white: null
            }, Bo = {
                get brown () {
                    if (!Wo.brown) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            t1[e] = s1;
                            let n = 0;
                            for(let t1 = 0; t1 < zo; t1++){
                                const e = 2 * Math.random() - 1;
                                s1[t1] = (n + .02 * e) / 1.02, n = s1[t1], s1[t1] *= 3.5;
                            }
                        }
                        Wo.brown = (new Ri).fromArray(t1);
                    }
                    return Wo.brown;
                },
                get pink () {
                    if (!Wo.pink) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            let n, i, o, r, a, c, h;
                            t1[e] = s1, n = i = o = r = a = c = h = 0;
                            for(let t1 = 0; t1 < zo; t1++){
                                const e = 2 * Math.random() - 1;
                                n = .99886 * n + .0555179 * e, i = .99332 * i + .0750759 * e, o = .969 * o + .153852 * e, r = .8665 * r + .3104856 * e, a = .55 * a + .5329522 * e, c = -0.7616 * c - .016898 * e, s1[t1] = n + i + o + r + a + c + h + .5362 * e, s1[t1] *= .11, h = .115926 * e;
                            }
                        }
                        Wo.pink = (new Ri).fromArray(t1);
                    }
                    return Wo.pink;
                },
                get white () {
                    if (!Wo.white) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            t1[e] = s1;
                            for(let t1 = 0; t1 < zo; t1++)s1[t1] = 2 * Math.random() - 1;
                        }
                        Wo.white = (new Ri).fromArray(t1);
                    }
                    return Wo.white;
                }
            };
            class Uo extends io {
                constructor(){
                    super(ui(Uo.getDefaults(), arguments, [
                        "volume"
                    ])), this.name = "UserMedia";
                    const t1 = ui(Uo.getDefaults(), arguments, [
                        "volume"
                    ]);
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this.mute = t1.mute;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                open(t1) {
                    return ni(this, void 0, void 0, function*() {
                        Bn(Uo.supported, "UserMedia is not supported"), "started" === this.state && this.close();
                        const e = yield Uo.enumerateDevices();
                        Nn(t1) ? this._device = e[t1] : (this._device = e.find((e)=>e.label === t1 || e.deviceId === t1), !this._device && e.length > 0 && (this._device = e[0]), Bn(In(this._device), `No matching device ${t1}`));
                        const s1 = {
                            audio: {
                                echoCancellation: !1,
                                sampleRate: this.context.sampleRate,
                                noiseSuppression: !1,
                                mozNoiseSuppression: !1
                            }
                        };
                        this._device && (s1.audio.deviceId = this._device.deviceId);
                        const n = yield navigator.mediaDevices.getUserMedia(s1);
                        if (!this._stream) {
                            this._stream = n;
                            const t1 = this.context.createMediaStreamSource(n);
                            ro(t1, this.output), this._mediaStream = t1;
                        }
                        return this;
                    });
                }
                close() {
                    return this._stream && this._mediaStream && (this._stream.getAudioTracks().forEach((t1)=>{
                        t1.stop();
                    }), this._stream = void 0, this._mediaStream.disconnect(), this._mediaStream = void 0), this._device = void 0, this;
                }
                static enumerateDevices() {
                    return ni(this, void 0, void 0, function*() {
                        return (yield navigator.mediaDevices.enumerateDevices()).filter((t1)=>"audioinput" === t1.kind);
                    });
                }
                get state() {
                    return this._stream && this._stream.active ? "started" : "stopped";
                }
                get deviceId() {
                    return this._device ? this._device.deviceId : void 0;
                }
                get groupId() {
                    return this._device ? this._device.groupId : void 0;
                }
                get label() {
                    return this._device ? this._device.label : void 0;
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                dispose() {
                    return super.dispose(), this.close(), this._volume.dispose(), this.volume.dispose(), this;
                }
                static get supported() {
                    return In(navigator.mediaDevices) && In(navigator.mediaDevices.getUserMedia);
                }
            }
            function Go(t1, e) {
                return ni(this, void 0, void 0, function*() {
                    const s1 = e / t1.context.sampleRate, n = new qi(1, s1, t1.context.sampleRate);
                    return new t1.constructor(Object.assign(t1.get(), {
                        frequency: 2 / s1,
                        detune: 0,
                        context: n
                    })).toDestination().start(0), (yield n.render()).getChannelData(0);
                });
            }
            class Qo extends lo {
                constructor(){
                    super(ui(Qo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "ToneOscillatorNode", this._oscillator = this.context.createOscillator(), this._internalChannels = [
                        this._oscillator
                    ];
                    const t1 = ui(Qo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    ro(this._oscillator, this._gainNode), this.type = t1.type, this.frequency = new no({
                        context: this.context,
                        param: this._oscillator.frequency,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new no({
                        context: this.context,
                        param: this._oscillator.detune,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, [
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        type: "sine"
                    });
                }
                start(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("start", e), this._startGain(e), this._oscillator.start(e), this;
                }
                _stopSource(t1) {
                    this._oscillator.stop(t1);
                }
                setPeriodicWave(t1) {
                    return this._oscillator.setPeriodicWave(t1), this;
                }
                get type() {
                    return this._oscillator.type;
                }
                set type(t1) {
                    this._oscillator.type = t1;
                }
                dispose() {
                    return super.dispose(), "started" === this.state && this.stop(), this._oscillator.disconnect(), this.frequency.dispose(), this.detune.dispose(), this;
                }
            }
            class Zo extends Po {
                constructor(){
                    super(ui(Zo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "Oscillator", this._oscillator = null;
                    const t1 = ui(Zo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), Oi(this, "frequency"), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, "detune"), this._partials = t1.partials, this._partialCount = t1.partialCount, this._type = t1.type, t1.partialCount && "custom" !== t1.type && (this._type = this.baseType + t1.partialCount.toString()), this.phase = t1.phase;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        partialCount: 0,
                        partials: [],
                        phase: 0,
                        type: "sine"
                    });
                }
                _start(t1) {
                    const e = this.toSeconds(t1), s1 = new Qo({
                        context: this.context,
                        onended: ()=>this.onstop(this)
                    });
                    this._oscillator = s1, this._wave ? this._oscillator.setPeriodicWave(this._wave) : this._oscillator.type = this._type, this._oscillator.connect(this.output), this.frequency.connect(this._oscillator.frequency), this.detune.connect(this._oscillator.detune), this._oscillator.start(e);
                }
                _stop(t1) {
                    const e = this.toSeconds(t1);
                    this._oscillator && this._oscillator.stop(e);
                }
                _restart(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("restart", e), this._oscillator && this._oscillator.cancelStop(), this._state.cancel(e), this;
                }
                syncFrequency() {
                    return this.context.transport.syncSignal(this.frequency), this;
                }
                unsyncFrequency() {
                    return this.context.transport.unsyncSignal(this.frequency), this;
                }
                _getCachedPeriodicWave() {
                    if ("custom" === this._type) return Zo._periodicWaveCache.find((t1)=>{
                        var e, s1;
                        return t1.phase === this._phase && (e = t1.partials, s1 = this._partials, e.length === s1.length && e.every((t1, e)=>s1[e] === t1));
                    });
                    {
                        const t1 = Zo._periodicWaveCache.find((t1)=>t1.type === this._type && t1.phase === this._phase);
                        return this._partialCount = t1 ? t1.partialCount : this._partialCount, t1;
                    }
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1;
                    const e = -1 !== [
                        "sine",
                        "square",
                        "sawtooth",
                        "triangle"
                    ].indexOf(t1);
                    if (0 === this._phase && e) this._wave = void 0, this._partialCount = 0, null !== this._oscillator && (this._oscillator.type = t1);
                    else {
                        const e = this._getCachedPeriodicWave();
                        if (In(e)) {
                            const { partials: t1, wave: s1 } = e;
                            this._wave = s1, this._partials = t1, null !== this._oscillator && this._oscillator.setPeriodicWave(this._wave);
                        } else {
                            const [e, s1] = this._getRealImaginary(t1, this._phase), n = this.context.createPeriodicWave(e, s1);
                            this._wave = n, null !== this._oscillator && this._oscillator.setPeriodicWave(this._wave), Zo._periodicWaveCache.push({
                                imag: s1,
                                partialCount: this._partialCount,
                                partials: this._partials,
                                phase: this._phase,
                                real: e,
                                type: this._type,
                                wave: this._wave
                            }), Zo._periodicWaveCache.length > 100 && Zo._periodicWaveCache.shift();
                        }
                    }
                }
                get baseType() {
                    return this._type.replace(this.partialCount.toString(), "");
                }
                set baseType(t1) {
                    this.partialCount && "custom" !== this._type && "custom" !== t1 ? this.type = t1 + this.partialCount : this.type = t1;
                }
                get partialCount() {
                    return this._partialCount;
                }
                set partialCount(t1) {
                    Un(t1, 0);
                    let e = this._type;
                    const s1 = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);
                    if (s1 && (e = s1[1]), "custom" !== this._type) this.type = 0 === t1 ? e : e + t1.toString();
                    else {
                        const e = new Float32Array(t1);
                        this._partials.forEach((t1, s1)=>e[s1] = t1), this._partials = Array.from(e), this.type = this._type;
                    }
                }
                _getRealImaginary(t1, e) {
                    let s1 = 2048;
                    const n = new Float32Array(s1), i = new Float32Array(s1);
                    let o = 1;
                    if ("custom" === t1) {
                        if (o = this._partials.length + 1, this._partialCount = this._partials.length, s1 = o, 0 === this._partials.length) return [
                            n,
                            i
                        ];
                    } else {
                        const e = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(t1);
                        e ? (o = parseInt(e[2], 10) + 1, this._partialCount = parseInt(e[2], 10), t1 = e[1], o = Math.max(o, 2), s1 = o) : this._partialCount = 0, this._partials = [];
                    }
                    for(let r = 1; r < s1; ++r){
                        const s1 = 2 / (r * Math.PI);
                        let a;
                        switch(t1){
                            case "sine":
                                a = r <= o ? 1 : 0, this._partials[r - 1] = a;
                                break;
                            case "square":
                                a = 1 & r ? 2 * s1 : 0, this._partials[r - 1] = a;
                                break;
                            case "sawtooth":
                                a = s1 * (1 & r ? 1 : -1), this._partials[r - 1] = a;
                                break;
                            case "triangle":
                                a = 1 & r ? s1 * s1 * 2 * (r - 1 >> 1 & 1 ? -1 : 1) : 0, this._partials[r - 1] = a;
                                break;
                            case "custom":
                                a = this._partials[r - 1];
                                break;
                            default:
                                throw new TypeError("Oscillator: invalid type: " + t1);
                        }
                        0 !== a ? (n[r] = -a * Math.sin(e * r), i[r] = a * Math.cos(e * r)) : (n[r] = 0, i[r] = 0);
                    }
                    return [
                        n,
                        i
                    ];
                }
                _inverseFFT(t1, e, s1) {
                    let n = 0;
                    const i = t1.length;
                    for(let o = 0; o < i; o++)n += t1[o] * Math.cos(o * s1) + e[o] * Math.sin(o * s1);
                    return n;
                }
                getInitialValue() {
                    const [t1, e] = this._getRealImaginary(this._type, 0);
                    let s1 = 0;
                    const n = 2 * Math.PI;
                    for(let i = 0; i < 32; i++)s1 = Math.max(this._inverseFFT(t1, e, i / 32 * n), s1);
                    return xi(-this._inverseFFT(t1, e, this._phase) / s1, -1, 1);
                }
                get partials() {
                    return this._partials.slice(0, this.partialCount);
                }
                set partials(t1) {
                    this._partials = t1, this._partialCount = this._partials.length, t1.length && (this.type = "custom");
                }
                get phase() {
                    return this._phase * (180 / Math.PI);
                }
                set phase(t1) {
                    this._phase = t1 * Math.PI / 180, this.type = this._type;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), null !== this._oscillator && this._oscillator.dispose(), this._wave = void 0, this.frequency.dispose(), this.detune.dispose(), this;
                }
            }
            Zo._periodicWaveCache = [];
            class Xo extends Ro {
                constructor(){
                    super(...arguments), this.name = "AudioToGain", this._norm = new qo({
                        context: this.context,
                        mapping: (t1)=>(t1 + 1) / 2
                    }), this.input = this._norm, this.output = this._norm;
                }
                dispose() {
                    return super.dispose(), this._norm.dispose(), this;
                }
            }
            class Yo extends po {
                constructor(){
                    super(Object.assign(ui(Yo.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "Multiply", this.override = !1;
                    const t1 = ui(Yo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._mult = this.input = this.output = new ho({
                        context: this.context,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), this.factor = this._param = this._mult.gain, this.factor.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._mult.dispose(), this;
                }
            }
            class $o extends Po {
                constructor(){
                    super(ui($o.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ])), this.name = "AMOscillator", this._modulationScale = new Xo({
                        context: this.context
                    }), this._modulationNode = new ho({
                        context: this.context
                    });
                    const t1 = ui($o.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ]);
                    this._carrier = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: t1.type
                    }), this.frequency = this._carrier.frequency, this.detune = this._carrier.detune, this._modulator = new Zo({
                        context: this.context,
                        phase: t1.phase,
                        type: t1.modulationType
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this.frequency.chain(this.harmonicity, this._modulator.frequency), this._modulator.chain(this._modulationScale, this._modulationNode.gain), this._carrier.chain(this._modulationNode, this.output), Oi(this, [
                        "frequency",
                        "detune",
                        "harmonicity"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        harmonicity: 1,
                        modulationType: "square"
                    });
                }
                _start(t1) {
                    this._modulator.start(t1), this._carrier.start(t1);
                }
                _stop(t1) {
                    this._modulator.stop(t1), this._carrier.stop(t1);
                }
                _restart(t1) {
                    this._modulator.restart(t1), this._carrier.restart(t1);
                }
                get type() {
                    return this._carrier.type;
                }
                set type(t1) {
                    this._carrier.type = t1;
                }
                get baseType() {
                    return this._carrier.baseType;
                }
                set baseType(t1) {
                    this._carrier.baseType = t1;
                }
                get partialCount() {
                    return this._carrier.partialCount;
                }
                set partialCount(t1) {
                    this._carrier.partialCount = t1;
                }
                get modulationType() {
                    return this._modulator.type;
                }
                set modulationType(t1) {
                    this._modulator.type = t1;
                }
                get phase() {
                    return this._carrier.phase;
                }
                set phase(t1) {
                    this._carrier.phase = t1, this._modulator.phase = t1;
                }
                get partials() {
                    return this._carrier.partials;
                }
                set partials(t1) {
                    this._carrier.partials = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.detune.dispose(), this.harmonicity.dispose(), this._carrier.dispose(), this._modulator.dispose(), this._modulationNode.dispose(), this._modulationScale.dispose(), this;
                }
            }
            class Ho extends Po {
                constructor(){
                    super(ui(Ho.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ])), this.name = "FMOscillator", this._modulationNode = new ho({
                        context: this.context,
                        gain: 0
                    });
                    const t1 = ui(Ho.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ]);
                    this._carrier = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: 0,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: t1.type
                    }), this.detune = this._carrier.detune, this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this._modulator = new Zo({
                        context: this.context,
                        phase: t1.phase,
                        type: t1.modulationType
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this.modulationIndex = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.modulationIndex
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.frequency.chain(this.modulationIndex, this._modulationNode), this._modulator.connect(this._modulationNode.gain), this._modulationNode.connect(this._carrier.frequency), this._carrier.connect(this.output), this.detune.connect(this._modulator.detune), Oi(this, [
                        "modulationIndex",
                        "frequency",
                        "detune",
                        "harmonicity"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        harmonicity: 1,
                        modulationIndex: 2,
                        modulationType: "square"
                    });
                }
                _start(t1) {
                    this._modulator.start(t1), this._carrier.start(t1);
                }
                _stop(t1) {
                    this._modulator.stop(t1), this._carrier.stop(t1);
                }
                _restart(t1) {
                    return this._modulator.restart(t1), this._carrier.restart(t1), this;
                }
                get type() {
                    return this._carrier.type;
                }
                set type(t1) {
                    this._carrier.type = t1;
                }
                get baseType() {
                    return this._carrier.baseType;
                }
                set baseType(t1) {
                    this._carrier.baseType = t1;
                }
                get partialCount() {
                    return this._carrier.partialCount;
                }
                set partialCount(t1) {
                    this._carrier.partialCount = t1;
                }
                get modulationType() {
                    return this._modulator.type;
                }
                set modulationType(t1) {
                    this._modulator.type = t1;
                }
                get phase() {
                    return this._carrier.phase;
                }
                set phase(t1) {
                    this._carrier.phase = t1, this._modulator.phase = t1;
                }
                get partials() {
                    return this._carrier.partials;
                }
                set partials(t1) {
                    this._carrier.partials = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.harmonicity.dispose(), this._carrier.dispose(), this._modulator.dispose(), this._modulationNode.dispose(), this.modulationIndex.dispose(), this;
                }
            }
            class Jo extends Po {
                constructor(){
                    super(ui(Jo.getDefaults(), arguments, [
                        "frequency",
                        "width"
                    ])), this.name = "PulseOscillator", this._widthGate = new ho({
                        context: this.context,
                        gain: 0
                    }), this._thresh = new qo({
                        context: this.context,
                        mapping: (t1)=>t1 <= 0 ? -1 : 1
                    });
                    const t1 = ui(Jo.getDefaults(), arguments, [
                        "frequency",
                        "width"
                    ]);
                    this.width = new po({
                        context: this.context,
                        units: "audioRange",
                        value: t1.width
                    }), this._triangle = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: "triangle"
                    }), this.frequency = this._triangle.frequency, this.detune = this._triangle.detune, this._triangle.chain(this._thresh, this.output), this.width.chain(this._widthGate, this._thresh), Oi(this, [
                        "width",
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        phase: 0,
                        type: "pulse",
                        width: .2
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._triangle.start(t1), this._widthGate.gain.setValueAtTime(1, t1);
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._triangle.stop(t1), this._widthGate.gain.cancelScheduledValues(t1), this._widthGate.gain.setValueAtTime(0, t1);
                }
                _restart(t1) {
                    this._triangle.restart(t1), this._widthGate.gain.cancelScheduledValues(t1), this._widthGate.gain.setValueAtTime(1, t1);
                }
                get phase() {
                    return this._triangle.phase;
                }
                set phase(t1) {
                    this._triangle.phase = t1;
                }
                get type() {
                    return "pulse";
                }
                get baseType() {
                    return "pulse";
                }
                get partials() {
                    return [];
                }
                get partialCount() {
                    return 0;
                }
                set carrierType(t1) {
                    this._triangle.type = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this._triangle.dispose(), this.width.dispose(), this._widthGate.dispose(), this._thresh.dispose(), this;
                }
            }
            class Ko extends Po {
                constructor(){
                    super(ui(Ko.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "spread"
                    ])), this.name = "FatOscillator", this._oscillators = [];
                    const t1 = ui(Ko.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "spread"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this._spread = t1.spread, this._type = t1.type, this._phase = t1.phase, this._partials = t1.partials, this._partialCount = t1.partialCount, this.count = t1.count, Oi(this, [
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        count: 3,
                        spread: 20,
                        type: "sawtooth"
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._forEach((e)=>e.start(t1));
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._forEach((e)=>e.stop(t1));
                }
                _restart(t1) {
                    this._forEach((e)=>e.restart(t1));
                }
                _forEach(t1) {
                    for(let e = 0; e < this._oscillators.length; e++)t1(this._oscillators[e], e);
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1, this._forEach((e)=>e.type = t1);
                }
                get spread() {
                    return this._spread;
                }
                set spread(t1) {
                    if (this._spread = t1, this._oscillators.length > 1) {
                        const e = -t1 / 2, s1 = t1 / (this._oscillators.length - 1);
                        this._forEach((t1, n)=>t1.detune.value = e + s1 * n);
                    }
                }
                get count() {
                    return this._oscillators.length;
                }
                set count(t1) {
                    if (Un(t1, 1), this._oscillators.length !== t1) {
                        this._forEach((t1)=>t1.dispose()), this._oscillators = [];
                        for(let e = 0; e < t1; e++){
                            const s1 = new Zo({
                                context: this.context,
                                volume: -6 - 1.1 * t1,
                                type: this._type,
                                phase: this._phase + e / t1 * 360,
                                partialCount: this._partialCount,
                                onstop: 0 === e ? ()=>this.onstop(this) : Ei
                            });
                            "custom" === this.type && (s1.partials = this._partials), this.frequency.connect(s1.frequency), this.detune.connect(s1.detune), s1.detune.overridden = !1, s1.connect(this.output), this._oscillators[e] = s1;
                        }
                        this.spread = this._spread, "started" === this.state && this._forEach((t1)=>t1.start());
                    }
                }
                get phase() {
                    return this._phase;
                }
                set phase(t1) {
                    this._phase = t1, this._forEach((t1, e)=>t1.phase = this._phase + e / this.count * 360);
                }
                get baseType() {
                    return this._oscillators[0].baseType;
                }
                set baseType(t1) {
                    this._forEach((e)=>e.baseType = t1), this._type = this._oscillators[0].type;
                }
                get partials() {
                    return this._oscillators[0].partials;
                }
                set partials(t1) {
                    this._partials = t1, this._partialCount = this._partials.length, t1.length && (this._type = "custom", this._forEach((e)=>e.partials = t1));
                }
                get partialCount() {
                    return this._oscillators[0].partialCount;
                }
                set partialCount(t1) {
                    this._partialCount = t1, this._forEach((e)=>e.partialCount = t1), this._type = this._oscillators[0].type;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.detune.dispose(), this._forEach((t1)=>t1.dispose()), this;
                }
            }
            class tr extends Po {
                constructor(){
                    super(ui(tr.getDefaults(), arguments, [
                        "frequency",
                        "modulationFrequency"
                    ])), this.name = "PWMOscillator", this.sourceType = "pwm", this._scale = new Yo({
                        context: this.context,
                        value: 2
                    });
                    const t1 = ui(tr.getDefaults(), arguments, [
                        "frequency",
                        "modulationFrequency"
                    ]);
                    this._pulse = new Jo({
                        context: this.context,
                        frequency: t1.modulationFrequency
                    }), this._pulse.carrierType = "sine", this.modulationFrequency = this._pulse.frequency, this._modulator = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase
                    }), this.frequency = this._modulator.frequency, this.detune = this._modulator.detune, this._modulator.chain(this._scale, this._pulse.width), this._pulse.connect(this.output), Oi(this, [
                        "modulationFrequency",
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        modulationFrequency: .4,
                        phase: 0,
                        type: "pwm"
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._modulator.start(t1), this._pulse.start(t1);
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._modulator.stop(t1), this._pulse.stop(t1);
                }
                _restart(t1) {
                    this._modulator.restart(t1), this._pulse.restart(t1);
                }
                get type() {
                    return "pwm";
                }
                get baseType() {
                    return "pwm";
                }
                get partials() {
                    return [];
                }
                get partialCount() {
                    return 0;
                }
                get phase() {
                    return this._modulator.phase;
                }
                set phase(t1) {
                    this._modulator.phase = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this._pulse.dispose(), this._scale.dispose(), this._modulator.dispose(), this;
                }
            }
            const er = {
                am: $o,
                fat: Ko,
                fm: Ho,
                oscillator: Zo,
                pulse: Jo,
                pwm: tr
            };
            class sr extends Po {
                constructor(){
                    super(ui(sr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "OmniOscillator";
                    const t1 = ui(sr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, [
                        "frequency",
                        "detune"
                    ]), this.set(t1);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), Ho.getDefaults(), $o.getDefaults(), Ko.getDefaults(), Jo.getDefaults(), tr.getDefaults());
                }
                _start(t1) {
                    this._oscillator.start(t1);
                }
                _stop(t1) {
                    this._oscillator.stop(t1);
                }
                _restart(t1) {
                    return this._oscillator.restart(t1), this;
                }
                get type() {
                    let t1 = "";
                    return [
                        "am",
                        "fm",
                        "fat"
                    ].some((t1)=>this._sourceType === t1) && (t1 = this._sourceType), t1 + this._oscillator.type;
                }
                set type(t1) {
                    "fm" === t1.substr(0, 2) ? (this._createNewOscillator("fm"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(2)) : "am" === t1.substr(0, 2) ? (this._createNewOscillator("am"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(2)) : "fat" === t1.substr(0, 3) ? (this._createNewOscillator("fat"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(3)) : "pwm" === t1 ? (this._createNewOscillator("pwm"), this._oscillator = this._oscillator) : "pulse" === t1 ? this._createNewOscillator("pulse") : (this._createNewOscillator("oscillator"), this._oscillator = this._oscillator, this._oscillator.type = t1);
                }
                get partials() {
                    return this._oscillator.partials;
                }
                set partials(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || (this._oscillator.partials = t1);
                }
                get partialCount() {
                    return this._oscillator.partialCount;
                }
                set partialCount(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || (this._oscillator.partialCount = t1);
                }
                set(t1) {
                    return Reflect.has(t1, "type") && t1.type && (this.type = t1.type), super.set(t1), this;
                }
                _createNewOscillator(t1) {
                    if (t1 !== this._sourceType) {
                        this._sourceType = t1;
                        const e = er[t1], s1 = this.now();
                        if (this._oscillator) {
                            const t1 = this._oscillator;
                            t1.stop(s1), this.context.setTimeout(()=>t1.dispose(), this.blockTime);
                        }
                        this._oscillator = new e({
                            context: this.context
                        }), this.frequency.connect(this._oscillator.frequency), this.detune.connect(this._oscillator.detune), this._oscillator.connect(this.output), this._oscillator.onstop = ()=>this.onstop(this), "started" === this.state && this._oscillator.start(s1);
                    }
                }
                get phase() {
                    return this._oscillator.phase;
                }
                set phase(t1) {
                    this._oscillator.phase = t1;
                }
                get sourceType() {
                    return this._sourceType;
                }
                set sourceType(t1) {
                    let e = "sine";
                    "pwm" !== this._oscillator.type && "pulse" !== this._oscillator.type && (e = this._oscillator.type), "fm" === t1 ? this.type = "fm" + e : "am" === t1 ? this.type = "am" + e : "fat" === t1 ? this.type = "fat" + e : "oscillator" === t1 ? this.type = e : "pulse" === t1 ? this.type = "pulse" : "pwm" === t1 && (this.type = "pwm");
                }
                _getOscType(t1, e) {
                    return t1 instanceof er[e];
                }
                get baseType() {
                    return this._oscillator.baseType;
                }
                set baseType(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || "pulse" === t1 || "pwm" === t1 || (this._oscillator.baseType = t1);
                }
                get width() {
                    return this._getOscType(this._oscillator, "pulse") ? this._oscillator.width : void 0;
                }
                get count() {
                    return this._getOscType(this._oscillator, "fat") ? this._oscillator.count : void 0;
                }
                set count(t1) {
                    this._getOscType(this._oscillator, "fat") && Nn(t1) && (this._oscillator.count = t1);
                }
                get spread() {
                    return this._getOscType(this._oscillator, "fat") ? this._oscillator.spread : void 0;
                }
                set spread(t1) {
                    this._getOscType(this._oscillator, "fat") && Nn(t1) && (this._oscillator.spread = t1);
                }
                get modulationType() {
                    return this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am") ? this._oscillator.modulationType : void 0;
                }
                set modulationType(t1) {
                    (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) && zn(t1) && (this._oscillator.modulationType = t1);
                }
                get modulationIndex() {
                    return this._getOscType(this._oscillator, "fm") ? this._oscillator.modulationIndex : void 0;
                }
                get harmonicity() {
                    return this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am") ? this._oscillator.harmonicity : void 0;
                }
                get modulationFrequency() {
                    return this._getOscType(this._oscillator, "pwm") ? this._oscillator.modulationFrequency : void 0;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.detune.dispose(), this.frequency.dispose(), this._oscillator.dispose(), this;
                }
            }
            class nr extends po {
                constructor(){
                    super(Object.assign(ui(nr.getDefaults(), arguments, [
                        "value"
                    ]))), this.override = !1, this.name = "Add", this._sum = new ho({
                        context: this.context
                    }), this.input = this._sum, this.output = this._sum, this.addend = this._param, oo(this._constantSource, this._sum);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._sum.dispose(), this;
                }
            }
            class ir extends Ro {
                constructor(){
                    super(Object.assign(ui(ir.getDefaults(), arguments, [
                        "min",
                        "max"
                    ]))), this.name = "Scale";
                    const t1 = ui(ir.getDefaults(), arguments, [
                        "min",
                        "max"
                    ]);
                    this._mult = this.input = new Yo({
                        context: this.context,
                        value: t1.max - t1.min
                    }), this._add = this.output = new nr({
                        context: this.context,
                        value: t1.min
                    }), this._min = t1.min, this._max = t1.max, this.input.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(Ro.getDefaults(), {
                        max: 1,
                        min: 0
                    });
                }
                get min() {
                    return this._min;
                }
                set min(t1) {
                    this._min = t1, this._setRange();
                }
                get max() {
                    return this._max;
                }
                set max(t1) {
                    this._max = t1, this._setRange();
                }
                _setRange() {
                    this._add.value = this._min, this._mult.value = this._max - this._min;
                }
                dispose() {
                    return super.dispose(), this._add.dispose(), this._mult.dispose(), this;
                }
            }
            class or extends Ro {
                constructor(){
                    super(Object.assign(ui(or.getDefaults(), arguments))), this.name = "Zero", this._gain = new ho({
                        context: this.context
                    }), this.output = this._gain, this.input = void 0, ro(this.context.getConstant(0), this._gain);
                }
                dispose() {
                    return super.dispose(), ao(this.context.getConstant(0), this._gain), this;
                }
            }
            class rr extends io {
                constructor(){
                    super(ui(rr.getDefaults(), arguments, [
                        "frequency",
                        "min",
                        "max"
                    ])), this.name = "LFO", this._stoppedValue = 0, this._units = "number", this.convert = !0, this._fromType = no.prototype._fromType, this._toType = no.prototype._toType, this._is = no.prototype._is, this._clampValue = no.prototype._clampValue;
                    const t1 = ui(rr.getDefaults(), arguments, [
                        "frequency",
                        "min",
                        "max"
                    ]);
                    this._oscillator = new Zo(t1), this.frequency = this._oscillator.frequency, this._amplitudeGain = new ho({
                        context: this.context,
                        gain: t1.amplitude,
                        units: "normalRange"
                    }), this.amplitude = this._amplitudeGain.gain, this._stoppedSignal = new po({
                        context: this.context,
                        units: "audioRange",
                        value: 0
                    }), this._zeros = new or({
                        context: this.context
                    }), this._a2g = new Xo({
                        context: this.context
                    }), this._scaler = this.output = new ir({
                        context: this.context,
                        max: t1.max,
                        min: t1.min
                    }), this.units = t1.units, this.min = t1.min, this.max = t1.max, this._oscillator.chain(this._amplitudeGain, this._a2g, this._scaler), this._zeros.connect(this._a2g), this._stoppedSignal.connect(this._a2g), Oi(this, [
                        "amplitude",
                        "frequency"
                    ]), this.phase = t1.phase;
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        amplitude: 1,
                        frequency: "4n",
                        max: 1,
                        min: 0,
                        type: "sine",
                        units: "number"
                    });
                }
                start(t1) {
                    return t1 = this.toSeconds(t1), this._stoppedSignal.setValueAtTime(0, t1), this._oscillator.start(t1), this;
                }
                stop(t1) {
                    return t1 = this.toSeconds(t1), this._stoppedSignal.setValueAtTime(this._stoppedValue, t1), this._oscillator.stop(t1), this;
                }
                sync() {
                    return this._oscillator.sync(), this._oscillator.syncFrequency(), this;
                }
                unsync() {
                    return this._oscillator.unsync(), this._oscillator.unsyncFrequency(), this;
                }
                _setStoppedValue() {
                    this._stoppedValue = this._oscillator.getInitialValue(), this._stoppedSignal.value = this._stoppedValue;
                }
                get min() {
                    return this._toType(this._scaler.min);
                }
                set min(t1) {
                    t1 = this._fromType(t1), this._scaler.min = t1;
                }
                get max() {
                    return this._toType(this._scaler.max);
                }
                set max(t1) {
                    t1 = this._fromType(t1), this._scaler.max = t1;
                }
                get type() {
                    return this._oscillator.type;
                }
                set type(t1) {
                    this._oscillator.type = t1, this._setStoppedValue();
                }
                get partials() {
                    return this._oscillator.partials;
                }
                set partials(t1) {
                    this._oscillator.partials = t1, this._setStoppedValue();
                }
                get phase() {
                    return this._oscillator.phase;
                }
                set phase(t1) {
                    this._oscillator.phase = t1, this._setStoppedValue();
                }
                get units() {
                    return this._units;
                }
                set units(t1) {
                    const e = this.min, s1 = this.max;
                    this._units = t1, this.min = e, this.max = s1;
                }
                get state() {
                    return this._oscillator.state;
                }
                connect(t1, e, s1) {
                    return (t1 instanceof no || t1 instanceof po) && (this.convert = t1.convert, this.units = t1.units), fo(this, t1, e, s1), this;
                }
                dispose() {
                    return super.dispose(), this._oscillator.dispose(), this._stoppedSignal.dispose(), this._zeros.dispose(), this._scaler.dispose(), this._a2g.dispose(), this._amplitudeGain.dispose(), this.amplitude.dispose(), this;
                }
            }
            function ar(t1, e = 1 / 0) {
                const s1 = new WeakMap;
                return function(n, i) {
                    Reflect.defineProperty(n, i, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return s1.get(this);
                        },
                        set: function(n) {
                            Un(n, t1, e), s1.set(this, n);
                        }
                    });
                };
            }
            function cr(t1, e = 1 / 0) {
                const s1 = new WeakMap;
                return function(n, i) {
                    Reflect.defineProperty(n, i, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return s1.get(this);
                        },
                        set: function(n) {
                            Un(this.toSeconds(n), t1, e), s1.set(this, n);
                        }
                    });
                };
            }
            class hr extends Po {
                constructor(){
                    super(ui(hr.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "Player", this._activeSources = new Set;
                    const t1 = ui(hr.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this._buffer = new Ri({
                        onload: this._onload.bind(this, t1.onload),
                        onerror: t1.onerror,
                        reverse: t1.reverse,
                        url: t1.url
                    }), this.autostart = t1.autostart, this._loop = t1.loop, this._loopStart = t1.loopStart, this._loopEnd = t1.loopEnd, this._playbackRate = t1.playbackRate, this.fadeIn = t1.fadeIn, this.fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        autostart: !1,
                        fadeIn: 0,
                        fadeOut: 0,
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        onload: Ei,
                        onerror: Ei,
                        playbackRate: 1,
                        reverse: !1
                    });
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        return yield this._buffer.load(t1), this._onload(), this;
                    });
                }
                _onload(t1 = Ei) {
                    t1(), this.autostart && this.start();
                }
                _onSourceEnd(t1) {
                    this.onstop(this), this._activeSources.delete(t1), 0 !== this._activeSources.size || this._synced || "started" !== this._state.getValueAtTime(this.now()) || (this._state.cancel(this.now()), this._state.setStateAtTime("stopped", this.now()));
                }
                start(t1, e, s1) {
                    return super.start(t1, e, s1), this;
                }
                _start(t1, e, s1) {
                    e = this._loop ? pi(e, this._loopStart) : pi(e, 0);
                    const n = this.toSeconds(e), i = s1;
                    s1 = pi(s1, Math.max(this._buffer.duration - n, 0));
                    let o = this.toSeconds(s1);
                    o /= this._playbackRate, t1 = this.toSeconds(t1);
                    const r = new jo({
                        url: this._buffer,
                        context: this.context,
                        fadeIn: this.fadeIn,
                        fadeOut: this.fadeOut,
                        loop: this._loop,
                        loopEnd: this._loopEnd,
                        loopStart: this._loopStart,
                        onended: this._onSourceEnd.bind(this),
                        playbackRate: this._playbackRate
                    }).connect(this.output);
                    this._loop || this._synced || (this._state.cancel(t1 + o), this._state.setStateAtTime("stopped", t1 + o, {
                        implicitEnd: !0
                    })), this._activeSources.add(r), this._loop && Fn(i) ? r.start(t1, n) : r.start(t1, n, o - this.toSeconds(this.fadeOut));
                }
                _stop(t1) {
                    const e = this.toSeconds(t1);
                    this._activeSources.forEach((t1)=>t1.stop(e));
                }
                restart(t1, e, s1) {
                    return super.restart(t1, e, s1), this;
                }
                _restart(t1, e, s1) {
                    var n;
                    null === (n = [
                        ...this._activeSources
                    ].pop()) || void 0 === n || n.stop(t1), this._start(t1, e, s1);
                }
                seek(t1, e) {
                    const s1 = this.toSeconds(e);
                    if ("started" === this._state.getValueAtTime(s1)) {
                        const e = this.toSeconds(t1);
                        this._stop(s1), this._start(s1, e);
                    }
                    return this;
                }
                setLoopPoints(t1, e) {
                    return this.loopStart = t1, this.loopEnd = e, this;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this._loopStart = t1, this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._activeSources.forEach((e)=>{
                        e.loopStart = t1;
                    });
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this._loopEnd = t1, this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._activeSources.forEach((e)=>{
                        e.loopEnd = t1;
                    });
                }
                get buffer() {
                    return this._buffer;
                }
                set buffer(t1) {
                    this._buffer.set(t1);
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    if (this._loop !== t1 && (this._loop = t1, this._activeSources.forEach((e)=>{
                        e.loop = t1;
                    }), t1)) {
                        const t1 = this._state.getNextState("stopped", this.now());
                        t1 && this._state.cancel(t1.time);
                    }
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1;
                    const e = this.now(), s1 = this._state.getNextState("stopped", e);
                    s1 && s1.implicitEnd && (this._state.cancel(s1.time), this._activeSources.forEach((t1)=>t1.cancelStop())), this._activeSources.forEach((s1)=>{
                        s1.playbackRate.setValueAtTime(t1, e);
                    });
                }
                get reverse() {
                    return this._buffer.reverse;
                }
                set reverse(t1) {
                    this._buffer.reverse = t1;
                }
                get loaded() {
                    return this._buffer.loaded;
                }
                dispose() {
                    return super.dispose(), this._activeSources.forEach((t1)=>t1.dispose()), this._activeSources.clear(), this._buffer.dispose(), this;
                }
            }
            si([
                cr(0)
            ], hr.prototype, "fadeIn", void 0), si([
                cr(0)
            ], hr.prototype, "fadeOut", void 0);
            class lr extends io {
                constructor(){
                    super(ui(lr.getDefaults(), arguments, [
                        "urls",
                        "onload"
                    ], "urls")), this.name = "Players", this.input = void 0, this._players = new Map;
                    const t1 = ui(lr.getDefaults(), arguments, [
                        "urls",
                        "onload"
                    ], "urls");
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this._buffers = new wo({
                        urls: t1.urls,
                        onload: t1.onload,
                        baseUrl: t1.baseUrl,
                        onerror: t1.onerror
                    }), this.mute = t1.mute, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        baseUrl: "",
                        fadeIn: 0,
                        fadeOut: 0,
                        mute: !1,
                        onload: Ei,
                        onerror: Ei,
                        urls: {},
                        volume: 0
                    });
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1, this._players.forEach((e)=>{
                        e.fadeIn = t1;
                    });
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1, this._players.forEach((e)=>{
                        e.fadeOut = t1;
                    });
                }
                get state() {
                    return Array.from(this._players).some(([t1, e])=>"started" === e.state) ? "started" : "stopped";
                }
                has(t1) {
                    return this._buffers.has(t1);
                }
                player(t1) {
                    if (Bn(this.has(t1), `No Player with the name ${t1} exists on this object`), !this._players.has(t1)) {
                        const e = new hr({
                            context: this.context,
                            fadeIn: this._fadeIn,
                            fadeOut: this._fadeOut,
                            url: this._buffers.get(t1)
                        }).connect(this.output);
                        this._players.set(t1, e);
                    }
                    return this._players.get(t1);
                }
                get loaded() {
                    return this._buffers.loaded;
                }
                add(t1, e, s1) {
                    return Bn(!this._buffers.has(t1), "A buffer with that name already exists on this object"), this._buffers.add(t1, e, s1), this;
                }
                stopAll(t1) {
                    return this._players.forEach((e)=>e.stop(t1)), this;
                }
                dispose() {
                    return super.dispose(), this._volume.dispose(), this.volume.dispose(), this._players.forEach((t1)=>t1.dispose()), this._buffers.dispose(), this;
                }
            }
            class ur extends Po {
                constructor(){
                    super(ui(ur.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "GrainPlayer", this._loopStart = 0, this._loopEnd = 0, this._activeSources = [];
                    const t1 = ui(ur.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this.buffer = new Ri({
                        onload: t1.onload,
                        onerror: t1.onerror,
                        reverse: t1.reverse,
                        url: t1.url
                    }), this._clock = new vo({
                        context: this.context,
                        callback: this._tick.bind(this),
                        frequency: 1 / t1.grainSize
                    }), this._playbackRate = t1.playbackRate, this._grainSize = t1.grainSize, this._overlap = t1.overlap, this.detune = t1.detune, this.overlap = t1.overlap, this.loop = t1.loop, this.playbackRate = t1.playbackRate, this.grainSize = t1.grainSize, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this.reverse = t1.reverse, this._clock.on("stop", this._onstop.bind(this));
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        onload: Ei,
                        onerror: Ei,
                        overlap: .1,
                        grainSize: .2,
                        playbackRate: 1,
                        detune: 0,
                        loop: !1,
                        loopStart: 0,
                        loopEnd: 0,
                        reverse: !1
                    });
                }
                _start(t1, e, s1) {
                    e = pi(e, 0), e = this.toSeconds(e), t1 = this.toSeconds(t1);
                    const n = 1 / this._clock.frequency.getValueAtTime(t1);
                    this._clock.start(t1, e / n), s1 && this.stop(t1 + this.toSeconds(s1));
                }
                restart(t1, e, s1) {
                    return super.restart(t1, e, s1), this;
                }
                _restart(t1, e, s1) {
                    this._stop(t1), this._start(t1, e, s1);
                }
                _stop(t1) {
                    this._clock.stop(t1);
                }
                _onstop(t1) {
                    this._activeSources.forEach((e)=>{
                        e.fadeOut = 0, e.stop(t1);
                    }), this.onstop(this);
                }
                _tick(t1) {
                    const e = this._clock.getTicksAtTime(t1), s1 = e * this._grainSize;
                    if (this.log("offset", s1), !this.loop && s1 > this.buffer.duration) return void this.stop(t1);
                    const n = s1 < this._overlap ? 0 : this._overlap, i = new jo({
                        context: this.context,
                        url: this.buffer,
                        fadeIn: n,
                        fadeOut: this._overlap,
                        loop: this.loop,
                        loopStart: this._loopStart,
                        loopEnd: this._loopEnd,
                        playbackRate: zi(this.detune / 100)
                    }).connect(this.output);
                    i.start(t1, this._grainSize * e), i.stop(t1 + this._grainSize / this.playbackRate), this._activeSources.push(i), i.onended = ()=>{
                        const t1 = this._activeSources.indexOf(i);
                        -1 !== t1 && this._activeSources.splice(t1, 1);
                    };
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    Un(t1, .001), this._playbackRate = t1, this.grainSize = this._grainSize;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._loopStart = this.toSeconds(t1);
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._loopEnd = this.toSeconds(t1);
                }
                get reverse() {
                    return this.buffer.reverse;
                }
                set reverse(t1) {
                    this.buffer.reverse = t1;
                }
                get grainSize() {
                    return this._grainSize;
                }
                set grainSize(t1) {
                    this._grainSize = this.toSeconds(t1), this._clock.frequency.setValueAtTime(this._playbackRate / this._grainSize, this.now());
                }
                get overlap() {
                    return this._overlap;
                }
                set overlap(t1) {
                    const e = this.toSeconds(t1);
                    Un(e, 0), this._overlap = e;
                }
                get loaded() {
                    return this.buffer.loaded;
                }
                dispose() {
                    return super.dispose(), this.buffer.dispose(), this._clock.dispose(), this._activeSources.forEach((t1)=>t1.dispose()), this;
                }
            }
            class pr extends Ro {
                constructor(){
                    super(...arguments), this.name = "Abs", this._abs = new qo({
                        context: this.context,
                        mapping: (t1)=>Math.abs(t1) < .001 ? 0 : Math.abs(t1)
                    }), this.input = this._abs, this.output = this._abs;
                }
                dispose() {
                    return super.dispose(), this._abs.dispose(), this;
                }
            }
            class dr extends Ro {
                constructor(){
                    super(...arguments), this.name = "GainToAudio", this._norm = new qo({
                        context: this.context,
                        mapping: (t1)=>2 * Math.abs(t1) - 1
                    }), this.input = this._norm, this.output = this._norm;
                }
                dispose() {
                    return super.dispose(), this._norm.dispose(), this;
                }
            }
            class fr extends Ro {
                constructor(){
                    super(...arguments), this.name = "Negate", this._multiply = new Yo({
                        context: this.context,
                        value: -1
                    }), this.input = this._multiply, this.output = this._multiply;
                }
                dispose() {
                    return super.dispose(), this._multiply.dispose(), this;
                }
            }
            class _r extends po {
                constructor(){
                    super(Object.assign(ui(_r.getDefaults(), arguments, [
                        "value"
                    ]))), this.override = !1, this.name = "Subtract", this._sum = new ho({
                        context: this.context
                    }), this.input = this._sum, this.output = this._sum, this._neg = new fr({
                        context: this.context
                    }), this.subtrahend = this._param, oo(this._constantSource, this._neg, this._sum);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._neg.dispose(), this._sum.dispose(), this;
                }
            }
            class mr extends Ro {
                constructor(){
                    super(Object.assign(ui(mr.getDefaults(), arguments))), this.name = "GreaterThanZero", this._thresh = this.output = new qo({
                        context: this.context,
                        length: 127,
                        mapping: (t1)=>t1 <= 0 ? 0 : 1
                    }), this._scale = this.input = new Yo({
                        context: this.context,
                        value: 1e4
                    }), this._scale.connect(this._thresh);
                }
                dispose() {
                    return super.dispose(), this._scale.dispose(), this._thresh.dispose(), this;
                }
            }
            class gr extends po {
                constructor(){
                    super(Object.assign(ui(gr.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "GreaterThan", this.override = !1;
                    const t1 = ui(gr.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._subtract = this.input = new _r({
                        context: this.context,
                        value: t1.value
                    }), this._gtz = this.output = new mr({
                        context: this.context
                    }), this.comparator = this._param = this._subtract.subtrahend, Oi(this, "comparator"), this._subtract.connect(this._gtz);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._gtz.dispose(), this._subtract.dispose(), this.comparator.dispose(), this;
                }
            }
            class vr extends ir {
                constructor(){
                    super(Object.assign(ui(vr.getDefaults(), arguments, [
                        "min",
                        "max",
                        "exponent"
                    ]))), this.name = "ScaleExp";
                    const t1 = ui(vr.getDefaults(), arguments, [
                        "min",
                        "max",
                        "exponent"
                    ]);
                    this.input = this._exp = new Fo({
                        context: this.context,
                        value: t1.exponent
                    }), this._exp.connect(this._mult);
                }
                static getDefaults() {
                    return Object.assign(ir.getDefaults(), {
                        exponent: 1
                    });
                }
                get exponent() {
                    return this._exp.value;
                }
                set exponent(t1) {
                    this._exp.value = t1;
                }
                dispose() {
                    return super.dispose(), this._exp.dispose(), this;
                }
            }
            class yr extends po {
                constructor(){
                    super(ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ])), this.name = "SyncedSignal", this.override = !1;
                    const t1 = ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ]);
                    this._lastVal = t1.value, this._synced = this.context.transport.scheduleRepeat(this._onTick.bind(this), "1i"), this._syncedCallback = this._anchorValue.bind(this), this.context.transport.on("start", this._syncedCallback), this.context.transport.on("pause", this._syncedCallback), this.context.transport.on("stop", this._syncedCallback), this._constantSource.disconnect(), this._constantSource.stop(0), this._constantSource = this.output = new uo({
                        context: this.context,
                        offset: t1.value,
                        units: t1.units
                    }).start(0), this.setValueAtTime(t1.value, 0);
                }
                _onTick(t1) {
                    const e = super.getValueAtTime(this.context.transport.seconds);
                    this._lastVal !== e && (this._lastVal = e, this._constantSource.offset.setValueAtTime(e, t1));
                }
                _anchorValue(t1) {
                    const e = super.getValueAtTime(this.context.transport.seconds);
                    this._lastVal = e, this._constantSource.offset.cancelAndHoldAtTime(t1), this._constantSource.offset.setValueAtTime(e, t1);
                }
                getValueAtTime(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.getValueAtTime(e);
                }
                setValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.setValueAtTime(t1, s1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.linearRampToValueAtTime(t1, s1), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.exponentialRampToValueAtTime(t1, s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    const n = new Ki(this.context, e).toSeconds();
                    return super.setTargetAtTime(t1, n, s1), this;
                }
                cancelScheduledValues(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.cancelScheduledValues(e), this;
                }
                setValueCurveAtTime(t1, e, s1, n) {
                    const i = new Ki(this.context, e).toSeconds();
                    return s1 = this.toSeconds(s1), super.setValueCurveAtTime(t1, i, s1, n), this;
                }
                cancelAndHoldAtTime(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.cancelAndHoldAtTime(e), this;
                }
                setRampPoint(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.setRampPoint(e), this;
                }
                exponentialRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.exponentialRampTo(t1, e, n), this;
                }
                linearRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.linearRampTo(t1, e, n), this;
                }
                targetRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.targetRampTo(t1, e, n), this;
                }
                dispose() {
                    return super.dispose(), this.context.transport.clear(this._synced), this.context.transport.off("start", this._syncedCallback), this.context.transport.off("pause", this._syncedCallback), this.context.transport.off("stop", this._syncedCallback), this._constantSource.dispose(), this;
                }
            }
            class xr extends io {
                constructor(){
                    super(ui(xr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "Envelope", this._sig = new po({
                        context: this.context,
                        value: 0
                    }), this.output = this._sig, this.input = void 0;
                    const t1 = ui(xr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ]);
                    this.attack = t1.attack, this.decay = t1.decay, this.sustain = t1.sustain, this.release = t1.release, this.attackCurve = t1.attackCurve, this.releaseCurve = t1.releaseCurve, this.decayCurve = t1.decayCurve;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        attack: .01,
                        attackCurve: "linear",
                        decay: .1,
                        decayCurve: "exponential",
                        release: 1,
                        releaseCurve: "exponential",
                        sustain: .5
                    });
                }
                get value() {
                    return this.getValueAtTime(this.now());
                }
                _getCurve(t1, e) {
                    if (zn(t1)) return t1;
                    {
                        let s1;
                        for(s1 in wr)if (wr[s1][e] === t1) return s1;
                        return t1;
                    }
                }
                _setCurve(t1, e, s1) {
                    if (zn(s1) && Reflect.has(wr, s1)) {
                        const n = wr[s1];
                        Pn(n) ? "_decayCurve" !== t1 && (this[t1] = n[e]) : this[t1] = n;
                    } else {
                        if (!Ln(s1) || "_decayCurve" === t1) throw new Error("Envelope: invalid curve: " + s1);
                        this[t1] = s1;
                    }
                }
                get attackCurve() {
                    return this._getCurve(this._attackCurve, "In");
                }
                set attackCurve(t1) {
                    this._setCurve("_attackCurve", "In", t1);
                }
                get releaseCurve() {
                    return this._getCurve(this._releaseCurve, "Out");
                }
                set releaseCurve(t1) {
                    this._setCurve("_releaseCurve", "Out", t1);
                }
                get decayCurve() {
                    return this._getCurve(this._decayCurve, "Out");
                }
                set decayCurve(t1) {
                    this._setCurve("_decayCurve", "Out", t1);
                }
                triggerAttack(t1, e = 1) {
                    this.log("triggerAttack", t1, e), t1 = this.toSeconds(t1);
                    let s1 = this.toSeconds(this.attack);
                    const n = this.toSeconds(this.decay), i = this.getValueAtTime(t1);
                    if (i > 0 && (s1 = (1 - i) / (1 / s1)), s1 < this.sampleTime) this._sig.cancelScheduledValues(t1), this._sig.setValueAtTime(e, t1);
                    else if ("linear" === this._attackCurve) this._sig.linearRampTo(e, s1, t1);
                    else if ("exponential" === this._attackCurve) this._sig.targetRampTo(e, s1, t1);
                    else {
                        this._sig.cancelAndHoldAtTime(t1);
                        let n = this._attackCurve;
                        for(let t1 = 1; t1 < n.length; t1++)if (n[t1 - 1] <= i && i <= n[t1]) {
                            n = this._attackCurve.slice(t1), n[0] = i;
                            break;
                        }
                        this._sig.setValueCurveAtTime(n, t1, s1, e);
                    }
                    if (n && this.sustain < 1) {
                        const i = e * this.sustain, o = t1 + s1;
                        this.log("decay", o), "linear" === this._decayCurve ? this._sig.linearRampToValueAtTime(i, n + o) : this._sig.exponentialApproachValueAtTime(i, o, n);
                    }
                    return this;
                }
                triggerRelease(t1) {
                    this.log("triggerRelease", t1), t1 = this.toSeconds(t1);
                    const e = this.getValueAtTime(t1);
                    if (e > 0) {
                        const s1 = this.toSeconds(this.release);
                        s1 < this.sampleTime ? this._sig.setValueAtTime(0, t1) : "linear" === this._releaseCurve ? this._sig.linearRampTo(0, s1, t1) : "exponential" === this._releaseCurve ? this._sig.targetRampTo(0, s1, t1) : (Bn(Ln(this._releaseCurve), "releaseCurve must be either 'linear', 'exponential' or an array"), this._sig.cancelAndHoldAtTime(t1), this._sig.setValueCurveAtTime(this._releaseCurve, t1, s1, e));
                    }
                    return this;
                }
                getValueAtTime(t1) {
                    return this._sig.getValueAtTime(t1);
                }
                triggerAttackRelease(t1, e, s1 = 1) {
                    return e = this.toSeconds(e), this.triggerAttack(e, s1), this.triggerRelease(e + this.toSeconds(t1)), this;
                }
                cancel(t1) {
                    return this._sig.cancelScheduledValues(this.toSeconds(t1)), this;
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        const e = t1 / this.context.sampleRate, s1 = new qi(1, e, this.context.sampleRate), n = this.toSeconds(this.attack) + this.toSeconds(this.decay), i = n + this.toSeconds(this.release), o = .1 * i, r = i + o, a = new this.constructor(Object.assign(this.get(), {
                            attack: e * this.toSeconds(this.attack) / r,
                            decay: e * this.toSeconds(this.decay) / r,
                            release: e * this.toSeconds(this.release) / r,
                            context: s1
                        }));
                        return a._sig.toDestination(), a.triggerAttackRelease(e * (n + o) / r, 0), (yield s1.render()).getChannelData(0);
                    });
                }
                dispose() {
                    return super.dispose(), this._sig.dispose(), this;
                }
            }
            si([
                cr(0)
            ], xr.prototype, "attack", void 0), si([
                cr(0)
            ], xr.prototype, "decay", void 0), si([
                ar(0, 1)
            ], xr.prototype, "sustain", void 0), si([
                cr(0)
            ], xr.prototype, "release", void 0);
            const wr = (()=>{
                const t1 = 128;
                let e, s1;
                const n = [];
                for(e = 0; e < t1; e++)n[e] = Math.sin(e / 127 * (Math.PI / 2));
                const i = [];
                for(e = 0; e < 127; e++){
                    s1 = e / 127;
                    const t1 = Math.sin(s1 * (2 * Math.PI) * 6.4 - Math.PI / 2) + 1;
                    i[e] = t1 / 10 + .83 * s1;
                }
                i[127] = 1;
                const o = [];
                for(e = 0; e < t1; e++)o[e] = Math.ceil(e / 127 * 5) / 5;
                const r = [];
                for(e = 0; e < t1; e++)s1 = e / 127, r[e] = .5 * (1 - Math.cos(Math.PI * s1));
                const a = [];
                for(e = 0; e < t1; e++){
                    s1 = e / 127;
                    const t1 = 4 * Math.pow(s1, 3) + .2, n = Math.cos(t1 * Math.PI * 2 * s1);
                    a[e] = Math.abs(n * (1 - s1));
                }
                function c(t1) {
                    const e = new Array(t1.length);
                    for(let s1 = 0; s1 < t1.length; s1++)e[s1] = 1 - t1[s1];
                    return e;
                }
                var h;
                return {
                    bounce: {
                        In: c(a),
                        Out: a
                    },
                    cosine: {
                        In: n,
                        Out: (h = n, h.slice(0).reverse())
                    },
                    exponential: "exponential",
                    linear: "linear",
                    ripple: {
                        In: i,
                        Out: c(i)
                    },
                    sine: {
                        In: r,
                        Out: c(r)
                    },
                    step: {
                        In: o,
                        Out: c(o)
                    }
                };
            })();
            class br extends io {
                constructor(){
                    super(ui(br.getDefaults(), arguments)), this._scheduledEvents = [], this._synced = !1, this._original_triggerAttack = this.triggerAttack, this._original_triggerRelease = this.triggerRelease, this._syncedRelease = (t1)=>this._original_triggerRelease(t1);
                    const t1 = ui(br.getDefaults(), arguments);
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        volume: 0
                    });
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 0), this.context.transport.on("stop", this._syncedRelease), this.context.transport.on("pause", this._syncedRelease), this.context.transport.on("loopEnd", this._syncedRelease)), this;
                }
                _syncState() {
                    let t1 = !1;
                    return this._synced || (this._synced = !0, t1 = !0), t1;
                }
                _syncMethod(t1, e) {
                    const s1 = this["_original_" + t1] = this[t1];
                    this[t1] = (...t1)=>{
                        const n = t1[e], i = this.context.transport.schedule((n)=>{
                            t1[e] = n, s1.apply(this, t1);
                        }, n);
                        this._scheduledEvents.push(i);
                    };
                }
                unsync() {
                    return this._scheduledEvents.forEach((t1)=>this.context.transport.clear(t1)), this._scheduledEvents = [], this._synced && (this._synced = !1, this.triggerAttack = this._original_triggerAttack, this.triggerRelease = this._original_triggerRelease, this.context.transport.off("stop", this._syncedRelease), this.context.transport.off("pause", this._syncedRelease), this.context.transport.off("loopEnd", this._syncedRelease)), this;
                }
                triggerAttackRelease(t1, e, s1, n) {
                    const i = this.toSeconds(s1), o = this.toSeconds(e);
                    return this.triggerAttack(t1, i, n), this.triggerRelease(i + o), this;
                }
                dispose() {
                    return super.dispose(), this._volume.dispose(), this.unsync(), this._scheduledEvents = [], this;
                }
            }
            class Tr extends br {
                constructor(){
                    super(ui(Tr.getDefaults(), arguments));
                    const t1 = ui(Tr.getDefaults(), arguments);
                    this.portamento = t1.portamento, this.onsilence = t1.onsilence;
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        detune: 0,
                        onsilence: Ei,
                        portamento: 0
                    });
                }
                triggerAttack(t1, e, s1 = 1) {
                    this.log("triggerAttack", t1, e, s1);
                    const n = this.toSeconds(e);
                    return this._triggerEnvelopeAttack(n, s1), this.setNote(t1, n), this;
                }
                triggerRelease(t1) {
                    this.log("triggerRelease", t1);
                    const e = this.toSeconds(t1);
                    return this._triggerEnvelopeRelease(e), this;
                }
                setNote(t1, e) {
                    const s1 = this.toSeconds(e), n = t1 instanceof Yi ? t1.toFrequency() : t1;
                    if (this.portamento > 0 && this.getLevelAtTime(s1) > .05) {
                        const t1 = this.toSeconds(this.portamento);
                        this.frequency.exponentialRampTo(n, t1, s1);
                    } else this.frequency.setValueAtTime(n, s1);
                    return this;
                }
            }
            si([
                cr(0)
            ], Tr.prototype, "portamento", void 0);
            class Sr extends xr {
                constructor(){
                    super(ui(Sr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "AmplitudeEnvelope", this._gainNode = new ho({
                        context: this.context,
                        gain: 0
                    }), this.output = this._gainNode, this.input = this._gainNode, this._sig.connect(this._gainNode.gain), this.output = this._gainNode, this.input = this._gainNode;
                }
                dispose() {
                    return super.dispose(), this._gainNode.dispose(), this;
                }
            }
            class kr extends Tr {
                constructor(){
                    super(ui(kr.getDefaults(), arguments)), this.name = "Synth";
                    const t1 = ui(kr.getDefaults(), arguments);
                    this.oscillator = new sr(Object.assign({
                        context: this.context,
                        detune: t1.detune,
                        onstop: ()=>this.onsilence(this)
                    }, t1.oscillator)), this.frequency = this.oscillator.frequency, this.detune = this.oscillator.detune, this.envelope = new Sr(Object.assign({
                        context: this.context
                    }, t1.envelope)), this.oscillator.chain(this.envelope, this.output), Oi(this, [
                        "oscillator",
                        "frequency",
                        "detune",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .005,
                            decay: .1,
                            release: 1,
                            sustain: .3
                        }),
                        oscillator: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "triangle"
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    if (this.envelope.triggerAttack(t1, e), this.oscillator.start(t1), 0 === this.envelope.sustain) {
                        const e = this.toSeconds(this.envelope.attack), s1 = this.toSeconds(this.envelope.decay);
                        this.oscillator.stop(t1 + e + s1);
                    }
                }
                _triggerEnvelopeRelease(t1) {
                    this.envelope.triggerRelease(t1), this.oscillator.stop(t1 + this.toSeconds(this.envelope.release));
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this.oscillator.dispose(), this.envelope.dispose(), this;
                }
            }
            class Ar extends Tr {
                constructor(){
                    super(ui(Ar.getDefaults(), arguments)), this.name = "ModulationSynth";
                    const t1 = ui(Ar.getDefaults(), arguments);
                    this._carrier = new kr({
                        context: this.context,
                        oscillator: t1.oscillator,
                        envelope: t1.envelope,
                        onsilence: ()=>this.onsilence(this),
                        volume: -10
                    }), this._modulator = new kr({
                        context: this.context,
                        oscillator: t1.modulation,
                        envelope: t1.modulationEnvelope,
                        volume: -10
                    }), this.oscillator = this._carrier.oscillator, this.envelope = this._carrier.envelope, this.modulation = this._modulator.oscillator, this.modulationEnvelope = this._modulator.envelope, this.frequency = new po({
                        context: this.context,
                        units: "frequency"
                    }), this.detune = new po({
                        context: this.context,
                        value: t1.detune,
                        units: "cents"
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        value: t1.harmonicity,
                        minValue: 0
                    }), this._modulationNode = new ho({
                        context: this.context,
                        gain: 0
                    }), Oi(this, [
                        "frequency",
                        "harmonicity",
                        "oscillator",
                        "envelope",
                        "modulation",
                        "modulationEnvelope",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        harmonicity: 3,
                        oscillator: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "sine"
                        }),
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .01,
                            decay: .01,
                            sustain: 1,
                            release: .5
                        }),
                        modulation: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "square"
                        }),
                        modulationEnvelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .5,
                            decay: 0,
                            sustain: 1,
                            release: .5
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    this._carrier._triggerEnvelopeAttack(t1, e), this._modulator._triggerEnvelopeAttack(t1, e);
                }
                _triggerEnvelopeRelease(t1) {
                    return this._carrier._triggerEnvelopeRelease(t1), this._modulator._triggerEnvelopeRelease(t1), this;
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this._carrier.dispose(), this._modulator.dispose(), this.frequency.dispose(), this.detune.dispose(), this.harmonicity.dispose(), this._modulationNode.dispose(), this;
                }
            }
            class Cr extends Ar {
                constructor(){
                    super(ui(Cr.getDefaults(), arguments)), this.name = "AMSynth", this._modulationScale = new Xo({
                        context: this.context
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.detune.fan(this._carrier.detune, this._modulator.detune), this._modulator.chain(this._modulationScale, this._modulationNode.gain), this._carrier.chain(this._modulationNode, this.output);
                }
                dispose() {
                    return super.dispose(), this._modulationScale.dispose(), this;
                }
            }
            class Dr extends io {
                constructor(){
                    super(ui(Dr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "BiquadFilter";
                    const t1 = ui(Dr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this._filter = this.context.createBiquadFilter(), this.input = this.output = this._filter, this.Q = new no({
                        context: this.context,
                        units: "number",
                        value: t1.Q,
                        param: this._filter.Q
                    }), this.frequency = new no({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency,
                        param: this._filter.frequency
                    }), this.detune = new no({
                        context: this.context,
                        units: "cents",
                        value: t1.detune,
                        param: this._filter.detune
                    }), this.gain = new no({
                        context: this.context,
                        units: "decibels",
                        convert: !1,
                        value: t1.gain,
                        param: this._filter.gain
                    }), this.type = t1.type;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        type: "lowpass",
                        frequency: 350,
                        detune: 0,
                        gain: 0
                    });
                }
                get type() {
                    return this._filter.type;
                }
                set type(t1) {
                    Bn(-1 !== [
                        "lowpass",
                        "highpass",
                        "bandpass",
                        "lowshelf",
                        "highshelf",
                        "notch",
                        "allpass",
                        "peaking"
                    ].indexOf(t1), `Invalid filter type: ${t1}`), this._filter.type = t1;
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Float32Array(t1);
                    for(let s1 = 0; s1 < t1; s1++){
                        const n = 19980 * Math.pow(s1 / t1, 2) + 20;
                        e[s1] = n;
                    }
                    const s1 = new Float32Array(t1), n = new Float32Array(t1), i = this.context.createBiquadFilter();
                    return i.type = this.type, i.Q.value = this.Q.value, i.frequency.value = this.frequency.value, i.gain.value = this.gain.value, i.getFrequencyResponse(e, s1, n), s1;
                }
                dispose() {
                    return super.dispose(), this._filter.disconnect(), this.Q.dispose(), this.frequency.dispose(), this.gain.dispose(), this.detune.dispose(), this;
                }
            }
            class Or extends io {
                constructor(){
                    super(ui(Or.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "rolloff"
                    ])), this.name = "Filter", this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._filters = [];
                    const t1 = ui(Or.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "rolloff"
                    ]);
                    this._filters = [], this.Q = new po({
                        context: this.context,
                        units: "positive",
                        value: t1.Q
                    }), this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.gain = new po({
                        context: this.context,
                        units: "decibels",
                        convert: !1,
                        value: t1.gain
                    }), this._type = t1.type, this.rolloff = t1.rolloff, Oi(this, [
                        "detune",
                        "frequency",
                        "gain",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        detune: 0,
                        frequency: 350,
                        gain: 0,
                        rolloff: -12,
                        type: "lowpass"
                    });
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    Bn(-1 !== [
                        "lowpass",
                        "highpass",
                        "bandpass",
                        "lowshelf",
                        "highshelf",
                        "notch",
                        "allpass",
                        "peaking"
                    ].indexOf(t1), `Invalid filter type: ${t1}`), this._type = t1, this._filters.forEach((e)=>e.type = t1);
                }
                get rolloff() {
                    return this._rolloff;
                }
                set rolloff(t1) {
                    const e = Nn(t1) ? t1 : parseInt(t1, 10), s1 = [
                        -12,
                        -24,
                        -48,
                        -96
                    ];
                    let n = s1.indexOf(e);
                    Bn(-1 !== n, `rolloff can only be ${s1.join(", ")}`), n += 1, this._rolloff = e, this.input.disconnect(), this._filters.forEach((t1)=>t1.disconnect()), this._filters = new Array(n);
                    for(let t1 = 0; t1 < n; t1++){
                        const e = new Dr({
                            context: this.context
                        });
                        e.type = this._type, this.frequency.connect(e.frequency), this.detune.connect(e.detune), this.Q.connect(e.Q), this.gain.connect(e.gain), this._filters[t1] = e;
                    }
                    this._internalChannels = this._filters, oo(this.input, ...this._internalChannels, this.output);
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Dr({
                        frequency: this.frequency.value,
                        gain: this.gain.value,
                        Q: this.Q.value,
                        type: this._type,
                        detune: this.detune.value
                    }), s1 = new Float32Array(t1).map(()=>1);
                    return this._filters.forEach(()=>{
                        e.getFrequencyResponse(t1).forEach((t1, e)=>s1[e] *= t1);
                    }), e.dispose(), s1;
                }
                dispose() {
                    return super.dispose(), this._filters.forEach((t1)=>{
                        t1.dispose();
                    }), Mi(this, [
                        "detune",
                        "frequency",
                        "gain",
                        "Q"
                    ]), this.frequency.dispose(), this.Q.dispose(), this.detune.dispose(), this.gain.dispose(), this;
                }
            }
            class Mr extends xr {
                constructor(){
                    super(ui(Mr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "FrequencyEnvelope";
                    const t1 = ui(Mr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ]);
                    this._octaves = t1.octaves, this._baseFrequency = this.toFrequency(t1.baseFrequency), this._exponent = this.input = new Fo({
                        context: this.context,
                        value: t1.exponent
                    }), this._scale = this.output = new ir({
                        context: this.context,
                        min: this._baseFrequency,
                        max: this._baseFrequency * Math.pow(2, this._octaves)
                    }), this._sig.chain(this._exponent, this._scale);
                }
                static getDefaults() {
                    return Object.assign(xr.getDefaults(), {
                        baseFrequency: 200,
                        exponent: 1,
                        octaves: 4
                    });
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    const e = this.toFrequency(t1);
                    Un(e, 0), this._baseFrequency = e, this._scale.min = this._baseFrequency, this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._scale.max = this._baseFrequency * Math.pow(2, t1);
                }
                get exponent() {
                    return this._exponent.value;
                }
                set exponent(t1) {
                    this._exponent.value = t1;
                }
                dispose() {
                    return super.dispose(), this._exponent.dispose(), this._scale.dispose(), this;
                }
            }
            class Er extends Tr {
                constructor(){
                    super(ui(Er.getDefaults(), arguments)), this.name = "MonoSynth";
                    const t1 = ui(Er.getDefaults(), arguments);
                    this.oscillator = new sr(Object.assign(t1.oscillator, {
                        context: this.context,
                        detune: t1.detune,
                        onstop: ()=>this.onsilence(this)
                    })), this.frequency = this.oscillator.frequency, this.detune = this.oscillator.detune, this.filter = new Or(Object.assign(t1.filter, {
                        context: this.context
                    })), this.filterEnvelope = new Mr(Object.assign(t1.filterEnvelope, {
                        context: this.context
                    })), this.envelope = new Sr(Object.assign(t1.envelope, {
                        context: this.context
                    })), this.oscillator.chain(this.filter, this.envelope, this.output), this.filterEnvelope.connect(this.filter.frequency), Oi(this, [
                        "oscillator",
                        "frequency",
                        "detune",
                        "filter",
                        "filterEnvelope",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .005,
                            decay: .1,
                            release: 1,
                            sustain: .9
                        }),
                        filter: Object.assign(di(Or.getDefaults(), Object.keys(io.getDefaults())), {
                            Q: 1,
                            rolloff: -12,
                            type: "lowpass"
                        }),
                        filterEnvelope: Object.assign(di(Mr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .6,
                            baseFrequency: 200,
                            decay: .2,
                            exponent: 2,
                            octaves: 3,
                            release: 2,
                            sustain: .5
                        }),
                        oscillator: Object.assign(di(sr.getDefaults(), Object.keys(Po.getDefaults())), {
                            type: "sawtooth"
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e = 1) {
                    if (this.envelope.triggerAttack(t1, e), this.filterEnvelope.triggerAttack(t1), this.oscillator.start(t1), 0 === this.envelope.sustain) {
                        const e = this.toSeconds(this.envelope.attack), s1 = this.toSeconds(this.envelope.decay);
                        this.oscillator.stop(t1 + e + s1);
                    }
                }
                _triggerEnvelopeRelease(t1) {
                    this.envelope.triggerRelease(t1), this.filterEnvelope.triggerRelease(t1), this.oscillator.stop(t1 + this.toSeconds(this.envelope.release));
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this.oscillator.dispose(), this.envelope.dispose(), this.filterEnvelope.dispose(), this.filter.dispose(), this;
                }
            }
            class Rr extends Tr {
                constructor(){
                    super(ui(Rr.getDefaults(), arguments)), this.name = "DuoSynth";
                    const t1 = ui(Rr.getDefaults(), arguments);
                    this.voice0 = new Er(Object.assign(t1.voice0, {
                        context: this.context,
                        onsilence: ()=>this.onsilence(this)
                    })), this.voice1 = new Er(Object.assign(t1.voice1, {
                        context: this.context
                    })), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this._vibrato = new rr({
                        frequency: t1.vibratoRate,
                        context: this.context,
                        min: -50,
                        max: 50
                    }), this._vibrato.start(), this.vibratoRate = this._vibrato.frequency, this._vibratoGain = new ho({
                        context: this.context,
                        units: "normalRange",
                        gain: t1.vibratoAmount
                    }), this.vibratoAmount = this._vibratoGain.gain, this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: 440
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.frequency.connect(this.voice0.frequency), this.frequency.chain(this.harmonicity, this.voice1.frequency), this._vibrato.connect(this._vibratoGain), this._vibratoGain.fan(this.voice0.detune, this.voice1.detune), this.detune.fan(this.voice0.detune, this.voice1.detune), this.voice0.connect(this.output), this.voice1.connect(this.output), Oi(this, [
                        "voice0",
                        "voice1",
                        "frequency",
                        "vibratoAmount",
                        "vibratoRate"
                    ]);
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.voice0.envelope.getValueAtTime(t1) + this.voice1.envelope.getValueAtTime(t1);
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), {
                        vibratoAmount: .5,
                        vibratoRate: 5,
                        harmonicity: 1.5,
                        voice0: li(di(Er.getDefaults(), Object.keys(Tr.getDefaults())), {
                            filterEnvelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            },
                            envelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            }
                        }),
                        voice1: li(di(Er.getDefaults(), Object.keys(Tr.getDefaults())), {
                            filterEnvelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            },
                            envelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            }
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    this.voice0._triggerEnvelopeAttack(t1, e), this.voice1._triggerEnvelopeAttack(t1, e);
                }
                _triggerEnvelopeRelease(t1) {
                    return this.voice0._triggerEnvelopeRelease(t1), this.voice1._triggerEnvelopeRelease(t1), this;
                }
                dispose() {
                    return super.dispose(), this.voice0.dispose(), this.voice1.dispose(), this.frequency.dispose(), this.detune.dispose(), this._vibrato.dispose(), this.vibratoRate.dispose(), this._vibratoGain.dispose(), this.harmonicity.dispose(), this;
                }
            }
            class qr extends Ar {
                constructor(){
                    super(ui(qr.getDefaults(), arguments)), this.name = "FMSynth";
                    const t1 = ui(qr.getDefaults(), arguments);
                    this.modulationIndex = new Yo({
                        context: this.context,
                        value: t1.modulationIndex
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.frequency.chain(this.modulationIndex, this._modulationNode), this.detune.fan(this._carrier.detune, this._modulator.detune), this._modulator.connect(this._modulationNode.gain), this._modulationNode.connect(this._carrier.frequency), this._carrier.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(Ar.getDefaults(), {
                        modulationIndex: 10
                    });
                }
                dispose() {
                    return super.dispose(), this.modulationIndex.dispose(), this;
                }
            }
            const Fr = [
                1,
                1.483,
                1.932,
                2.546,
                2.63,
                3.897
            ];
            class Ir extends Tr {
                constructor(){
                    super(ui(Ir.getDefaults(), arguments)), this.name = "MetalSynth", this._oscillators = [], this._freqMultipliers = [];
                    const t1 = ui(Ir.getDefaults(), arguments);
                    this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.frequency = new po({
                        context: this.context,
                        units: "frequency"
                    }), this._amplitude = new ho({
                        context: this.context,
                        gain: 0
                    }).connect(this.output), this._highpass = new Or({
                        Q: 0,
                        context: this.context,
                        type: "highpass"
                    }).connect(this._amplitude);
                    for(let e = 0; e < Fr.length; e++){
                        const s1 = new Ho({
                            context: this.context,
                            harmonicity: t1.harmonicity,
                            modulationIndex: t1.modulationIndex,
                            modulationType: "square",
                            onstop: 0 === e ? ()=>this.onsilence(this) : Ei,
                            type: "square"
                        });
                        s1.connect(this._highpass), this._oscillators[e] = s1;
                        const n = new Yo({
                            context: this.context,
                            value: Fr[e]
                        });
                        this._freqMultipliers[e] = n, this.frequency.chain(n, s1.frequency), this.detune.connect(s1.detune);
                    }
                    this._filterFreqScaler = new ir({
                        context: this.context,
                        max: 7e3,
                        min: this.toFrequency(t1.resonance)
                    }), this.envelope = new xr({
                        attack: t1.envelope.attack,
                        attackCurve: "linear",
                        context: this.context,
                        decay: t1.envelope.decay,
                        release: t1.envelope.release,
                        sustain: 0
                    }), this.envelope.chain(this._filterFreqScaler, this._highpass.frequency), this.envelope.connect(this._amplitude.gain), this._octaves = t1.octaves, this.octaves = t1.octaves;
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .001,
                            decay: 1.4,
                            release: .2
                        }),
                        harmonicity: 5.1,
                        modulationIndex: 32,
                        octaves: 1.5,
                        resonance: 4e3
                    });
                }
                _triggerEnvelopeAttack(t1, e = 1) {
                    return this.envelope.triggerAttack(t1, e), this._oscillators.forEach((e)=>e.start(t1)), 0 === this.envelope.sustain && this._oscillators.forEach((e)=>{
                        e.stop(t1 + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
                    }), this;
                }
                _triggerEnvelopeRelease(t1) {
                    return this.envelope.triggerRelease(t1), this._oscillators.forEach((e)=>e.stop(t1 + this.toSeconds(this.envelope.release))), this;
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                get modulationIndex() {
                    return this._oscillators[0].modulationIndex.value;
                }
                set modulationIndex(t1) {
                    this._oscillators.forEach((e)=>e.modulationIndex.value = t1);
                }
                get harmonicity() {
                    return this._oscillators[0].harmonicity.value;
                }
                set harmonicity(t1) {
                    this._oscillators.forEach((e)=>e.harmonicity.value = t1);
                }
                get resonance() {
                    return this._filterFreqScaler.min;
                }
                set resonance(t1) {
                    this._filterFreqScaler.min = this.toFrequency(t1), this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, t1);
                }
                dispose() {
                    return super.dispose(), this._oscillators.forEach((t1)=>t1.dispose()), this._freqMultipliers.forEach((t1)=>t1.dispose()), this.frequency.dispose(), this.detune.dispose(), this._filterFreqScaler.dispose(), this._amplitude.dispose(), this.envelope.dispose(), this._highpass.dispose(), this;
                }
            }
            class Vr extends kr {
                constructor(){
                    super(ui(Vr.getDefaults(), arguments)), this.name = "MembraneSynth", this.portamento = 0;
                    const t1 = ui(Vr.getDefaults(), arguments);
                    this.pitchDecay = t1.pitchDecay, this.octaves = t1.octaves, Oi(this, [
                        "oscillator",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), kr.getDefaults(), {
                        envelope: {
                            attack: .001,
                            attackCurve: "exponential",
                            decay: .4,
                            release: 1.4,
                            sustain: .01
                        },
                        octaves: 10,
                        oscillator: {
                            type: "sine"
                        },
                        pitchDecay: .05
                    });
                }
                setNote(t1, e) {
                    const s1 = this.toSeconds(e), n = this.toFrequency(t1 instanceof Yi ? t1.toFrequency() : t1), i = n * this.octaves;
                    return this.oscillator.frequency.setValueAtTime(i, s1), this.oscillator.frequency.exponentialRampToValueAtTime(n, s1 + this.toSeconds(this.pitchDecay)), this;
                }
                dispose() {
                    return super.dispose(), this;
                }
            }
            si([
                ar(0)
            ], Vr.prototype, "octaves", void 0), si([
                cr(0)
            ], Vr.prototype, "pitchDecay", void 0);
            class Nr extends br {
                constructor(){
                    super(ui(Nr.getDefaults(), arguments)), this.name = "NoiseSynth";
                    const t1 = ui(Nr.getDefaults(), arguments);
                    this.noise = new Lo(Object.assign({
                        context: this.context
                    }, t1.noise)), this.envelope = new Sr(Object.assign({
                        context: this.context
                    }, t1.envelope)), this.noise.chain(this.envelope, this.output);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            decay: .1,
                            sustain: 0
                        }),
                        noise: Object.assign(di(Lo.getDefaults(), Object.keys(Po.getDefaults())), {
                            type: "white"
                        })
                    });
                }
                triggerAttack(t1, e = 1) {
                    return t1 = this.toSeconds(t1), this.envelope.triggerAttack(t1, e), this.noise.start(t1), 0 === this.envelope.sustain && this.noise.stop(t1 + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay)), this;
                }
                triggerRelease(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.triggerRelease(t1), this.noise.stop(t1 + this.toSeconds(this.envelope.release)), this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 0), this._syncMethod("triggerRelease", 0)), this;
                }
                triggerAttackRelease(t1, e, s1 = 1) {
                    return e = this.toSeconds(e), t1 = this.toSeconds(t1), this.triggerAttack(e, s1), this.triggerRelease(e + t1), this;
                }
                dispose() {
                    return super.dispose(), this.noise.dispose(), this.envelope.dispose(), this;
                }
            }
            const Pr = new Set;
            function jr(t1) {
                Pr.add(t1);
            }
            function Lr(t1, e) {
                const s1 = `registerProcessor("${t1}", ${e})`;
                Pr.add(s1);
            }
            class zr extends io {
                constructor(t1){
                    super(t1), this.name = "ToneAudioWorklet", this.workletOptions = {}, this.onprocessorerror = Ei;
                    const e = URL.createObjectURL(new Blob([
                        Array.from(Pr).join("\n")
                    ], {
                        type: "text/javascript"
                    })), s1 = this._audioWorkletName();
                    this._dummyGain = this.context.createGain(), this._dummyParam = this._dummyGain.gain, this.context.addAudioWorkletModule(e).then(()=>{
                        this.disposed || (this._worklet = this.context.createAudioWorkletNode(s1, this.workletOptions), this._worklet.onprocessorerror = this.onprocessorerror.bind(this), this.onReady(this._worklet));
                    });
                }
                dispose() {
                    return super.dispose(), this._dummyGain.disconnect(), this._worklet && (this._worklet.port.postMessage("dispose"), this._worklet.disconnect()), this;
                }
            }
            jr('\n\t/**\n\t * The base AudioWorkletProcessor for use in Tone.js. Works with the {@link ToneAudioWorklet}. \n\t */\n\tclass ToneAudioWorkletProcessor extends AudioWorkletProcessor {\n\n\t\tconstructor(options) {\n\t\t\t\n\t\t\tsuper(options);\n\t\t\t/**\n\t\t\t * If the processor was disposed or not. Keep alive until it\'s disposed.\n\t\t\t */\n\t\t\tthis.disposed = false;\n\t\t   \t/** \n\t\t\t * The number of samples in the processing block\n\t\t\t */\n\t\t\tthis.blockSize = 128;\n\t\t\t/**\n\t\t\t * the sample rate\n\t\t\t */\n\t\t\tthis.sampleRate = sampleRate;\n\n\t\t\tthis.port.onmessage = (event) => {\n\t\t\t\t// when it receives a dispose \n\t\t\t\tif (event.data === "dispose") {\n\t\t\t\t\tthis.disposed = true;\n\t\t\t\t}\n\t\t\t};\n\t\t}\n\t}\n'), jr("\n\t/**\n\t * Abstract class for a single input/output processor. \n\t * has a 'generate' function which processes one sample at a time\n\t */\n\tclass SingleIOProcessor extends ToneAudioWorkletProcessor {\n\n\t\tconstructor(options) {\n\t\t\tsuper(Object.assign(options, {\n\t\t\t\tnumberOfInputs: 1,\n\t\t\t\tnumberOfOutputs: 1\n\t\t\t}));\n\t\t\t/**\n\t\t\t * Holds the name of the parameter and a single value of that\n\t\t\t * parameter at the current sample\n\t\t\t * @type { [name: string]: number }\n\t\t\t */\n\t\t\tthis.params = {}\n\t\t}\n\n\t\t/**\n\t\t * Generate an output sample from the input sample and parameters\n\t\t * @abstract\n\t\t * @param input number\n\t\t * @param channel number\n\t\t * @param parameters { [name: string]: number }\n\t\t * @returns number\n\t\t */\n\t\tgenerate(){}\n\n\t\t/**\n\t\t * Update the private params object with the \n\t\t * values of the parameters at the given index\n\t\t * @param parameters { [name: string]: Float32Array },\n\t\t * @param index number\n\t\t */\n\t\tupdateParams(parameters, index) {\n\t\t\tfor (const paramName in parameters) {\n\t\t\t\tconst param = parameters[paramName];\n\t\t\t\tif (param.length > 1) {\n\t\t\t\t\tthis.params[paramName] = parameters[paramName][index];\n\t\t\t\t} else {\n\t\t\t\t\tthis.params[paramName] = parameters[paramName][0];\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/**\n\t\t * Process a single frame of the audio\n\t\t * @param inputs Float32Array[][]\n\t\t * @param outputs Float32Array[][]\n\t\t */\n\t\tprocess(inputs, outputs, parameters) {\n\t\t\tconst input = inputs[0];\n\t\t\tconst output = outputs[0];\n\t\t\t// get the parameter values\n\t\t\tconst channelCount = Math.max(input && input.length || 0, output.length);\n\t\t\tfor (let sample = 0; sample < this.blockSize; sample++) {\n\t\t\t\tthis.updateParams(parameters, sample);\n\t\t\t\tfor (let channel = 0; channel < channelCount; channel++) {\n\t\t\t\t\tconst inputSample = input && input.length ? input[channel][sample] : 0;\n\t\t\t\t\toutput[channel][sample] = this.generate(inputSample, channel, this.params);\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn !this.disposed;\n\t\t}\n\t};\n"), jr("\n\t/**\n\t * A multichannel buffer for use within an AudioWorkletProcessor as a delay line\n\t */\n\tclass DelayLine {\n\t\t\n\t\tconstructor(size, channels) {\n\t\t\tthis.buffer = [];\n\t\t\tthis.writeHead = []\n\t\t\tthis.size = size;\n\n\t\t\t// create the empty channels\n\t\t\tfor (let i = 0; i < channels; i++) {\n\t\t\t\tthis.buffer[i] = new Float32Array(this.size);\n\t\t\t\tthis.writeHead[i] = 0;\n\t\t\t}\n\t\t}\n\n\t\t/**\n\t\t * Push a value onto the end\n\t\t * @param channel number\n\t\t * @param value number\n\t\t */\n\t\tpush(channel, value) {\n\t\t\tthis.writeHead[channel] += 1;\n\t\t\tif (this.writeHead[channel] > this.size) {\n\t\t\t\tthis.writeHead[channel] = 0;\n\t\t\t}\n\t\t\tthis.buffer[channel][this.writeHead[channel]] = value;\n\t\t}\n\n\t\t/**\n\t\t * Get the recorded value of the channel given the delay\n\t\t * @param channel number\n\t\t * @param delay number delay samples\n\t\t */\n\t\tget(channel, delay) {\n\t\t\tlet readHead = this.writeHead[channel] - Math.floor(delay);\n\t\t\tif (readHead < 0) {\n\t\t\t\treadHead += this.size;\n\t\t\t}\n\t\t\treturn this.buffer[channel][readHead];\n\t\t}\n\t}\n");
            const Wr = "feedback-comb-filter";
            Lr(Wr, '\n\tclass FeedbackCombFilterWorklet extends SingleIOProcessor {\n\n\t\tconstructor(options) {\n\t\t\tsuper(options);\n\t\t\tthis.delayLine = new DelayLine(this.sampleRate, options.channelCount || 2);\n\t\t}\n\n\t\tstatic get parameterDescriptors() {\n\t\t\treturn [{\n\t\t\t\tname: "delayTime",\n\t\t\t\tdefaultValue: 0.1,\n\t\t\t\tminValue: 0,\n\t\t\t\tmaxValue: 1,\n\t\t\t\tautomationRate: "k-rate"\n\t\t\t}, {\n\t\t\t\tname: "feedback",\n\t\t\t\tdefaultValue: 0.5,\n\t\t\t\tminValue: 0,\n\t\t\t\tmaxValue: 0.9999,\n\t\t\t\tautomationRate: "k-rate"\n\t\t\t}];\n\t\t}\n\n\t\tgenerate(input, channel, parameters) {\n\t\t\tconst delayedSample = this.delayLine.get(channel, parameters.delayTime * this.sampleRate);\n\t\t\tthis.delayLine.push(channel, input + delayedSample * parameters.feedback);\n\t\t\treturn delayedSample;\n\t\t}\n\t}\n');
            class Br extends zr {
                constructor(){
                    super(ui(Br.getDefaults(), arguments, [
                        "delayTime",
                        "resonance"
                    ])), this.name = "FeedbackCombFilter";
                    const t1 = ui(Br.getDefaults(), arguments, [
                        "delayTime",
                        "resonance"
                    ]);
                    this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.delayTime = new no({
                        context: this.context,
                        value: t1.delayTime,
                        units: "time",
                        minValue: 0,
                        maxValue: 1,
                        param: this._dummyParam,
                        swappable: !0
                    }), this.resonance = new no({
                        context: this.context,
                        value: t1.resonance,
                        units: "normalRange",
                        param: this._dummyParam,
                        swappable: !0
                    }), Oi(this, [
                        "resonance",
                        "delayTime"
                    ]);
                }
                _audioWorkletName() {
                    return Wr;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        delayTime: .1,
                        resonance: .5
                    });
                }
                onReady(t1) {
                    oo(this.input, t1, this.output);
                    const e = t1.parameters.get("delayTime");
                    this.delayTime.setParam(e);
                    const s1 = t1.parameters.get("feedback");
                    this.resonance.setParam(s1);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.delayTime.dispose(), this.resonance.dispose(), this;
                }
            }
            class Ur extends io {
                constructor(){
                    super(ui(Ur.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "OnePoleFilter";
                    const t1 = ui(Ur.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this._frequency = t1.frequency, this._type = t1.type, this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._createFilter();
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        frequency: 880,
                        type: "lowpass"
                    });
                }
                _createFilter() {
                    const t1 = this._filter, e = this.toFrequency(this._frequency), s1 = 1 / (2 * Math.PI * e);
                    if ("lowpass" === this._type) {
                        const t1 = 1 / (s1 * this.context.sampleRate), e = t1 - 1;
                        this._filter = this.context.createIIRFilter([
                            t1,
                            0
                        ], [
                            1,
                            e
                        ]);
                    } else {
                        const t1 = 1 / (s1 * this.context.sampleRate) - 1;
                        this._filter = this.context.createIIRFilter([
                            1,
                            -1
                        ], [
                            1,
                            t1
                        ]);
                    }
                    this.input.chain(this._filter, this.output), t1 && this.context.setTimeout(()=>{
                        this.disposed || (this.input.disconnect(t1), t1.disconnect());
                    }, this.blockTime);
                }
                get frequency() {
                    return this._frequency;
                }
                set frequency(t1) {
                    this._frequency = t1, this._createFilter();
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1, this._createFilter();
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Float32Array(t1);
                    for(let s1 = 0; s1 < t1; s1++){
                        const n = 19980 * Math.pow(s1 / t1, 2) + 20;
                        e[s1] = n;
                    }
                    const s1 = new Float32Array(t1), n = new Float32Array(t1);
                    return this._filter.getFrequencyResponse(e, s1, n), s1;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this._filter.disconnect(), this;
                }
            }
            class Gr extends io {
                constructor(){
                    super(ui(Gr.getDefaults(), arguments, [
                        "delayTime",
                        "resonance",
                        "dampening"
                    ])), this.name = "LowpassCombFilter";
                    const t1 = ui(Gr.getDefaults(), arguments, [
                        "delayTime",
                        "resonance",
                        "dampening"
                    ]);
                    this._combFilter = this.output = new Br({
                        context: this.context,
                        delayTime: t1.delayTime,
                        resonance: t1.resonance
                    }), this.delayTime = this._combFilter.delayTime, this.resonance = this._combFilter.resonance, this._lowpass = this.input = new Ur({
                        context: this.context,
                        frequency: t1.dampening,
                        type: "lowpass"
                    }), this._lowpass.connect(this._combFilter);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        dampening: 3e3,
                        delayTime: .1,
                        resonance: .5
                    });
                }
                get dampening() {
                    return this._lowpass.frequency;
                }
                set dampening(t1) {
                    this._lowpass.frequency = t1;
                }
                dispose() {
                    return super.dispose(), this._combFilter.dispose(), this._lowpass.dispose(), this;
                }
            }
            class Qr extends br {
                constructor(){
                    super(ui(Qr.getDefaults(), arguments)), this.name = "PluckSynth";
                    const t1 = ui(Qr.getDefaults(), arguments);
                    this._noise = new Lo({
                        context: this.context,
                        type: "pink"
                    }), this.attackNoise = t1.attackNoise, this._lfcf = new Gr({
                        context: this.context,
                        dampening: t1.dampening,
                        resonance: t1.resonance
                    }), this.resonance = t1.resonance, this.release = t1.release, this._noise.connect(this._lfcf), this._lfcf.connect(this.output);
                }
                static getDefaults() {
                    return li(br.getDefaults(), {
                        attackNoise: 1,
                        dampening: 4e3,
                        resonance: .7,
                        release: 1
                    });
                }
                get dampening() {
                    return this._lfcf.dampening;
                }
                set dampening(t1) {
                    this._lfcf.dampening = t1;
                }
                triggerAttack(t1, e) {
                    const s1 = this.toFrequency(t1);
                    e = this.toSeconds(e);
                    const n = 1 / s1;
                    return this._lfcf.delayTime.setValueAtTime(n, e), this._noise.start(e), this._noise.stop(e + n * this.attackNoise), this._lfcf.resonance.cancelScheduledValues(e), this._lfcf.resonance.setValueAtTime(this.resonance, e), this;
                }
                triggerRelease(t1) {
                    return this._lfcf.resonance.linearRampTo(0, this.release, t1), this;
                }
                dispose() {
                    return super.dispose(), this._noise.dispose(), this._lfcf.dispose(), this;
                }
            }
            class Zr extends br {
                constructor(){
                    super(ui(Zr.getDefaults(), arguments, [
                        "voice",
                        "options"
                    ])), this.name = "PolySynth", this._availableVoices = [], this._activeVoices = [], this._voices = [], this._gcTimeout = -1, this._averageActiveVoices = 0, this._syncedRelease = (t1)=>this.releaseAll(t1);
                    const t1 = ui(Zr.getDefaults(), arguments, [
                        "voice",
                        "options"
                    ]);
                    Bn(!Nn(t1.voice), "DEPRECATED: The polyphony count is no longer the first argument.");
                    const e = t1.voice.getDefaults();
                    this.options = Object.assign(e, t1.options), this.voice = t1.voice, this.maxPolyphony = t1.maxPolyphony, this._dummyVoice = this._getNextAvailableVoice();
                    const s1 = this._voices.indexOf(this._dummyVoice);
                    this._voices.splice(s1, 1), this._gcTimeout = this.context.setInterval(this._collectGarbage.bind(this), 1);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        maxPolyphony: 32,
                        options: {},
                        voice: kr
                    });
                }
                get activeVoices() {
                    return this._activeVoices.length;
                }
                _makeVoiceAvailable(t1) {
                    this._availableVoices.push(t1);
                    const e = this._activeVoices.findIndex((e)=>e.voice === t1);
                    this._activeVoices.splice(e, 1);
                }
                _getNextAvailableVoice() {
                    if (this._availableVoices.length) return this._availableVoices.shift();
                    if (this._voices.length < this.maxPolyphony) {
                        const t1 = new this.voice(Object.assign(this.options, {
                            context: this.context,
                            onsilence: this._makeVoiceAvailable.bind(this)
                        }));
                        return Bn(t1 instanceof Tr, "Voice must extend Monophonic class"), t1.connect(this.output), this._voices.push(t1), t1;
                    }
                    Kn("Max polyphony exceeded. Note dropped.");
                }
                _collectGarbage() {
                    if (this._averageActiveVoices = Math.max(.95 * this._averageActiveVoices, this.activeVoices), this._availableVoices.length && this._voices.length > Math.ceil(this._averageActiveVoices + 1)) {
                        const t1 = this._availableVoices.shift(), e = this._voices.indexOf(t1);
                        this._voices.splice(e, 1), this.context.isOffline || t1.dispose();
                    }
                }
                _triggerAttack(t1, e, s1) {
                    t1.forEach((t1)=>{
                        const n = new bo(this.context, t1).toMidi(), i = this._getNextAvailableVoice();
                        i && (i.triggerAttack(t1, e, s1), this._activeVoices.push({
                            midi: n,
                            voice: i,
                            released: !1
                        }), this.log("triggerAttack", t1, e));
                    });
                }
                _triggerRelease(t1, e) {
                    t1.forEach((t1)=>{
                        const s1 = new bo(this.context, t1).toMidi(), n = this._activeVoices.find(({ midi: t1, released: e })=>t1 === s1 && !e);
                        n && (n.voice.triggerRelease(e), n.released = !0, this.log("triggerRelease", t1, e));
                    });
                }
                _scheduleEvent(t1, e, s1, n) {
                    Bn(!this.disposed, "Synth was already disposed"), s1 <= this.now() ? "attack" === t1 ? this._triggerAttack(e, s1, n) : this._triggerRelease(e, s1) : this.context.setTimeout(()=>{
                        this.disposed || this._scheduleEvent(t1, e, s1, n);
                    }, s1 - this.now());
                }
                triggerAttack(t1, e, s1) {
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const n = this.toSeconds(e);
                    return this._scheduleEvent("attack", t1, n, s1), this;
                }
                triggerRelease(t1, e) {
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const s1 = this.toSeconds(e);
                    return this._scheduleEvent("release", t1, s1), this;
                }
                triggerAttackRelease(t1, e, s1, n) {
                    const i = this.toSeconds(s1);
                    if (this.triggerAttack(t1, i, n), Ln(e)) {
                        Bn(Ln(t1), "If the duration is an array, the notes must also be an array");
                        for(let s1 = 0; s1 < t1.length; s1++){
                            const n = e[Math.min(s1, e.length - 1)], o = this.toSeconds(n);
                            Bn(o > 0, "The duration must be greater than 0"), this.triggerRelease(t1[s1], i + o);
                        }
                    } else {
                        const s1 = this.toSeconds(e);
                        Bn(s1 > 0, "The duration must be greater than 0"), this.triggerRelease(t1, i + s1);
                    }
                    return this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 1), this.context.transport.on("stop", this._syncedRelease), this.context.transport.on("pause", this._syncedRelease), this.context.transport.on("loopEnd", this._syncedRelease)), this;
                }
                set(t1) {
                    const e = di(t1, [
                        "onsilence",
                        "context"
                    ]);
                    return this.options = li(this.options, e), this._voices.forEach((t1)=>t1.set(e)), this._dummyVoice.set(e), this;
                }
                get() {
                    return this._dummyVoice.get();
                }
                releaseAll(t1) {
                    const e = this.toSeconds(t1);
                    return this._activeVoices.forEach(({ voice: t1 })=>{
                        t1.triggerRelease(e);
                    }), this;
                }
                dispose() {
                    return super.dispose(), this._dummyVoice.dispose(), this._voices.forEach((t1)=>t1.dispose()), this._activeVoices = [], this._availableVoices = [], this.context.clearInterval(this._gcTimeout), this;
                }
            }
            class Xr extends br {
                constructor(){
                    super(ui(Xr.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls")), this.name = "Sampler", this._activeSources = new Map;
                    const t1 = ui(Xr.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls"), e = {};
                    Object.keys(t1.urls).forEach((s1)=>{
                        const n = parseInt(s1, 10);
                        if (Bn(Wn(s1) || Nn(n) && isFinite(n), `url key is neither a note or midi pitch: ${s1}`), Wn(s1)) {
                            const n = new Yi(this.context, s1).toMidi();
                            e[n] = t1.urls[s1];
                        } else Nn(n) && isFinite(n) && (e[n] = t1.urls[n]);
                    }), this._buffers = new wo({
                        urls: e,
                        onload: t1.onload,
                        baseUrl: t1.baseUrl,
                        onerror: t1.onerror
                    }), this.attack = t1.attack, this.release = t1.release, this.curve = t1.curve, this._buffers.loaded && Promise.resolve().then(t1.onload);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        attack: 0,
                        baseUrl: "",
                        curve: "exponential",
                        onload: Ei,
                        onerror: Ei,
                        release: .1,
                        urls: {}
                    });
                }
                _findClosest(t1) {
                    let e = 0;
                    for(; e < 96;){
                        if (this._buffers.has(t1 + e)) return -e;
                        if (this._buffers.has(t1 - e)) return e;
                        e++;
                    }
                    throw new Error(`No available buffers for note: ${t1}`);
                }
                triggerAttack(t1, e, s1 = 1) {
                    return this.log("triggerAttack", t1, e, s1), Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1.forEach((t1)=>{
                        const n = Ui(new Yi(this.context, t1).toFrequency()), i = Math.round(n), o = n - i, r = this._findClosest(i), a = i - r, c = this._buffers.get(a), h = zi(r + o), l = new jo({
                            url: c,
                            context: this.context,
                            curve: this.curve,
                            fadeIn: this.attack,
                            fadeOut: this.release,
                            playbackRate: h
                        }).connect(this.output);
                        l.start(e, 0, c.duration / h, s1), Ln(this._activeSources.get(i)) || this._activeSources.set(i, []), this._activeSources.get(i).push(l), l.onended = ()=>{
                            if (this._activeSources && this._activeSources.has(i)) {
                                const t1 = this._activeSources.get(i), e = t1.indexOf(l);
                                -1 !== e && t1.splice(e, 1);
                            }
                        };
                    }), this;
                }
                triggerRelease(t1, e) {
                    return this.log("triggerRelease", t1, e), Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1.forEach((t1)=>{
                        const s1 = new Yi(this.context, t1).toMidi();
                        if (this._activeSources.has(s1) && this._activeSources.get(s1).length) {
                            const t1 = this._activeSources.get(s1);
                            e = this.toSeconds(e), t1.forEach((t1)=>{
                                t1.stop(e);
                            }), this._activeSources.set(s1, []);
                        }
                    }), this;
                }
                releaseAll(t1) {
                    const e = this.toSeconds(t1);
                    return this._activeSources.forEach((t1)=>{
                        for(; t1.length;)t1.shift().stop(e);
                    }), this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 1)), this;
                }
                triggerAttackRelease(t1, e, s1, n = 1) {
                    const i = this.toSeconds(s1);
                    return this.triggerAttack(t1, i, n), Ln(e) ? (Bn(Ln(t1), "notes must be an array when duration is array"), t1.forEach((t1, s1)=>{
                        const n = e[Math.min(s1, e.length - 1)];
                        this.triggerRelease(t1, i + this.toSeconds(n));
                    })) : this.triggerRelease(t1, i + this.toSeconds(e)), this;
                }
                add(t1, e, s1) {
                    if (Bn(Wn(t1) || isFinite(t1), `note must be a pitch or midi: ${t1}`), Wn(t1)) {
                        const n = new Yi(this.context, t1).toMidi();
                        this._buffers.add(n, e, s1);
                    } else this._buffers.add(t1, e, s1);
                    return this;
                }
                get loaded() {
                    return this._buffers.loaded;
                }
                dispose() {
                    return super.dispose(), this._buffers.dispose(), this._activeSources.forEach((t1)=>{
                        t1.forEach((t1)=>t1.dispose());
                    }), this._activeSources.clear(), this;
                }
            }
            si([
                cr(0)
            ], Xr.prototype, "attack", void 0), si([
                cr(0)
            ], Xr.prototype, "release", void 0);
            class Yr extends eo {
                constructor(){
                    super(ui(Yr.getDefaults(), arguments, [
                        "callback",
                        "value"
                    ])), this.name = "ToneEvent", this._state = new so("stopped"), this._startOffset = 0;
                    const t1 = ui(Yr.getDefaults(), arguments, [
                        "callback",
                        "value"
                    ]);
                    this._loop = t1.loop, this.callback = t1.callback, this.value = t1.value, this._loopStart = this.toTicks(t1.loopStart), this._loopEnd = this.toTicks(t1.loopEnd), this._playbackRate = t1.playbackRate, this._probability = t1.probability, this._humanize = t1.humanize, this.mute = t1.mute, this._playbackRate = t1.playbackRate, this._state.increasing = !0, this._rescheduleEvents();
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        callback: Ei,
                        humanize: !1,
                        loop: !1,
                        loopEnd: "1m",
                        loopStart: 0,
                        mute: !1,
                        playbackRate: 1,
                        probability: 1,
                        value: null
                    });
                }
                _rescheduleEvents(t1 = -1) {
                    this._state.forEachFrom(t1, (t1)=>{
                        let e;
                        if ("started" === t1.state) {
                            -1 !== t1.id && this.context.transport.clear(t1.id);
                            const s1 = t1.time + Math.round(this.startOffset / this._playbackRate);
                            if (!0 === this._loop || Nn(this._loop) && this._loop > 1) {
                                e = 1 / 0, Nn(this._loop) && (e = this._loop * this._getLoopDuration());
                                const n = this._state.getAfter(s1);
                                null !== n && (e = Math.min(e, n.time - s1)), e !== 1 / 0 && (e = new So(this.context, e));
                                const i = new So(this.context, this._getLoopDuration());
                                t1.id = this.context.transport.scheduleRepeat(this._tick.bind(this), i, new So(this.context, s1), e);
                            } else t1.id = this.context.transport.schedule(this._tick.bind(this), new So(this.context, s1));
                        }
                    });
                }
                get state() {
                    return this._state.getValueAtTime(this.context.transport.ticks);
                }
                get startOffset() {
                    return this._startOffset;
                }
                set startOffset(t1) {
                    this._startOffset = t1;
                }
                get probability() {
                    return this._probability;
                }
                set probability(t1) {
                    this._probability = t1;
                }
                get humanize() {
                    return this._humanize;
                }
                set humanize(t1) {
                    this._humanize = t1;
                }
                start(t1) {
                    const e = this.toTicks(t1);
                    return "stopped" === this._state.getValueAtTime(e) && (this._state.add({
                        id: -1,
                        state: "started",
                        time: e
                    }), this._rescheduleEvents(e)), this;
                }
                stop(t1) {
                    this.cancel(t1);
                    const e = this.toTicks(t1);
                    if ("started" === this._state.getValueAtTime(e)) {
                        this._state.setStateAtTime("stopped", e, {
                            id: -1
                        });
                        const t1 = this._state.getBefore(e);
                        let s1 = e;
                        null !== t1 && (s1 = t1.time), this._rescheduleEvents(s1);
                    }
                    return this;
                }
                cancel(t1) {
                    t1 = pi(t1, -1 / 0);
                    const e = this.toTicks(t1);
                    return this._state.forEachFrom(e, (t1)=>{
                        this.context.transport.clear(t1.id);
                    }), this._state.cancel(e), this;
                }
                _tick(t1) {
                    const e = this.context.transport.getTicksAtTime(t1);
                    if (!this.mute && "started" === this._state.getValueAtTime(e)) {
                        if (this.probability < 1 && Math.random() > this.probability) return;
                        if (this.humanize) {
                            let e = .02;
                            jn(this.humanize) || (e = this.toSeconds(this.humanize)), t1 += (2 * Math.random() - 1) * e;
                        }
                        this.callback(t1, this.value);
                    }
                }
                _getLoopDuration() {
                    return (this._loopEnd - this._loopStart) / this._playbackRate;
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    this._loop = t1, this._rescheduleEvents();
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._rescheduleEvents();
                }
                get loopEnd() {
                    return new So(this.context, this._loopEnd).toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1), this._loop && this._rescheduleEvents();
                }
                get loopStart() {
                    return new So(this.context, this._loopStart).toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1), this._loop && this._rescheduleEvents();
                }
                get progress() {
                    if (this._loop) {
                        const t1 = this.context.transport.ticks, e = this._state.get(t1);
                        if (null !== e && "started" === e.state) {
                            const s1 = this._getLoopDuration();
                            return (t1 - e.time) % s1 / s1;
                        }
                        return 0;
                    }
                    return 0;
                }
                dispose() {
                    return super.dispose(), this.cancel(), this._state.dispose(), this;
                }
            }
            class $r extends eo {
                constructor(){
                    super(ui($r.getDefaults(), arguments, [
                        "callback",
                        "interval"
                    ])), this.name = "Loop";
                    const t1 = ui($r.getDefaults(), arguments, [
                        "callback",
                        "interval"
                    ]);
                    this._event = new Yr({
                        context: this.context,
                        callback: this._tick.bind(this),
                        loop: !0,
                        loopEnd: t1.interval,
                        playbackRate: t1.playbackRate,
                        probability: t1.probability,
                        humanize: t1.humanize
                    }), this.callback = t1.callback, this.iterations = t1.iterations;
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        interval: "4n",
                        callback: Ei,
                        playbackRate: 1,
                        iterations: 1 / 0,
                        probability: 1,
                        mute: !1,
                        humanize: !1
                    });
                }
                start(t1) {
                    return this._event.start(t1), this;
                }
                stop(t1) {
                    return this._event.stop(t1), this;
                }
                cancel(t1) {
                    return this._event.cancel(t1), this;
                }
                _tick(t1) {
                    this.callback(t1);
                }
                get state() {
                    return this._event.state;
                }
                get progress() {
                    return this._event.progress;
                }
                get interval() {
                    return this._event.loopEnd;
                }
                set interval(t1) {
                    this._event.loopEnd = t1;
                }
                get playbackRate() {
                    return this._event.playbackRate;
                }
                set playbackRate(t1) {
                    this._event.playbackRate = t1;
                }
                get humanize() {
                    return this._event.humanize;
                }
                set humanize(t1) {
                    this._event.humanize = t1;
                }
                get probability() {
                    return this._event.probability;
                }
                set probability(t1) {
                    this._event.probability = t1;
                }
                get mute() {
                    return this._event.mute;
                }
                set mute(t1) {
                    this._event.mute = t1;
                }
                get iterations() {
                    return !0 === this._event.loop ? 1 / 0 : this._event.loop;
                }
                set iterations(t1) {
                    this._event.loop = t1 === 1 / 0 || t1;
                }
                dispose() {
                    return super.dispose(), this._event.dispose(), this;
                }
            }
            class Hr extends Yr {
                constructor(){
                    super(ui(Hr.getDefaults(), arguments, [
                        "callback",
                        "events"
                    ])), this.name = "Part", this._state = new so("stopped"), this._events = new Set;
                    const t1 = ui(Hr.getDefaults(), arguments, [
                        "callback",
                        "events"
                    ]);
                    this._state.increasing = !0, t1.events.forEach((t1)=>{
                        Ln(t1) ? this.add(t1[0], t1[1]) : this.add(t1);
                    });
                }
                static getDefaults() {
                    return Object.assign(Yr.getDefaults(), {
                        events: []
                    });
                }
                start(t1, e) {
                    const s1 = this.toTicks(t1);
                    if ("started" !== this._state.getValueAtTime(s1)) {
                        e = pi(e, this._loop ? this._loopStart : 0), e = this._loop ? pi(e, this._loopStart) : pi(e, 0);
                        const t1 = this.toTicks(e);
                        this._state.add({
                            id: -1,
                            offset: t1,
                            state: "started",
                            time: s1
                        }), this._forEach((e)=>{
                            this._startNote(e, s1, t1);
                        });
                    }
                    return this;
                }
                _startNote(t1, e, s1) {
                    e -= s1, this._loop ? t1.startOffset >= this._loopStart && t1.startOffset < this._loopEnd ? (t1.startOffset < s1 && (e += this._getLoopDuration()), t1.start(new So(this.context, e))) : t1.startOffset < this._loopStart && t1.startOffset >= s1 && (t1.loop = !1, t1.start(new So(this.context, e))) : t1.startOffset >= s1 && t1.start(new So(this.context, e));
                }
                get startOffset() {
                    return this._startOffset;
                }
                set startOffset(t1) {
                    this._startOffset = t1, this._forEach((t1)=>{
                        t1.startOffset += this._startOffset;
                    });
                }
                stop(t1) {
                    const e = this.toTicks(t1);
                    return this._state.cancel(e), this._state.setStateAtTime("stopped", e), this._forEach((e)=>{
                        e.stop(t1);
                    }), this;
                }
                at(t1, e) {
                    const s1 = new Ki(this.context, t1).toTicks(), n = new So(this.context, 1).toSeconds(), i = this._events.values();
                    let o = i.next();
                    for(; !o.done;){
                        const t1 = o.value;
                        if (Math.abs(s1 - t1.startOffset) < n) return In(e) && (t1.value = e), t1;
                        o = i.next();
                    }
                    return In(e) ? (this.add(t1, e), this.at(t1)) : null;
                }
                add(t1, e) {
                    t1 instanceof Object && Reflect.has(t1, "time") && (t1 = (e = t1).time);
                    const s1 = this.toTicks(t1);
                    let n;
                    return e instanceof Yr ? (n = e, n.callback = this._tick.bind(this)) : n = new Yr({
                        callback: this._tick.bind(this),
                        context: this.context,
                        value: e
                    }), n.startOffset = s1, n.set({
                        humanize: this.humanize,
                        loop: this.loop,
                        loopEnd: this.loopEnd,
                        loopStart: this.loopStart,
                        playbackRate: this.playbackRate,
                        probability: this.probability
                    }), this._events.add(n), this._restartEvent(n), this;
                }
                _restartEvent(t1) {
                    this._state.forEach((e)=>{
                        "started" === e.state ? this._startNote(t1, e.time, e.offset) : t1.stop(new So(this.context, e.time));
                    });
                }
                remove(t1, e) {
                    return Pn(t1) && t1.hasOwnProperty("time") && (t1 = (e = t1).time), t1 = this.toTicks(t1), this._events.forEach((s1)=>{
                        s1.startOffset === t1 && (Fn(e) || In(e) && s1.value === e) && (this._events.delete(s1), s1.dispose());
                    }), this;
                }
                clear() {
                    return this._forEach((t1)=>t1.dispose()), this._events.clear(), this;
                }
                cancel(t1) {
                    return this._forEach((e)=>e.cancel(t1)), this._state.cancel(this.toTicks(t1)), this;
                }
                _forEach(t1) {
                    return this._events && this._events.forEach((e)=>{
                        e instanceof Hr ? e._forEach(t1) : t1(e);
                    }), this;
                }
                _setAll(t1, e) {
                    this._forEach((s1)=>{
                        s1[t1] = e;
                    });
                }
                _tick(t1, e) {
                    this.mute || this.callback(t1, e);
                }
                _testLoopBoundries(t1) {
                    this._loop && (t1.startOffset < this._loopStart || t1.startOffset >= this._loopEnd) ? t1.cancel(0) : "stopped" === t1.state && this._restartEvent(t1);
                }
                get probability() {
                    return this._probability;
                }
                set probability(t1) {
                    this._probability = t1, this._setAll("probability", t1);
                }
                get humanize() {
                    return this._humanize;
                }
                set humanize(t1) {
                    this._humanize = t1, this._setAll("humanize", t1);
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    this._loop = t1, this._forEach((e)=>{
                        e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.loop = t1, this._testLoopBoundries(e);
                    });
                }
                get loopEnd() {
                    return new So(this.context, this._loopEnd).toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1), this._loop && this._forEach((e)=>{
                        e.loopEnd = t1, this._testLoopBoundries(e);
                    });
                }
                get loopStart() {
                    return new So(this.context, this._loopStart).toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1), this._loop && this._forEach((t1)=>{
                        t1.loopStart = this.loopStart, this._testLoopBoundries(t1);
                    });
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._setAll("playbackRate", t1);
                }
                get length() {
                    return this._events.size;
                }
                dispose() {
                    return super.dispose(), this.clear(), this;
                }
            }
            function* Jr(t1) {
                let e = 0;
                for(; e < t1;)e = xi(e, 0, t1 - 1), yield e, e++;
            }
            function* Kr(t1) {
                let e = t1 - 1;
                for(; e >= 0;)e = xi(e, 0, t1 - 1), yield e, e--;
            }
            function* ta(t1, e) {
                for(;;)yield* e(t1);
            }
            function* ea(t1, e) {
                let s1 = e ? 0 : t1 - 1;
                for(;;)s1 = xi(s1, 0, t1 - 1), yield s1, e ? (s1++, s1 >= t1 - 1 && (e = !1)) : (s1--, s1 <= 0 && (e = !0));
            }
            function* sa(t1) {
                let e = 0, s1 = 0;
                for(; e < t1;)e = xi(e, 0, t1 - 1), yield e, s1++, e += s1 % 2 ? 2 : -1;
            }
            function* na(t1) {
                let e = t1 - 1, s1 = 0;
                for(; e >= 0;)e = xi(e, 0, t1 - 1), yield e, s1++, e += s1 % 2 ? -2 : 1;
            }
            function* ia(t1) {
                const e = [];
                for(let s1 = 0; s1 < t1; s1++)e.push(s1);
                for(; e.length > 0;){
                    const s1 = xi(e.splice(Math.floor(e.length * Math.random()), 1)[0], 0, t1 - 1);
                    yield s1;
                }
            }
            function* oa(t1, e = "up", s1 = 0) {
                switch(Bn(t1 >= 1, "The number of values must be at least one"), e){
                    case "up":
                        yield* ta(t1, Jr);
                    case "down":
                        yield* ta(t1, Kr);
                    case "upDown":
                        yield* ea(t1, !0);
                    case "downUp":
                        yield* ea(t1, !1);
                    case "alternateUp":
                        yield* ta(t1, sa);
                    case "alternateDown":
                        yield* ta(t1, na);
                    case "random":
                        yield* function*(t1) {
                            for(;;){
                                const e = Math.floor(Math.random() * t1);
                                yield e;
                            }
                        }(t1);
                    case "randomOnce":
                        yield* ta(t1, ia);
                    case "randomWalk":
                        yield* function*(t1) {
                            let e = Math.floor(Math.random() * t1);
                            for(;;)0 === e ? e++ : e === t1 - 1 || Math.random() < .5 ? e-- : e++, yield e;
                        }(t1);
                }
            }
            class ra extends $r {
                constructor(){
                    super(ui(ra.getDefaults(), arguments, [
                        "callback",
                        "values",
                        "pattern"
                    ])), this.name = "Pattern";
                    const t1 = ui(ra.getDefaults(), arguments, [
                        "callback",
                        "values",
                        "pattern"
                    ]);
                    this.callback = t1.callback, this._values = t1.values, this._pattern = oa(t1.values.length, t1.pattern), this._type = t1.pattern;
                }
                static getDefaults() {
                    return Object.assign($r.getDefaults(), {
                        pattern: "up",
                        values: [],
                        callback: Ei
                    });
                }
                _tick(t1) {
                    const e = this._pattern.next();
                    this._index = e.value, this._value = this._values[e.value], this.callback(t1, this._value);
                }
                get values() {
                    return this._values;
                }
                set values(t1) {
                    this._values = t1, this.pattern = this._type;
                }
                get value() {
                    return this._value;
                }
                get index() {
                    return this._index;
                }
                get pattern() {
                    return this._type;
                }
                set pattern(t1) {
                    this._type = t1, this._pattern = oa(this._values.length, this._type);
                }
            }
            class aa extends Yr {
                constructor(){
                    super(ui(aa.getDefaults(), arguments, [
                        "callback",
                        "events",
                        "subdivision"
                    ])), this.name = "Sequence", this._part = new Hr({
                        callback: this._seqCallback.bind(this),
                        context: this.context
                    }), this._events = [], this._eventsArray = [];
                    const t1 = ui(aa.getDefaults(), arguments, [
                        "callback",
                        "events",
                        "subdivision"
                    ]);
                    this._subdivision = this.toTicks(t1.subdivision), this.events = t1.events, this.loop = t1.loop, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this.playbackRate = t1.playbackRate, this.probability = t1.probability, this.humanize = t1.humanize, this.mute = t1.mute, this.playbackRate = t1.playbackRate;
                }
                static getDefaults() {
                    return Object.assign(di(Yr.getDefaults(), [
                        "value"
                    ]), {
                        events: [],
                        loop: !0,
                        loopEnd: 0,
                        loopStart: 0,
                        subdivision: "8n"
                    });
                }
                _seqCallback(t1, e) {
                    null === e || this.mute || this.callback(t1, e);
                }
                get events() {
                    return this._events;
                }
                set events(t1) {
                    this.clear(), this._eventsArray = t1, this._events = this._createSequence(this._eventsArray), this._eventsUpdated();
                }
                start(t1, e) {
                    return this._part.start(t1, e ? this._indexTime(e) : e), this;
                }
                stop(t1) {
                    return this._part.stop(t1), this;
                }
                get subdivision() {
                    return new So(this.context, this._subdivision).toSeconds();
                }
                _createSequence(t1) {
                    return new Proxy(t1, {
                        get: (t1, e)=>t1[e],
                        set: (t1, e, s1)=>(zn(e) && isFinite(parseInt(e, 10)) && Ln(s1) ? t1[e] = this._createSequence(s1) : t1[e] = s1, this._eventsUpdated(), !0)
                    });
                }
                _eventsUpdated() {
                    this._part.clear(), this._rescheduleSequence(this._eventsArray, this._subdivision, this.startOffset), this.loopEnd = this.loopEnd;
                }
                _rescheduleSequence(t1, e, s1) {
                    t1.forEach((t1, n)=>{
                        const i = n * e + s1;
                        if (Ln(t1)) this._rescheduleSequence(t1, e / t1.length, i);
                        else {
                            const e = new So(this.context, i, "i").toSeconds();
                            this._part.add(e, t1);
                        }
                    });
                }
                _indexTime(t1) {
                    return new So(this.context, t1 * this._subdivision + this.startOffset).toSeconds();
                }
                clear() {
                    return this._part.clear(), this;
                }
                dispose() {
                    return super.dispose(), this._part.dispose(), this;
                }
                get loop() {
                    return this._part.loop;
                }
                set loop(t1) {
                    this._part.loop = t1;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this._loopStart = t1, this._part.loopStart = this._indexTime(t1);
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this._loopEnd = t1, this._part.loopEnd = 0 === t1 ? this._indexTime(this._eventsArray.length) : this._indexTime(t1);
                }
                get startOffset() {
                    return this._part.startOffset;
                }
                set startOffset(t1) {
                    this._part.startOffset = t1;
                }
                get playbackRate() {
                    return this._part.playbackRate;
                }
                set playbackRate(t1) {
                    this._part.playbackRate = t1;
                }
                get probability() {
                    return this._part.probability;
                }
                set probability(t1) {
                    this._part.probability = t1;
                }
                get progress() {
                    return this._part.progress;
                }
                get humanize() {
                    return this._part.humanize;
                }
                set humanize(t1) {
                    this._part.humanize = t1;
                }
                get length() {
                    return this._part.length;
                }
            }
            class ca extends io {
                constructor(){
                    super(Object.assign(ui(ca.getDefaults(), arguments, [
                        "fade"
                    ]))), this.name = "CrossFade", this._panner = this.context.createStereoPanner(), this._split = this.context.createChannelSplitter(2), this._g2a = new dr({
                        context: this.context
                    }), this.a = new ho({
                        context: this.context,
                        gain: 0
                    }), this.b = new ho({
                        context: this.context,
                        gain: 0
                    }), this.output = new ho({
                        context: this.context
                    }), this._internalChannels = [
                        this.a,
                        this.b
                    ];
                    const t1 = ui(ca.getDefaults(), arguments, [
                        "fade"
                    ]);
                    this.fade = new po({
                        context: this.context,
                        units: "normalRange",
                        value: t1.fade
                    }), Oi(this, "fade"), this.context.getConstant(1).connect(this._panner), this._panner.connect(this._split), this._panner.channelCount = 1, this._panner.channelCountMode = "explicit", ro(this._split, this.a.gain, 0), ro(this._split, this.b.gain, 1), this.fade.chain(this._g2a, this._panner.pan), this.a.connect(this.output), this.b.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        fade: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.a.dispose(), this.b.dispose(), this.output.dispose(), this.fade.dispose(), this._g2a.dispose(), this._panner.disconnect(), this._split.disconnect(), this;
                }
            }
            class ha extends io {
                constructor(t1){
                    super(t1), this.name = "Effect", this._dryWet = new ca({
                        context: this.context
                    }), this.wet = this._dryWet.fade, this.effectSend = new ho({
                        context: this.context
                    }), this.effectReturn = new ho({
                        context: this.context
                    }), this.input = new ho({
                        context: this.context
                    }), this.output = this._dryWet, this.input.fan(this._dryWet.a, this.effectSend), this.effectReturn.connect(this._dryWet.b), this.wet.setValueAtTime(t1.wet, 0), this._internalChannels = [
                        this.effectReturn,
                        this.effectSend
                    ], Oi(this, "wet");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        wet: 1
                    });
                }
                connectEffect(t1) {
                    return this._internalChannels.push(t1), this.effectSend.chain(t1, this.effectReturn), this;
                }
                dispose() {
                    return super.dispose(), this._dryWet.dispose(), this.effectSend.dispose(), this.effectReturn.dispose(), this.wet.dispose(), this;
                }
            }
            class la extends ha {
                constructor(t1){
                    super(t1), this.name = "LFOEffect", this._lfo = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        amplitude: t1.depth
                    }), this.depth = this._lfo.amplitude, this.frequency = this._lfo.frequency, this.type = t1.type, Oi(this, [
                        "frequency",
                        "depth"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        frequency: 1,
                        type: "sine",
                        depth: 1
                    });
                }
                start(t1) {
                    return this._lfo.start(t1), this;
                }
                stop(t1) {
                    return this._lfo.stop(t1), this;
                }
                sync() {
                    return this._lfo.sync(), this;
                }
                unsync() {
                    return this._lfo.unsync(), this;
                }
                get type() {
                    return this._lfo.type;
                }
                set type(t1) {
                    this._lfo.type = t1;
                }
                dispose() {
                    return super.dispose(), this._lfo.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class ua extends la {
                constructor(){
                    super(ui(ua.getDefaults(), arguments, [
                        "frequency",
                        "baseFrequency",
                        "octaves"
                    ])), this.name = "AutoFilter";
                    const t1 = ui(ua.getDefaults(), arguments, [
                        "frequency",
                        "baseFrequency",
                        "octaves"
                    ]);
                    this.filter = new Or(Object.assign(t1.filter, {
                        context: this.context
                    })), this.connectEffect(this.filter), this._lfo.connect(this.filter.frequency), this.octaves = t1.octaves, this.baseFrequency = t1.baseFrequency;
                }
                static getDefaults() {
                    return Object.assign(la.getDefaults(), {
                        baseFrequency: 200,
                        octaves: 2.6,
                        filter: {
                            type: "lowpass",
                            rolloff: -12,
                            Q: 1
                        }
                    });
                }
                get baseFrequency() {
                    return this._lfo.min;
                }
                set baseFrequency(t1) {
                    this._lfo.min = this.toFrequency(t1), this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._lfo.max = this._lfo.min * Math.pow(2, t1);
                }
                dispose() {
                    return super.dispose(), this.filter.dispose(), this;
                }
            }
            class pa extends io {
                constructor(){
                    super(Object.assign(ui(pa.getDefaults(), arguments, [
                        "pan"
                    ]))), this.name = "Panner", this._panner = this.context.createStereoPanner(), this.input = this._panner, this.output = this._panner;
                    const t1 = ui(pa.getDefaults(), arguments, [
                        "pan"
                    ]);
                    this.pan = new no({
                        context: this.context,
                        param: this._panner.pan,
                        value: t1.pan,
                        minValue: -1,
                        maxValue: 1
                    }), this._panner.channelCount = t1.channelCount, this._panner.channelCountMode = "explicit", Oi(this, "pan");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        pan: 0,
                        channelCount: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._panner.disconnect(), this.pan.dispose(), this;
                }
            }
            class da extends la {
                constructor(){
                    super(ui(da.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "AutoPanner";
                    const t1 = ui(da.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this._panner = new pa({
                        context: this.context,
                        channelCount: t1.channelCount
                    }), this.connectEffect(this._panner), this._lfo.connect(this._panner.pan), this._lfo.min = -1, this._lfo.max = 1;
                }
                static getDefaults() {
                    return Object.assign(la.getDefaults(), {
                        channelCount: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._panner.dispose(), this;
                }
            }
            class fa extends io {
                constructor(){
                    super(ui(fa.getDefaults(), arguments, [
                        "smoothing"
                    ])), this.name = "Follower";
                    const t1 = ui(fa.getDefaults(), arguments, [
                        "smoothing"
                    ]);
                    this._abs = this.input = new pr({
                        context: this.context
                    }), this._lowpass = this.output = new Ur({
                        context: this.context,
                        frequency: 1 / this.toSeconds(t1.smoothing),
                        type: "lowpass"
                    }), this._abs.connect(this._lowpass), this._smoothing = t1.smoothing;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        smoothing: .05
                    });
                }
                get smoothing() {
                    return this._smoothing;
                }
                set smoothing(t1) {
                    this._smoothing = t1, this._lowpass.frequency = 1 / this.toSeconds(this.smoothing);
                }
                dispose() {
                    return super.dispose(), this._abs.dispose(), this._lowpass.dispose(), this;
                }
            }
            class _a extends ha {
                constructor(){
                    super(ui(_a.getDefaults(), arguments, [
                        "baseFrequency",
                        "octaves",
                        "sensitivity"
                    ])), this.name = "AutoWah";
                    const t1 = ui(_a.getDefaults(), arguments, [
                        "baseFrequency",
                        "octaves",
                        "sensitivity"
                    ]);
                    this._follower = new fa({
                        context: this.context,
                        smoothing: t1.follower
                    }), this._sweepRange = new vr({
                        context: this.context,
                        min: 0,
                        max: 1,
                        exponent: .5
                    }), this._baseFrequency = this.toFrequency(t1.baseFrequency), this._octaves = t1.octaves, this._inputBoost = new ho({
                        context: this.context
                    }), this._bandpass = new Or({
                        context: this.context,
                        rolloff: -48,
                        frequency: 0,
                        Q: t1.Q
                    }), this._peaking = new Or({
                        context: this.context,
                        type: "peaking"
                    }), this._peaking.gain.value = t1.gain, this.gain = this._peaking.gain, this.Q = this._bandpass.Q, this.effectSend.chain(this._inputBoost, this._follower, this._sweepRange), this._sweepRange.connect(this._bandpass.frequency), this._sweepRange.connect(this._peaking.frequency), this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn), this._setSweepRange(), this.sensitivity = t1.sensitivity, Oi(this, [
                        "gain",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        baseFrequency: 100,
                        octaves: 6,
                        sensitivity: 0,
                        Q: 2,
                        gain: 2,
                        follower: .2
                    });
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._setSweepRange();
                }
                get follower() {
                    return this._follower.smoothing;
                }
                set follower(t1) {
                    this._follower.smoothing = t1;
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    this._baseFrequency = this.toFrequency(t1), this._setSweepRange();
                }
                get sensitivity() {
                    return Li(1 / this._inputBoost.gain.value);
                }
                set sensitivity(t1) {
                    this._inputBoost.gain.value = 1 / ji(t1);
                }
                _setSweepRange() {
                    this._sweepRange.min = this._baseFrequency, this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
                }
                dispose() {
                    return super.dispose(), this._follower.dispose(), this._sweepRange.dispose(), this._bandpass.dispose(), this._peaking.dispose(), this._inputBoost.dispose(), this;
                }
            }
            const ma = "bit-crusher";
            Lr(ma, "\n\tclass BitCrusherWorklet extends SingleIOProcessor {\n\n\t\tstatic get parameterDescriptors() {\n\t\t\treturn [{\n\t\t\t\tname: \"bits\",\n\t\t\t\tdefaultValue: 12,\n\t\t\t\tminValue: 1,\n\t\t\t\tmaxValue: 16,\n\t\t\t\tautomationRate: 'k-rate'\n\t\t\t}];\n\t\t}\n\n\t\tgenerate(input, _channel, parameters) {\n\t\t\tconst step = Math.pow(0.5, parameters.bits - 1);\n\t\t\tconst val = step * Math.floor(input / step + 0.5);\n\t\t\treturn val;\n\t\t}\n\t}\n");
            class ga extends ha {
                constructor(){
                    super(ui(ga.getDefaults(), arguments, [
                        "bits"
                    ])), this.name = "BitCrusher";
                    const t1 = ui(ga.getDefaults(), arguments, [
                        "bits"
                    ]);
                    this._bitCrusherWorklet = new va({
                        context: this.context,
                        bits: t1.bits
                    }), this.connectEffect(this._bitCrusherWorklet), this.bits = this._bitCrusherWorklet.bits;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        bits: 4
                    });
                }
                dispose() {
                    return super.dispose(), this._bitCrusherWorklet.dispose(), this;
                }
            }
            class va extends zr {
                constructor(){
                    super(ui(va.getDefaults(), arguments)), this.name = "BitCrusherWorklet";
                    const t1 = ui(va.getDefaults(), arguments);
                    this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.bits = new no({
                        context: this.context,
                        value: t1.bits,
                        units: "positive",
                        minValue: 1,
                        maxValue: 16,
                        param: this._dummyParam,
                        swappable: !0
                    });
                }
                static getDefaults() {
                    return Object.assign(zr.getDefaults(), {
                        bits: 12
                    });
                }
                _audioWorkletName() {
                    return ma;
                }
                onReady(t1) {
                    oo(this.input, t1, this.output);
                    const e = t1.parameters.get("bits");
                    this.bits.setParam(e);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.bits.dispose(), this;
                }
            }
            class ya extends ha {
                constructor(){
                    super(ui(ya.getDefaults(), arguments, [
                        "order"
                    ])), this.name = "Chebyshev";
                    const t1 = ui(ya.getDefaults(), arguments, [
                        "order"
                    ]);
                    this._shaper = new qo({
                        context: this.context,
                        length: 4096
                    }), this._order = t1.order, this.connectEffect(this._shaper), this.order = t1.order, this.oversample = t1.oversample;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        order: 1,
                        oversample: "none"
                    });
                }
                _getCoefficient(t1, e, s1) {
                    return s1.has(e) || (0 === e ? s1.set(e, 0) : 1 === e ? s1.set(e, t1) : s1.set(e, 2 * t1 * this._getCoefficient(t1, e - 1, s1) - this._getCoefficient(t1, e - 2, s1))), s1.get(e);
                }
                get order() {
                    return this._order;
                }
                set order(t1) {
                    Bn(Number.isInteger(t1), "'order' must be an integer"), this._order = t1, this._shaper.setMap((e)=>this._getCoefficient(e, t1, new Map));
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.dispose(), this;
                }
            }
            class xa extends io {
                constructor(){
                    super(ui(xa.getDefaults(), arguments, [
                        "channels"
                    ])), this.name = "Split";
                    const t1 = ui(xa.getDefaults(), arguments, [
                        "channels"
                    ]);
                    this._splitter = this.input = this.output = this.context.createChannelSplitter(t1.channels), this._internalChannels = [
                        this._splitter
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        channels: 2
                    });
                }
                dispose() {
                    return super.dispose(), this._splitter.disconnect(), this;
                }
            }
            class wa extends io {
                constructor(){
                    super(ui(wa.getDefaults(), arguments, [
                        "channels"
                    ])), this.name = "Merge";
                    const t1 = ui(wa.getDefaults(), arguments, [
                        "channels"
                    ]);
                    this._merger = this.output = this.input = this.context.createChannelMerger(t1.channels);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        channels: 2
                    });
                }
                dispose() {
                    return super.dispose(), this._merger.disconnect(), this;
                }
            }
            class ba extends io {
                constructor(t1){
                    super(t1), this.name = "StereoEffect", this.input = new ho({
                        context: this.context
                    }), this.input.channelCount = 2, this.input.channelCountMode = "explicit", this._dryWet = this.output = new ca({
                        context: this.context,
                        fade: t1.wet
                    }), this.wet = this._dryWet.fade, this._split = new xa({
                        context: this.context,
                        channels: 2
                    }), this._merge = new wa({
                        context: this.context,
                        channels: 2
                    }), this.input.connect(this._split), this.input.connect(this._dryWet.a), this._merge.connect(this._dryWet.b), Oi(this, [
                        "wet"
                    ]);
                }
                connectEffectLeft(...t1) {
                    this._split.connect(t1[0], 0, 0), oo(...t1), ro(t1[t1.length - 1], this._merge, 0, 0);
                }
                connectEffectRight(...t1) {
                    this._split.connect(t1[0], 1, 0), oo(...t1), ro(t1[t1.length - 1], this._merge, 0, 1);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        wet: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._dryWet.dispose(), this._split.dispose(), this._merge.dispose(), this;
                }
            }
            class Ta extends ba {
                constructor(t1){
                    super(t1), this.feedback = new po({
                        context: this.context,
                        value: t1.feedback,
                        units: "normalRange"
                    }), this._feedbackL = new ho({
                        context: this.context
                    }), this._feedbackR = new ho({
                        context: this.context
                    }), this._feedbackSplit = new xa({
                        context: this.context,
                        channels: 2
                    }), this._feedbackMerge = new wa({
                        context: this.context,
                        channels: 2
                    }), this._merge.connect(this._feedbackSplit), this._feedbackMerge.connect(this._split), this._feedbackSplit.connect(this._feedbackL, 0, 0), this._feedbackL.connect(this._feedbackMerge, 0, 0), this._feedbackSplit.connect(this._feedbackR, 1, 0), this._feedbackR.connect(this._feedbackMerge, 0, 1), this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain), Oi(this, [
                        "feedback"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        feedback: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.feedback.dispose(), this._feedbackL.dispose(), this._feedbackR.dispose(), this._feedbackSplit.dispose(), this._feedbackMerge.dispose(), this;
                }
            }
            class Sa extends Ta {
                constructor(){
                    super(ui(Sa.getDefaults(), arguments, [
                        "frequency",
                        "delayTime",
                        "depth"
                    ])), this.name = "Chorus";
                    const t1 = ui(Sa.getDefaults(), arguments, [
                        "frequency",
                        "delayTime",
                        "depth"
                    ]);
                    this._depth = t1.depth, this._delayTime = t1.delayTime / 1e3, this._lfoL = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1
                    }), this._lfoR = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1,
                        phase: 180
                    }), this._delayNodeL = new yo({
                        context: this.context
                    }), this._delayNodeR = new yo({
                        context: this.context
                    }), this.frequency = this._lfoL.frequency, Oi(this, [
                        "frequency"
                    ]), this._lfoL.frequency.connect(this._lfoR.frequency), this.connectEffectLeft(this._delayNodeL), this.connectEffectRight(this._delayNodeR), this._lfoL.connect(this._delayNodeL.delayTime), this._lfoR.connect(this._delayNodeR.delayTime), this.depth = this._depth, this.type = t1.type, this.spread = t1.spread;
                }
                static getDefaults() {
                    return Object.assign(Ta.getDefaults(), {
                        frequency: 1.5,
                        delayTime: 3.5,
                        depth: .7,
                        type: "sine",
                        spread: 180,
                        feedback: 0,
                        wet: .5
                    });
                }
                get depth() {
                    return this._depth;
                }
                set depth(t1) {
                    this._depth = t1;
                    const e = this._delayTime * t1;
                    this._lfoL.min = Math.max(this._delayTime - e, 0), this._lfoL.max = this._delayTime + e, this._lfoR.min = Math.max(this._delayTime - e, 0), this._lfoR.max = this._delayTime + e;
                }
                get delayTime() {
                    return 1e3 * this._delayTime;
                }
                set delayTime(t1) {
                    this._delayTime = t1 / 1e3, this.depth = this._depth;
                }
                get type() {
                    return this._lfoL.type;
                }
                set type(t1) {
                    this._lfoL.type = t1, this._lfoR.type = t1;
                }
                get spread() {
                    return this._lfoR.phase - this._lfoL.phase;
                }
                set spread(t1) {
                    this._lfoL.phase = 90 - t1 / 2, this._lfoR.phase = t1 / 2 + 90;
                }
                start(t1) {
                    return this._lfoL.start(t1), this._lfoR.start(t1), this;
                }
                stop(t1) {
                    return this._lfoL.stop(t1), this._lfoR.stop(t1), this;
                }
                sync() {
                    return this._lfoL.sync(), this._lfoR.sync(), this;
                }
                unsync() {
                    return this._lfoL.unsync(), this._lfoR.unsync(), this;
                }
                dispose() {
                    return super.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._delayNodeL.dispose(), this._delayNodeR.dispose(), this.frequency.dispose(), this;
                }
            }
            class ka extends ha {
                constructor(){
                    super(ui(ka.getDefaults(), arguments, [
                        "distortion"
                    ])), this.name = "Distortion";
                    const t1 = ui(ka.getDefaults(), arguments, [
                        "distortion"
                    ]);
                    this._shaper = new qo({
                        context: this.context,
                        length: 4096
                    }), this._distortion = t1.distortion, this.connectEffect(this._shaper), this.distortion = t1.distortion, this.oversample = t1.oversample;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        distortion: .4,
                        oversample: "none"
                    });
                }
                get distortion() {
                    return this._distortion;
                }
                set distortion(t1) {
                    this._distortion = t1;
                    const e = 100 * t1, s1 = Math.PI / 180;
                    this._shaper.setMap((t1)=>Math.abs(t1) < .001 ? 0 : (3 + e) * t1 * 20 * s1 / (Math.PI + e * Math.abs(t1)));
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.dispose(), this;
                }
            }
            class Aa extends ha {
                constructor(t1){
                    super(t1), this.name = "FeedbackEffect", this._feedbackGain = new ho({
                        context: this.context,
                        gain: t1.feedback,
                        units: "normalRange"
                    }), this.feedback = this._feedbackGain.gain, Oi(this, "feedback"), this.effectReturn.chain(this._feedbackGain, this.effectSend);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        feedback: .125
                    });
                }
                dispose() {
                    return super.dispose(), this._feedbackGain.dispose(), this.feedback.dispose(), this;
                }
            }
            class Ca extends Aa {
                constructor(){
                    super(ui(Ca.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ])), this.name = "FeedbackDelay";
                    const t1 = ui(Ca.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ]);
                    this._delayNode = new yo({
                        context: this.context,
                        delayTime: t1.delayTime,
                        maxDelay: t1.maxDelay
                    }), this.delayTime = this._delayNode.delayTime, this.connectEffect(this._delayNode), Oi(this, "delayTime");
                }
                static getDefaults() {
                    return Object.assign(Aa.getDefaults(), {
                        delayTime: .25,
                        maxDelay: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._delayNode.dispose(), this.delayTime.dispose(), this;
                }
            }
            class Da extends io {
                constructor(t1){
                    super(t1), this.name = "PhaseShiftAllpass", this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.offset90 = new ho({
                        context: this.context
                    }), this._bank0 = this._createAllPassFilterBank([
                        .6923878,
                        .9360654322959,
                        .988229522686,
                        .9987488452737
                    ]), this._bank1 = this._createAllPassFilterBank([
                        .4021921162426,
                        .856171088242,
                        .9722909545651,
                        .9952884791278
                    ]), this._oneSampleDelay = this.context.createIIRFilter([
                        0,
                        1
                    ], [
                        1,
                        0
                    ]), oo(this.input, ...this._bank0, this._oneSampleDelay, this.output), oo(this.input, ...this._bank1, this.offset90);
                }
                _createAllPassFilterBank(t1) {
                    return t1.map((t1)=>{
                        const e = [
                            [
                                t1 * t1,
                                0,
                                -1
                            ],
                            [
                                1,
                                0,
                                -t1 * t1
                            ]
                        ];
                        return this.context.createIIRFilter(e[0], e[1]);
                    });
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.offset90.dispose(), this._bank0.forEach((t1)=>t1.disconnect()), this._bank1.forEach((t1)=>t1.disconnect()), this._oneSampleDelay.disconnect(), this;
                }
            }
            class Oa extends ha {
                constructor(){
                    super(ui(Oa.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "FrequencyShifter";
                    const t1 = ui(Oa.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency,
                        minValue: -this.context.sampleRate / 2,
                        maxValue: this.context.sampleRate / 2
                    }), this._sine = new Qo({
                        context: this.context,
                        type: "sine"
                    }), this._cosine = new Zo({
                        context: this.context,
                        phase: -90,
                        type: "sine"
                    }), this._sineMultiply = new Yo({
                        context: this.context
                    }), this._cosineMultiply = new Yo({
                        context: this.context
                    }), this._negate = new fr({
                        context: this.context
                    }), this._add = new nr({
                        context: this.context
                    }), this._phaseShifter = new Da({
                        context: this.context
                    }), this.effectSend.connect(this._phaseShifter), this.frequency.fan(this._sine.frequency, this._cosine.frequency), this._phaseShifter.offset90.connect(this._cosineMultiply), this._cosine.connect(this._cosineMultiply.factor), this._phaseShifter.connect(this._sineMultiply), this._sine.connect(this._sineMultiply.factor), this._sineMultiply.connect(this._negate), this._cosineMultiply.connect(this._add), this._negate.connect(this._add.addend), this._add.connect(this.effectReturn);
                    const e = this.immediate();
                    this._sine.start(e), this._cosine.start(e);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        frequency: 0
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this._add.dispose(), this._cosine.dispose(), this._cosineMultiply.dispose(), this._negate.dispose(), this._phaseShifter.dispose(), this._sine.dispose(), this._sineMultiply.dispose(), this;
                }
            }
            const Ma = [
                1557 / 44100,
                1617 / 44100,
                1491 / 44100,
                1422 / 44100,
                1277 / 44100,
                1356 / 44100,
                1188 / 44100,
                1116 / 44100
            ], Ea = [
                225,
                556,
                441,
                341
            ];
            class Ra extends ba {
                constructor(){
                    super(ui(Ra.getDefaults(), arguments, [
                        "roomSize",
                        "dampening"
                    ])), this.name = "Freeverb", this._combFilters = [], this._allpassFiltersL = [], this._allpassFiltersR = [];
                    const t1 = ui(Ra.getDefaults(), arguments, [
                        "roomSize",
                        "dampening"
                    ]);
                    this.roomSize = new po({
                        context: this.context,
                        value: t1.roomSize,
                        units: "normalRange"
                    }), this._allpassFiltersL = Ea.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._allpassFiltersR = Ea.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._combFilters = Ma.map((e, s1)=>{
                        const n = new Gr({
                            context: this.context,
                            dampening: t1.dampening,
                            delayTime: e
                        });
                        return s1 < Ma.length / 2 ? this.connectEffectLeft(n, ...this._allpassFiltersL) : this.connectEffectRight(n, ...this._allpassFiltersR), this.roomSize.connect(n.resonance), n;
                    }), Oi(this, [
                        "roomSize"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        roomSize: .7,
                        dampening: 3e3
                    });
                }
                get dampening() {
                    return this._combFilters[0].dampening;
                }
                set dampening(t1) {
                    this._combFilters.forEach((e)=>e.dampening = t1);
                }
                dispose() {
                    return super.dispose(), this._allpassFiltersL.forEach((t1)=>t1.disconnect()), this._allpassFiltersR.forEach((t1)=>t1.disconnect()), this._combFilters.forEach((t1)=>t1.dispose()), this.roomSize.dispose(), this;
                }
            }
            const qa = [
                .06748,
                .06404,
                .08212,
                .09004
            ], Fa = [
                .773,
                .802,
                .753,
                .733
            ], Ia = [
                347,
                113,
                37
            ];
            class Va extends ba {
                constructor(){
                    super(ui(Va.getDefaults(), arguments, [
                        "roomSize"
                    ])), this.name = "JCReverb", this._allpassFilters = [], this._feedbackCombFilters = [];
                    const t1 = ui(Va.getDefaults(), arguments, [
                        "roomSize"
                    ]);
                    this.roomSize = new po({
                        context: this.context,
                        value: t1.roomSize,
                        units: "normalRange"
                    }), this._scaleRoomSize = new ir({
                        context: this.context,
                        min: -0.733,
                        max: .197
                    }), this._allpassFilters = Ia.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._feedbackCombFilters = qa.map((t1, e)=>{
                        const s1 = new Br({
                            context: this.context,
                            delayTime: t1
                        });
                        return this._scaleRoomSize.connect(s1.resonance), s1.resonance.value = Fa[e], e < qa.length / 2 ? this.connectEffectLeft(...this._allpassFilters, s1) : this.connectEffectRight(...this._allpassFilters, s1), s1;
                    }), this.roomSize.connect(this._scaleRoomSize), Oi(this, [
                        "roomSize"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        roomSize: .5
                    });
                }
                dispose() {
                    return super.dispose(), this._allpassFilters.forEach((t1)=>t1.disconnect()), this._feedbackCombFilters.forEach((t1)=>t1.dispose()), this.roomSize.dispose(), this._scaleRoomSize.dispose(), this;
                }
            }
            class Na extends Ta {
                constructor(t1){
                    super(t1), this._feedbackL.disconnect(), this._feedbackL.connect(this._feedbackMerge, 0, 1), this._feedbackR.disconnect(), this._feedbackR.connect(this._feedbackMerge, 0, 0), Oi(this, [
                        "feedback"
                    ]);
                }
            }
            class Pa extends Na {
                constructor(){
                    super(ui(Pa.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ])), this.name = "PingPongDelay";
                    const t1 = ui(Pa.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ]);
                    this._leftDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this._rightDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this._rightPreDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this.delayTime = new po({
                        context: this.context,
                        units: "time",
                        value: t1.delayTime
                    }), this.connectEffectLeft(this._leftDelay), this.connectEffectRight(this._rightPreDelay, this._rightDelay), this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime), this._feedbackL.disconnect(), this._feedbackL.connect(this._rightDelay), Oi(this, [
                        "delayTime"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Na.getDefaults(), {
                        delayTime: .25,
                        maxDelay: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._leftDelay.dispose(), this._rightDelay.dispose(), this._rightPreDelay.dispose(), this.delayTime.dispose(), this;
                }
            }
            class ja extends Aa {
                constructor(){
                    super(ui(ja.getDefaults(), arguments, [
                        "pitch"
                    ])), this.name = "PitchShift";
                    const t1 = ui(ja.getDefaults(), arguments, [
                        "pitch"
                    ]);
                    this._frequency = new po({
                        context: this.context
                    }), this._delayA = new yo({
                        maxDelay: 1,
                        context: this.context
                    }), this._lfoA = new rr({
                        context: this.context,
                        min: 0,
                        max: .1,
                        type: "sawtooth"
                    }).connect(this._delayA.delayTime), this._delayB = new yo({
                        maxDelay: 1,
                        context: this.context
                    }), this._lfoB = new rr({
                        context: this.context,
                        min: 0,
                        max: .1,
                        type: "sawtooth",
                        phase: 180
                    }).connect(this._delayB.delayTime), this._crossFade = new ca({
                        context: this.context
                    }), this._crossFadeLFO = new rr({
                        context: this.context,
                        min: 0,
                        max: 1,
                        type: "triangle",
                        phase: 90
                    }).connect(this._crossFade.fade), this._feedbackDelay = new yo({
                        delayTime: t1.delayTime,
                        context: this.context
                    }), this.delayTime = this._feedbackDelay.delayTime, Oi(this, "delayTime"), this._pitch = t1.pitch, this._windowSize = t1.windowSize, this._delayA.connect(this._crossFade.a), this._delayB.connect(this._crossFade.b), this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency), this.effectSend.fan(this._delayA, this._delayB), this._crossFade.chain(this._feedbackDelay, this.effectReturn);
                    const e = this.now();
                    this._lfoA.start(e), this._lfoB.start(e), this._crossFadeLFO.start(e), this.windowSize = this._windowSize;
                }
                static getDefaults() {
                    return Object.assign(Aa.getDefaults(), {
                        pitch: 0,
                        windowSize: .1,
                        delayTime: 0,
                        feedback: 0
                    });
                }
                get pitch() {
                    return this._pitch;
                }
                set pitch(t1) {
                    this._pitch = t1;
                    let e = 0;
                    t1 < 0 ? (this._lfoA.min = 0, this._lfoA.max = this._windowSize, this._lfoB.min = 0, this._lfoB.max = this._windowSize, e = zi(t1 - 1) + 1) : (this._lfoA.min = this._windowSize, this._lfoA.max = 0, this._lfoB.min = this._windowSize, this._lfoB.max = 0, e = zi(t1) - 1), this._frequency.value = e * (1.2 / this._windowSize);
                }
                get windowSize() {
                    return this._windowSize;
                }
                set windowSize(t1) {
                    this._windowSize = this.toSeconds(t1), this.pitch = this._pitch;
                }
                dispose() {
                    return super.dispose(), this._frequency.dispose(), this._delayA.dispose(), this._delayB.dispose(), this._lfoA.dispose(), this._lfoB.dispose(), this._crossFade.dispose(), this._crossFadeLFO.dispose(), this._feedbackDelay.dispose(), this;
                }
            }
            class La extends ba {
                constructor(){
                    super(ui(La.getDefaults(), arguments, [
                        "frequency",
                        "octaves",
                        "baseFrequency"
                    ])), this.name = "Phaser";
                    const t1 = ui(La.getDefaults(), arguments, [
                        "frequency",
                        "octaves",
                        "baseFrequency"
                    ]);
                    this._lfoL = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1
                    }), this._lfoR = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1,
                        phase: 180
                    }), this._baseFrequency = this.toFrequency(t1.baseFrequency), this._octaves = t1.octaves, this.Q = new po({
                        context: this.context,
                        value: t1.Q,
                        units: "positive"
                    }), this._filtersL = this._makeFilters(t1.stages, this._lfoL), this._filtersR = this._makeFilters(t1.stages, this._lfoR), this.frequency = this._lfoL.frequency, this.frequency.value = t1.frequency, this.connectEffectLeft(...this._filtersL), this.connectEffectRight(...this._filtersR), this._lfoL.frequency.connect(this._lfoR.frequency), this.baseFrequency = t1.baseFrequency, this.octaves = t1.octaves, this._lfoL.start(), this._lfoR.start(), Oi(this, [
                        "frequency",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        frequency: .5,
                        octaves: 3,
                        stages: 10,
                        Q: 10,
                        baseFrequency: 350
                    });
                }
                _makeFilters(t1, e) {
                    const s1 = [];
                    for(let n = 0; n < t1; n++){
                        const t1 = this.context.createBiquadFilter();
                        t1.type = "allpass", this.Q.connect(t1.Q), e.connect(t1.frequency), s1.push(t1);
                    }
                    return s1;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1;
                    const e = this._baseFrequency * Math.pow(2, t1);
                    this._lfoL.max = e, this._lfoR.max = e;
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    this._baseFrequency = this.toFrequency(t1), this._lfoL.min = this._baseFrequency, this._lfoR.min = this._baseFrequency, this.octaves = this._octaves;
                }
                dispose() {
                    return super.dispose(), this.Q.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._filtersL.forEach((t1)=>t1.disconnect()), this._filtersR.forEach((t1)=>t1.disconnect()), this.frequency.dispose(), this;
                }
            }
            class za extends ha {
                constructor(){
                    super(ui(za.getDefaults(), arguments, [
                        "decay"
                    ])), this.name = "Reverb", this._convolver = this.context.createConvolver(), this.ready = Promise.resolve();
                    const t1 = ui(za.getDefaults(), arguments, [
                        "decay"
                    ]);
                    this._decay = t1.decay, this._preDelay = t1.preDelay, this.generate(), this.connectEffect(this._convolver);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        decay: 1.5,
                        preDelay: .01
                    });
                }
                get decay() {
                    return this._decay;
                }
                set decay(t1) {
                    Un(t1 = this.toSeconds(t1), .001), this._decay = t1, this.generate();
                }
                get preDelay() {
                    return this._preDelay;
                }
                set preDelay(t1) {
                    Un(t1 = this.toSeconds(t1), 0), this._preDelay = t1, this.generate();
                }
                generate() {
                    return ni(this, void 0, void 0, function*() {
                        const t1 = this.ready, e = new qi(2, this._decay + this._preDelay, this.context.sampleRate), s1 = new Lo({
                            context: e
                        }), n = new Lo({
                            context: e
                        }), i = new wa({
                            context: e
                        });
                        s1.connect(i, 0, 0), n.connect(i, 0, 1);
                        const o = new ho({
                            context: e
                        }).toDestination();
                        i.connect(o), s1.start(0), n.start(0), o.gain.setValueAtTime(0, 0), o.gain.setValueAtTime(1, this._preDelay), o.gain.exponentialApproachValueAtTime(0, this._preDelay, this.decay);
                        const r = e.render();
                        return this.ready = r.then(Ei), yield t1, this._convolver.buffer = (yield r).get(), this;
                    });
                }
                dispose() {
                    return super.dispose(), this._convolver.disconnect(), this;
                }
            }
            class Wa extends io {
                constructor(){
                    super(ui(Wa.getDefaults(), arguments)), this.name = "MidSideSplit", this._split = this.input = new xa({
                        channels: 2,
                        context: this.context
                    }), this._midAdd = new nr({
                        context: this.context
                    }), this.mid = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._sideSubtract = new _r({
                        context: this.context
                    }), this.side = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._split.connect(this._midAdd, 0), this._split.connect(this._midAdd.addend, 1), this._split.connect(this._sideSubtract, 0), this._split.connect(this._sideSubtract.subtrahend, 1), this._midAdd.connect(this.mid), this._sideSubtract.connect(this.side);
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._midAdd.dispose(), this._sideSubtract.dispose(), this._split.dispose(), this;
                }
            }
            class Ba extends io {
                constructor(){
                    super(ui(Ba.getDefaults(), arguments)), this.name = "MidSideMerge", this.mid = new ho({
                        context: this.context
                    }), this.side = new ho({
                        context: this.context
                    }), this._left = new nr({
                        context: this.context
                    }), this._leftMult = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._right = new _r({
                        context: this.context
                    }), this._rightMult = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._merge = this.output = new wa({
                        context: this.context
                    }), this.mid.fan(this._left), this.side.connect(this._left.addend), this.mid.connect(this._right), this.side.connect(this._right.subtrahend), this._left.connect(this._leftMult), this._right.connect(this._rightMult), this._leftMult.connect(this._merge, 0, 0), this._rightMult.connect(this._merge, 0, 1);
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._leftMult.dispose(), this._rightMult.dispose(), this._left.dispose(), this._right.dispose(), this;
                }
            }
            class Ua extends ha {
                constructor(t1){
                    super(t1), this.name = "MidSideEffect", this._midSideMerge = new Ba({
                        context: this.context
                    }), this._midSideSplit = new Wa({
                        context: this.context
                    }), this._midSend = this._midSideSplit.mid, this._sideSend = this._midSideSplit.side, this._midReturn = this._midSideMerge.mid, this._sideReturn = this._midSideMerge.side, this.effectSend.connect(this._midSideSplit), this._midSideMerge.connect(this.effectReturn);
                }
                connectEffectMid(...t1) {
                    this._midSend.chain(...t1, this._midReturn);
                }
                connectEffectSide(...t1) {
                    this._sideSend.chain(...t1, this._sideReturn);
                }
                dispose() {
                    return super.dispose(), this._midSideSplit.dispose(), this._midSideMerge.dispose(), this._midSend.dispose(), this._sideSend.dispose(), this._midReturn.dispose(), this._sideReturn.dispose(), this;
                }
            }
            class Ga extends Ua {
                constructor(){
                    super(ui(Ga.getDefaults(), arguments, [
                        "width"
                    ])), this.name = "StereoWidener";
                    const t1 = ui(Ga.getDefaults(), arguments, [
                        "width"
                    ]);
                    this.width = new po({
                        context: this.context,
                        value: t1.width,
                        units: "normalRange"
                    }), Oi(this, [
                        "width"
                    ]), this._twoTimesWidthMid = new Yo({
                        context: this.context,
                        value: 2
                    }), this._twoTimesWidthSide = new Yo({
                        context: this.context,
                        value: 2
                    }), this._midMult = new Yo({
                        context: this.context
                    }), this._twoTimesWidthMid.connect(this._midMult.factor), this.connectEffectMid(this._midMult), this._oneMinusWidth = new _r({
                        context: this.context
                    }), this._oneMinusWidth.connect(this._twoTimesWidthMid), ro(this.context.getConstant(1), this._oneMinusWidth), this.width.connect(this._oneMinusWidth.subtrahend), this._sideMult = new Yo({
                        context: this.context
                    }), this.width.connect(this._twoTimesWidthSide), this._twoTimesWidthSide.connect(this._sideMult.factor), this.connectEffectSide(this._sideMult);
                }
                static getDefaults() {
                    return Object.assign(Ua.getDefaults(), {
                        width: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.width.dispose(), this._midMult.dispose(), this._sideMult.dispose(), this._twoTimesWidthMid.dispose(), this._twoTimesWidthSide.dispose(), this._oneMinusWidth.dispose(), this;
                }
            }
            class Qa extends ba {
                constructor(){
                    super(ui(Qa.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ])), this.name = "Tremolo";
                    const t1 = ui(Qa.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ]);
                    this._lfoL = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 1,
                        max: 0
                    }), this._lfoR = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 1,
                        max: 0
                    }), this._amplitudeL = new ho({
                        context: this.context
                    }), this._amplitudeR = new ho({
                        context: this.context
                    }), this.frequency = new po({
                        context: this.context,
                        value: t1.frequency,
                        units: "frequency"
                    }), this.depth = new po({
                        context: this.context,
                        value: t1.depth,
                        units: "normalRange"
                    }), Oi(this, [
                        "frequency",
                        "depth"
                    ]), this.connectEffectLeft(this._amplitudeL), this.connectEffectRight(this._amplitudeR), this._lfoL.connect(this._amplitudeL.gain), this._lfoR.connect(this._amplitudeR.gain), this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency), this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude), this.spread = t1.spread;
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        frequency: 10,
                        type: "sine",
                        depth: .5,
                        spread: 180
                    });
                }
                start(t1) {
                    return this._lfoL.start(t1), this._lfoR.start(t1), this;
                }
                stop(t1) {
                    return this._lfoL.stop(t1), this._lfoR.stop(t1), this;
                }
                sync() {
                    return this._lfoL.sync(), this._lfoR.sync(), this.context.transport.syncSignal(this.frequency), this;
                }
                unsync() {
                    return this._lfoL.unsync(), this._lfoR.unsync(), this.context.transport.unsyncSignal(this.frequency), this;
                }
                get type() {
                    return this._lfoL.type;
                }
                set type(t1) {
                    this._lfoL.type = t1, this._lfoR.type = t1;
                }
                get spread() {
                    return this._lfoR.phase - this._lfoL.phase;
                }
                set spread(t1) {
                    this._lfoL.phase = 90 - t1 / 2, this._lfoR.phase = t1 / 2 + 90;
                }
                dispose() {
                    return super.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._amplitudeL.dispose(), this._amplitudeR.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class Za extends ha {
                constructor(){
                    super(ui(Za.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ])), this.name = "Vibrato";
                    const t1 = ui(Za.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ]);
                    this._delayNode = new yo({
                        context: this.context,
                        delayTime: 0,
                        maxDelay: t1.maxDelay
                    }), this._lfo = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 0,
                        max: t1.maxDelay,
                        frequency: t1.frequency,
                        phase: -90
                    }).start().connect(this._delayNode.delayTime), this.frequency = this._lfo.frequency, this.depth = this._lfo.amplitude, this.depth.value = t1.depth, Oi(this, [
                        "frequency",
                        "depth"
                    ]), this.effectSend.chain(this._delayNode, this.effectReturn);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        maxDelay: .005,
                        frequency: 5,
                        depth: .1,
                        type: "sine"
                    });
                }
                get type() {
                    return this._lfo.type;
                }
                set type(t1) {
                    this._lfo.type = t1;
                }
                dispose() {
                    return super.dispose(), this._delayNode.dispose(), this._lfo.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class Xa extends io {
                constructor(){
                    super(ui(Xa.getDefaults(), arguments, [
                        "type",
                        "size"
                    ])), this.name = "Analyser", this._analysers = [], this._buffers = [];
                    const t1 = ui(Xa.getDefaults(), arguments, [
                        "type",
                        "size"
                    ]);
                    this.input = this.output = this._gain = new ho({
                        context: this.context
                    }), this._split = new xa({
                        context: this.context,
                        channels: t1.channels
                    }), this.input.connect(this._split), Un(t1.channels, 1);
                    for(let e = 0; e < t1.channels; e++)this._analysers[e] = this.context.createAnalyser(), this._split.connect(this._analysers[e], e, 0);
                    this.size = t1.size, this.type = t1.type, this.smoothing = t1.smoothing;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        size: 1024,
                        smoothing: .8,
                        type: "fft",
                        channels: 1
                    });
                }
                getValue() {
                    return this._analysers.forEach((t1, e)=>{
                        const s1 = this._buffers[e];
                        "fft" === this._type ? t1.getFloatFrequencyData(s1) : "waveform" === this._type && t1.getFloatTimeDomainData(s1);
                    }), 1 === this.channels ? this._buffers[0] : this._buffers;
                }
                get size() {
                    return this._analysers[0].frequencyBinCount;
                }
                set size(t1) {
                    this._analysers.forEach((e, s1)=>{
                        e.fftSize = 2 * t1, this._buffers[s1] = new Float32Array(t1);
                    });
                }
                get channels() {
                    return this._analysers.length;
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    Bn("waveform" === t1 || "fft" === t1, `Analyser: invalid type: ${t1}`), this._type = t1;
                }
                get smoothing() {
                    return this._analysers[0].smoothingTimeConstant;
                }
                set smoothing(t1) {
                    this._analysers.forEach((e)=>e.smoothingTimeConstant = t1);
                }
                dispose() {
                    return super.dispose(), this._analysers.forEach((t1)=>t1.disconnect()), this._split.dispose(), this._gain.dispose(), this;
                }
            }
            class Ya extends io {
                constructor(){
                    super(ui(Ya.getDefaults(), arguments)), this.name = "MeterBase", this.input = this.output = this._analyser = new Xa({
                        context: this.context,
                        size: 256,
                        type: "waveform"
                    });
                }
                dispose() {
                    return super.dispose(), this._analyser.dispose(), this;
                }
            }
            class $a extends Ya {
                constructor(){
                    super(ui($a.getDefaults(), arguments, [
                        "smoothing"
                    ])), this.name = "Meter";
                    const t1 = ui($a.getDefaults(), arguments, [
                        "smoothing"
                    ]);
                    this.input = this.output = this._analyser = new Xa({
                        context: this.context,
                        size: 256,
                        type: "waveform",
                        channels: t1.channelCount
                    }), this.smoothing = t1.smoothing, this.normalRange = t1.normalRange, this._rms = new Array(t1.channelCount), this._rms.fill(0);
                }
                static getDefaults() {
                    return Object.assign(Ya.getDefaults(), {
                        smoothing: .8,
                        normalRange: !1,
                        channelCount: 1
                    });
                }
                getLevel() {
                    return Kn("'getLevel' has been changed to 'getValue'"), this.getValue();
                }
                getValue() {
                    const t1 = this._analyser.getValue(), e = (1 === this.channels ? [
                        t1
                    ] : t1).map((t1, e)=>{
                        const s1 = t1.reduce((t1, e)=>t1 + e * e, 0), n = Math.sqrt(s1 / t1.length);
                        return this._rms[e] = Math.max(n, this._rms[e] * this.smoothing), this.normalRange ? this._rms[e] : Li(this._rms[e]);
                    });
                    return 1 === this.channels ? e[0] : e;
                }
                get channels() {
                    return this._analyser.channels;
                }
                dispose() {
                    return super.dispose(), this._analyser.dispose(), this;
                }
            }
            class Ha extends Ya {
                constructor(){
                    super(ui(Ha.getDefaults(), arguments, [
                        "size"
                    ])), this.name = "FFT";
                    const t1 = ui(Ha.getDefaults(), arguments, [
                        "size"
                    ]);
                    this.normalRange = t1.normalRange, this._analyser.type = "fft", this.size = t1.size;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        normalRange: !1,
                        size: 1024,
                        smoothing: .8
                    });
                }
                getValue() {
                    return this._analyser.getValue().map((t1)=>this.normalRange ? ji(t1) : t1);
                }
                get size() {
                    return this._analyser.size;
                }
                set size(t1) {
                    this._analyser.size = t1;
                }
                get smoothing() {
                    return this._analyser.smoothing;
                }
                set smoothing(t1) {
                    this._analyser.smoothing = t1;
                }
                getFrequencyOfIndex(t1) {
                    return Bn(0 <= t1 && t1 < this.size, `index must be greater than or equal to 0 and less than ${this.size}`), t1 * this.context.sampleRate / (2 * this.size);
                }
            }
            class Ja extends Ya {
                constructor(){
                    super(ui(Ja.getDefaults(), arguments)), this.name = "DCMeter", this._analyser.type = "waveform", this._analyser.size = 256;
                }
                getValue() {
                    return this._analyser.getValue()[0];
                }
            }
            class Ka extends Ya {
                constructor(){
                    super(ui(Ka.getDefaults(), arguments, [
                        "size"
                    ])), this.name = "Waveform";
                    const t1 = ui(Ka.getDefaults(), arguments, [
                        "size"
                    ]);
                    this._analyser.type = "waveform", this.size = t1.size;
                }
                static getDefaults() {
                    return Object.assign(Ya.getDefaults(), {
                        size: 1024
                    });
                }
                getValue() {
                    return this._analyser.getValue();
                }
                get size() {
                    return this._analyser.size;
                }
                set size(t1) {
                    this._analyser.size = t1;
                }
            }
            class tc extends io {
                constructor(){
                    super(ui(tc.getDefaults(), arguments, [
                        "solo"
                    ])), this.name = "Solo";
                    const t1 = ui(tc.getDefaults(), arguments, [
                        "solo"
                    ]);
                    this.input = this.output = new ho({
                        context: this.context
                    }), tc._allSolos.has(this.context) || tc._allSolos.set(this.context, new Set), tc._allSolos.get(this.context).add(this), this.solo = t1.solo;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        solo: !1
                    });
                }
                get solo() {
                    return this._isSoloed();
                }
                set solo(t1) {
                    t1 ? this._addSolo() : this._removeSolo(), tc._allSolos.get(this.context).forEach((t1)=>t1._updateSolo());
                }
                get muted() {
                    return 0 === this.input.gain.value;
                }
                _addSolo() {
                    tc._soloed.has(this.context) || tc._soloed.set(this.context, new Set), tc._soloed.get(this.context).add(this);
                }
                _removeSolo() {
                    tc._soloed.has(this.context) && tc._soloed.get(this.context).delete(this);
                }
                _isSoloed() {
                    return tc._soloed.has(this.context) && tc._soloed.get(this.context).has(this);
                }
                _noSolos() {
                    return !tc._soloed.has(this.context) || tc._soloed.has(this.context) && 0 === tc._soloed.get(this.context).size;
                }
                _updateSolo() {
                    this._isSoloed() || this._noSolos() ? this.input.gain.value = 1 : this.input.gain.value = 0;
                }
                dispose() {
                    return super.dispose(), tc._allSolos.get(this.context).delete(this), this._removeSolo(), this;
                }
            }
            tc._allSolos = new Map, tc._soloed = new Map;
            class ec extends io {
                constructor(){
                    super(ui(ec.getDefaults(), arguments, [
                        "pan",
                        "volume"
                    ])), this.name = "PanVol";
                    const t1 = ui(ec.getDefaults(), arguments, [
                        "pan",
                        "volume"
                    ]);
                    this._panner = this.input = new pa({
                        context: this.context,
                        pan: t1.pan,
                        channelCount: t1.channelCount
                    }), this.pan = this._panner.pan, this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, this._panner.connect(this._volume), this.mute = t1.mute, Oi(this, [
                        "pan",
                        "volume"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        pan: 0,
                        volume: 0,
                        channelCount: 1
                    });
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                dispose() {
                    return super.dispose(), this._panner.dispose(), this.pan.dispose(), this._volume.dispose(), this.volume.dispose(), this;
                }
            }
            class sc extends io {
                constructor(){
                    super(ui(sc.getDefaults(), arguments, [
                        "volume",
                        "pan"
                    ])), this.name = "Channel";
                    const t1 = ui(sc.getDefaults(), arguments, [
                        "volume",
                        "pan"
                    ]);
                    this._solo = this.input = new tc({
                        solo: t1.solo,
                        context: this.context
                    }), this._panVol = this.output = new ec({
                        context: this.context,
                        pan: t1.pan,
                        volume: t1.volume,
                        mute: t1.mute,
                        channelCount: t1.channelCount
                    }), this.pan = this._panVol.pan, this.volume = this._panVol.volume, this._solo.connect(this._panVol), Oi(this, [
                        "pan",
                        "volume"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        pan: 0,
                        volume: 0,
                        mute: !1,
                        solo: !1,
                        channelCount: 1
                    });
                }
                get solo() {
                    return this._solo.solo;
                }
                set solo(t1) {
                    this._solo.solo = t1;
                }
                get muted() {
                    return this._solo.muted || this.mute;
                }
                get mute() {
                    return this._panVol.mute;
                }
                set mute(t1) {
                    this._panVol.mute = t1;
                }
                _getBus(t1) {
                    return sc.buses.has(t1) || sc.buses.set(t1, new ho({
                        context: this.context
                    })), sc.buses.get(t1);
                }
                send(t1, e = 0) {
                    const s1 = this._getBus(t1), n = new ho({
                        context: this.context,
                        units: "decibels",
                        gain: e
                    });
                    return this.connect(n), n.connect(s1), n;
                }
                receive(t1) {
                    return this._getBus(t1).connect(this), this;
                }
                dispose() {
                    return super.dispose(), this._panVol.dispose(), this.pan.dispose(), this.volume.dispose(), this._solo.dispose(), this;
                }
            }
            sc.buses = new Map;
            class nc extends io {
                constructor(){
                    super(ui(nc.getDefaults(), arguments)), this.name = "Mono", this.input = new ho({
                        context: this.context
                    }), this._merge = this.output = new wa({
                        channels: 2,
                        context: this.context
                    }), this.input.connect(this._merge, 0, 0), this.input.connect(this._merge, 0, 1);
                }
                dispose() {
                    return super.dispose(), this._merge.dispose(), this.input.dispose(), this;
                }
            }
            class ic extends io {
                constructor(){
                    super(ui(ic.getDefaults(), arguments, [
                        "lowFrequency",
                        "highFrequency"
                    ])), this.name = "MultibandSplit", this.input = new ho({
                        context: this.context
                    }), this.output = void 0, this.low = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "lowpass"
                    }), this._lowMidFilter = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "highpass"
                    }), this.mid = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "lowpass"
                    }), this.high = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "highpass"
                    }), this._internalChannels = [
                        this.low,
                        this.mid,
                        this.high
                    ];
                    const t1 = ui(ic.getDefaults(), arguments, [
                        "lowFrequency",
                        "highFrequency"
                    ]);
                    this.lowFrequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.lowFrequency
                    }), this.highFrequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.highFrequency
                    }), this.Q = new po({
                        context: this.context,
                        units: "positive",
                        value: t1.Q
                    }), this.input.fan(this.low, this.high), this.input.chain(this._lowMidFilter, this.mid), this.lowFrequency.fan(this.low.frequency, this._lowMidFilter.frequency), this.highFrequency.fan(this.mid.frequency, this.high.frequency), this.Q.connect(this.low.Q), this.Q.connect(this._lowMidFilter.Q), this.Q.connect(this.mid.Q), this.Q.connect(this.high.Q), Oi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        highFrequency: 2500,
                        lowFrequency: 400
                    });
                }
                dispose() {
                    return super.dispose(), Mi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]), this.low.dispose(), this._lowMidFilter.dispose(), this.mid.dispose(), this.high.dispose(), this.lowFrequency.dispose(), this.highFrequency.dispose(), this.Q.dispose(), this;
                }
            }
            class oc extends io {
                constructor(){
                    super(...arguments), this.name = "Listener", this.positionX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionX
                    }), this.positionY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionY
                    }), this.positionZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionZ
                    }), this.forwardX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardX
                    }), this.forwardY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardY
                    }), this.forwardZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardZ
                    }), this.upX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upX
                    }), this.upY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upY
                    }), this.upZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upZ
                    });
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        positionX: 0,
                        positionY: 0,
                        positionZ: 0,
                        forwardX: 0,
                        forwardY: 0,
                        forwardZ: -1,
                        upX: 0,
                        upY: 1,
                        upZ: 0
                    });
                }
                dispose() {
                    return super.dispose(), this.positionX.dispose(), this.positionY.dispose(), this.positionZ.dispose(), this.forwardX.dispose(), this.forwardY.dispose(), this.forwardZ.dispose(), this.upX.dispose(), this.upY.dispose(), this.upZ.dispose(), this;
                }
            }
            Ti((t1)=>{
                t1.listener = new oc({
                    context: t1
                });
            }), ki((t1)=>{
                t1.listener.dispose();
            });
            class rc extends io {
                constructor(){
                    super(ui(rc.getDefaults(), arguments, [
                        "positionX",
                        "positionY",
                        "positionZ"
                    ])), this.name = "Panner3D";
                    const t1 = ui(rc.getDefaults(), arguments, [
                        "positionX",
                        "positionY",
                        "positionZ"
                    ]);
                    this._panner = this.input = this.output = this.context.createPanner(), this.panningModel = t1.panningModel, this.maxDistance = t1.maxDistance, this.distanceModel = t1.distanceModel, this.coneOuterGain = t1.coneOuterGain, this.coneOuterAngle = t1.coneOuterAngle, this.coneInnerAngle = t1.coneInnerAngle, this.refDistance = t1.refDistance, this.rolloffFactor = t1.rolloffFactor, this.positionX = new no({
                        context: this.context,
                        param: this._panner.positionX,
                        value: t1.positionX
                    }), this.positionY = new no({
                        context: this.context,
                        param: this._panner.positionY,
                        value: t1.positionY
                    }), this.positionZ = new no({
                        context: this.context,
                        param: this._panner.positionZ,
                        value: t1.positionZ
                    }), this.orientationX = new no({
                        context: this.context,
                        param: this._panner.orientationX,
                        value: t1.orientationX
                    }), this.orientationY = new no({
                        context: this.context,
                        param: this._panner.orientationY,
                        value: t1.orientationY
                    }), this.orientationZ = new no({
                        context: this.context,
                        param: this._panner.orientationZ,
                        value: t1.orientationZ
                    });
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        coneInnerAngle: 360,
                        coneOuterAngle: 360,
                        coneOuterGain: 0,
                        distanceModel: "inverse",
                        maxDistance: 1e4,
                        orientationX: 0,
                        orientationY: 0,
                        orientationZ: 0,
                        panningModel: "equalpower",
                        positionX: 0,
                        positionY: 0,
                        positionZ: 0,
                        refDistance: 1,
                        rolloffFactor: 1
                    });
                }
                setPosition(t1, e, s1) {
                    return this.positionX.value = t1, this.positionY.value = e, this.positionZ.value = s1, this;
                }
                setOrientation(t1, e, s1) {
                    return this.orientationX.value = t1, this.orientationY.value = e, this.orientationZ.value = s1, this;
                }
                get panningModel() {
                    return this._panner.panningModel;
                }
                set panningModel(t1) {
                    this._panner.panningModel = t1;
                }
                get refDistance() {
                    return this._panner.refDistance;
                }
                set refDistance(t1) {
                    this._panner.refDistance = t1;
                }
                get rolloffFactor() {
                    return this._panner.rolloffFactor;
                }
                set rolloffFactor(t1) {
                    this._panner.rolloffFactor = t1;
                }
                get distanceModel() {
                    return this._panner.distanceModel;
                }
                set distanceModel(t1) {
                    this._panner.distanceModel = t1;
                }
                get coneInnerAngle() {
                    return this._panner.coneInnerAngle;
                }
                set coneInnerAngle(t1) {
                    this._panner.coneInnerAngle = t1;
                }
                get coneOuterAngle() {
                    return this._panner.coneOuterAngle;
                }
                set coneOuterAngle(t1) {
                    this._panner.coneOuterAngle = t1;
                }
                get coneOuterGain() {
                    return this._panner.coneOuterGain;
                }
                set coneOuterGain(t1) {
                    this._panner.coneOuterGain = t1;
                }
                get maxDistance() {
                    return this._panner.maxDistance;
                }
                set maxDistance(t1) {
                    this._panner.maxDistance = t1;
                }
                dispose() {
                    return super.dispose(), this._panner.disconnect(), this.orientationX.dispose(), this.orientationY.dispose(), this.orientationZ.dispose(), this.positionX.dispose(), this.positionY.dispose(), this.positionZ.dispose(), this;
                }
            }
            class ac extends io {
                constructor(){
                    super(ui(ac.getDefaults(), arguments)), this.name = "Recorder";
                    const t1 = ui(ac.getDefaults(), arguments);
                    this.input = new ho({
                        context: this.context
                    }), Bn(ac.supported, "Media Recorder API is not available"), this._stream = this.context.createMediaStreamDestination(), this.input.connect(this._stream), this._recorder = new MediaRecorder(this._stream.stream, {
                        mimeType: t1.mimeType
                    });
                }
                static getDefaults() {
                    return io.getDefaults();
                }
                get mimeType() {
                    return this._recorder.mimeType;
                }
                static get supported() {
                    return null !== ti && Reflect.has(ti, "MediaRecorder");
                }
                get state() {
                    return "inactive" === this._recorder.state ? "stopped" : "paused" === this._recorder.state ? "paused" : "started";
                }
                start() {
                    return ni(this, void 0, void 0, function*() {
                        Bn("started" !== this.state, "Recorder is already started");
                        const t1 = new Promise((t1)=>{
                            const e = ()=>{
                                this._recorder.removeEventListener("start", e, !1), t1();
                            };
                            this._recorder.addEventListener("start", e, !1);
                        });
                        return this._recorder.start(), yield t1;
                    });
                }
                stop() {
                    return ni(this, void 0, void 0, function*() {
                        Bn("stopped" !== this.state, "Recorder is not started");
                        const t1 = new Promise((t1)=>{
                            const e = (s1)=>{
                                this._recorder.removeEventListener("dataavailable", e, !1), t1(s1.data);
                            };
                            this._recorder.addEventListener("dataavailable", e, !1);
                        });
                        return this._recorder.stop(), yield t1;
                    });
                }
                pause() {
                    return Bn("started" === this.state, "Recorder must be started"), this._recorder.pause(), this;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this._stream.disconnect(), this;
                }
            }
            class cc extends io {
                constructor(){
                    super(ui(cc.getDefaults(), arguments, [
                        "threshold",
                        "ratio"
                    ])), this.name = "Compressor", this._compressor = this.context.createDynamicsCompressor(), this.input = this._compressor, this.output = this._compressor;
                    const t1 = ui(cc.getDefaults(), arguments, [
                        "threshold",
                        "ratio"
                    ]);
                    this.threshold = new no({
                        minValue: this._compressor.threshold.minValue,
                        maxValue: this._compressor.threshold.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.threshold,
                        units: "decibels",
                        value: t1.threshold
                    }), this.attack = new no({
                        minValue: this._compressor.attack.minValue,
                        maxValue: this._compressor.attack.maxValue,
                        context: this.context,
                        param: this._compressor.attack,
                        units: "time",
                        value: t1.attack
                    }), this.release = new no({
                        minValue: this._compressor.release.minValue,
                        maxValue: this._compressor.release.maxValue,
                        context: this.context,
                        param: this._compressor.release,
                        units: "time",
                        value: t1.release
                    }), this.knee = new no({
                        minValue: this._compressor.knee.minValue,
                        maxValue: this._compressor.knee.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.knee,
                        units: "decibels",
                        value: t1.knee
                    }), this.ratio = new no({
                        minValue: this._compressor.ratio.minValue,
                        maxValue: this._compressor.ratio.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.ratio,
                        units: "positive",
                        value: t1.ratio
                    }), Oi(this, [
                        "knee",
                        "release",
                        "attack",
                        "ratio",
                        "threshold"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        attack: .003,
                        knee: 30,
                        ratio: 12,
                        release: .25,
                        threshold: -24
                    });
                }
                get reduction() {
                    return this._compressor.reduction;
                }
                dispose() {
                    return super.dispose(), this._compressor.disconnect(), this.attack.dispose(), this.release.dispose(), this.threshold.dispose(), this.ratio.dispose(), this.knee.dispose(), this;
                }
            }
            class hc extends io {
                constructor(){
                    super(Object.assign(ui(hc.getDefaults(), arguments, [
                        "threshold",
                        "smoothing"
                    ]))), this.name = "Gate";
                    const t1 = ui(hc.getDefaults(), arguments, [
                        "threshold",
                        "smoothing"
                    ]);
                    this._follower = new fa({
                        context: this.context,
                        smoothing: t1.smoothing
                    }), this._gt = new gr({
                        context: this.context,
                        value: ji(t1.threshold)
                    }), this.input = new ho({
                        context: this.context
                    }), this._gate = this.output = new ho({
                        context: this.context
                    }), this.input.connect(this._gate), this.input.chain(this._follower, this._gt, this._gate.gain);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        smoothing: .1,
                        threshold: -40
                    });
                }
                get threshold() {
                    return Li(this._gt.value);
                }
                set threshold(t1) {
                    this._gt.value = ji(t1);
                }
                get smoothing() {
                    return this._follower.smoothing;
                }
                set smoothing(t1) {
                    this._follower.smoothing = t1;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this._follower.dispose(), this._gt.dispose(), this._gate.dispose(), this;
                }
            }
            class lc extends io {
                constructor(){
                    super(Object.assign(ui(lc.getDefaults(), arguments, [
                        "threshold"
                    ]))), this.name = "Limiter";
                    const t1 = ui(lc.getDefaults(), arguments, [
                        "threshold"
                    ]);
                    this._compressor = this.input = this.output = new cc({
                        context: this.context,
                        ratio: 20,
                        attack: .003,
                        release: .01,
                        threshold: t1.threshold
                    }), this.threshold = this._compressor.threshold, Oi(this, "threshold");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        threshold: -12
                    });
                }
                get reduction() {
                    return this._compressor.reduction;
                }
                dispose() {
                    return super.dispose(), this._compressor.dispose(), this.threshold.dispose(), this;
                }
            }
            class uc extends io {
                constructor(){
                    super(Object.assign(ui(uc.getDefaults(), arguments))), this.name = "MidSideCompressor";
                    const t1 = ui(uc.getDefaults(), arguments);
                    this._midSideSplit = this.input = new Wa({
                        context: this.context
                    }), this._midSideMerge = this.output = new Ba({
                        context: this.context
                    }), this.mid = new cc(Object.assign(t1.mid, {
                        context: this.context
                    })), this.side = new cc(Object.assign(t1.side, {
                        context: this.context
                    })), this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid), this._midSideSplit.side.chain(this.side, this._midSideMerge.side), Oi(this, [
                        "mid",
                        "side"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mid: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        },
                        side: {
                            ratio: 6,
                            threshold: -30,
                            release: .25,
                            attack: .03,
                            knee: 10
                        }
                    });
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._midSideSplit.dispose(), this._midSideMerge.dispose(), this;
                }
            }
            class pc extends io {
                constructor(){
                    super(Object.assign(ui(pc.getDefaults(), arguments))), this.name = "MultibandCompressor";
                    const t1 = ui(pc.getDefaults(), arguments);
                    this._splitter = this.input = new ic({
                        context: this.context,
                        lowFrequency: t1.lowFrequency,
                        highFrequency: t1.highFrequency
                    }), this.lowFrequency = this._splitter.lowFrequency, this.highFrequency = this._splitter.highFrequency, this.output = new ho({
                        context: this.context
                    }), this.low = new cc(Object.assign(t1.low, {
                        context: this.context
                    })), this.mid = new cc(Object.assign(t1.mid, {
                        context: this.context
                    })), this.high = new cc(Object.assign(t1.high, {
                        context: this.context
                    })), this._splitter.low.chain(this.low, this.output), this._splitter.mid.chain(this.mid, this.output), this._splitter.high.chain(this.high, this.output), Oi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        lowFrequency: 250,
                        highFrequency: 2e3,
                        low: {
                            ratio: 6,
                            threshold: -30,
                            release: .25,
                            attack: .03,
                            knee: 10
                        },
                        mid: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        },
                        high: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        }
                    });
                }
                dispose() {
                    return super.dispose(), this._splitter.dispose(), this.low.dispose(), this.mid.dispose(), this.high.dispose(), this.output.dispose(), this;
                }
            }
            class dc extends io {
                constructor(){
                    super(ui(dc.getDefaults(), arguments, [
                        "low",
                        "mid",
                        "high"
                    ])), this.name = "EQ3", this.output = new ho({
                        context: this.context
                    }), this._internalChannels = [];
                    const t1 = ui(dc.getDefaults(), arguments, [
                        "low",
                        "mid",
                        "high"
                    ]);
                    this.input = this._multibandSplit = new ic({
                        context: this.context,
                        highFrequency: t1.highFrequency,
                        lowFrequency: t1.lowFrequency
                    }), this._lowGain = new ho({
                        context: this.context,
                        gain: t1.low,
                        units: "decibels"
                    }), this._midGain = new ho({
                        context: this.context,
                        gain: t1.mid,
                        units: "decibels"
                    }), this._highGain = new ho({
                        context: this.context,
                        gain: t1.high,
                        units: "decibels"
                    }), this.low = this._lowGain.gain, this.mid = this._midGain.gain, this.high = this._highGain.gain, this.Q = this._multibandSplit.Q, this.lowFrequency = this._multibandSplit.lowFrequency, this.highFrequency = this._multibandSplit.highFrequency, this._multibandSplit.low.chain(this._lowGain, this.output), this._multibandSplit.mid.chain(this._midGain, this.output), this._multibandSplit.high.chain(this._highGain, this.output), Oi(this, [
                        "low",
                        "mid",
                        "high",
                        "lowFrequency",
                        "highFrequency"
                    ]), this._internalChannels = [
                        this._multibandSplit
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        high: 0,
                        highFrequency: 2500,
                        low: 0,
                        lowFrequency: 400,
                        mid: 0
                    });
                }
                dispose() {
                    return super.dispose(), Mi(this, [
                        "low",
                        "mid",
                        "high",
                        "lowFrequency",
                        "highFrequency"
                    ]), this._multibandSplit.dispose(), this.lowFrequency.dispose(), this.highFrequency.dispose(), this._lowGain.dispose(), this._midGain.dispose(), this._highGain.dispose(), this.low.dispose(), this.mid.dispose(), this.high.dispose(), this.Q.dispose(), this;
                }
            }
            class fc extends io {
                constructor(){
                    super(ui(fc.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "Convolver", this._convolver = this.context.createConvolver();
                    const t1 = ui(fc.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this._buffer = new Ri(t1.url, (e)=>{
                        this.buffer = e, t1.onload();
                    }), this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._buffer.loaded && (this.buffer = this._buffer), this.normalize = t1.normalize, this.input.chain(this._convolver, this.output);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        normalize: !0,
                        onload: Ei
                    });
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        this.buffer = yield this._buffer.load(t1);
                    });
                }
                get buffer() {
                    return this._buffer.length ? this._buffer : null;
                }
                set buffer(t1) {
                    t1 && this._buffer.set(t1), this._convolver.buffer && (this.input.disconnect(), this._convolver.disconnect(), this._convolver = this.context.createConvolver(), this.input.chain(this._convolver, this.output));
                    const e = this._buffer.get();
                    this._convolver.buffer = e || null;
                }
                get normalize() {
                    return this._convolver.normalize;
                }
                set normalize(t1) {
                    this._convolver.normalize = t1;
                }
                dispose() {
                    return super.dispose(), this._buffer.dispose(), this._convolver.disconnect(), this;
                }
            }
            function _c() {
                return Vi().now();
            }
            function mc() {
                return Vi().immediate();
            }
            const gc = Vi().transport;
            function vc() {
                return Vi().transport;
            }
            const yc = Vi().destination, xc = Vi().destination;
            function wc() {
                return Vi().destination;
            }
            const bc = Vi().listener;
            function Tc() {
                return Vi().listener;
            }
            const Sc = Vi().draw;
            function kc() {
                return Vi().draw;
            }
            const Ac = Vi();
            function Cc() {
                return Ri.loaded();
            }
            const Dc = Ri, Oc = wo, Mc = jo;
        })(), n;
    })());


class $45747524b18cbcbc$export$2e2bcd8739ae039 {
    constructor({ engine: engine, type: type }){
        this.type = type || "default";
        this.zindex = 0;
        this.engine = engine;
        this.engine.entities.push(this);
    }
    update() {}
    render(ctx) {}
}


class $138b36ed328bed3a$export$2e2bcd8739ae039 {
    constructor({ x: x, y: y, w: w, h: h }){
        this.set({
            x: x,
            y: y,
            w: w,
            h: h
        });
    }
    set({ x: x, y: y, w: w, h: h }) {
        this.x = x - w / 2;
        this.y = y - h / 2;
        this.w = w;
        this.h = h;
    }
    overlaps(other) {
        if (this.x >= other.x + other.w || other.x >= this.x + this.w) return false;
        if (this.y >= other.y + other.h || other.y >= this.y + this.h) return false;
        return true;
    }
    debug(ctx) {
        ctx.strokeStyle = "green";
        ctx.strokeRect(this.x, this.y, this.w, this.h);
    }
}



class $1c84fda684ccfcbe$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, position: position, size: size }){
        super({
            engine: engine,
            type: "fx"
        });
        this.position = {
            ...position
        };
        this.score = score || 0;
        this.size = size || 100;
        this.explosionScale = 0;
        this.lifetime = 0.1;
    }
    update() {
        this.explosionScale += this.engine.time.delta;
        this.lifetime -= this.engine.time.delta;
        if (this.lifetime <= 0) this.engine.destroyEntity(this);
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.shadowColor = "yellow";
        ctx.shadowBlur = this.size * 0.5 * s;
        ctx.fillStyle = "yellow";
        ctx.beginPath();
        ctx.arc(0, 0, this.explosionScale * this.size * s, 2 * Math.PI, false);
        ctx.fill();
        ctx.fill();
        ctx.fill();
        ctx.restore();
    }
}


class $e71c549b974bb53f$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, note: note }){
        super({
            engine: engine,
            type: "note"
        });
        this.instrument = "guitar";
        this.note = note;
        this.speed = 500;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: this.note.midi / 128 * this.engine.height + Math.sin(this.note.time * Math.PI * 0.5) * 300 + 100
        };
        this.position = {
            x: this.startPosition.x,
            y: this.startPosition.y
        };
        this.playing = false;
        this.timer = 0;
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 30,
            h: 30
        });
    }
    update() {
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.position.x = this.engine.width + this.note.time * this.speed * s - this.timer * this.speed * s;
        this.scale = (this.timer - this.note.time) / this.note.duration;
        if (this.scale < 0) this.scale = 0;
        if (this.scale > 1) this.scale = 1;
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        let h = 8 * s;
        let noseL = 20 * s;
        if (this.position.x > this.engine.width || this.position.x < -w) return;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        const gradient = ctx.createLinearGradient(0, -h / 2, w * this.scale, h);
        if (this.playing) {
            gradient.addColorStop(0, 'rgba(255,0,0,1)');
            gradient.addColorStop(0.3, 'rgba(255,0,0,0.5)');
            gradient.addColorStop(1, 'rgba(255,0,0,0)');
        } else {
            gradient.addColorStop(0, 'rgba(255,255,255,1)');
            gradient.addColorStop(0.3, 'rgba(255,255,255,0.5)');
            gradient.addColorStop(1, 'rgba(255,255,255,0)');
        }
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(noseL, -h / 2);
        ctx.lineTo(w * this.scale - 5, -h / 2);
        ctx.lineTo(w * this.scale - 5, h / 2);
        ctx.lineTo(noseL, h / 2);
        ctx.fill();
        ctx.restore();
        this.hitbox.set({
            x: this.position.x + w / 2,
            y: this.position.y,
            w: w,
            h: h
        });
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
    kill() {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if (this.position.x < this.engine.width && this.position.x > -w) new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
}





class $9379e936737b4e5b$export$2e2bcd8739ae039 {
    constructor(url){
        this.img = new Image();
        this.ratio = 1;
        this.ready = false;
        this.img.onload = ()=>{
            this.ready = true;
            this.ratio = this.img.height / this.img.width;
        };
        this.img.src = url;
    }
    draw(ctx, w) {
        let h = w * this.ratio;
        ctx.drawImage(this.img, -w / 2, -h / 2, w, h);
    }
}


var $a5c1d88f9c0e11ef$exports = {};
$a5c1d88f9c0e11ef$exports = import.meta.resolve("27W48");



class $8b5386c30272d04a$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, note: note }){
        super({
            engine: engine,
            type: "note"
        });
        this.note = note;
        this.instrument = "battery";
        this.speed = 700;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: this.note.midi / 128 * this.engine.height + Math.sin(this.note.time * Math.PI * 0.7) * 300 + 100
        };
        this.position = {
            x: this.startPosition.x,
            y: this.startPosition.y
        };
        this.playing = false;
        this.timer = 0;
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 30,
            h: 30
        });
        this.texture = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($a5c1d88f9c0e11ef$exports))));
    }
    update() {
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.started = this.timer >= this.note.time && this.timer <= this.note.time + 0.1;
        this.position.x = this.engine.width + this.note.time * this.speed * s - this.timer * this.speed * s;
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        const w = (20 + 50 * this.note.duration) * s;
        if (this.position.x > this.engine.width || this.position.x < -w) return;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        if (this.texture.ready) this.texture.draw(ctx, w);
        ctx.restore();
        this.hitbox.set({
            ...this.position,
            w: w * .5,
            h: w * .5
        });
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
    kill() {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if (this.position.x < this.engine.width && this.position.x > -w) new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
}






var $7489b065baeef507$exports = {};
$7489b065baeef507$exports = import.meta.resolve("3Itwk");



class $ea8558dc84994a44$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, note: note }){
        super({
            engine: engine,
            type: "note"
        });
        this.note = note;
        this.speed = 1000;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: this.note.midi / 128 * this.engine.height + Math.sin(this.note.time * Math.PI * 0.7) * 300 + 100
        };
        this.position = {
            x: this.startPosition.x,
            y: this.startPosition.y
        };
        this.playing = false;
        this.timer = 0;
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 30,
            h: 30
        });
        this.startRotation = Math.PI * 2 * Math.random();
        this.texture = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7489b065baeef507$exports))));
    }
    update() {
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.position.x = this.engine.width + this.note.time * this.speed * s - this.timer * this.speed * s;
        this.scale = (this.timer - this.note.time) / this.note.duration;
        if (this.scale < 0) this.scale = 0;
        if (this.scale > 1) this.scale = 1;
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        const w = 100 * this.note.duration * this.scale * s;
        if (this.position.x > this.engine.width || this.position.x < -w) return;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.rotate(this.startRotation + this.engine.time.time);
        if (this.texture.ready) this.texture.draw(ctx, w);
        ctx.restore();
        this.hitbox.set({
            ...this.position,
            w: w * 0.5,
            h: w * 0.5
        });
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
    kill() {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if (this.position.x < this.engine.width && this.position.x > -w) new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
}






class $80805233e646f193$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, note: note }){
        super({
            engine: engine,
            type: "note"
        });
        this.note = note;
        this.speed = 1500;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: this.note.midi / 128 * this.engine.height + Math.sin(this.note.time * Math.PI * 0.5) * 300 + 100
        };
        this.position = {
            x: this.startPosition.x,
            y: this.startPosition.y
        };
        this.playing = false;
        this.timer = 0;
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 30,
            h: 30
        });
    }
    update() {
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.position.x = this.engine.width + this.note.time * this.speed * s - this.timer * this.speed * s;
        this.scale = (this.timer - this.note.time) / this.note.duration;
        if (this.scale < 0) this.scale = 0;
        if (this.scale > 1) this.scale = 1;
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        let h = 30 * s;
        if (this.position.x > this.engine.width || this.position.x < -w) return;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        //gradient
        let gradient = ctx.createLinearGradient(0, -h / 2, w * this.scale, h);
        if (this.playing) {
            gradient.addColorStop(0, 'rgba(255,0,0,0.15)');
            gradient.addColorStop(1, 'rgba(255,0,0,0)');
        } else {
            gradient.addColorStop(0, 'rgba(255,255,255,0.15)');
            gradient.addColorStop(1, 'rgba(255,255,255,0)');
        }
        ctx.fillStyle = gradient;
        //trail
        ctx.beginPath();
        ctx.lineTo(h / 2, h / 2);
        ctx.lineTo(h / 2, -h / 2);
        ctx.lineTo(w * this.scale, 0);
        ctx.fill();
        //circle
        ctx.fillStyle = this.playing ? "red" : "white";
        ctx.beginPath();
        ctx.arc(h / 2, 0, h / 2, 2 * Math.PI, false);
        ctx.fill();
        ctx.restore();
        this.hitbox.set({
            x: this.position.x + h / 2,
            y: this.position.y,
            w: h,
            h: h
        });
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
    kill() {
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if (this.position.x < this.engine.width && this.position.x > -w) new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
}



const $3f3c57753de1ef73$var$synths = [];
function $3f3c57753de1ef73$export$2e2bcd8739ae039({ engine: engine, midi: midi, delay: delay, playsound: playsound }) {
    while($3f3c57753de1ef73$var$synths.length){
        const synth = $3f3c57753de1ef73$var$synths.shift();
        synth.disconnect();
    }
    if (midi) {
        let index = 0;
        midi.tracks.forEach((track)=>{
            let synth = null;
            if (playsound) {
                //create a synth for each track
                synth = new $79372d29045e1680$exports.PolySynth($79372d29045e1680$exports.Synth, {
                    envelope: {
                        attack: 0.02,
                        decay: 0.1,
                        sustain: 0.3,
                        release: 1
                    }
                }).toDestination();
                $3f3c57753de1ef73$var$synths.push(synth);
            }
            //schedule all of the events
            track.notes.forEach((note)=>{
                note.time += delay;
                if (playsound) synth.triggerAttackRelease(note.name, note.duration, note.time + $79372d29045e1680$exports.now(), note.velocity);
                //create notes entities based on the midi track index
                switch(index){
                    case 3:
                        new (0, $80805233e646f193$export$2e2bcd8739ae039)({
                            engine: engine,
                            note: note
                        });
                        break;
                    case 4:
                        new (0, $8b5386c30272d04a$export$2e2bcd8739ae039)({
                            engine: engine,
                            note: note
                        });
                        break;
                    case 5:
                        new (0, $ea8558dc84994a44$export$2e2bcd8739ae039)({
                            engine: engine,
                            note: note
                        });
                        break;
                    default:
                        new (0, $e71c549b974bb53f$export$2e2bcd8739ae039)({
                            engine: engine,
                            note: note,
                            track: index
                        });
                        break;
                }
            });
            index++;
        });
    }
}


function $ae5894d785e164d6$var$loadTexture(gl, url) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Du fait que les images doivent être téléchargées depuis l'internet,
    // il peut s'écouler un certain temps avant qu'elles ne soient prêtes.
    // Jusque là, mettre un seul pixel dans la texture, de sorte que nous puissions
    // l'utiliser immédiatement. Quand le téléchargement de la page sera terminé,
    // nous mettrons à jour la texture avec le contenu de l'image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        0,
        255,
        255
    ]); // bleu opaque
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = function() {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        // WebGL1 a des spécifications différentes pour les images puissances de 2
        // par rapport aux images non puissances de 2 ; aussi vérifier si l'image est une
        // puissance de 2 sur chacune de ses dimensions.
        if ($ae5894d785e164d6$var$isPowerOf2(image.width) && $ae5894d785e164d6$var$isPowerOf2(image.height)) // Oui, c'est une puissance de 2. Générer les mips.
        gl.generateMipmap(gl.TEXTURE_2D);
        else {
            // Non, ce n'est pas une puissance de 2. Désactiver les mips et définir l'habillage
            // comme "accrocher au bord"
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
    };
    image.src = url;
    return texture;
}
function $ae5894d785e164d6$var$isPowerOf2(value) {
    return (value & value - 1) == 0;
}
var $ae5894d785e164d6$export$2e2bcd8739ae039 = $ae5894d785e164d6$var$loadTexture;


var $e2a21789f44b6886$exports = {};
$e2a21789f44b6886$exports = import.meta.resolve("jrTfb");


var $8a9fa6970a4348a8$exports = {};
$8a9fa6970a4348a8$exports = import.meta.resolve("hUg9v");


var $63ad87ffbecd606a$exports = {};
$63ad87ffbecd606a$exports = import.meta.resolve("ir3mg");


var $f4a12e8f46a0ba0d$exports = {};
$f4a12e8f46a0ba0d$exports = "#define GLSLIFY 1\nvarying highp vec2 v_texturecoord;\n\nuniform vec2 u_resolution;\nuniform float u_time;\nuniform float u_damage;\nuniform sampler2D u_sampler;\nuniform sampler2D u_gradient;\nuniform sampler2D u_stars;\nuniform vec2 u_boss_position;\nuniform float u_music_intensity;\n\nfloat rand(vec2 n) { \n\treturn fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }\n\nfloat snoise(vec2 v){\n  const vec4 C = vec4(0.211324865405187, 0.366025403784439,\n           -0.577350269189626, 0.024390243902439);\n  vec2 i  = floor(v + dot(v, C.yy) );\n  vec2 x0 = v -   i + dot(i, C.xx);\n  vec2 i1;\n  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);\n  vec4 x12 = x0.xyxy + C.xxzz;\n  x12.xy -= i1;\n  i = mod(i, 289.0);\n  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))\n  + i.x + vec3(0.0, i1.x, 1.0 ));\n  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),\n    dot(x12.zw,x12.zw)), 0.0);\n  m = m*m ;\n  m = m*m ;\n  vec3 x = 2.0 * fract(p * C.www) - 1.0;\n  vec3 h = abs(x) - 0.5;\n  vec3 ox = floor(x + 0.5);\n  vec3 a0 = x - ox;\n  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );\n  vec3 g;\n  g.x  = a0.x  * x0.x  + h.x  * x0.y;\n  g.yz = a0.yz * x12.xz + h.yz * x12.yw;\n  return 130.0 * dot(m, g);\n}\n\nfloat czm_luminance(vec3 rgb)\n{\n    // Algorithm from Chapter 10 of Graphics Shaders.\n    const vec3 W = vec3(0.2125, 0.7154, 0.0721);\n    return dot(rgb, W);\n}\n\nvec4 fluid(vec2 uv){\n  //vec4 color = vec4(fract(uv.y * 10.),0,0,1.0);\n  float n = (snoise(uv * vec2(0.7,1.5)  + vec2(u_time, .0) * .1) + snoise(uv * vec2(0.5,3.) + vec2(u_time, .0) * .05)) * 2.;\n  float up = smoothstep(0.,0.1,n);\n  float down = smoothstep(0.6,0.4,n);\n  vec4 color = texture2D(u_gradient,uv + n) * up * down;\n  float l = czm_luminance(color.rgb) * 0.5;\n  vec3 d = mix(vec3(l),color.rgb, 0.);\n  return vec4(d,1.0);\n}\n\nvoid main(void) {\n  vec2 pixel = (gl_FragCoord.xy / u_resolution.x);\n  vec2 ratio = vec2(1. ,u_resolution.y / u_resolution.x);\n  vec2 uv = v_texturecoord;\n\n  vec4 color = texture2D(u_sampler, uv);\n\n  float dist = distance((uv - vec2(0.5)) * ratio + vec2(0.5), (u_boss_position - vec2(0.5)) * ratio + vec2(0.5));\n  float ripple = fract(dist * 5. - u_time * 60./117. * 4.);\n  float r = 0.8;\n  float s = 0.1;\n  float w = 0.1;\n  ripple = smoothstep(r + w, r + w + s,ripple) + (1.-smoothstep(r, r + s,ripple));\n  float rs = .05 * smoothstep(0.6, 0.,dist) * u_music_intensity;\n  ripple = ripple * rs + (1. - rs); \n  uv *= ripple;\n\n  vec4 cloud = fluid(uv);\n\n  vec4 stars1 = texture2D(u_stars, fract(uv * ratio * 3. + vec2(u_time * 0.1,0)));\n  vec4 stars2 = texture2D(u_stars, fract(uv * ratio  * 5. + vec2(u_time * 0.1,0))) * 0.5;\n\n  vec4 stars = (stars1 + stars2) * 0.6;\n  vec4 bg = mix(stars, cloud, clamp(cloud * 3.,0.,1.));\n\n  vec4 final = mix(bg, color, color.a);\n  gl_FragColor = final;\n}\n";


var $e23455acf6b14ade$exports = {};
$e23455acf6b14ade$exports = "#define GLSLIFY 1\nvarying highp vec2 v_texturecoord;\n\nuniform vec2 u_resolution;\nuniform float u_time;\nuniform sampler2D u_sampler;\nuniform sampler2D u_windowsTex;\nuniform float u_damage;\nuniform float u_music_volume;\nuniform float u_deathtransition;\n\nfloat rand(vec2 n) { \n\treturn fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);\n}\n\nvec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }\n\nfloat snoise(vec2 v){\n  const vec4 C = vec4(0.211324865405187, 0.366025403784439,\n           -0.577350269189626, 0.024390243902439);\n  vec2 i  = floor(v + dot(v, C.yy) );\n  vec2 x0 = v -   i + dot(i, C.xx);\n  vec2 i1;\n  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);\n  vec4 x12 = x0.xyxy + C.xxzz;\n  x12.xy -= i1;\n  i = mod(i, 289.0);\n  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))\n  + i.x + vec3(0.0, i1.x, 1.0 ));\n  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),\n    dot(x12.zw,x12.zw)), 0.0);\n  m = m*m ;\n  m = m*m ;\n  vec3 x = 2.0 * fract(p * C.www) - 1.0;\n  vec3 h = abs(x) - 0.5;\n  vec3 ox = floor(x + 0.5);\n  vec3 a0 = x - ox;\n  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );\n  vec3 g;\n  g.x  = a0.x  * x0.x  + h.x  * x0.y;\n  g.yz = a0.yz * x12.xz + h.yz * x12.yw;\n  return 130.0 * dot(m, g);\n}\n\nfloat czm_luminance(vec3 rgb)\n{\n    // Algorithm from Chapter 10 of Graphics Shaders.\n    const vec3 W = vec3(0.2125, 0.7154, 0.0721);\n    return dot(rgb, W);\n}\n\nvec2 uvglitch(vec2 uv, float offset){\n  vec2 guv = uv;\n  guv.x += snoise(vec2(floor(u_time * 10. + uv.y * 10. + offset))) * 0.01 * u_damage;\n  guv.y += snoise(vec2(floor(u_time * 10. + uv.x * 10. + 1000. + offset))) * 0.01 * u_damage;\n  return guv;\n}\n\nvec4 chromaticAberation(vec2 uv, sampler2D tex){\n  vec2 dir = (uv - 0.5) * vec2(1.0, 1.0);\n  float radius = length(dir);\n\n  float aberation = 0.2 * u_music_volume;\n\n  vec2 uvR = fract((uvglitch(uv,0.) - dir * radius * aberation * 1.2 - 0.5) + 0.5);\n  vec2 uvG = fract((uvglitch(uv,10.) - dir * radius * aberation * 1.1 - 0.5) + 0.5);\n  vec2 uvB = fract((uvglitch(uv,20.) - dir * radius * aberation - 0.5) + 0.5);\n\n  vec4 R = texture2D(tex, uvR);\n  vec4 G = texture2D(tex, uvG);\n  vec4 B = texture2D(tex, uvB);\n\n  vec4 color = vec4(R.r,G.g,B.b,R.a + B.a + G.a);\n  return color;\n}\n\nvoid main(void) {\n  vec2 pixel = (gl_FragCoord.xy / u_resolution.x);\n  vec2 ratio = vec2(1. ,u_resolution.y / u_resolution.x);\n  vec2 uv = v_texturecoord;\n  uv.y = 1. - uv.y;\n\n  float vibrato = 5.; \n  float shake = 0.01;\n  uv += vec2(snoise(vec2(u_time) * vibrato), snoise(vec2(u_time + 1000.) * vibrato)) * shake * u_damage;\n\n  vec4 chroma = chromaticAberation(uv, u_sampler);\n\n  float noise = rand(fract(uv + u_time));\n  float rnoise = noise * 0.1 + noise * czm_luminance(chroma.rgb) * 0.9;\n\n  vec4 windows = chromaticAberation(v_texturecoord, u_windowsTex);\n  float wnoise = noise * 0.01 + noise * czm_luminance(windows.rgb) * 0.5;\n\n  vec4 render = chroma + rnoise;\n  vec4 final = mix(render, windows + wnoise, u_deathtransition);\n\n  gl_FragColor = final;\n}\n";


class $2f8b41d5f89752ba$export$2e2bcd8739ae039 {
    constructor({ engine: engine }){
        this.outCanvas = document.createElement("canvas");
        this.ctx = this.outCanvas.getContext('2d');
    }
    resize(w, h) {
        this.outCanvas.width = w;
        this.outCanvas.height = h;
    }
    setPixelated(value) {
        this.ctx['imageSmoothingEnabled'] = value;
        this.ctx['mozImageSmoothingEnabled'] = value;
        this.ctx['oImageSmoothingEnabled'] = value;
        this.ctx['webkitImageSmoothingEnabled'] = value;
        this.ctx['msImageSmoothingEnabled'] = value;
    }
    render(entities) {
        this.ctx.clearRect(0, 0, this.outCanvas.width, this.outCanvas.height);
        entities.forEach((e)=>e.render(this.ctx));
    }
}


class $0d7f8bb4178555e9$export$2e2bcd8739ae039 {
    constructor(gl, { vertexShader: vertexShader, fragmentShader: fragmentShader, uniforms: uniforms }){
        this.gl = gl;
        this.compile({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            uniforms: uniforms
        });
    }
    compile({ vertexShader: vertexShader, fragmentShader: fragmentShader, uniforms: uniforms }) {
        let compiledVertexShader = $0d7f8bb4178555e9$var$createShader(this.gl, vertexShader, this.gl.VERTEX_SHADER);
        let compiledFragmentShader = $0d7f8bb4178555e9$var$createShader(this.gl, $0d7f8bb4178555e9$var$fragmentPrecision + fragmentShader, this.gl.FRAGMENT_SHADER);
        if (compiledVertexShader.status && compiledFragmentShader.status) {
            this.program = this.gl.createProgram();
            this.rawVertexShader = vertexShader;
            this.rawFragmentShader = fragmentShader;
            this.rawUniforms = uniforms;
            this.vertexShader = compiledVertexShader.shader;
            this.fragmentShader = compiledFragmentShader.shader;
            this.gl.attachShader(this.program, this.vertexShader);
            this.gl.attachShader(this.program, this.fragmentShader);
            this.gl.linkProgram(this.program);
            this.attributes = {
                vertexPosition: this.gl.getAttribLocation(this.program, 'a_position'),
                textureCoord: this.gl.getAttribLocation(this.program, 'a_textureCord')
            };
            this.uniforms = {};
            let textureUnit = 0;
            Object.entries(uniforms).forEach(([key, value])=>{
                this.uniforms[key] = new $0d7f8bb4178555e9$var$Uniform(this.gl, this.program, value);
                if (this.uniforms[key].type == "t") {
                    this.uniforms[key].textureUnit = textureUnit;
                    textureUnit++;
                }
            });
        }
        return {
            fragment: compiledFragmentShader,
            vertex: compiledVertexShader
        };
    }
    updateFragmentShader(fragmentShader) {
        return this.compile({
            vertexShader: this.rawVertexShader,
            fragmentShader: fragmentShader,
            uniforms: this.rawUniforms
        });
    }
    resetUniforms() {}
    use() {
        if (this.program) {
            this.gl.useProgram(this.program);
            Object.values(this.uniforms).forEach((uniform)=>uniform.apply());
        }
    }
}
class $0d7f8bb4178555e9$var$Uniform {
    constructor(gl, program, { name: name, type: type, size: size, value: value }){
        this.gl = gl;
        this.program = program;
        this.location = this.gl.getUniformLocation(program, name);
        this.name = name;
        this.type = type;
        this.size = size;
        this.value = value;
        this.textureUnit = -1;
    }
    apply() {
        if (this.value != null) switch(this.type){
            case "f":
                return this.applyVector();
            case "t":
                return this.applyTexture();
            case "m":
                return this.applyMatrix();
            default:
                throw "Unknow uniform type";
        }
    }
    applyVector() {
        const value = this.value.length ? this.value : [
            this.value
        ];
        this.gl[`uniform${this.size}f`](this.location, ...value);
    }
    applyTexture() {
        if (this.value) {
            this.gl.activeTexture(this.gl.TEXTURE0 + this.textureUnit);
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.value);
            this.gl.uniform1i(this.location, this.textureUnit);
        }
    }
    applyMatrix() {
        this.gl[`uniformMatrix${this.size}fv`](this.location, false, this.value);
    }
}
const $0d7f8bb4178555e9$var$createShader = (gl, sourceCode, type)=>{
    // Compiles either a shader of type gl.VERTEX_SHADER or gl.FRAGMENT_SHADER
    var shader = gl.createShader(type);
    gl.shaderSource(shader, sourceCode);
    gl.compileShader(shader);
    let res = {
        log: gl.getShaderInfoLog(shader).slice(0, -1),
        status: gl.getShaderParameter(shader, gl.COMPILE_STATUS),
        shader: shader
    };
    return res;
};
const $0d7f8bb4178555e9$var$fragmentPrecision = `
#ifdef GL_ES
  precision mediump float;
#endif
`;


var $7b900938c5b5128b$exports = {};
$7b900938c5b5128b$exports = "#define GLSLIFY 1\nattribute vec2 a_position;\n\nvarying highp vec2 v_texturecoord;\n\nconst vec2 scale = vec2(0.5, 0.5);\n\nvoid main(void) {\n  v_texturecoord  = (a_position * scale + scale);\n  v_texturecoord.y = 1.0 - v_texturecoord.y;\n  gl_Position = vec4(a_position, 0, 1);\n}\n";


class $07aee7aada81d157$export$2e2bcd8739ae039 {
    constructor({ gl: gl, geometry: geometry, fragment: fragment, uniforms: uniforms }){
        this.gl = gl;
        this.geometry = geometry;
        this.material = new (0, $0d7f8bb4178555e9$export$2e2bcd8739ae039)(this.gl, {
            vertexShader: (0, (/*@__PURE__*/$parcel$interopDefault($7b900938c5b5128b$exports))),
            fragmentShader: fragment,
            uniforms: {
                resolution: {
                    name: "u_resolution",
                    type: "f",
                    size: 2
                },
                time: {
                    name: "u_time",
                    type: "f",
                    size: 1
                },
                sampler: {
                    name: "u_sampler",
                    type: "t"
                },
                ...uniforms
            }
        });
        this.createFramebuffer(this.gl);
    }
    resize(w, h) {
        const gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    }
    createFramebuffer(gl, w, h) {
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        this.framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);
    }
    render(final) {
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, final ? null : this.framebuffer);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.geometry);
        this.gl.enableVertexAttribArray(this.material.attributes.vertexPosition);
        this.gl.vertexAttribPointer(this.material.attributes.vertexPosition, 2, this.gl.FLOAT, false, 0, 0);
        this.material.use();
        this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4);
    }
}


function $fa1b1b331abf5115$var$createTexture(gl, canvas) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.bindTexture(gl.TEXTURE_2D, null);
    return texture;
}
function $fa1b1b331abf5115$var$updateTexture(gl, texture, canvas) {
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
    gl.bindTexture(gl.TEXTURE_2D, null);
}
class $fa1b1b331abf5115$export$8a2415f691305ab {
    constructor({ gl: gl, canvas: canvas }){
        this.gl = gl;
        this.canvas = canvas;
        this.texture = $fa1b1b331abf5115$var$createTexture(this.gl, this.canvas);
    }
    update() {
        $fa1b1b331abf5115$var$updateTexture(this.gl, this.texture, this.canvas);
    }
}


function $85c071251c00cae7$export$2e2bcd8739ae039(gl) {
    // Create and initialize buffer
    const geometryBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, geometryBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        1.0,
        -1,
        -1,
        1.0,
        1.0,
        1.0
    ]), gl.STATIC_DRAW);
    return geometryBuffer;
}


class $0531a6e328bdea8f$export$2e2bcd8739ae039 {
    constructor({ engine: engine, inCanvas: inCanvas, passes: passes }){
        this.outCanvas = document.createElement("canvas");
        this.gl = this.outCanvas.getContext('webgl');
        this.inCanvas = inCanvas;
        this.engine = engine;
        this.geometry = (0, $85c071251c00cae7$export$2e2bcd8739ae039)(this.gl);
        this.canvasbuffer = new (0, $fa1b1b331abf5115$export$8a2415f691305ab)({
            gl: this.gl,
            canvas: this.inCanvas
        });
        this.passes = [];
        for(let i = 0; i < passes.length; i++){
            const pass = new (0, $07aee7aada81d157$export$2e2bcd8739ae039)({
                gl: this.gl,
                geometry: this.geometry,
                fragment: passes[i].fragment,
                uniforms: passes[i].uniforms
            });
            pass.material.uniforms.sampler.value = i == 0 ? this.canvasbuffer.texture : this.passes[i - 1].texture;
            //pass.material.uniforms.sampler.value = this.canvasbuffer.texture;
            this.passes.push(pass);
        }
    }
    resize(w, h) {
        this.gl.canvas.width = w;
        this.gl.canvas.height = h;
        for(let i = 0; i < this.passes.length; i++)this.passes[i].resize(w, h);
        this.gl.viewport(0, 0, this.gl.canvas.width, this.gl.canvas.height);
    }
    render() {
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
        this.canvasbuffer.update();
        for(let i = 0; i < this.passes.length; i++){
            this.passes[i].material.uniforms.resolution.value = [
                this.gl.canvas.width,
                this.gl.canvas.height
            ];
            this.passes[i].material.uniforms.time.value = this.engine.time.time;
            this.passes[i].render(i == this.passes.length - 1);
        }
    }
}


/**
 * @author mrdoob / http://mrdoob.com/
 */ var $2a4ce4393771bd6a$var$Stats = function() {
    var mode = 0;
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
    container.addEventListener('click', function(event) {
        event.preventDefault();
        showPanel(++mode % container.children.length);
    }, false);
    //
    function addPanel(panel) {
        container.appendChild(panel.dom);
        return panel;
    }
    function showPanel(id) {
        for(var i = 0; i < container.children.length; i++)container.children[i].style.display = i === id ? 'block' : 'none';
        mode = id;
    }
    //
    var beginTime = (performance || Date).now(), prevTime = beginTime, frames = 0;
    var fpsPanel = addPanel(new $2a4ce4393771bd6a$var$Stats.Panel('FPS', '#0ff', '#002'));
    var msPanel = addPanel(new $2a4ce4393771bd6a$var$Stats.Panel('MS', '#0f0', '#020'));
    if (self.performance && self.performance.memory) var memPanel = addPanel(new $2a4ce4393771bd6a$var$Stats.Panel('MB', '#f08', '#201'));
    showPanel(0);
    return {
        REVISION: 16,
        dom: container,
        addPanel: addPanel,
        showPanel: showPanel,
        begin: function() {
            beginTime = (performance || Date).now();
        },
        end: function() {
            frames++;
            var time = (performance || Date).now();
            msPanel.update(time - beginTime, 200);
            if (time >= prevTime + 1000) {
                fpsPanel.update(frames * 1000 / (time - prevTime), 100);
                prevTime = time;
                frames = 0;
                if (memPanel) {
                    var memory = performance.memory;
                    memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
                }
            }
            return time;
        },
        update: function() {
            beginTime = this.end();
        },
        // Backwards Compatibility
        domElement: container,
        setMode: showPanel
    };
};
$2a4ce4393771bd6a$var$Stats.Panel = function(name, fg, bg) {
    var min = Infinity, max = 0, round = Math.round;
    var PR = round(window.devicePixelRatio || 1);
    var WIDTH = 80 * PR, HEIGHT = 48 * PR, TEXT_X = 3 * PR, TEXT_Y = 2 * PR, GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR, GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;
    var canvas = document.createElement('canvas');
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = 'width:80px;height:48px';
    var context = canvas.getContext('2d');
    context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
    context.textBaseline = 'top';
    context.fillStyle = bg;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = fg;
    context.fillText(name, TEXT_X, TEXT_Y);
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    context.fillStyle = bg;
    context.globalAlpha = 0.9;
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    return {
        dom: canvas,
        update: function(value, maxValue) {
            min = Math.min(min, value);
            max = Math.max(max, value);
            context.fillStyle = bg;
            context.globalAlpha = 1;
            context.fillRect(0, 0, WIDTH, GRAPH_Y);
            context.fillStyle = fg;
            context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);
            context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
            context.fillStyle = bg;
            context.globalAlpha = 0.9;
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
        }
    };
};
var $2a4ce4393771bd6a$export$2e2bcd8739ae039 = $2a4ce4393771bd6a$var$Stats;


class $76c47054cd4b5e74$export$2e2bcd8739ae039 {
    constructor(id, passes){
        this.stats = new (0, $2a4ce4393771bd6a$export$2e2bcd8739ae039)();
        this.stats.showPanel(0);
        //document.body.appendChild( this.stats.dom );
        this.c2Drenderer = new (0, $2f8b41d5f89752ba$export$2e2bcd8739ae039)({
            engine: this
        });
        this.renderer = new (0, $0531a6e328bdea8f$export$2e2bcd8739ae039)({
            engine: this,
            inCanvas: this.c2Drenderer.outCanvas,
            passes: passes
        });
        document.getElementById("game").append(this.renderer.outCanvas);
        this.resize();
        window.addEventListener("resize", ()=>this.resize());
        this.time = {
            time: 0,
            delta: 0
        };
        this.entities = [];
        this.destroyQueue = [];
        this.clearRender = true;
    }
    resize() {
        const factor = .9;
        this.width = window.innerWidth * factor;
        this.height = window.innerHeight * factor;
        [
            this.c2Drenderer,
            this.renderer
        ].forEach((r)=>{
            r.resize(this.width, this.height);
        });
        this.scaleFactor = window.innerHeight / 1000 * factor;
    }
    destroyEntity(entity) {
        this.destroyQueue.push(entity);
    }
    destroyQueueUpdate() {
        for(let i = this.entities.length - 1; i >= 0; i--)if (this.destroyQueue.includes(this.entities[i])) {
            this.entities[i] = null;
            this.entities.splice(i, 1);
        }
    }
    start() {
        const update = ()=>{
            this.stats.begin();
            let currentTime = performance.now() / 1000;
            this.time.delta = currentTime - this.time.time;
            this.time.time = currentTime;
            this.entities.sort((a, b)=>a.zindex - b.zindex);
            this.entities.forEach((e)=>e.update());
            this.destroyQueueUpdate();
            this.c2Drenderer.render(this.entities);
            this.renderer.render();
            this.stats.end();
            requestAnimationFrame(()=>update());
        };
        update();
    }
}


function $e21f92a4ed8f2216$export$2e2bcd8739ae039() {
    const engine = new (0, $76c47054cd4b5e74$export$2e2bcd8739ae039)("gl-canvas", [
        {
            fragment: (0, (/*@__PURE__*/$parcel$interopDefault($f4a12e8f46a0ba0d$exports))),
            uniforms: {
                gradient: {
                    name: "u_gradient",
                    type: "t"
                },
                stars: {
                    name: "u_stars",
                    type: "t"
                },
                boss_position: {
                    name: "u_boss_position",
                    type: "f",
                    size: 2
                },
                music_intensity: {
                    name: "u_music_intensity",
                    type: "f",
                    size: 1
                }
            }
        },
        {
            fragment: (0, (/*@__PURE__*/$parcel$interopDefault($e23455acf6b14ade$exports))),
            uniforms: {
                music_volume: {
                    name: "u_music_volume",
                    type: "f",
                    size: 1
                },
                damage: {
                    name: "u_damage",
                    type: "f",
                    size: 1
                },
                deathtransition: {
                    name: "u_deathtransition",
                    type: "f",
                    size: 1
                },
                windowsTex: {
                    name: "u_windowsTex",
                    type: "t"
                }
            }
        }
    ]);
    engine.renderer.passes[0].material.uniforms.gradient.value = (0, $ae5894d785e164d6$export$2e2bcd8739ae039)(engine.renderer.gl, (0, (/*@__PURE__*/$parcel$interopDefault($e2a21789f44b6886$exports))));
    engine.renderer.passes[0].material.uniforms.stars.value = (0, $ae5894d785e164d6$export$2e2bcd8739ae039)(engine.renderer.gl, (0, (/*@__PURE__*/$parcel$interopDefault($8a9fa6970a4348a8$exports))));
    engine.renderer.passes[1].material.uniforms.windowsTex.value = (0, $ae5894d785e164d6$export$2e2bcd8739ae039)(engine.renderer.gl, (0, (/*@__PURE__*/$parcel$interopDefault($63ad87ffbecd606a$exports))));
    return engine;
}


class $93a93d85ffca0694$export$2e2bcd8739ae039 {
    constructor(){
        this.keys = new Array();
        this.mousepos = {
            x: 0,
            y: 0
        };
        this.mousedelta = {
            x: 0,
            y: 0
        };
        this.mouseUpdated = false;
        document.onkeydown = (e)=>{
            this.removeKey(e.code);
            this.keys.push(e.code);
        };
        document.onmousedown = (e)=>{
            this.removeKey("click");
            this.keys.push("click");
        };
        document.onmouseup = (e)=>{
            this.removeKey("click");
        };
        document.onmousemove = (e)=>{
            this.mousepos.x = e.clientX;
            this.mousepos.y = e.clientY;
            this.mousedelta.x = e.movementX;
            this.mousedelta.y = e.movementY;
            this.mouseUpdated = true;
        };
        document.onkeyup = (e)=>{
            this.removeKey(e.code);
        };
        document.oncontextmenu = (e)=>{
        //  e.preventDefault();
        };
    }
    getKey(key) {
        for(let i = 0; i < this.keys.length; i++){
            if (this.keys[i] == key) return true;
        }
        return false;
    }
    removeKey(key) {
        for(let i = 0; i < this.keys.length; i++)if (this.keys[i] == key) this.keys.splice(i, 1);
    }
    hasMouseUpdate() {
        const val = this.mouseUpdated;
        this.mouseUpdated = false;
        return val;
    }
}








var $8e3724fef59ee1d5$exports = {};
$8e3724fef59ee1d5$exports = import.meta.resolve("lUvYT");


class $9a9cc80374b2bd1a$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, position: position, direction: direction, player: player }){
        super({
            engine: engine,
            type: "bullet"
        });
        this.position = {
            ...position
        };
        this.direction = {
            ...direction
        };
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 50,
            h: 3
        });
        this.player = player;
        this.speed = 1500;
        const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($8e3724fef59ee1d5$exports))));
        sfx.volume = 0.1;
        sfx.play();
    }
    update() {
        const s = this.engine.scaleFactor;
        this.position.x += this.direction.x * this.speed * this.engine.time.delta * s;
        this.position.y += this.direction.y * this.speed * this.engine.time.delta * s;
        if (this.position.x > this.engine.width) this.engine.destroyEntity(this);
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 100
        });
        this.engine.destroyEntity(this);
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        const w = 50;
        const h = 3;
        let angle = Math.atan2(this.direction.y, this.direction.x);
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.shadowColor = "#7EFFE4";
        ctx.shadowBlur = 10 * s;
        ctx.fillStyle = "#7EFFE4";
        ctx.beginPath();
        ctx.rotate(angle);
        ctx.fillRect(-w / 2 * s, -h / 2 * s, w * s, h * s);
        ctx.fill();
        ctx.restore();
        this.hitbox.set({
            ...this.position,
            w: w,
            h: h
        });
    }
}



var $754ed878fed86975$exports = {};
$754ed878fed86975$exports = import.meta.resolve("6YMBq");


var $6e9e0340ad74cd6d$exports = {};
$6e9e0340ad74cd6d$exports = import.meta.resolve("bqqrH");


function $23fe82e59dfa02b3$export$4d973b3eababff1d(v) {
    let l = Math.sqrt(v.x * v.x + v.y * v.y);
    if (l == 0) return {
        x: 0,
        y: 0
    };
    return {
        x: v.x / l,
        y: v.y / l
    };
}
function $23fe82e59dfa02b3$export$3be2733b34fb8ad5(vec, ang) {
    return {
        x: vec.x * Math.cos(ang) - vec.y * Math.sin(ang),
        y: vec.x * Math.sin(ang) + vec.y * Math.cos(ang)
    };
}


var $a220e6c34acc2f22$exports = {};
$a220e6c34acc2f22$exports = import.meta.resolve("cKn0n");


var $04d95ac4e8a2eda8$exports = {};
$04d95ac4e8a2eda8$exports = import.meta.resolve("jPbR1");



var $2Tywo = parcelRequire("2Tywo");

var $ec56fb03736c7e5f$exports = {};
$ec56fb03736c7e5f$exports = import.meta.resolve("7y8GY");


var $d2e690ee3b3e3ff1$exports = {};
$d2e690ee3b3e3ff1$exports = import.meta.resolve("1eucj");


var $3fb1761bbc132863$exports = {};
$3fb1761bbc132863$exports = import.meta.resolve("8TQIx");



var $2Tywo = parcelRequire("2Tywo");
/*!
 * CSSPlugin 3.14.1
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2Tywo = parcelRequire("2Tywo");
var $0cdfc2eaac330c87$var$_win, $0cdfc2eaac330c87$var$_doc, $0cdfc2eaac330c87$var$_docElement, $0cdfc2eaac330c87$var$_pluginInitted, $0cdfc2eaac330c87$var$_tempDiv, $0cdfc2eaac330c87$var$_tempDivStyler, $0cdfc2eaac330c87$var$_recentSetterPlugin, $0cdfc2eaac330c87$var$_reverting, $0cdfc2eaac330c87$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $0cdfc2eaac330c87$var$_transformProps = {}, $0cdfc2eaac330c87$var$_RAD2DEG = 180 / Math.PI, $0cdfc2eaac330c87$var$_DEG2RAD = Math.PI / 180, $0cdfc2eaac330c87$var$_atan2 = Math.atan2, $0cdfc2eaac330c87$var$_bigNum = 1e8, $0cdfc2eaac330c87$var$_capsExp = /([A-Z])/g, $0cdfc2eaac330c87$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $0cdfc2eaac330c87$var$_complexExp = /[\s,\(]\S/, $0cdfc2eaac330c87$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $0cdfc2eaac330c87$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $0cdfc2eaac330c87$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $0cdfc2eaac330c87$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $0cdfc2eaac330c87$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $0cdfc2eaac330c87$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $0cdfc2eaac330c87$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_transformProp = "transform", $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin", $0cdfc2eaac330c87$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $0cdfc2eaac330c87$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $0cdfc2eaac330c87$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $0cdfc2eaac330c87$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $0cdfc2eaac330c87$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $0cdfc2eaac330c87$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $0cdfc2eaac330c87$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($0cdfc2eaac330c87$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($0cdfc2eaac330c87$var$_transformOriginProp, isNotCSS, "");
        }
        property = $0cdfc2eaac330c87$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $0cdfc2eaac330c87$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $0cdfc2eaac330c87$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $0cdfc2eaac330c87$var$_reverting();
        if ((!i || !i.isStart) && !style[$0cdfc2eaac330c87$var$_transformProp]) {
            $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$0cdfc2eaac330c87$var$_transformOriginProp]) {
                style[$0cdfc2eaac330c87$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $0cdfc2eaac330c87$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $0cdfc2eaac330c87$var$_revertStyle,
        save: $0cdfc2eaac330c87$var$_saveStyle
    };
    target._gsap || (0, $2Tywo.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $0cdfc2eaac330c87$var$_supports3D, $0cdfc2eaac330c87$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $0cdfc2eaac330c87$var$_doc.createElementNS ? $0cdfc2eaac330c87$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $0cdfc2eaac330c87$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $0cdfc2eaac330c87$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $0cdfc2eaac330c87$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $0cdfc2eaac330c87$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $0cdfc2eaac330c87$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $0cdfc2eaac330c87$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($0cdfc2eaac330c87$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $0cdfc2eaac330c87$var$_prefixes[i] : "") + property;
}, $0cdfc2eaac330c87$var$_initCore = function _initCore() {
    if ($0cdfc2eaac330c87$var$_windowExists() && window.document) {
        $0cdfc2eaac330c87$var$_win = window;
        $0cdfc2eaac330c87$var$_doc = $0cdfc2eaac330c87$var$_win.document;
        $0cdfc2eaac330c87$var$_docElement = $0cdfc2eaac330c87$var$_doc.documentElement;
        $0cdfc2eaac330c87$var$_tempDiv = $0cdfc2eaac330c87$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $0cdfc2eaac330c87$var$_tempDivStyler = $0cdfc2eaac330c87$export$a232bb0480ae674a("div");
        $0cdfc2eaac330c87$var$_transformProp = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b($0cdfc2eaac330c87$var$_transformProp);
        $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin";
        $0cdfc2eaac330c87$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $0cdfc2eaac330c87$var$_supports3D = !!$0cdfc2eaac330c87$export$8cbef5dd49a09c8b("perspective");
        $0cdfc2eaac330c87$var$_reverting = (0, $2Tywo.gsap).core.reverting;
        $0cdfc2eaac330c87$var$_pluginInitted = 1;
    }
}, $0cdfc2eaac330c87$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $0cdfc2eaac330c87$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $0cdfc2eaac330c87$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $0cdfc2eaac330c87$var$_docElement.removeChild(svg);
    return bbox;
}, $0cdfc2eaac330c87$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $0cdfc2eaac330c87$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $0cdfc2eaac330c87$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $0cdfc2eaac330c87$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$0cdfc2eaac330c87$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp) property = $0cdfc2eaac330c87$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $0cdfc2eaac330c87$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $0cdfc2eaac330c87$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$0cdfc2eaac330c87$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $0cdfc2eaac330c87$var$_tempDiv.style, horizontal = $0cdfc2eaac330c87$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $0cdfc2eaac330c87$var$_nonConvertibleUnits[unit] || $0cdfc2eaac330c87$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($0cdfc2eaac330c87$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Tywo._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $0cdfc2eaac330c87$var$_doc || !parent.appendChild) parent = $0cdfc2eaac330c87$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Tywo._ticker).time && !cache.uncache) return (0, $2Tywo._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $0cdfc2eaac330c87$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$0cdfc2eaac330c87$var$_nonStandardLayouts[$0cdfc2eaac330c87$var$_getComputedProperty(parent, "display")] && (style.position = $0cdfc2eaac330c87$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($0cdfc2eaac330c87$var$_tempDiv);
            px = $0cdfc2eaac330c87$var$_tempDiv[measureProperty];
            parent.removeChild($0cdfc2eaac330c87$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Tywo._getCache)(parent);
            cache.time = (0, $2Tywo._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Tywo._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $0cdfc2eaac330c87$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore();
    if (property in $0cdfc2eaac330c87$var$_propertyAliases && property !== "transform") {
        property = $0cdfc2eaac330c87$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($0cdfc2eaac330c87$var$_transformProps[property] && property !== "transform") {
        value = $0cdfc2eaac330c87$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $0cdfc2eaac330c87$var$_firstTwoOnly($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $0cdfc2eaac330c87$var$_specialProps[property] && $0cdfc2eaac330c87$var$_specialProps[property](target, property, unit) || $0cdfc2eaac330c87$var$_getComputedProperty(target, property) || (0, $2Tywo._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $0cdfc2eaac330c87$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $0cdfc2eaac330c87$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $0cdfc2eaac330c87$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $0cdfc2eaac330c87$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Tywo.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Tywo._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $0cdfc2eaac330c87$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $0cdfc2eaac330c87$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $0cdfc2eaac330c87$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Tywo._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Tywo._numWithUnitExp)) || [];
    endValues = end.match((0, $2Tywo._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Tywo._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Tywo._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Tywo._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Tywo._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue;
    (0, $2Tywo._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $0cdfc2eaac330c87$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $0cdfc2eaac330c87$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $0cdfc2eaac330c87$var$_keywordToPercent[x] || x;
    split[1] = $0cdfc2eaac330c87$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $0cdfc2eaac330c87$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($0cdfc2eaac330c87$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $0cdfc2eaac330c87$var$_transformOriginProp : $0cdfc2eaac330c87$var$_transformProp;
                }
                $0cdfc2eaac330c87$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $0cdfc2eaac330c87$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$0cdfc2eaac330c87$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 0, $0cdfc2eaac330c87$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $0cdfc2eaac330c87$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $0cdfc2eaac330c87$var$_rotationalProperties = {}, $0cdfc2eaac330c87$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp);
    return $0cdfc2eaac330c87$var$_isNullTransform(matrixString) ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Tywo._numExp)).map((0, $2Tywo._round));
}, $0cdfc2eaac330c87$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Tywo._getCache)(target), style = target.style, matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrix;
    } else if (matrix === $0cdfc2eaac330c87$var$_identity2DMatrix && !target.offsetParent && target !== $0cdfc2eaac330c87$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $0cdfc2eaac330c87$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $0cdfc2eaac330c87$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $0cdfc2eaac330c87$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $0cdfc2eaac330c87$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $0cdfc2eaac330c87$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$0cdfc2eaac330c87$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $0cdfc2eaac330c87$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Tywo.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$0cdfc2eaac330c87$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$0cdfc2eaac330c87$var$_transformProp] !== "none" ? cs[$0cdfc2eaac330c87$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $0cdfc2eaac330c87$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $0cdfc2eaac330c87$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $0cdfc2eaac330c87$var$_atan2(b, a) * $0cdfc2eaac330c87$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $0cdfc2eaac330c87$var$_atan2(c, d) * $0cdfc2eaac330c87$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $0cdfc2eaac330c87$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $0cdfc2eaac330c87$var$_atan2(a32, a33);
            rotationX = angle * $0cdfc2eaac330c87$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $0cdfc2eaac330c87$var$_atan2(-c, a33);
            rotationY = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $0cdfc2eaac330c87$var$_atan2(b, a);
            rotation = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Tywo._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Tywo._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $0cdfc2eaac330c87$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $0cdfc2eaac330c87$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$0cdfc2eaac330c87$var$_isNullTransform($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Tywo._round)(scaleX);
    cache.scaleY = (0, $2Tywo._round)(scaleY);
    cache.rotation = (0, $2Tywo._round)(rotation) + deg;
    cache.rotationX = (0, $2Tywo._round)(rotationX) + deg;
    cache.rotationY = (0, $2Tywo._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$0cdfc2eaac330c87$var$_transformOriginProp] = $0cdfc2eaac330c87$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Tywo._config).force3D;
    cache.renderTransform = cache.svg ? $0cdfc2eaac330c87$var$_renderSVGTransforms : $0cdfc2eaac330c87$var$_supports3D ? $0cdfc2eaac330c87$var$_renderCSSTransforms : $0cdfc2eaac330c87$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $0cdfc2eaac330c87$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$0cdfc2eaac330c87$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Tywo.getUnit)(start);
    return (0, $2Tywo._round)(parseFloat(start) + parseFloat($0cdfc2eaac330c87$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $0cdfc2eaac330c87$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $0cdfc2eaac330c87$var$_renderCSSTransforms(ratio, cache);
}, $0cdfc2eaac330c87$var$_zeroDeg = "0deg", $0cdfc2eaac330c87$var$_zeroPx = "0px", $0cdfc2eaac330c87$var$_endParenthesis = ") ", $0cdfc2eaac330c87$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg || rotationY !== $0cdfc2eaac330c87$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $0cdfc2eaac330c87$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $0cdfc2eaac330c87$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $0cdfc2eaac330c87$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $0cdfc2eaac330c87$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $0cdfc2eaac330c87$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $0cdfc2eaac330c87$var$_zeroPx) transforms += "perspective(" + transformPerspective + $0cdfc2eaac330c87$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $0cdfc2eaac330c87$var$_zeroPx || y !== $0cdfc2eaac330c87$var$_zeroPx || z !== $0cdfc2eaac330c87$var$_zeroPx) transforms += z !== $0cdfc2eaac330c87$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotation !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotate(" + rotation + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateY(" + rotationY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateX(" + rotationX + $0cdfc2eaac330c87$var$_endParenthesis;
    if (skewX !== $0cdfc2eaac330c87$var$_zeroDeg || skewY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $0cdfc2eaac330c87$var$_endParenthesis;
    target.style[$0cdfc2eaac330c87$var$_transformProp] = transforms || "translate(0, 0)";
}, $0cdfc2eaac330c87$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $0cdfc2eaac330c87$var$_DEG2RAD;
        skewX *= $0cdfc2eaac330c87$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $0cdfc2eaac330c87$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Tywo._round)(a11);
        a21 = (0, $2Tywo._round)(a21);
        a12 = (0, $2Tywo._round)(a12);
        a22 = (0, $2Tywo._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $0cdfc2eaac330c87$var$_convertToUnit(target, "x", x, "px");
        ty = $0cdfc2eaac330c87$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Tywo._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Tywo._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Tywo._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Tywo._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$0cdfc2eaac330c87$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $0cdfc2eaac330c87$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Tywo._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $0cdfc2eaac330c87$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, startNum, change, $0cdfc2eaac330c87$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $0cdfc2eaac330c87$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $0cdfc2eaac330c87$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$0cdfc2eaac330c87$var$_transformProp];
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        style[$0cdfc2eaac330c87$var$_transformProp] = startValue;
    }
    for(p in $0cdfc2eaac330c87$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Tywo.getUnit)(startValue);
            endUnit = (0, $2Tywo.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $0cdfc2eaac330c87$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $0cdfc2eaac330c87$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Tywo._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $0cdfc2eaac330c87$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $0cdfc2eaac330c87$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $0cdfc2eaac330c87$export$855822f522f18eef = {
    name: "css",
    register: $0cdfc2eaac330c87$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $0cdfc2eaac330c87$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Tywo._plugins)[p] && (0, $2Tywo._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $0cdfc2eaac330c87$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Tywo._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Tywo._colorExp).lastIndex = 0;
                if (!(0, $2Tywo._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Tywo.getUnit)(startValue);
                    endUnit = (0, $2Tywo.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Tywo._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Tywo._replaceRandom)(startValue));
                    (0, $2Tywo.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Tywo._config).units[p] || (0, $2Tywo.getUnit)($0cdfc2eaac330c87$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $0cdfc2eaac330c87$var$_get(target, p)); // can't work with relative values
                } else startValue = $0cdfc2eaac330c87$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $0cdfc2eaac330c87$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $0cdfc2eaac330c87$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $0cdfc2eaac330c87$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $0cdfc2eaac330c87$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $0cdfc2eaac330c87$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $0cdfc2eaac330c87$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $0cdfc2eaac330c87$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $0cdfc2eaac330c87$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Tywo.PropTween)(this._pt, style, $0cdfc2eaac330c87$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Tywo.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Tywo._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $0cdfc2eaac330c87$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($0cdfc2eaac330c87$var$_transformOriginProp, 0, style[$0cdfc2eaac330c87$var$_transformOriginProp]);
                        endValue = $0cdfc2eaac330c87$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, p, $0cdfc2eaac330c87$var$_firstTwoOnly(startValue), $0cdfc2eaac330c87$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $0cdfc2eaac330c87$var$_rotationalProperties) {
                        $0cdfc2eaac330c87$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Tywo._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $0cdfc2eaac330c87$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$0cdfc2eaac330c87$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Tywo.getUnit)(endValue) || (p in (0, $2Tywo._config).units ? (0, $2Tywo._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Tywo.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Tywo._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $0cdfc2eaac330c87$var$_renderRoundedCSSProp : $0cdfc2eaac330c87$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Tywo._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $0cdfc2eaac330c87$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Tywo._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$0cdfc2eaac330c87$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $0cdfc2eaac330c87$var$_get,
    aliases: $0cdfc2eaac330c87$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $0cdfc2eaac330c87$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp && (target._gsap.x || $0cdfc2eaac330c87$var$_get(target, "x")) ? plugin && $0cdfc2eaac330c87$var$_recentSetterPlugin === plugin ? property === "scale" ? $0cdfc2eaac330c87$var$_setterScale : $0cdfc2eaac330c87$var$_setterTransform : ($0cdfc2eaac330c87$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $0cdfc2eaac330c87$var$_setterScaleWithRender : $0cdfc2eaac330c87$var$_setterTransformWithRender) : target.style && !(0, $2Tywo._isUndefined)(target.style[property]) ? $0cdfc2eaac330c87$var$_setterCSSStyle : ~property.indexOf("-") ? $0cdfc2eaac330c87$var$_setterCSSProp : (0, $2Tywo._getSetter)(target, property);
    },
    core: {
        _removeProperty: $0cdfc2eaac330c87$var$_removeProperty,
        _getMatrix: $0cdfc2eaac330c87$var$_getMatrix
    }
};
(0, $2Tywo.gsap).utils.checkPrefix = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b;
(0, $2Tywo.gsap).core.getStyleSaver = $0cdfc2eaac330c87$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Tywo._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $0cdfc2eaac330c87$var$_transformProps[name] = 1;
    });
    (0, $2Tywo._forEachName)(rotation, function(name) {
        (0, $2Tywo._config).units[name] = "deg";
        $0cdfc2eaac330c87$var$_rotationalProperties[name] = 1;
    });
    $0cdfc2eaac330c87$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Tywo._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $0cdfc2eaac330c87$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Tywo._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Tywo._config).units[name] = "px";
});
(0, $2Tywo.gsap).registerPlugin($0cdfc2eaac330c87$export$855822f522f18eef);


var $357b3f2d5f2ec9d5$export$99ee26438460406a = (0, $2Tywo.gsap).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef)) || (0, $2Tywo.gsap), // to protect from tree shaking
$357b3f2d5f2ec9d5$export$7b23975ad686bf91 = $357b3f2d5f2ec9d5$export$99ee26438460406a.core.Tween;


let $53363953c764d94d$var$scoreSent = false;
const $53363953c764d94d$var$trad = {
    fr: {
        h3_win: "Bien jou\xe9 l'artiste !",
        p_win: "Tu nous as impressionn\xe9. Bonnes f\xeates de fin d'ann\xe9e \uD83C\uDF85",
        h3_loose: "Pas mal, mais Internet Explorer t'as vaincu ! Bonnes f\xeates de fin d\u2019ann\xe9e \uD83C\uDF85",
        damage: "D\xe9gats",
        time: "Temps",
        total: "Score total",
        send: "Partage ton score !",
        tryagain: "Recommencer"
    }
};
function $53363953c764d94d$export$2e2bcd8739ae039({ win: win, score: score, time: time }) {
    const lang = document.getElementById("game").getAttribute("data-lang");
    const c = $53363953c764d94d$var$trad[lang];
    let fscore = score;
    if (win) {
        let tratio = 1 - time / 207;
        fscore += Math.floor(tratio * 5000);
    }
    let result = {
        win: win,
        score: fscore,
        time: $53363953c764d94d$var$formatTime(time)
    };
    const base64 = encodeURI(btoa(JSON.stringify(result)));
    const contact_url = document.getElementById("game").getAttribute("data-contact") + "?game=" + base64;
    const gameover = document.createElement("div");
    gameover.classList.add("gameover");
    if (!win) gameover.classList.add("gameover--lose");
    gameover.innerHTML = `<div class="gameover__header">
        <h3 class="${win ? 'win' : 'lose'}">${win ? c.h3_win : c.h3_loose}</h3>
        <div class="gameover__header__line"></div>
        ${win ? `<p>${win ? c.p_win : c.p_loose}</p>` : ""}
        <img src="${win ? (0, (/*@__PURE__*/$parcel$interopDefault($ec56fb03736c7e5f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d2e690ee3b3e3ff1$exports)))}">
    </div>
    <div class="scoreboard">
        <div class="scoreboard__score">
            <span>${c.damage}</span><span>${score}</span>
        </div>
        <div class="scoreboard__score scoreboard__score--time">
            <span>${c.time}</span><span>${$53363953c764d94d$var$formatTime(time)}</span>
        </div>
        <div class="scoreboard__score">
            <span>${c.total}</span><span>${fscore}</span>
        </div>
        <button class="scoreboard__send" id="open-share-modal-btn" href="${contact_url}">${c.send}</button>
        <button id="scoreboard__tryagain" class="scoreboard__tryagain">${c.tryagain}</button>
    </div>`;
    document.getElementById("game").append(gameover);
    $53363953c764d94d$var$scoreSent = false;
    const openShareModalBtn = document.getElementById("open-share-modal-btn");
    if (openShareModalBtn) openShareModalBtn.addEventListener('click', ()=>$53363953c764d94d$var$toggleShareModal(score, $53363953c764d94d$var$formatTime(time), fscore));
    const shareModalOverlay = document.getElementById("share-modal-overlay");
    if (shareModalOverlay) shareModalOverlay.addEventListener('click', ()=>$53363953c764d94d$var$toggleShareModal(score, $53363953c764d94d$var$formatTime(time), fscore));
    const shareModalCloseBtn = document.getElementById("share-modal-close-btn");
    if (shareModalCloseBtn) shareModalCloseBtn.addEventListener('click', ()=>$53363953c764d94d$var$toggleShareModal(score, $53363953c764d94d$var$formatTime(time), fscore));
    const shareBtn = document.getElementById("share-btn");
    if (shareBtn) shareBtn.addEventListener('click', ()=>$53363953c764d94d$var$sendScoreToDB(score, time, fscore, win));
    const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
    tl.delay(win ? 3 : 1);
    tl.from(".gameover__header img", {
        duration: .3,
        opacity: 0,
        scale: 0.8
    });
    tl.from(".gameover__header h3, .gameover__header .gameover__header__line, .gameover__header p", {
        duration: .3,
        y: 20,
        opacity: 0
    });
    tl.from(".scoreboard__score", {
        delay: 0.5,
        duration: .3,
        opacity: 0,
        scale: 0.8,
        stagger: {
            each: 0.5,
            onStart: $53363953c764d94d$var$playsound
        },
        ease: "back.out(1.7)"
    });
    tl.from(".scoreboard__send, .scoreboard__tryagain", {
        delay: 0.5,
        duration: 1.5,
        opacity: 0
    });
    document.getElementById("scoreboard__tryagain").onclick = function() {
        document.location.reload();
    };
}
function $53363953c764d94d$var$playsound() {
    const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3fb1761bbc132863$exports))));
    sfx.volume = 0.1;
    sfx.play();
}
function $53363953c764d94d$var$formatTime(time) {
    let min = Math.floor(time / 60);
    let sec = Math.floor(time % 60);
    if (sec < 10) sec = "0" + sec;
    return min + ":" + sec;
}
function $53363953c764d94d$var$validerEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}
function $53363953c764d94d$var$toggleShareModal(damage = 0, time = 0, total = 0) {
    const shareModalWrapper = document.getElementById("share-modal-wrapper");
    shareModalWrapper.style.display = shareModalWrapper.style.display === "flex" ? "none" : "flex";
    shareModalWrapper.querySelector("#damage-stats-value").textContent = damage;
    shareModalWrapper.querySelector("#time-stats-value").textContent = time;
    shareModalWrapper.querySelector("#total-stats-value").textContent = total;
}
async function $53363953c764d94d$var$encryptData(data) {
    const publicKeyPem = `
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzm4OpnNRD+XJtdVWjiiN
qoWBaEVjswpCLnao9CPjzMubHJuiMzekjJjEWk0cY+EkvQnUY1NZjqv8cIlwwXx8
Mp8ruPprEQNuHRCXXn3tvWvnf74WZj5wHwWv9Pktuh6G99Emm79jVnrlIj0Rh/Oc
V/FrMt2njgCIHDXII779HBPBGt6+iUipTlYjroib34ETC+vO0QQH+IMvzEYUrs7K
v+WS+KqbJvxllt+fl3/Nn43JFQTnFO7Xs7OUzO/NYsV4flN0rND8ZZyHQx2WV3/v
jvhnZaGTGVQS93g3lXL5gBXvKtVz08mBHhEmd5ob1yafgYUVO+0UCQcbBaHc4JA3
vwIDAQAB  
`;
    const publicKey = await window.crypto.subtle.importKey("spki", $53363953c764d94d$var$pemToArrayBuffer(publicKeyPem), {
        name: "RSA-OAEP",
        hash: "SHA-256"
    }, false, [
        "encrypt"
    ]);
    const encoded = new TextEncoder().encode(JSON.stringify(data));
    const encrypted = await window.crypto.subtle.encrypt({
        name: "RSA-OAEP"
    }, publicKey, encoded);
    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
function $53363953c764d94d$var$pemToArrayBuffer(pem) {
    const b64 = pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, '').trim();
    const binary = atob(b64);
    const array = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)array[i] = binary.charCodeAt(i);
    return array.buffer;
}
async function $53363953c764d94d$var$sendScoreToDB(damage, time, score, win) {
    if ($53363953c764d94d$var$scoreSent) return;
    const shareModalMessage = document.getElementById('share-modal-message');
    const username = document.getElementById('usernameInput').value;
    const email = document.getElementById('emailInput').value;
    shareModalMessage.textContent = '';
    shareModalMessage.classList.remove('error');
    shareModalMessage.classList.remove('success');
    if (!username.trim()) {
        shareModalMessage.textContent = 'Nom requis';
        shareModalMessage.classList.add('error');
        return;
    }
    if (!email.trim()) {
        shareModalMessage.textContent = 'Email requis';
        shareModalMessage.classList.add('error');
        return;
    }
    if (!$53363953c764d94d$var$validerEmail(email)) {
        shareModalMessage.textContent = 'Email invalide';
        shareModalMessage.classList.add('error');
        return;
    }
    const payload = {
        username: username,
        email: email,
        score: score,
        time: time,
        damage: damage,
        win: win,
        ts: Date.now()
    };
    const encryptedPayload = await $53363953c764d94d$var$encryptData(payload);
    //const response = await fetch("http://creano.paris/xxxx/addScore", {
    const response = await fetch("/api/addScore", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            data: encryptedPayload
        })
    });
    if (!response.ok) {
        const data = await response.json();
        if (data.error) {
            shareModalMessage.textContent = data.error;
            shareModalMessage.classList.add('error');
        }
        return;
    }
    $53363953c764d94d$var$scoreSent = true;
    const data = await response.json();
    if (data.message) {
        shareModalMessage.textContent = data.message;
        shareModalMessage.classList.add('success');
    }
    setTimeout(()=>{
        document.getElementById('usernameInput').value = "";
        document.getElementById('emailInput').value = "";
        $53363953c764d94d$var$toggleShareModal();
    }, 1000);
}


class $849bf9afc8e96ee4$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, inputs: inputs, music: music }){
        super({
            engine: engine,
            type: "player"
        });
        this.music = music;
        this.position = {
            x: 0,
            y: this.engine.height / 2
        };
        this.inputs = inputs;
        this.controllerPosition = {
            x: 0,
            y: 0
        };
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 10,
            h: 10
        });
        this.attackSpeed = 0.1;
        this.attackTimer = 0;
        this.maxHp = 7;
        this.hp = this.maxHp;
        this.hpBarsDOM = document.getElementById("player-hp").querySelectorAll(".healthbar__inner div");
        this.score = 0;
        this.hitstreak = 0;
        this.scoreMult = 1;
        this.scoreDOM = document.getElementById("score");
        this.scoreMultDOM = document.getElementById("score-mult");
        this.scoreTime = 0;
        this.smoothing = 0.3;
        this.texture = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($754ed878fed86975$exports))));
        this.textureMask = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6e9e0340ad74cd6d$exports))));
        this.rotation = 0;
        this.hitted = false;
        this.regenTimer = 0;
        this.immortalityTimer = 0;
    }
    update() {
        if (this.gameover) return;
        const s = this.engine.scaleFactor;
        this.scoreTime += this.engine.time.delta;
        //mouse control
        if (this.inputs.hasMouseUpdate()) this.controllerPosition = {
            ...this.inputs.mousepos
        };
        //keyboard control
        const speed = 800 * s * this.engine.time.delta;
        if (this.inputs.getKey("ArrowRight")) this.controllerPosition.x += speed;
        if (this.inputs.getKey("ArrowLeft")) this.controllerPosition.x -= speed;
        if (this.inputs.getKey("ArrowUp")) this.controllerPosition.y -= speed;
        if (this.inputs.getKey("ArrowDown")) this.controllerPosition.y += speed;
        let direction = {
            x: this.controllerPosition.x / window.innerWidth * this.engine.width - this.position.x,
            y: this.controllerPosition.y / window.innerHeight * this.engine.height - this.position.y
        };
        this.position.y += direction.y * this.smoothing;
        this.position.x += direction.x * this.smoothing;
        this.rotation = Math.atan2(direction.y, direction.x + 300 * s);
        this.immortalityTimer -= this.engine.time.delta;
        this.attackTimer -= this.engine.time.delta;
        this.regenTimer -= this.engine.time.delta;
        if (this.inputs.getKey("click") || this.inputs.getKey("Space")) {
            if (this.attackTimer <= 0) {
                this.attackTimer = this.attackSpeed;
                let direction = (0, $23fe82e59dfa02b3$export$4d973b3eababff1d)({
                    x: 1,
                    y: (Math.random() - 0.5) * 0.05
                });
                new (0, $9a9cc80374b2bd1a$export$2e2bcd8739ae039)({
                    engine: this.engine,
                    position: this.position,
                    direction: direction,
                    player: this
                });
            }
        } else if (this.regenTimer <= 0) {
            this.hp += this.engine.time.delta;
            if (this.hp > this.maxHp) this.hp = this.maxHp;
        }
        this.collision();
        this.updateUI();
    }
    updateUI() {
        const percent = (1 - this.hp / this.maxHp) * 100;
        this.hpBarsDOM[0].style = "transform: translateX(" + percent + "%);";
        this.hpBarsDOM[1].style = "transform: translateX(" + percent + "%);";
        this.scoreDOM.textContent = this.score;
        this.scoreMultDOM.textContent = this.scoreMult;
    }
    collision() {
        this.engine.entities.forEach((e)=>{
            if ((e.type == "note" || e.type == "rocket") && e.hitbox.overlaps(this.hitbox)) {
                e.hit();
                this.regenTimer = 1;
                if (this.immortalityTimer <= 0) {
                    this.immortalityTimer = 0.3;
                    this.hp -= e.type == "note" ? 1 : 2;
                    this.hitstreak /= 2;
                    if (this.hitstreak < 0) this.hitstreak = 0;
                    this.calcScoreMult();
                    if (this.hp <= 0) this.death();
                }
                if (this.hp > 0) this.damageFx(e);
            }
        });
    }
    death() {
        this.music.stop();
        (0, $2Tywo.default).timeline().to(".hud", {
            duration: .5,
            autoAlpha: 0,
            ease: "power3.inOut"
        }, "0").fromTo(this.engine.renderer.passes[1].material.uniforms.damage, {
            value: 10
        }, {
            duration: 1,
            value: 0.05
        }, "0").fromTo(this.engine.renderer.passes[1].material.uniforms.deathtransition, {
            value: 0
        }, {
            duration: 0.5,
            value: 1
        }, "0.2");
        (0, $53363953c764d94d$export$2e2bcd8739ae039)({
            win: false,
            score: this.score,
            time: this.scoreTime
        });
        this.engine.entities.forEach((e)=>{
            this.engine.destroyEntity(e);
        });
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 10000
        });
        const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($04d95ac4e8a2eda8$exports))));
        sfx.volume = 1;
        sfx.play();
    }
    damageFx(e) {
        this.engine.renderer.passes[1].material.uniforms.damage.value = 1;
        clearTimeout(this.damageTimeout);
        this.damageTimeout = setTimeout(()=>this.engine.renderer.passes[1].material.uniforms.damage.value = 0, e.type == "note" ? 300 : 1000);
        this.hitted = true;
        clearTimeout(this.hitTimeout);
        this.hitTimeout = setTimeout(()=>this.hitted = false, 300);
        const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($a220e6c34acc2f22$exports))));
        sfx.volume = e.type == "note" ? 0.2 : 0.3;
        sfx.play();
    }
    render(ctx) {
        if (!this.texture.ready) return;
        const s = this.engine.scaleFactor;
        const texSize = 100 * s;
        const glowRadius = 70 * s;
        ctx.save();
        ctx.translate(this.position.x, this.position.y - 3);
        ctx.rotate(this.rotation);
        //light
        const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, glowRadius);
        gradient.addColorStop(0, 'rgba(39, 58, 155, 0.5)');
        gradient.addColorStop(1, 'rgba(39, 58, 155, 0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(-glowRadius, -glowRadius, glowRadius * 2, glowRadius * 2);
        //texture
        this.texture.draw(ctx, texSize);
        if (this.hitted) this.textureMask.draw(ctx, texSize);
        ctx.restore();
        //hitbox update
        this.hitbox.set({
            ...this.position,
            w: 10 * s,
            h: 10 * s
        });
    }
    calcScoreMult() {
        let current = parseInt(this.hitstreak / 3) + 1;
        if (current != this.scoreMult) {
            (0, $2Tywo.default).timeline().to(".score-mult-wrapper", {
                duration: .1,
                scale: 0.9
            }).to(".score-mult-wrapper", {
                duration: .2,
                scale: 1
            });
            this.scoreMult = current;
        }
    }
    addScore() {
        this.hitstreak++;
        this.calcScoreMult();
        this.score += this.scoreMult;
    }
}




var $7f9986d0b71cf3d1$exports = {};
/*
 * A fast javascript implementation of simplex noise by Jonas Wagner

Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
Better rank ordering method by Stefan Gustavson in 2012.


 Copyright (c) 2018 Jonas Wagner

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */ (function() {
    'use strict';
    var F2 = 0.5 * (Math.sqrt(3.0) - 1.0);
    var G2 = (3.0 - Math.sqrt(3.0)) / 6.0;
    var F3 = 1.0 / 3.0;
    var G3 = 1.0 / 6.0;
    var F4 = (Math.sqrt(5.0) - 1.0) / 4.0;
    var G4 = (5.0 - Math.sqrt(5.0)) / 20.0;
    function SimplexNoise(randomOrSeed) {
        var random;
        if (typeof randomOrSeed == 'function') random = randomOrSeed;
        else if (randomOrSeed) random = alea(randomOrSeed);
        else random = Math.random;
        this.p = buildPermutationTable(random);
        this.perm = new Uint8Array(512);
        this.permMod12 = new Uint8Array(512);
        for(var i = 0; i < 512; i++){
            this.perm[i] = this.p[i & 255];
            this.permMod12[i] = this.perm[i] % 12;
        }
    }
    SimplexNoise.prototype = {
        grad3: new Float32Array([
            1,
            1,
            0,
            -1,
            1,
            0,
            1,
            -1,
            0,
            -1,
            -1,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            1,
            -1,
            0,
            -1,
            -1
        ]),
        grad4: new Float32Array([
            0,
            1,
            1,
            1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            1,
            0,
            1,
            1,
            1,
            0,
            1,
            -1,
            1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            -1,
            -1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            0
        ]),
        noise2D: function(xin, yin) {
            var permMod12 = this.permMod12;
            var perm = this.perm;
            var grad3 = this.grad3;
            var n0 = 0; // Noise contributions from the three corners
            var n1 = 0;
            var n2 = 0;
            // Skew the input space to determine which simplex cell we're in
            var s = (xin + yin) * F2; // Hairy factor for 2D
            var i = Math.floor(xin + s);
            var j = Math.floor(yin + s);
            var t = (i + j) * G2;
            var X0 = i - t; // Unskew the cell origin back to (x,y) space
            var Y0 = j - t;
            var x0 = xin - X0; // The x,y distances from the cell origin
            var y0 = yin - Y0;
            // For the 2D case, the simplex shape is an equilateral triangle.
            // Determine which simplex we are in.
            var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
            if (x0 > y0) {
                i1 = 1;
                j1 = 0;
            } else {
                i1 = 0;
                j1 = 1;
            } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
            // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
            // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
            // c = (3-sqrt(3))/6
            var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
            var y1 = y0 - j1 + G2;
            var x2 = x0 - 1.0 + 2.0 * G2; // Offsets for last corner in (x,y) unskewed coords
            var y2 = y0 - 1.0 + 2.0 * G2;
            // Work out the hashed gradient indices of the three simplex corners
            var ii = i & 255;
            var jj = j & 255;
            // Calculate the contribution from the three corners
            var t0 = 0.5 - x0 * x0 - y0 * y0;
            if (t0 >= 0) {
                var gi0 = permMod12[ii + perm[jj]] * 3;
                t0 *= t0;
                n0 = t0 * t0 * (grad3[gi0] * x0 + grad3[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            }
            var t1 = 0.5 - x1 * x1 - y1 * y1;
            if (t1 >= 0) {
                var gi1 = permMod12[ii + i1 + perm[jj + j1]] * 3;
                t1 *= t1;
                n1 = t1 * t1 * (grad3[gi1] * x1 + grad3[gi1 + 1] * y1);
            }
            var t2 = 0.5 - x2 * x2 - y2 * y2;
            if (t2 >= 0) {
                var gi2 = permMod12[ii + 1 + perm[jj + 1]] * 3;
                t2 *= t2;
                n2 = t2 * t2 * (grad3[gi2] * x2 + grad3[gi2 + 1] * y2);
            }
            // Add contributions from each corner to get the final noise value.
            // The result is scaled to return values in the interval [-1,1].
            return 70.0 * (n0 + n1 + n2);
        },
        // 3D simplex noise
        noise3D: function(xin, yin, zin) {
            var permMod12 = this.permMod12;
            var perm = this.perm;
            var grad3 = this.grad3;
            var n0, n1, n2, n3; // Noise contributions from the four corners
            // Skew the input space to determine which simplex cell we're in
            var s = (xin + yin + zin) * F3; // Very nice and simple skew factor for 3D
            var i = Math.floor(xin + s);
            var j = Math.floor(yin + s);
            var k = Math.floor(zin + s);
            var t = (i + j + k) * G3;
            var X0 = i - t; // Unskew the cell origin back to (x,y,z) space
            var Y0 = j - t;
            var Z0 = k - t;
            var x0 = xin - X0; // The x,y,z distances from the cell origin
            var y0 = yin - Y0;
            var z0 = zin - Z0;
            // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
            // Determine which simplex we are in.
            var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
            var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
            if (x0 >= y0) {
                if (y0 >= z0) {
                    i1 = 1;
                    j1 = 0;
                    k1 = 0;
                    i2 = 1;
                    j2 = 1;
                    k2 = 0;
                } else if (x0 >= z0) {
                    i1 = 1;
                    j1 = 0;
                    k1 = 0;
                    i2 = 1;
                    j2 = 0;
                    k2 = 1;
                } else {
                    i1 = 0;
                    j1 = 0;
                    k1 = 1;
                    i2 = 1;
                    j2 = 0;
                    k2 = 1;
                } // Z X Y order
            } else {
                if (y0 < z0) {
                    i1 = 0;
                    j1 = 0;
                    k1 = 1;
                    i2 = 0;
                    j2 = 1;
                    k2 = 1;
                } else if (x0 < z0) {
                    i1 = 0;
                    j1 = 1;
                    k1 = 0;
                    i2 = 0;
                    j2 = 1;
                    k2 = 1;
                } else {
                    i1 = 0;
                    j1 = 1;
                    k1 = 0;
                    i2 = 1;
                    j2 = 1;
                    k2 = 0;
                } // Y X Z order
            }
            // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
            // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
            // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
            // c = 1/6.
            var x1 = x0 - i1 + G3; // Offsets for second corner in (x,y,z) coords
            var y1 = y0 - j1 + G3;
            var z1 = z0 - k1 + G3;
            var x2 = x0 - i2 + 2.0 * G3; // Offsets for third corner in (x,y,z) coords
            var y2 = y0 - j2 + 2.0 * G3;
            var z2 = z0 - k2 + 2.0 * G3;
            var x3 = x0 - 1.0 + 3.0 * G3; // Offsets for last corner in (x,y,z) coords
            var y3 = y0 - 1.0 + 3.0 * G3;
            var z3 = z0 - 1.0 + 3.0 * G3;
            // Work out the hashed gradient indices of the four simplex corners
            var ii = i & 255;
            var jj = j & 255;
            var kk = k & 255;
            // Calculate the contribution from the four corners
            var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
            if (t0 < 0) n0 = 0.0;
            else {
                var gi0 = permMod12[ii + perm[jj + perm[kk]]] * 3;
                t0 *= t0;
                n0 = t0 * t0 * (grad3[gi0] * x0 + grad3[gi0 + 1] * y0 + grad3[gi0 + 2] * z0);
            }
            var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
            if (t1 < 0) n1 = 0.0;
            else {
                var gi1 = permMod12[ii + i1 + perm[jj + j1 + perm[kk + k1]]] * 3;
                t1 *= t1;
                n1 = t1 * t1 * (grad3[gi1] * x1 + grad3[gi1 + 1] * y1 + grad3[gi1 + 2] * z1);
            }
            var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
            if (t2 < 0) n2 = 0.0;
            else {
                var gi2 = permMod12[ii + i2 + perm[jj + j2 + perm[kk + k2]]] * 3;
                t2 *= t2;
                n2 = t2 * t2 * (grad3[gi2] * x2 + grad3[gi2 + 1] * y2 + grad3[gi2 + 2] * z2);
            }
            var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
            if (t3 < 0) n3 = 0.0;
            else {
                var gi3 = permMod12[ii + 1 + perm[jj + 1 + perm[kk + 1]]] * 3;
                t3 *= t3;
                n3 = t3 * t3 * (grad3[gi3] * x3 + grad3[gi3 + 1] * y3 + grad3[gi3 + 2] * z3);
            }
            // Add contributions from each corner to get the final noise value.
            // The result is scaled to stay just inside [-1,1]
            return 32.0 * (n0 + n1 + n2 + n3);
        },
        // 4D simplex noise, better simplex rank ordering method 2012-03-09
        noise4D: function(x, y, z, w) {
            var perm = this.perm;
            var grad4 = this.grad4;
            var n0, n1, n2, n3, n4; // Noise contributions from the five corners
            // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
            var s = (x + y + z + w) * F4; // Factor for 4D skewing
            var i = Math.floor(x + s);
            var j = Math.floor(y + s);
            var k = Math.floor(z + s);
            var l = Math.floor(w + s);
            var t = (i + j + k + l) * G4; // Factor for 4D unskewing
            var X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
            var Y0 = j - t;
            var Z0 = k - t;
            var W0 = l - t;
            var x0 = x - X0; // The x,y,z,w distances from the cell origin
            var y0 = y - Y0;
            var z0 = z - Z0;
            var w0 = w - W0;
            // For the 4D case, the simplex is a 4D shape I won't even try to describe.
            // To find out which of the 24 possible simplices we're in, we need to
            // determine the magnitude ordering of x0, y0, z0 and w0.
            // Six pair-wise comparisons are performed between each possible pair
            // of the four coordinates, and the results are used to rank the numbers.
            var rankx = 0;
            var ranky = 0;
            var rankz = 0;
            var rankw = 0;
            if (x0 > y0) rankx++;
            else ranky++;
            if (x0 > z0) rankx++;
            else rankz++;
            if (x0 > w0) rankx++;
            else rankw++;
            if (y0 > z0) ranky++;
            else rankz++;
            if (y0 > w0) ranky++;
            else rankw++;
            if (z0 > w0) rankz++;
            else rankw++;
            var i1, j1, k1, l1; // The integer offsets for the second simplex corner
            var i2, j2, k2, l2; // The integer offsets for the third simplex corner
            var i3, j3, k3, l3; // The integer offsets for the fourth simplex corner
            // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
            // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
            // impossible. Only the 24 indices which have non-zero entries make any sense.
            // We use a thresholding to set the coordinates in turn from the largest magnitude.
            // Rank 3 denotes the largest coordinate.
            i1 = rankx >= 3 ? 1 : 0;
            j1 = ranky >= 3 ? 1 : 0;
            k1 = rankz >= 3 ? 1 : 0;
            l1 = rankw >= 3 ? 1 : 0;
            // Rank 2 denotes the second largest coordinate.
            i2 = rankx >= 2 ? 1 : 0;
            j2 = ranky >= 2 ? 1 : 0;
            k2 = rankz >= 2 ? 1 : 0;
            l2 = rankw >= 2 ? 1 : 0;
            // Rank 1 denotes the second smallest coordinate.
            i3 = rankx >= 1 ? 1 : 0;
            j3 = ranky >= 1 ? 1 : 0;
            k3 = rankz >= 1 ? 1 : 0;
            l3 = rankw >= 1 ? 1 : 0;
            // The fifth corner has all coordinate offsets = 1, so no need to compute that.
            var x1 = x0 - i1 + G4; // Offsets for second corner in (x,y,z,w) coords
            var y1 = y0 - j1 + G4;
            var z1 = z0 - k1 + G4;
            var w1 = w0 - l1 + G4;
            var x2 = x0 - i2 + 2.0 * G4; // Offsets for third corner in (x,y,z,w) coords
            var y2 = y0 - j2 + 2.0 * G4;
            var z2 = z0 - k2 + 2.0 * G4;
            var w2 = w0 - l2 + 2.0 * G4;
            var x3 = x0 - i3 + 3.0 * G4; // Offsets for fourth corner in (x,y,z,w) coords
            var y3 = y0 - j3 + 3.0 * G4;
            var z3 = z0 - k3 + 3.0 * G4;
            var w3 = w0 - l3 + 3.0 * G4;
            var x4 = x0 - 1.0 + 4.0 * G4; // Offsets for last corner in (x,y,z,w) coords
            var y4 = y0 - 1.0 + 4.0 * G4;
            var z4 = z0 - 1.0 + 4.0 * G4;
            var w4 = w0 - 1.0 + 4.0 * G4;
            // Work out the hashed gradient indices of the five simplex corners
            var ii = i & 255;
            var jj = j & 255;
            var kk = k & 255;
            var ll = l & 255;
            // Calculate the contribution from the five corners
            var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
            if (t0 < 0) n0 = 0.0;
            else {
                var gi0 = perm[ii + perm[jj + perm[kk + perm[ll]]]] % 32 * 4;
                t0 *= t0;
                n0 = t0 * t0 * (grad4[gi0] * x0 + grad4[gi0 + 1] * y0 + grad4[gi0 + 2] * z0 + grad4[gi0 + 3] * w0);
            }
            var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
            if (t1 < 0) n1 = 0.0;
            else {
                var gi1 = perm[ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]]] % 32 * 4;
                t1 *= t1;
                n1 = t1 * t1 * (grad4[gi1] * x1 + grad4[gi1 + 1] * y1 + grad4[gi1 + 2] * z1 + grad4[gi1 + 3] * w1);
            }
            var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
            if (t2 < 0) n2 = 0.0;
            else {
                var gi2 = perm[ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]]] % 32 * 4;
                t2 *= t2;
                n2 = t2 * t2 * (grad4[gi2] * x2 + grad4[gi2 + 1] * y2 + grad4[gi2 + 2] * z2 + grad4[gi2 + 3] * w2);
            }
            var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
            if (t3 < 0) n3 = 0.0;
            else {
                var gi3 = perm[ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]]] % 32 * 4;
                t3 *= t3;
                n3 = t3 * t3 * (grad4[gi3] * x3 + grad4[gi3 + 1] * y3 + grad4[gi3 + 2] * z3 + grad4[gi3 + 3] * w3);
            }
            var t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
            if (t4 < 0) n4 = 0.0;
            else {
                var gi4 = perm[ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]]] % 32 * 4;
                t4 *= t4;
                n4 = t4 * t4 * (grad4[gi4] * x4 + grad4[gi4 + 1] * y4 + grad4[gi4 + 2] * z4 + grad4[gi4 + 3] * w4);
            }
            // Sum up and scale the result to cover the range [-1,1]
            return 27.0 * (n0 + n1 + n2 + n3 + n4);
        }
    };
    function buildPermutationTable(random) {
        var i;
        var p = new Uint8Array(256);
        for(i = 0; i < 256; i++)p[i] = i;
        for(i = 0; i < 255; i++){
            var r = i + ~~(random() * (256 - i));
            var aux = p[i];
            p[i] = p[r];
            p[r] = aux;
        }
        return p;
    }
    SimplexNoise._buildPermutationTable = buildPermutationTable;
    function alea() {
        // Johannes Baagøe <baagoe@baagoe.com>, 2010
        var s0 = 0;
        var s1 = 0;
        var s2 = 0;
        var c = 1;
        var mash = masher();
        s0 = mash(' ');
        s1 = mash(' ');
        s2 = mash(' ');
        for(var i = 0; i < arguments.length; i++){
            s0 -= mash(arguments[i]);
            if (s0 < 0) s0 += 1;
            s1 -= mash(arguments[i]);
            if (s1 < 0) s1 += 1;
            s2 -= mash(arguments[i]);
            if (s2 < 0) s2 += 1;
        }
        mash = null;
        return function() {
            var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
            s0 = s1;
            s1 = s2;
            return s2 = t - (c = t | 0);
        };
    }
    function masher() {
        var n = 0xefc8249d;
        return function(data) {
            data = data.toString();
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
    }
    // amd
    if (typeof define !== 'undefined' && define.amd) define(function() {
        return SimplexNoise;
    });
    $7f9986d0b71cf3d1$exports.SimplexNoise = SimplexNoise;
    $7f9986d0b71cf3d1$exports = SimplexNoise;
})();



var $eb6468a6724a7e01$exports = {};
$eb6468a6724a7e01$exports = import.meta.resolve("glL91");


var $57ecab759070ecb6$exports = {};
$57ecab759070ecb6$exports = import.meta.resolve("k0Qkj");








class $045a6cdaef4f9cc2$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, position: position }){
        super({
            engine: engine,
            type: "fx"
        });
        this.zindex = -1;
        this.engine = engine;
        this.position = {
            ...position
        };
        this.lifetime = 2;
        this.currentLifetime = this.lifetime;
        this.noise = new (0, (/*@__PURE__*/$parcel$interopDefault($7f9986d0b71cf3d1$exports)))();
        this.size = Math.random() * 5 + 10;
        this.rotation = Math.random() * Math.PI * 2;
    }
    update() {
        const s = this.engine.scaleFactor;
        this.position.x += (this.noise.noise2D(0, this.engine.time.time * 0.2) * 50 - 300) * this.engine.time.delta;
        this.position.y += this.noise.noise2D(this.engine.time.time * 0.2, 0) * 50 * this.engine.time.delta;
        this.currentLifetime -= this.engine.time.delta;
        if (this.currentLifetime <= 0) this.engine.destroyEntity(this);
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        const w = this.size * s;
        const r = this.currentLifetime / this.lifetime;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.scale(r, r);
        ctx.rotate(this.rotation);
        ctx.strokeStyle = "red";
        ctx.globalAlpha = r * 0.5;
        ctx.beginPath();
        ctx.arc(0, 0, w, 2 * Math.PI, false);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.restore();
    }
}



var $45a608a400f86e46$exports = {};
$45a608a400f86e46$exports = import.meta.resolve("afdl3");


var $a65f0fbc46bb0f07$exports = {};
$a65f0fbc46bb0f07$exports = import.meta.resolve("1yhIT");


var $52152bf71e867ea3$exports = {};
$52152bf71e867ea3$exports = import.meta.resolve("lPQLk");


var $980fc96ede34d95e$exports = {};
$980fc96ede34d95e$exports = import.meta.resolve("f7Wle");


class $edfe72f42a1199ca$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, position: position, player: player }){
        super({
            engine: engine,
            type: "rocket"
        });
        this.engine = engine;
        this.position = {
            ...position
        };
        this.direction = {
            x: 0,
            y: 0
        };
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 50,
            h: 50
        });
        this.player = player;
        this.speed = 1500;
        this.lerp = Math.random() * 0.0025 + 0.0075;
        const urls = [
            (0, (/*@__PURE__*/$parcel$interopDefault($45a608a400f86e46$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($a65f0fbc46bb0f07$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($980fc96ede34d95e$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($52152bf71e867ea3$exports)))
        ];
        const url = urls[Math.floor(Math.random() * urls.length)];
        this.texture = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)(url);
        this.particleEmissionTimer = 0.2;
        this.lifeTime = 10;
    }
    update() {
        const s = this.engine.scaleFactor;
        let direction = {
            x: this.player.position.x - this.position.x,
            y: this.player.position.y - this.position.y
        };
        direction = (0, $23fe82e59dfa02b3$export$4d973b3eababff1d)(direction);
        this.direction.x += (direction.x - this.direction.x) * this.lerp;
        this.direction.y += (direction.y - this.direction.y) * this.lerp;
        let angle = Math.atan2(this.direction.y, this.direction.x);
        this.position.x += this.direction.x * this.speed * this.engine.time.delta * s;
        this.position.y += this.direction.y * this.speed * this.engine.time.delta * s;
        this.particleEmissionTimer -= this.engine.time.delta;
        if (this.particleEmissionTimer <= 0) {
            this.particleEmissionTimer = 0.05;
            new (0, $045a6cdaef4f9cc2$export$2e2bcd8739ae039)({
                engine: this.engine,
                position: this.position
            });
        }
        this.lifeTime -= this.engine.time.delta;
        if (this.lifeTime <= 0) this.hit();
    }
    render(ctx) {
        const s = this.engine.scaleFactor;
        const w = 50 * s;
        const glowRadius = 50 * s;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.beginPath();
        //light
        const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, glowRadius);
        gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)');
        gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(-glowRadius, -glowRadius, glowRadius * 2, glowRadius * 2);
        this.texture.draw(ctx, w);
        ctx.restore();
        this.hitbox.set({
            ...this.position,
            w: w,
            h: w
        });
    }
    hit() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 600
        });
        this.engine.destroyEntity(this);
    }
    kill() {
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 300
        });
        this.engine.destroyEntity(this);
    }
}



var $090975e7b8b3f841$exports = {};
$090975e7b8b3f841$exports = import.meta.resolve("lfciU");


var $31a67a974f3f85e0$exports = {};
$31a67a974f3f85e0$exports = import.meta.resolve("iSSH4");



var $2Tywo = parcelRequire("2Tywo");

class $ad9105582447a126$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, music: music, player: player }){
        super({
            engine: engine,
            type: "boss"
        });
        this.position = {
            x: this.engine.width * 0.75,
            y: this.engine.height * 0.5
        };
        this.offset = this.engine.width * 0.5;
        this.hitbox = new (0, $138b36ed328bed3a$export$2e2bcd8739ae039)({
            ...this.position,
            w: 100,
            h: 100
        });
        this.noise = new (0, (/*@__PURE__*/$parcel$interopDefault($7f9986d0b71cf3d1$exports)))("boss");
        this.maxHp = 200;
        this.hp = this.maxHp;
        this.hpBarsDOM = document.getElementById("boss-hp").querySelectorAll(".healthbar__inner div");
        this.texture = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($eb6468a6724a7e01$exports))));
        this.textureMask = new (0, $9379e936737b4e5b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($57ecab759070ecb6$exports))));
        this.rotation = 0;
        this.direction = {
            x: 500,
            y: 0
        };
        this.music = music;
        this.hitted = false;
        this.player = player;
        this.fireTimer = 0;
        this.dying = false;
        this.time = 0;
    }
    update() {
        if (!this.dying) {
            let x = (this.noise.noise2D(0, (this.engine.time.time - .5) * 0.2) + 1) * 0.5 * this.engine.width * 0.5 + this.engine.width * 0.5 + this.offset;
            let y = (this.noise.noise2D((this.engine.time.time - .5) * 0.2, 0) + 1) * 0.5 * this.engine.height;
            this.position.x = (this.noise.noise2D(0, this.engine.time.time * 0.2) + 1) * 0.5 * this.engine.width * 0.5 + this.engine.width * 0.5 + this.offset;
            this.position.y = (this.noise.noise2D(this.engine.time.time * 0.2, 0) + 1) * 0.5 * this.engine.height;
            let direction = {
                x: x - this.position.x,
                y: y - this.position.y
            };
            this.direction.x += (direction.x - this.direction.x) * 0.1;
            this.direction.y += (direction.y - this.direction.y) * 0.1;
            this.rotation = Math.atan2(-this.direction.y, this.direction.x + 500);
            this.fireTimer += this.engine.time.delta;
            if (this.fireTimer > 1.5 + 18.5 * (this.hp / this.maxHp)) {
                this.fireTimer = 0;
                new (0, $edfe72f42a1199ca$export$2e2bcd8739ae039)({
                    engine: this.engine,
                    position: this.position,
                    player: this.player
                });
                const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($090975e7b8b3f841$exports))));
                sfx.volume = 0.5;
                sfx.play();
            }
            this.collision();
        } else {
            this.hitted = Math.sin(this.engine.time.time * 50) > 0;
            this.rotation += this.engine.time.delta * (Math.PI / 180) * 180;
            this.fireTimer += this.engine.time.delta;
            if (this.fireTimer > .02) {
                const s = this.engine.scaleFactor;
                this.fireTimer = 0;
                const pos = {
                    ...this.position
                };
                const angle = Math.random() * Math.PI * 2;
                const dist = Math.random() * 100;
                pos.x -= 120 * s + Math.cos(angle) * dist;
                pos.y += 50 * s + Math.sin(angle) * dist;
                new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
                    engine: this.engine,
                    position: pos,
                    size: 100 + Math.random() * 200
                });
            }
        }
        this.engine.renderer.passes[0].material.uniforms.boss_position.value = [
            this.position.x / this.engine.width,
            this.position.y / this.engine.height
        ];
        this.updateUI();
    }
    collision() {
        this.engine.entities.forEach((e)=>{
            if (e.type == "bullet" && e.hitbox.overlaps(this.hitbox)) {
                e.hit();
                this.hp--;
                this.hitted = true;
                clearTimeout(this.hitTimeout);
                this.hitTimeout = setTimeout(()=>this.hitted = false, 30);
                e.player.addScore();
                if (this.hp <= 0) this.death();
            }
        });
    }
    death() {
        this.dying = true;
        this.music.stop();
        new (0, $1c84fda684ccfcbe$export$2e2bcd8739ae039)({
            engine: this.engine,
            position: this.position,
            size: 2000
        });
        (0, $2Tywo.default).timeline().to(".hud", {
            duration: 1.5,
            autoAlpha: 0,
            ease: "power3.inOut"
        }, "0").to(this.position, {
            duration: 5,
            y: this.position.y + window.innerHeight,
            x: this.position.x - 1000,
            ease: "power1.in"
        }, "0").to(this.player, {
            duration: 2,
            rotation: 0
        }, "0").to(this.player.position, {
            duration: 2,
            y: window.innerHeight / 2,
            x: window.innerWidth * 1.5,
            ease: "power4.in"
        }, "1");
        this.engine.entities.forEach((e)=>{
            if (e.type == "note") setTimeout(()=>{
                e.kill();
            }, 500 * Math.random());
            else if (e.type == "rocket") e.kill();
        });
        this.player.gameover = true;
        const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($31a67a974f3f85e0$exports))));
        sfx.volume = 1;
        sfx.play();
        (0, $53363953c764d94d$export$2e2bcd8739ae039)({
            win: true,
            score: this.player.score,
            time: this.player.scoreTime
        });
    }
    updateUI() {
        const percent = (1 - this.hp / this.maxHp) * 100;
        this.hpBarsDOM[0].style = "transform: translateX(-" + percent + "%);";
        this.hpBarsDOM[1].style = "transform: translateX(-" + percent + "%);";
    }
    render(ctx) {
        if (!this.texture.ready) return;
        const s = this.engine.scaleFactor;
        const texSize = 300 * s;
        const texOffset = 75 * s;
        const glowRadius = 400 * this.music.analyser.data.rawvolume * s;
        ctx.save();
        ctx.translate(this.position.x - texOffset, this.position.y);
        ctx.rotate(this.rotation);
        //light
        const gradient = ctx.createRadialGradient(texOffset, 0, 0, texOffset, 0, glowRadius);
        gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)');
        gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(-glowRadius + texOffset, -glowRadius, glowRadius * 2, glowRadius * 2);
        this.drawAura(ctx);
        ctx.shadowBlur = 20 * s * this.music.analyser.data.rawvolume;
        //texture
        this.texture.draw(ctx, texSize);
        ctx.globalAlpha = 0.5;
        if (this.hitted) this.textureMask.draw(ctx, texSize);
        ctx.globalAlpha = 1;
        ctx.restore();
        //Update hitbox
        this.hitbox.set({
            ...this.position,
            w: 100 * s,
            h: 100 * s
        });
    }
    drawAura(ctx) {
        const s = this.engine.scaleFactor;
        const offset = 100 * s;
        const size = 150 * s;
        let values = this.music.analyser.extractData({
            min: 0,
            max: 50
        });
        ctx.beginPath();
        for(let i = 0; i < values.length; i++){
            let angle = i / values.length * Math.PI;
            let x = -Math.cos(angle) * values[i] / 255 * size + offset;
            let y = Math.sin(angle) * values[i] / 255 * size;
            ctx.lineTo(x, y);
        }
        for(let i = values.length - 1; i >= 0; i--){
            let angle = -i / values.length * Math.PI;
            let x = -Math.cos(angle) * values[i] / 255 * size + offset;
            let y = Math.sin(angle) * values[i] / 255 * size;
            ctx.lineTo(x, y);
        }
        ctx.shadowColor = "red";
        ctx.shadowBlur = 20 * s;
        ctx.lineWidth = 1;
        ctx.strokeStyle = "red";
        ctx.stroke();
        ctx.beginPath();
    }
}


class $a88f862e1a7cb912$export$2e2bcd8739ae039 {
    constructor({ tracklist: tracklist }){
        this.tracklist = tracklist;
        this.audioNode = document.createElement("audio");
        this.source = this.audioNode.appendChild(document.createElement("source"));
        this.audioNode.volume = 0.4;
        this.started = false;
        this.autoPlaylist = true;
        this.audioNode.onended = ()=>{
            console.log("Song has ended");
            if (this.autoPlaylist) this.nextTrack();
        };
        this.tracksetEvent = new Event("trackset");
    }
    get tracks() {
        return this.tracklist;
    }
    reload() {
        this.setTrack(0);
    }
    start() {
        if (!this.started) {
            this.setTrack(0);
            this.started = true;
            console.log("audio started");
        }
    }
    setTrack(id) {
        if (id < 0) id = this.tracks.length - 1;
        else if (id > this.tracks.length - 1) id = 0;
        this.currentTrackIndex = id;
        this.source.src = this.getCurrentTrack().url;
        this.audioNode.load();
        this.audioNode.play();
        this.audioNode.dispatchEvent(this.tracksetEvent);
        console.log("track setted " + this.currentTrackIndex);
    }
    getCurrentTrack() {
        return this.tracks[this.currentTrackIndex];
    }
    nextTrack() {
        this.setTrack(this.currentTrackIndex + 1);
    }
    previousTrack() {
        this.setTrack(this.currentTrackIndex - 1);
    }
    getProgress() {
        return this.audioNode.currentTime / this.audioNode.duration;
    }
    isPlaying() {
        return !this.audioNode.paused && this.audioNode.currentTime > 0;
    }
    play() {
        this.audioNode.play();
    }
    pause() {
        this.audioNode.pause();
    }
    togglePlay() {
        if (this.isPlaying()) this.audioNode.pause();
        else this.audioNode.play();
    }
}


class $243bd4f4d01dfa48$export$2e2bcd8739ae039 {
    constructor({ audio: audio, fftSize: fftSize }){
        this.audio = audio;
        this.context = new AudioContext();
        this.src = this.context.createMediaElementSource(this.audio.audioNode);
        this.analyser = this.context.createAnalyser();
        this.src.connect(this.analyser);
        this.analyser.connect(this.context.destination);
        this.analyser.fftSize = fftSize;
        this.bufferLength = this.analyser.frequencyBinCount;
        this.dataArray = new Uint8Array(this.bufferLength);
        this.beats = [];
        this.bpmTimer = 0;
        for(let i = 0; i < 10; i++)this.beats[i] = new $243bd4f4d01dfa48$var$Beat();
        this.data = {
            time: {
                time: 0,
                delta: 0
            },
            volume: 0,
            rawvolume: 0,
            intensity: 0,
            difference: 0,
            color: "white",
            saturation: 0,
            onBpm: false,
            bpmNumber: 0,
            bpm: function(i) {
                return this.onBpm && this.bpmNumber > 0 && this.bpmNumber % i === 0;
            },
            trackname: "",
            artist: ""
        };
        this.audio.audioNode.addEventListener("trackset", ()=>{
            this.context.resume();
        });
        /*
                DEBUGGER
            */ let debugCanvas = document.createElement("canvas");
        debugCanvas.width = window.innerWidth;
        debugCanvas.height = window.innerHeight;
        debugCanvas.style = `
            position: absolute;
            top: 0;
            left: 0;
            z-index: 9999;
            pointer-events: none;
        `;
        document.querySelector("body").append(debugCanvas);
        this.debugger = {
            on: false,
            canvas: debugCanvas,
            ctx: debugCanvas.getContext("2d")
        };
    }
    refreshData(time) {
        this.data.time = time;
        this.analyser.getByteFrequencyData(this.dataArray);
        for(let i = 0; i < this.beats.length; i++){
            let _min = i / this.beats.length * 100;
            let _max = (i + 1) / this.beats.length * 100;
            let currentAverage = this.getAverage({
                min: _min,
                max: _max
            });
            this.beats[i].update(currentAverage, time);
        }
        if (this.audio.isPlaying()) {
            this.bpmTimer += this.data.time.delta;
            this.data.onBpm = this.bpmTimer > 60 / this.audio.getCurrentTrack().bpm;
            if (this.data.onBpm) {
                this.bpmTimer = 0;
                this.data.bpmNumber += 1;
            }
            this.data.trackname = this.audio.getCurrentTrack().name;
            this.data.artist = this.audio.getCurrentTrack().artist;
        }
        this.data.rawvolume = this.getAverage({
            min: 0,
            max: 100
        });
        this.data.volume += (this.data.rawvolume - this.data.volume) * 0.8;
        this.data.intensity += (this.data.rawvolume - this.data.intensity) * 0.01;
        this.data.difference += ((this.data.rawvolume - this.data.intensity) * 10.0 - this.data.difference) * 0.7;
    }
    debug() {
        this.debugger.canvas.width = window.innerWidth;
        this.debugger.canvas.height = window.innerHeight;
        this.debugger.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (this.debugger.on) {
            let widthData = window.innerWidth / this.dataArray.length;
            let widthBeat = widthData * (this.bufferLength / this.beats.length);
            for(let i = 0; i < this.beats.length; i++){
                let height = this.beats[i].smoothedValue * window.innerHeight / 5 + 2;
                this.debugger.ctx.fillStyle = this.beats[i].on() ? "red" : "grey";
                this.debugger.ctx.fillRect(widthBeat * i + 1, window.innerHeight - height, widthBeat - 2, height);
            }
            this.debugger.ctx.fillStyle = "white";
            for(let i = 0; i < this.dataArray.length; i++){
                let height = this.dataArray[i] / 255 * window.innerHeight / 5;
                this.debugger.ctx.fillRect(widthData * i + 2, window.innerHeight - height, widthData - 1, height);
            }
        }
    }
    extractData(range) {
        let _min = Math.floor(range.min / 100 * this.dataArray.length);
        let _max = Math.ceil(range.max / 100 * this.dataArray.length);
        return this.dataArray.slice(_min, _max);
    }
    getAverage(range) {
        let array = this.extractData(range);
        let moy = 0;
        for(let i = 0; i < array.length; i++)moy += array[i];
        return moy / array.length / 255;
    }
    getMax(range) {
        let array = this.extractData(range);
        return Math.max(...array) / 255;
    }
    getMin(range) {
        let array = this.extractData(range);
        return Math.min(...array) / 255;
    }
    getQuartile(range, q) {
        let array = this.extractData(range);
        array = array.sort((a, b)=>{
            return a - b;
        });
        var pos = (array.length - 1) * q;
        var base = Math.floor(pos);
        var rest = pos - base;
        if (array[base + 1] !== undefined) return array[base] + rest * (array[base + 1] - array[base]);
        else return array[base];
    }
    getData() {
        return this.data;
    }
}
class $243bd4f4d01dfa48$var$Beat {
    constructor(){
        this.value = 0;
        this.smoothedValue = 0;
        this.beatedDelay = 0;
    }
    update(value, time) {
        if (value - 0.05 > this.smoothedValue && value > 0) {
            this.value = value;
            this.beatedDelay = 1;
        } else if (this.value > 0) this.beatedDelay -= time.delta * 10;
        else this.value = 0;
        this.smoothedValue += (value - this.smoothedValue) * 0.3;
    }
    on() {
        return this.beatedDelay > 0;
    }
}



class $fdd835f1e020b85c$export$2e2bcd8739ae039 extends (0, $45747524b18cbcbc$export$2e2bcd8739ae039) {
    constructor({ engine: engine, tracklist: tracklist }){
        super({
            engine: engine,
            type: "music"
        });
        this.audioPlayer = new (0, $a88f862e1a7cb912$export$2e2bcd8739ae039)({
            tracklist: tracklist
        });
        this.audioPlayer.autoPlaylist = false;
        this.analyser = new (0, $243bd4f4d01dfa48$export$2e2bcd8739ae039)({
            audio: this.audioPlayer,
            fftSize: 256
        });
        this.analyser.debugger.on = false;
        this.effectMult = 1;
    }
    update() {
        this.analyser.refreshData(this.engine.time.time);
    }
    render() {
        this.analyser.debug();
        this.engine.renderer.passes[0].material.uniforms.music_intensity.value = this.analyser.data.intensity * this.effectMult;
        this.engine.renderer.passes[1].material.uniforms.music_volume.value = Math.pow(this.analyser.data.rawvolume, 2) * this.effectMult;
    }
    stop() {
        this.audioPlayer.pause();
    }
}






var $2Tywo = parcelRequire("2Tywo");


var $35045335d8528428$exports = {};
$35045335d8528428$exports = import.meta.resolve("i2BUo");



var $8dc7816255eab221$exports = {};
$8dc7816255eab221$exports = import.meta.resolve("m76iD");


var $a7be2ec89a1d6e56$exports = {};
$a7be2ec89a1d6e56$exports = import.meta.resolve("lUfTJ");




var $fe254fdc9828c5b3$exports = {};
$fe254fdc9828c5b3$exports = import.meta.resolve("4zQqU");



var $e58a1104dca30f5c$exports = {};
$e58a1104dca30f5c$exports = import.meta.resolve("2nxlv");



var $df3fb87ac4325cfa$exports = {};
$df3fb87ac4325cfa$exports = import.meta.resolve("dt0YB");


var $3b4a49d273c59203$exports = {};
$3b4a49d273c59203$exports = import.meta.resolve("5Ulsu");








var $3f6dd0ee08ff9166$exports = {};
$3f6dd0ee08ff9166$exports = import.meta.resolve("3Btw4");




var $e2a484db740d7af3$exports = {};
$e2a484db740d7af3$exports = import.meta.resolve("fKBll");








const $cbcb3d7a68c9b7de$export$7388fe53b47ea720 = [];
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($57ecab759070ecb6$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($eb6468a6724a7e01$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($35045335d8528428$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($a5c1d88f9c0e11ef$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($8dc7816255eab221$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($a7be2ec89a1d6e56$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($a65f0fbc46bb0f07$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($e2a21789f44b6886$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($fe254fdc9828c5b3$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($45a608a400f86e46$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($e58a1104dca30f5c$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($980fc96ede34d95e$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($df3fb87ac4325cfa$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($3b4a49d273c59203$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($7489b065baeef507$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($8a9fa6970a4348a8$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($d2e690ee3b3e3ff1$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($ec56fb03736c7e5f$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($6e9e0340ad74cd6d$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($754ed878fed86975$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($3f6dd0ee08ff9166$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($63ad87ffbecd606a$exports))));
$cbcb3d7a68c9b7de$export$7388fe53b47ea720.push((0, (/*@__PURE__*/$parcel$interopDefault($52152bf71e867ea3$exports))));
const $cbcb3d7a68c9b7de$export$3e5cf65048461038 = [];
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($e2a484db740d7af3$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($31a67a974f3f85e0$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($3fb1761bbc132863$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($a220e6c34acc2f22$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($04d95ac4e8a2eda8$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($090975e7b8b3f841$exports))));
$cbcb3d7a68c9b7de$export$3e5cf65048461038.push((0, (/*@__PURE__*/$parcel$interopDefault($8e3724fef59ee1d5$exports))));


class $0e5a78bda799a799$export$2e2bcd8739ae039 {
    constructor(){
        document.getElementById("loader").classList.add("javascript-loaded");
    }
    load() {
        const images = [];
        (0, $cbcb3d7a68c9b7de$export$7388fe53b47ea720).forEach((src)=>{
            const img = new Image();
            images.push(img);
            img.onload = ()=>this.updateProgress();
            img.src = src;
        });
        const audios = [];
        (0, $cbcb3d7a68c9b7de$export$3e5cf65048461038).forEach((src)=>{
            const audio = new Audio(src);
            audios.push(audio);
            audio.oncanplaythrough = ()=>this.updateProgress();
            audio.load();
        });
        this.assetLength = images.length + audios.length;
        this.assetsLoaded = 0;
        this.progress = 0;
    }
    updateProgress() {
        this.assetsLoaded++;
        console.log("assets: " + this.assetsLoaded + "/" + this.assetLength);
        this.progress = this.assetsLoaded / this.assetLength;
        let tl = (0, $2Tywo.default).timeline();
        tl.to("#loader>div>div", {
            scaleX: this.progress,
            duration: .3
        });
        if (this.progress == 1) tl.to("#loader", {
            autoAlpha: 0,
            duration: .3
        });
    }
    force() {
        (0, $2Tywo.default).to("#loader", {
            autoAlpha: 0,
            duration: .3
        });
    }
}


var $4f9d7454d0b20384$exports = {};
$4f9d7454d0b20384$exports = import.meta.resolve("6VUa6");



window.addEventListener("load", function() {
    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef));
    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(".hud", {
        autoAlpha: 0
    });
    $8f6a480bb40b134f$var$loadScoreboard();
    const loader = new (0, $0e5a78bda799a799$export$2e2bcd8739ae039)();
    setTimeout(()=>loader.load(), 300);
    const engine = (0, $e21f92a4ed8f2216$export$2e2bcd8739ae039)();
    const inputs = new (0, $93a93d85ffca0694$export$2e2bcd8739ae039)();
    let started = false;
    document.getElementById("game-start").addEventListener("click", (e)=>{
        if (started) return;
        started = true;
        const music = new (0, $fdd835f1e020b85c$export$2e2bcd8739ae039)({
            engine: engine,
            tracklist: [
                {
                    name: "acdc",
                    url: $e2a484db740d7af3$exports
                }
            ]
        });
        let tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline();
        tl.to(".darkmoon", {
            duration: .5,
            x: 300
        }, 0);
        tl.to(".guitar-stand", {
            duration: 1,
            x: -300
        }, 0);
        tl.to(".tutorial", {
            duration: .5,
            autoAlpha: 0
        }, 0);
        tl.fromTo(".hud", {
            duration: .5,
            autoAlpha: 0,
            y: -10
        }, {
            duration: .5,
            autoAlpha: 1,
            y: 0
        }, 0);
        const counter = document.querySelector(".start-counter");
        [
            "3",
            "2",
            "1",
            "FIGHT"
        ].forEach((text, i)=>{
            tl.fromTo(counter, {
                duration: 1,
                scale: 0.5,
                autoAlpha: 0
            }, {
                duration: .5,
                scale: 1,
                autoAlpha: 1,
                onStart: ()=>{
                    counter.textContent = text;
                    const sfx = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3fb1761bbc132863$exports))));
                    sfx.volume = 0.1;
                    sfx.play();
                }
            });
            tl.to(counter, {
                autoAlpha: 0,
                scale: i == 3 ? 2 : 1,
                duration: .1,
                delay: 0.4
            });
        });
        tl.add(()=>$8f6a480bb40b134f$var$startGame(engine, music, inputs), 4);
    });
    engine.start();
});
function $8f6a480bb40b134f$var$startGame(engine, music, inputs) {
    (0, $28735cb37928c976$exports.Midi).fromUrl($4f9d7454d0b20384$exports).then((midi)=>{
        (0, $3f3c57753de1ef73$export$2e2bcd8739ae039)({
            engine: engine,
            midi: midi,
            delay: 0,
            playsound: false
        });
        setTimeout(()=>music.audioPlayer.start(), 0);
        const player = new (0, $849bf9afc8e96ee4$export$2e2bcd8739ae039)({
            engine: engine,
            inputs: inputs,
            music: music
        });
        const boss = new (0, $ad9105582447a126$export$2e2bcd8739ae039)({
            engine: engine,
            music: music,
            player: player
        });
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(boss, {
            duration: 3,
            offset: 0
        });
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).from(player, {
            duration: 5,
            smoothing: 0
        });
    });
}
async function $8f6a480bb40b134f$var$loadScoreboard() {
    //const response = await fetch('https://creano.paris/xxxx/ranking', {
    const response = await fetch('/api/ranking', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        console.error('Erreur lors du chargement du scoreboard');
        return;
    }
    const data = await response.json();
    const userList = document.querySelector('.userList');
    data.forEach((user, index)=>{
        const userDiv = document.createElement('div');
        userDiv.classList.add('user');
        userDiv.innerHTML = `
    <span>#${index + 1}</span>
    <span class="username">${user.username}</span>
    <span class="score">${user.score}</span>
  `;
        userList.appendChild(userDiv);
    });
}


//# sourceMappingURL=creano-game-guitar-shoot.9d5755b5.js.map
